// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const DMC = {
  AlscoMetals: {
    Alsco_878_White: 10708,
    Alsco_91R_Bronze: 10709,
    Alsco_TAD_Almond: 10710,
  },
  Alside: {
    Alside_AdobeCream: 10314,
    Alside_AgelessSlate: 10315,
    Alside_AntiqueParchment: 10316,
    Alside_Black: 10317,
    Alside_Bronze: 10986,
    Alside_CanyonClay: 10318,
    Alside_CanyonDrift: 10319,
    Alside_CapeCodGray: 10320,
    Alside_CastIron: 10321,
    Alside_CharcoalSmoke: 10322,
    Alside_CoastalSage: 10323,
    Alside_DeepEspresso: 10324,
    Alside_DeepMoss: 10325,
    Alside_FiredBrick: 10326,
    Alside_FlagshipBrown: 10327,
    Alside_GlacierWhite: 10328,
    Alside_HarborBlue: 10329,
    Alside_JuniperRidge: 10330,
    Alside_LagunaBlue: 10331,
    Alside_Maple: 10332,
    Alside_MidnightBlue: 10333,
    Alside_MontereySand: 10334,
    Alside_MountainFern: 10335,
    Alside_MusketBrown: 10336,
    Alside_MysticBlue: 10337,
    Alside_NaturalLinen: 10338,
    Alside_PlatinumGray: 10339,
    Alside_RivieraDusk: 10340,
    Alside_RusticTimber: 10341,
    Alside_SterlingGray: 10342,
    Alside_Storm: 10343,
    Alside_TerratoneBronze: 10987,
    Alside_TuscanClay: 10344,
    Alside_VintageWicker: 10345,
  },
  Ascend: {
    Ascend_AgelessSlate: 1756,
    Ascend_Almond: 1757,
    Ascend_CanyonDrift: 1758,
    Ascend_CapeCodGray: 1759,
    Ascend_CastIron: 1760,
    Ascend_CharcoalSmoke: 1761,
    Ascend_DeepMoss: 1762,
    Ascend_FiredBrick: 1763,
    Ascend_FlagshipBrown: 1764,
    Ascend_GlacierWhite: 1765,
    Ascend_HarborBlue: 1766,
    Ascend_LagunaBlue: 1767,
    Ascend_MidnightBlue: 1768,
    Ascend_MontereySand: 1769,
    Ascend_MountainFern: 1770,
    Ascend_Pebble: 1771,
    Ascend_RivieraDusk: 1772,
    Ascend_RusticTimber: 1773,
    Ascend_SterlingGray: 1774,
    Ascend_Storm: 1775,
  },
  Behr: {
    Behr_170E3_BridalRose: 1805,
    Behr_230D4_PecosSpice: 1806,
    Behr_290C2_CreamyBeige: 1807,
    Behr_310E3_RipeWheat: 1808,
    Behr_340F7_WovenBasket: 1809,
    Behr_350F4_QuietVeranda: 1810,
    Behr_400F4_Restful: 1811,
    Behr_420F6_EgyptianNile: 1812,
    Behr_460D7_SabalPalm: 1813,
    Behr_470F5_Garland: 1814,
    Behr_500D4_JamaicaBay: 1815,
    Behr_570A3_PacificPanorama: 1816,
    Behr_590D6_WickfordBay: 1817,
    Behr_700D7_SouthKingston: 1818,
    Behr_710D4_HarvestBrown: 1819,
    Behr_710E1_SnowLeopard: 1820,
    Behr_710E3_Rhino: 1821,
    Behr_720D4_Ashwood: 1822,
    Behr_720D6_ToastedWalnut: 1823,
    Behr_720F5_HiddenPeak: 1824,
    Behr_720F6_Paramount: 1825,
    Behr_730C3_CastlePath: 1826,
    Behr_730F6_Amphibian: 1827,
    Behr_740D6_MountainElk: 1828,
    Behr_770C2_BelvedereCream: 1829,
    Behr_770C3_SandFossil: 1830,
    Behr_770D4_ClayPeble: 1831,
    Behr_ClearTransparent: 11453,
    Behr_SG720_Fireside: 1832,
    Behr_SH160_SlyFox: 1833,
    Behr_ST129_Chocolate: 11454,
    Behr_WF720_SilverLeaf: 1834,
  },
  BenjaminMoore: {
    BM_1127_SedonaBrown: 1952,
    BM_1216_BakersDozen: 1953,
    BM_1232_FreshBrew: 10921,
    BM_1296_SailorsDelight: 1954,
    BM_1302_SweetRosyBrown: 1955,
    BM_1466_SmokeEmbers: 10977,
    BM_1471_Shoreline: 1956,
    BM_1495_OctoberMist: 1957,
    BM_1535_SeattleMist: 1958,
    BM_1547_DragonsBreath: 10911,
    BM_1578_IcedMarble: 1959,
    BM_1582_DeepRiver: 1960,
    BM_200510_RedRock: 1961,
    BM_204050_HazyBlue: 1962,
    BM_2107_MochaBrown: 11336,
    BM_212410_WroughtIron: 10978,
    BM_212470_DistantGray: 11018,
    BM_213_HarpStrings: 1963,
    BM_213140_SmokestackGray: 1964,
    BM_213210_Black: 10549,
    BM_213310_Onyx: 53,
    BM_213430_IronMountain: 217,
    BM_213530_NocturnalGray: 1965,
    BM_214430_RosemarySprig: 1966,
    BM_214850_SandyWhite: 1967,
    BM_235_OakRidge: 1968,
    BM_2772_NouveauBlue: 1969,
    BM_476_JadeRomanesque: 1979,
    BM_505_HintOfMint: 1970,
    BM_630_MarthasVineyard: 1971,
    BM_70_Topaz: 55,
    BM_706_CedarMountains: 1980,
    BM_820_MistyBlue: 56,
    BM_825_BlueNova: 1972,
    BM_835_GrandRapids: 57,
    BM_936_MeadowMist: 208,
    BM_961_SeaPearl: 218,
    BM_976_CoastalFog: 1973,
    BM_979_Stampede: 231,
    BM_980_WoodcliffLake: 1974,
    BM_984_StoneHearth: 10912,
    BM_998_CabotTrail: 1975,
    BM_AF25_PaperMache: 232,
    BM_AF440_UrbanNature: 233,
    BM_AF55_Sonnet: 59,
    BM_AF700_Storm: 60,
    BM_ATC75_PinotNoir: 61,
    BM_ES44_SpanishMoss: 10550,
    BM_ES72_SeagullGray: 10922,
    BM_ES76_Stonehenge: 10548,
    BM_HC154_HaleNavy: 219,
    BM_HC166_KendallCharcoal: 11019,
    BM_HC168_ChelseaGray: 63,
    BM_HC172_ReverePewter: 6413,
    BM_HC190_Black: 10923,
    BM_HC31_WaterburyCream: 1976,
    BM_HC57_SheratonBeige: 1977,
    BM_HC87_AshleyGray: 10979,
    BM_HC93_CarringtonBeige: 1978,
    BM_OC17_WhiteDove: 10913,
    BM_OC20_PaleOak: 10914,
    BM_OC26_SilverSatin: 11020,
    BM_OC45_SwissCoffee: 10915,
    BM_OC65_ChantillyLace: 11021,
  },
  BuildersEdge: {
    BuildersEdge_Almond048: 6448,
    BuildersEdge_Almond049: 6449,
    BuildersEdge_Black002: 6450,
    BuildersEdge_Bordeaux167: 6451,
    BuildersEdge_BrightWhite117: 6452,
    BuildersEdge_BurgundyRed027: 6453,
    BuildersEdge_Champagne089: 6454,
    BuildersEdge_ClassicBlue036: 6455,
    BuildersEdge_Clay008: 6456,
    BuildersEdge_Clay085: 6457,
    BuildersEdge_Clay095: 6458,
    BuildersEdge_Clay097: 6459,
    BuildersEdge_Cream020: 6460,
    BuildersEdge_DarkAlmond012: 6461,
    BuildersEdge_FederalBrown009: 6462,
    BuildersEdge_ForestGreen028: 6463,
    BuildersEdge_FrenchRoast385: 6490,
    BuildersEdge_LightAlmond013: 6464,
    BuildersEdge_LightGrey016: 6465,
    BuildersEdge_Linen082: 6466,
    BuildersEdge_MidnightBlue166: 6467,
    BuildersEdge_MidnightGreen122: 6468,
    BuildersEdge_MusketBrown010: 6469,
    BuildersEdge_Paintable030: 6470,
    BuildersEdge_Parchment034: 6471,
    BuildersEdge_Platinum945: 6491,
    BuildersEdge_Sandalwood011: 6472,
    BuildersEdge_SandstoneBeige021: 6473,
    BuildersEdge_SandstoneMaple045: 6474,
    BuildersEdge_StormCloud419: 6492,
    BuildersEdge_Tan069: 6475,
    BuildersEdge_TreatedCedar471: 6493,
    BuildersEdge_TuxedoGrey018: 6476,
    BuildersEdge_WedgewoodBlue004: 6477,
    BuildersEdge_White001: 6478,
    BuildersEdge_White123: 6479,
    BuildersEdge_Wicker023: 6480,
    BuildersEdge_Wineberry078: 6481,
  },
  Certainteed: {
    ArborBlend: 10587,
    AutumnRed: 10588,
    Brownstone: 10589,
    CastleStone: 10590,
    CedarBlend: 10591,
    CharcoalGray: 10592,
    ColonialWhite: 10593,
    Cypress: 10594,
    DeepMineral: 10595,
    DesertTan: 10596,
    DriftwoodBlend: 10597,
    Espresso: 10598,
    Flagstone: 10599,
    Forest: 10600,
    FrontierBlend: 10601,
    GraniteGray: 10602,
    Graystone: 10603,
    Hearthstone: 10782,
    HeritageCream: 10604,
    Herringbone: 10605,
    Melrose: 10606,
    MidnightBlue: 10607,
    NaturalBlend: 10608,
    NaturalClay: 10609,
    OliveGrove: 10610,
    OxfordBlue: 10611,
    PacificBlue: 10612,
    RusticBlend: 10613,
    SableBrown: 10614,
    SandstoneBeige: 10615,
    SavannahWicker: 10616,
    Seagrass: 10617,
    Slate: 10618,
    SmokyGray: 10619,
    Sparrow: 10620,
    Spruce: 10621,
    SterlingGray: 10622,
    Tuxedo: 10623,
    WeatheredBlend: 10624,
    WeatheredWood: 10625,
    WedgewoodBlue: 10626,
  },
  CHI_Colors: {
    Almond: 2075,
    Black: 2076,
    Bronze: 2077,
    Brown: 2078,
    DesertTan: 2079,
    Evergreen: 2080,
    Graphite: 2081,
    Gray: 2082,
    Sandstone: 2083,
    White: 2084,
  },
  Concrete_SherwinWilliams: {
    Concrete_SW_HC157_Sandstone: 10982,
  },
  DiamondKote: {
    DiamondKote_Bedrock: 10711,
    DiamondKote_Bordeaux: 10712,
    DiamondKote_BronzeWalnut: 10713,
    DiamondKote_Canyon: 10714,
    DiamondKote_Cascade: 10715,
    DiamondKote_Chestnut: 10716,
    DiamondKote_Clay: 10717,
    DiamondKote_Coffee: 10718,
    DiamondKote_CopperOak: 10719,
    DiamondKote_Denali: 10720,
    DiamondKote_Dune: 10721,
    DiamondKote_EbonyPine: 10722,
    DiamondKote_Elkhorn: 10723,
    DiamondKote_Emerald: 10724,
    DiamondKote_FrenchGray: 10725,
    DiamondKote_GlacierFog: 10726,
    DiamondKote_GoldenTeak: 10727,
    DiamondKote_Graphite: 10728,
    DiamondKote_Honeycomb: 10729,
    DiamondKote_IronAsh: 10730,
    DiamondKote_LightGray: 10731,
    DiamondKote_Midnight: 10732,
    DiamondKote_MountainLake: 10733,
    DiamondKote_Olive: 10734,
    DiamondKote_Onyx: 10735,
    DiamondKote_OysterShell: 10736,
    DiamondKote_Pelican: 10737,
    DiamondKote_Sand: 10738,
    DiamondKote_Seal: 10739,
    DiamondKote_SmokyAsh: 10740,
    DiamondKote_TerraBronze: 10741,
    DiamondKote_Umber: 10742,
    DiamondKote_White: 10743,
  },
  Dulux: {
    Dulux_00BB_06_017: 6575,
    Dulux_00GY_80_069: 6576,
    Dulux_00YR_08_409: 6577,
    Dulux_00YR_15_510: 6578,
    Dulux_00YR_17_365: 6579,
    Dulux_00YR_18_531: 6580,
    Dulux_00YR_26_490: 6581,
    Dulux_00YY_07_093: 6582,
    Dulux_00YY_09_069: 6583,
    Dulux_00YY_09_186: 6584,
    Dulux_00YY_12_173: 6585,
    Dulux_00YY_12_279: 6586,
    Dulux_00YY_15_371: 6587,
    Dulux_00YY_18_346: 6588,
    Dulux_00YY_19_261: 6589,
    Dulux_00YY_19_464: 6590,
    Dulux_00YY_23_557: 6591,
    Dulux_00YY_26_520: 6592,
    Dulux_00YY_28_650: 6593,
    Dulux_00YY_34_562: 6594,
    Dulux_00YY_41_475: 6595,
    Dulux_00YY_49_387: 6596,
    Dulux_00YY_50_091: 6597,
    Dulux_00YY_62_144: 6598,
    Dulux_00YY_63_067: 6599,
    Dulux_00YY_76_088: 6600,
    Dulux_00YY_83_034: 6601,
    Dulux_00YY_83_046: 6602,
    Dulux_00YY_83_057: 6603,
    Dulux_00YY_83_069: 6604,
    Dulux_00YY_83_080: 6605,
    Dulux_01BB_59_109: 6606,
    Dulux_01BG_11_248: 6607,
    Dulux_01GG_07_070: 6608,
    Dulux_01GG_59_285: 6609,
    Dulux_01RR_16_397: 6610,
    Dulux_01YR_07_180: 6611,
    Dulux_01YR_09_386: 6612,
    Dulux_01YY_36_694: 6613,
    Dulux_01YY_86_034: 6614,
    Dulux_02BB_81_030: 6615,
    Dulux_02GG_21_542: 6616,
    Dulux_02RB_53_171: 6617,
    Dulux_02RR_35_376: 6618,
    Dulux_02YR_09_373: 6619,
    Dulux_02YR_45_229: 6620,
    Dulux_03YR_08_318: 6621,
    Dulux_03YY_59_088: 6622,
    Dulux_03YY_66_085: 6623,
    Dulux_03YY_66_105: 6624,
    Dulux_03YY_82_067: 6625,
    Dulux_04BB_34_244: 6626,
    Dulux_04BB_57_189: 6627,
    Dulux_04BG_71_117: 6628,
    Dulux_04GY_87_028: 6629,
    Dulux_04RB_71_092: 6630,
    Dulux_04YR_24_029: 6631,
    Dulux_04YR_27_258: 6632,
    Dulux_04YR_82_010: 6633,
    Dulux_04YY_39_480: 6634,
    Dulux_04YY_39_638: 6635,
    Dulux_05BB_59_165: 6636,
    Dulux_05RB_32_259: 6637,
    Dulux_05YR_08_272: 6638,
    Dulux_05YR_15_555: 6639,
    Dulux_05YY_42_727: 6640,
    Dulux_05YY_52_658: 6641,
    Dulux_05YY_72_254: 6642,
    Dulux_06BB_39_179: 6643,
    Dulux_06BB_71_091: 6644,
    Dulux_06BB_79_016: 6645,
    Dulux_06GG_12_304: 6646,
    Dulux_06GG_19_406: 6647,
    Dulux_06YR_12_509: 6648,
    Dulux_06YY_21_130: 6649,
    Dulux_06YY_49_797: 6650,
    Dulux_07BB_62_156: 6651,
    Dulux_07GG_08_244: 6652,
    Dulux_07RB_07_079: 6653,
    Dulux_07RR_30_337: 6654,
    Dulux_07YR_10_489: 6655,
    Dulux_07YR_21_415: 6656,
    Dulux_08BB_46_152: 6657,
    Dulux_08GG_72_006: 6658,
    Dulux_08GY_19_067: 6659,
    Dulux_08GY_26_190: 6660,
    Dulux_08GY_32_058: 6661,
    Dulux_08GY_36_175: 6662,
    Dulux_08YR_70_012: 6663,
    Dulux_08YY_55_137: 6664,
    Dulux_08YY_72_077: 6665,
    Dulux_08YY_78_069: 6666,
    Dulux_08YY_82_100: 6667,
    Dulux_08YY_83_117: 6668,
    Dulux_09RB_12_102: 6669,
    Dulux_09RR_21_078: 6670,
    Dulux_09YR_05_305: 6671,
    Dulux_09YY_28_180: 6672,
    Dulux_09YY_45_402: 6673,
    Dulux_09YY_57_689: 6674,
    Dulux_09YY_59_325: 6675,
    Dulux_10BB_07_150: 6676,
    Dulux_10BB_09_250: 6677,
    Dulux_10BB_11_350: 6678,
    Dulux_10BB_13_362: 6679,
    Dulux_10BB_30_203: 6680,
    Dulux_10BB_39_100: 6681,
    Dulux_10BB_55_065: 6682,
    Dulux_10BB_59_176: 6683,
    Dulux_10BB_73_039: 6684,
    Dulux_10BB_83_006: 6685,
    Dulux_10BB_83_014: 6686,
    Dulux_10BG_13_156: 6687,
    Dulux_10BG_22_248: 6688,
    Dulux_10BG_26_134: 6689,
    Dulux_10BG_38_119: 6690,
    Dulux_10BG_39_219: 6691,
    Dulux_10BG_39_244: 6692,
    Dulux_10BG_46_112: 6693,
    Dulux_10BG_54_199: 6694,
    Dulux_10BG_55_223: 6695,
    Dulux_10BG_63_143: 6696,
    Dulux_10BG_63_189: 6697,
    Dulux_10BG_72_092: 6698,
    Dulux_10BG_83_061: 6699,
    Dulux_10GG_15_346: 6700,
    Dulux_10GG_17_239: 6701,
    Dulux_10GG_21_050: 6702,
    Dulux_10GG_23_485: 6703,
    Dulux_10GG_33_404: 6704,
    Dulux_10GG_33_483: 6705,
    Dulux_10GG_38_038: 6706,
    Dulux_10GG_39_152: 6707,
    Dulux_10GG_44_395: 6708,
    Dulux_10GG_49_300: 6709,
    Dulux_10GG_51_125: 6710,
    Dulux_10GG_57_307: 6711,
    Dulux_10GG_66_098: 6712,
    Dulux_10GG_72_022: 6713,
    Dulux_10GG_72_219: 6714,
    Dulux_10GG_76_153: 6715,
    Dulux_10GG_83_018: 6716,
    Dulux_10GG_83_071: 6717,
    Dulux_10GG_83_125: 6718,
    Dulux_10GY_14_135: 6719,
    Dulux_10GY_21_375: 6720,
    Dulux_10GY_29_158: 6721,
    Dulux_10GY_40_296: 6722,
    Dulux_10GY_41_600: 6723,
    Dulux_10GY_52_541: 6724,
    Dulux_10GY_54_238: 6725,
    Dulux_10GY_71_180: 6726,
    Dulux_10GY_74_325: 6727,
    Dulux_10GY_79_231: 6728,
    Dulux_10GY_83_050: 6729,
    Dulux_10GY_83_100: 6730,
    Dulux_10GY_86_138: 6731,
    Dulux_10RB_08_125: 6732,
    Dulux_10RB_10_219: 6733,
    Dulux_10RB_14_049: 6734,
    Dulux_10RB_17_122: 6735,
    Dulux_10RB_17_210: 6736,
    Dulux_10RB_23_061: 6737,
    Dulux_10RB_28_055: 6738,
    Dulux_10RB_35_167: 6739,
    Dulux_10RB_53_115: 6740,
    Dulux_10RB_65_042: 6741,
    Dulux_10RB_68_081: 6742,
    Dulux_10RB_73_024: 6743,
    Dulux_10RB_83_012: 6744,
    Dulux_10RR_08_100: 6745,
    Dulux_10RR_13_250: 6746,
    Dulux_10RR_14_186: 6747,
    Dulux_10RR_18_350: 6748,
    Dulux_10RR_21_325: 6749,
    Dulux_10RR_22_178: 6750,
    Dulux_10RR_25_437: 6751,
    Dulux_10RR_35_133: 6752,
    Dulux_10RR_39_184: 6753,
    Dulux_10RR_39_263: 6754,
    Dulux_10RR_53_087: 6755,
    Dulux_10RR_56_029: 6756,
    Dulux_10RR_56_121: 6757,
    Dulux_10RR_65_023: 6758,
    Dulux_10RR_67_057: 6759,
    Dulux_10RR_68_068: 6760,
    Dulux_10RR_73_016: 6761,
    Dulux_10RR_73_023: 6762,
    Dulux_10RR_83_009: 6763,
    Dulux_10RR_83_026: 6764,
    Dulux_10YR_09_250: 6765,
    Dulux_10YR_17_184: 6766,
    Dulux_10YR_38_318: 6767,
    Dulux_10YR_41_223: 6768,
    Dulux_10YR_50_101: 6769,
    Dulux_10YR_55_037: 6770,
    Dulux_10YR_67_111: 6771,
    Dulux_10YR_83_015: 6772,
    Dulux_10YY_08_093: 6773,
    Dulux_10YY_09_200: 6774,
    Dulux_10YY_11_187: 6775,
    Dulux_10YY_12_300: 6776,
    Dulux_10YY_14_080: 6777,
    Dulux_10YY_17_140: 6778,
    Dulux_10YY_21_500: 6779,
    Dulux_10YY_23_261: 6780,
    Dulux_10YY_26_321: 6781,
    Dulux_10YY_27_600: 6782,
    Dulux_10YY_30_560: 6783,
    Dulux_10YY_33_163: 6784,
    Dulux_10YY_35_543: 6785,
    Dulux_10YY_38_316: 6786,
    Dulux_10YY_40_608: 6787,
    Dulux_10YY_44_215: 6788,
    Dulux_10YY_46_041: 6789,
    Dulux_10YY_46_515: 6790,
    Dulux_10YY_48_071: 6791,
    Dulux_10YY_50_469: 6792,
    Dulux_10YY_53_132: 6793,
    Dulux_10YY_54_034: 6794,
    Dulux_10YY_55_163: 6795,
    Dulux_10YY_58_295: 6796,
    Dulux_10YY_65_285: 6797,
    Dulux_10YY_68_110: 6798,
    Dulux_10YY_69_130: 6799,
    Dulux_10YY_72_172: 6800,
    Dulux_10YY_72_200: 6801,
    Dulux_10YY_74_063: 6802,
    Dulux_10YY_74_192: 6803,
    Dulux_10YY_75_084: 6804,
    Dulux_10YY_77_125: 6805,
    Dulux_10YY_78_188: 6806,
    Dulux_10YY_83_029: 6807,
    Dulux_10YY_83_071: 6808,
    Dulux_11BB_15_359: 6809,
    Dulux_11BB_35_316: 6810,
    Dulux_11GG_26_195: 6811,
    Dulux_11GY_12_072: 6812,
    Dulux_11GY_85_016: 6813,
    Dulux_11RR_29_068: 6814,
    Dulux_11RR_43_050: 6815,
    Dulux_11YY_37_219: 6816,
    Dulux_11YY_38_694: 6817,
    Dulux_11YY_68_269: 6818,
    Dulux_11YY_70_356: 6819,
    Dulux_11YY_78_136: 6820,
    Dulux_11YY_79_170: 6821,
    Dulux_11YY_85_042: 6822,
    Dulux_12BB_35_025: 6823,
    Dulux_12BB_82_058: 6824,
    Dulux_12BG_79_065: 6825,
    Dulux_12GG_10_310: 6826,
    Dulux_12GY_10_087: 6827,
    Dulux_12GY_39_101: 6828,
    Dulux_12RB_18_337: 6829,
    Dulux_12RB_51_169: 6830,
    Dulux_12RR_07_229: 6831,
    Dulux_12YR_45_079: 6832,
    Dulux_12YY_47_184: 6833,
    Dulux_12YY_61_523: 6834,
    Dulux_13BG_72_151: 6835,
    Dulux_13GY_52_120: 6836,
    Dulux_13GY_77_016: 6837,
    Dulux_13RB_32_077: 6838,
    Dulux_13RR_06_179: 6839,
    Dulux_13RR_12_202: 6840,
    Dulux_13RR_72_121: 6841,
    Dulux_13YR_80_033: 6842,
    Dulux_13YY_60_475: 6843,
    Dulux_14BB_39_289: 6844,
    Dulux_14BB_55_113: 6845,
    Dulux_14BG_67_174: 6846,
    Dulux_14GY_12_129: 6847,
    Dulux_14GY_76_113: 6848,
    Dulux_14RB_45_074: 6849,
    Dulux_14RR_09_333: 6850,
    Dulux_14RR_12_349: 6851,
    Dulux_14RR_48_276: 6852,
    Dulux_14YR_10_434: 6853,
    Dulux_14YY_57_556: 6854,
    Dulux_14YY_63_272: 6855,
    Dulux_14YY_88_041: 6856,
    Dulux_15BB_13_261: 6857,
    Dulux_15BB_19_227: 6858,
    Dulux_15GG_53_086: 6859,
    Dulux_15RB_27_316: 6860,
    Dulux_15RB_66_112: 6861,
    Dulux_15RR_27_249: 6862,
    Dulux_15YY_37_276: 6863,
    Dulux_15YY_49_288: 6864,
    Dulux_15YY_57_150: 6865,
    Dulux_15YY_69_080: 6866,
    Dulux_16BB_19_395: 6867,
    Dulux_16BB_25_001: 6868,
    Dulux_16BB_27_091: 6869,
    Dulux_16BG_26_318: 6870,
    Dulux_16BG_27_325: 6871,
    Dulux_16GY_28_295: 6872,
    Dulux_16GY_54_615: 6873,
    Dulux_16GY_66_078: 6874,
    Dulux_16RB_13_349: 6875,
    Dulux_16RB_38_235: 6876,
    Dulux_16RB_69_065: 6877,
    Dulux_16RB_73_058: 6878,
    Dulux_16YR_12_037: 6879,
    Dulux_16YR_13_558: 6880,
    Dulux_16YR_16_594: 6881,
    Dulux_16YR_79_080: 6882,
    Dulux_16YY_76_189: 6883,
    Dulux_16YY_79_040: 6884,
    Dulux_17BB_08_104: 6885,
    Dulux_17BB_54_211: 6886,
    Dulux_17BB_71_069: 6887,
    Dulux_17BB_79_028: 6888,
    Dulux_17BG_08_158: 6889,
    Dulux_17BG_36_333: 6890,
    Dulux_17BG_60_228: 6891,
    Dulux_17GG_40_107: 6892,
    Dulux_17GY_27_098: 6893,
    Dulux_17GY_68_005: 6894,
    Dulux_17RR_18_239: 6895,
    Dulux_17YR_13_463: 6896,
    Dulux_17YR_60_073: 6897,
    Dulux_17YY_16_022: 6898,
    Dulux_17YY_68_203: 6899,
    Dulux_17YY_79_105: 6900,
    Dulux_18BB_18_075: 6901,
    Dulux_18BB_19_153: 6902,
    Dulux_18BB_59_133: 6903,
    Dulux_18GY_18_160: 6904,
    Dulux_18GY_38_328: 6905,
    Dulux_18RB_08_286: 6906,
    Dulux_18YR_05_072: 6907,
    Dulux_18YR_36_386: 6908,
    Dulux_18YR_54_304: 6909,
    Dulux_18YR_78_079: 6910,
    Dulux_18YR_83_042: 6911,
    Dulux_19BG_45_302: 6912,
    Dulux_19BG_61_207: 6913,
    Dulux_19GY_65_110: 6914,
    Dulux_19RR_78_088: 6915,
    Dulux_19YR_13_558: 6916,
    Dulux_19YR_14_629: 6917,
    Dulux_19YR_67_058: 6918,
    Dulux_19YY_15_105: 6919,
    Dulux_19YY_51_758: 6920,
    Dulux_19YY_61_057: 6921,
    Dulux_19YY_71_323: 6922,
    Dulux_20BB_08_051: 6923,
    Dulux_20GY_37_537: 6924,
    Dulux_20GY_39_466: 6925,
    Dulux_20YY_09_175: 6926,
    Dulux_20YY_12_263: 6927,
    Dulux_20YY_22_129: 6928,
    Dulux_20YY_23_246: 6929,
    Dulux_20YY_23_525: 6930,
    Dulux_20YY_24_177: 6931,
    Dulux_20YY_26_490: 6932,
    Dulux_20YY_27_426: 6933,
    Dulux_20YY_28_613: 6934,
    Dulux_20YY_29_095: 6935,
    Dulux_20YY_31_106: 6936,
    Dulux_20YY_31_205: 6937,
    Dulux_20YY_32_494: 6938,
    Dulux_20YY_34_700: 6939,
    Dulux_20YY_37_094: 6940,
    Dulux_20YY_38_225: 6941,
    Dulux_20YY_39_130: 6942,
    Dulux_20YY_40_608: 6943,
    Dulux_20YY_43_200: 6944,
    Dulux_20YY_45_114: 6945,
    Dulux_20YY_46_515: 6946,
    Dulux_20YY_51_306: 6947,
    Dulux_20YY_53_124: 6948,
    Dulux_20YY_57_178: 6949,
    Dulux_20YY_58_082: 6950,
    Dulux_20YY_60_104: 6951,
    Dulux_20YY_61_127: 6952,
    Dulux_20YY_64_171: 6953,
    Dulux_20YY_65_285: 6954,
    Dulux_20YY_67_084: 6955,
    Dulux_20YY_67_216: 6956,
    Dulux_20YY_68_102: 6957,
    Dulux_20YY_69_120: 6958,
    Dulux_20YY_70_138: 6959,
    Dulux_20YY_74_055: 6960,
    Dulux_20YY_77_110: 6961,
    Dulux_20YY_78_146: 6962,
    Dulux_20YY_83_038: 6963,
    Dulux_20YY_83_063: 6964,
    Dulux_21BB_12_077: 6965,
    Dulux_21BB_52_181: 6966,
    Dulux_21BG_45_002: 6967,
    Dulux_21GG_28_387: 6968,
    Dulux_21GY_25_379: 6969,
    Dulux_21GY_28_472: 6970,
    Dulux_21RR_19_459: 6971,
    Dulux_21RR_36_354: 6972,
    Dulux_21YR_13_383: 6973,
    Dulux_21YR_67_074: 6974,
    Dulux_21YR_73_125: 6975,
    Dulux_21YY_18_079: 6976,
    Dulux_21YY_38_102: 6977,
    Dulux_21YY_45_405: 6978,
    Dulux_21YY_60_577: 6979,
    Dulux_21YY_82_053: 6980,
    Dulux_21YY_84_128: 6981,
    Dulux_22BB_08_161: 6982,
    Dulux_22GY_70_140: 6983,
    Dulux_22YR_18_488: 6984,
    Dulux_22YR_50_316: 6985,
    Dulux_22YY_32_156: 6986,
    Dulux_22YY_59_694: 6987,
    Dulux_22YY_80_211: 6988,
    Dulux_23BB_68_102: 6989,
    Dulux_23BG_51_212: 6990,
    Dulux_23RB_11_349: 6991,
    Dulux_23RB_76_036: 6992,
    Dulux_23YR_08_237: 6993,
    Dulux_23YR_10_308: 6994,
    Dulux_23YY_44_541: 6995,
    Dulux_23YY_53_490: 6996,
    Dulux_23YY_62_816: 6997,
    Dulux_23YY_86_081: 6998,
    Dulux_24BB_43_232: 6999,
    Dulux_24GY_85_110: 7000,
    Dulux_24RB_66_037: 7001,
    Dulux_24YY_28_384: 7002,
    Dulux_24YY_39_319: 7003,
    Dulux_24YY_82_118: 7004,
    Dulux_25BG_26_253: 7005,
    Dulux_25GG_07_188: 7006,
    Dulux_25YY_38_510: 7007,
    Dulux_25YY_46_170: 7008,
    Dulux_25YY_49_757: 7009,
    Dulux_25YY_50_592: 7010,
    Dulux_25YY_54_123: 7011,
    Dulux_25YY_57_441: 7012,
    Dulux_25YY_62_353: 7013,
    Dulux_25YY_70_365: 7014,
    Dulux_25YY_77_087: 7015,
    Dulux_25YY_79_240: 7016,
    Dulux_25YY_81_177: 7017,
    Dulux_25YY_83_103: 7018,
    Dulux_25YY_85_108: 7019,
    Dulux_26BB_10_008: 7020,
    Dulux_26GG_19_130: 7021,
    Dulux_26GY_68_322: 7022,
    Dulux_26RR_14_332: 7023,
    Dulux_26RR_73_037: 7024,
    Dulux_26YR_18_404: 7025,
    Dulux_26YR_30_511: 7026,
    Dulux_26YY_52_359: 7027,
    Dulux_27YY_77_042: 7028,
    Dulux_27YY_78_255: 7029,
    Dulux_28GG_08_229: 7030,
    Dulux_28GG_22_002: 7031,
    Dulux_28GG_82_048: 7032,
    Dulux_28YR_25_461: 7033,
    Dulux_28YR_29_561: 7034,
    Dulux_28YR_67_165: 7035,
    Dulux_29YY_79_033: 7036,
    Dulux_30BB_08_188: 7037,
    Dulux_30BB_08_225: 7038,
    Dulux_30BB_08_263: 7039,
    Dulux_30BB_10_337: 7040,
    Dulux_30BB_11_244: 7041,
    Dulux_30BB_14_242: 7042,
    Dulux_30BB_17_158: 7043,
    Dulux_30BB_23_291: 7044,
    Dulux_30BB_27_236: 7045,
    Dulux_30BB_31_043: 7046,
    Dulux_30BB_33_235: 7047,
    Dulux_30BB_47_179: 7048,
    Dulux_30BB_53_012: 7049,
    Dulux_30BB_54_120: 7050,
    Dulux_30BB_62_004: 7051,
    Dulux_30BB_63_084: 7052,
    Dulux_30BB_63_097: 7053,
    Dulux_30BB_73_052: 7054,
    Dulux_30BB_83_013: 7055,
    Dulux_30BB_83_018: 7056,
    Dulux_30BG_08_200: 7057,
    Dulux_30BG_10_111: 7058,
    Dulux_30BG_14_248: 7059,
    Dulux_30BG_15_322: 7060,
    Dulux_30BG_16_133: 7061,
    Dulux_30BG_21_301: 7062,
    Dulux_30BG_23_124: 7063,
    Dulux_30BG_33_269: 7064,
    Dulux_30BG_37_110: 7065,
    Dulux_30BG_56_097: 7066,
    Dulux_30BG_64_072: 7067,
    Dulux_30BG_64_140: 7068,
    Dulux_30BG_72_017: 7069,
    Dulux_30BG_72_051: 7070,
    Dulux_30BG_72_069: 7071,
    Dulux_30BG_72_103: 7072,
    Dulux_30BG_76_107: 7073,
    Dulux_30GG_10_050: 7074,
    Dulux_30GG_10_225: 7075,
    Dulux_30GG_16_137: 7076,
    Dulux_30GG_16_394: 7077,
    Dulux_30GG_18_450: 7078,
    Dulux_30GG_19_370: 7079,
    Dulux_30GG_21_423: 7080,
    Dulux_30GG_29_196: 7081,
    Dulux_30GG_33_275: 7082,
    Dulux_30GG_37_423: 7083,
    Dulux_30GG_40_290: 7084,
    Dulux_30GG_47_180: 7085,
    Dulux_30GG_49_211: 7086,
    Dulux_30GG_52_011: 7087,
    Dulux_30GG_55_302: 7088,
    Dulux_30GG_57_217: 7089,
    Dulux_30GG_60_143: 7090,
    Dulux_30GG_61_168: 7091,
    Dulux_30GG_72_008: 7092,
    Dulux_30GG_72_212: 7093,
    Dulux_30GG_75_095: 7094,
    Dulux_30GG_75_111: 7095,
    Dulux_30GG_76_127: 7096,
    Dulux_30GG_83_025: 7097,
    Dulux_30GG_83_075: 7098,
    Dulux_30GG_83_088: 7099,
    Dulux_30GG_83_100: 7100,
    Dulux_30GY_09_171: 7101,
    Dulux_30GY_11_076: 7102,
    Dulux_30GY_12_257: 7103,
    Dulux_30GY_15_242: 7104,
    Dulux_30GY_16_343: 7105,
    Dulux_30GY_19_323: 7106,
    Dulux_30GY_21_429: 7107,
    Dulux_30GY_23_232: 7108,
    Dulux_30GY_31_202: 7109,
    Dulux_30GY_34_249: 7110,
    Dulux_30GY_40_029: 7111,
    Dulux_30GY_40_531: 7112,
    Dulux_30GY_41_173: 7113,
    Dulux_30GY_50_183: 7114,
    Dulux_30GY_51_294: 7115,
    Dulux_30GY_56_023: 7116,
    Dulux_30GY_58_375: 7117,
    Dulux_30GY_61_245: 7118,
    Dulux_30GY_62_159: 7119,
    Dulux_30GY_62_344: 7120,
    Dulux_30GY_72_196: 7121,
    Dulux_30GY_73_053: 7122,
    Dulux_30GY_75_105: 7123,
    Dulux_30GY_75_251: 7124,
    Dulux_30GY_76_017: 7125,
    Dulux_30GY_83_064: 7126,
    Dulux_30GY_83_107: 7127,
    Dulux_30GY_83_150: 7128,
    Dulux_30RB_10_214: 7129,
    Dulux_30RB_11_250: 7130,
    Dulux_30RB_13_199: 7131,
    Dulux_30RB_16_144: 7132,
    Dulux_30RB_19_261: 7133,
    Dulux_30RB_22_215: 7134,
    Dulux_30RB_26_067: 7135,
    Dulux_30RB_33_103: 7136,
    Dulux_30RB_35_166: 7137,
    Dulux_30RB_36_055: 7138,
    Dulux_30RB_49_042: 7139,
    Dulux_30RB_50_072: 7140,
    Dulux_30RB_53_117: 7141,
    Dulux_30RB_56_036: 7142,
    Dulux_30RB_64_030: 7143,
    Dulux_30RB_68_084: 7144,
    Dulux_30RB_73_016: 7145,
    Dulux_30RB_73_027: 7146,
    Dulux_30RB_74_038: 7147,
    Dulux_30RR_09_187: 7148,
    Dulux_30RR_10_321: 7149,
    Dulux_30RR_12_281: 7150,
    Dulux_30RR_15_375: 7151,
    Dulux_30RR_17_140: 7152,
    Dulux_30RR_23_270: 7153,
    Dulux_30RR_26_335: 7154,
    Dulux_30RR_30_103: 7155,
    Dulux_30RR_31_223: 7156,
    Dulux_30RR_42_198: 7157,
    Dulux_30RR_54_145: 7158,
    Dulux_30RR_61_195: 7159,
    Dulux_30RR_67_093: 7160,
    Dulux_30RR_74_058: 7161,
    Dulux_30RR_83_020: 7162,
    Dulux_30YR_07_157: 7163,
    Dulux_30YR_07_354: 7164,
    Dulux_30YR_08_236: 7165,
    Dulux_30YR_10_314: 7166,
    Dulux_30YR_11_219: 7167,
    Dulux_30YR_12_122: 7168,
    Dulux_30YR_12_292: 7169,
    Dulux_30YR_15_112: 7170,
    Dulux_30YR_15_550: 7171,
    Dulux_30YR_16_162: 7172,
    Dulux_30YR_18_212: 7173,
    Dulux_30YR_20_595: 7174,
    Dulux_30YR_21_505: 7175,
    Dulux_30YR_29_118: 7176,
    Dulux_30YR_31_154: 7177,
    Dulux_30YR_38_337: 7178,
    Dulux_30YR_40_061: 7179,
    Dulux_30YR_43_295: 7180,
    Dulux_30YR_48_074: 7181,
    Dulux_30YR_53_188: 7182,
    Dulux_30YR_63_031: 7183,
    Dulux_30YR_64_044: 7184,
    Dulux_30YR_67_113: 7185,
    Dulux_30YR_68_127: 7186,
    Dulux_30YR_74_045: 7187,
    Dulux_30YR_83_023: 7188,
    Dulux_30YR_83_029: 7189,
    Dulux_30YR_83_040: 7190,
    Dulux_30YY_05_044: 7191,
    Dulux_30YY_08_082: 7192,
    Dulux_30YY_09_175: 7193,
    Dulux_30YY_12_263: 7194,
    Dulux_30YY_17_209: 7195,
    Dulux_30YY_20_029: 7196,
    Dulux_30YY_20_193: 7197,
    Dulux_30YY_21_438: 7198,
    Dulux_30YY_23_246: 7199,
    Dulux_30YY_24_177: 7200,
    Dulux_30YY_27_226: 7201,
    Dulux_30YY_28_161: 7202,
    Dulux_30YY_33_613: 7203,
    Dulux_30YY_35_249: 7204,
    Dulux_30YY_36_185: 7205,
    Dulux_30YY_39_225: 7206,
    Dulux_30YY_41_700: 7207,
    Dulux_30YY_44_114: 7208,
    Dulux_30YY_46_036: 7209,
    Dulux_30YY_46_608: 7210,
    Dulux_30YY_47_145: 7211,
    Dulux_30YY_51_098: 7212,
    Dulux_30YY_53_124: 7213,
    Dulux_30YY_58_082: 7214,
    Dulux_30YY_58_178: 7215,
    Dulux_30YY_60_104: 7216,
    Dulux_30YY_62_127: 7217,
    Dulux_30YY_63_231: 7218,
    Dulux_30YY_64_149: 7219,
    Dulux_30YY_64_331: 7220,
    Dulux_30YY_65_171: 7221,
    Dulux_30YY_69_048: 7222,
    Dulux_30YY_69_216: 7223,
    Dulux_30YY_70_455: 7224,
    Dulux_30YY_71_073: 7225,
    Dulux_30YY_71_138: 7226,
    Dulux_30YY_72_018: 7227,
    Dulux_30YY_75_145: 7228,
    Dulux_30YY_77_169: 7229,
    Dulux_30YY_78_035: 7230,
    Dulux_30YY_79_070: 7231,
    Dulux_30YY_80_088: 7232,
    Dulux_30YY_81_123: 7233,
    Dulux_30YY_82_039: 7234,
    Dulux_30YY_83_026: 7235,
    Dulux_31BB_15_212: 7236,
    Dulux_31BG_10_240: 7237,
    Dulux_31BG_26_004: 7238,
    Dulux_31RR_21_462: 7239,
    Dulux_31YR_50_290: 7240,
    Dulux_31YR_84_056: 7241,
    Dulux_32BB_10_296: 7242,
    Dulux_32BB_33_133: 7243,
    Dulux_32BG_72_122: 7244,
    Dulux_32GY_51_432: 7245,
    Dulux_32RR_50_280: 7246,
    Dulux_32YR_38_392: 7247,
    Dulux_33BB_61_174: 7248,
    Dulux_33BG_43_240: 7249,
    Dulux_33RR_74_111: 7250,
    Dulux_33YR_48_037: 7251,
    Dulux_33YY_69_519: 7252,
    Dulux_33YY_74_360: 7253,
    Dulux_34BG_79_053: 7254,
    Dulux_34GG_81_080: 7255,
    Dulux_34YR_35_025: 7256,
    Dulux_34YY_31_502: 7257,
    Dulux_34YY_55_802: 7258,
    Dulux_34YY_61_672: 7259,
    Dulux_34YY_71_404: 7260,
    Dulux_34YY_76_174: 7261,
    Dulux_34YY_81_209: 7262,
    Dulux_35BG_42_331: 7263,
    Dulux_35YY_59_533: 7264,
    Dulux_35YY_61_431: 7265,
    Dulux_35YY_76_110: 7266,
    Dulux_35YY_78_269: 7267,
    Dulux_35YY_88_050: 7268,
    Dulux_36BB_46_231: 7269,
    Dulux_36GG_87_038: 7270,
    Dulux_36RR_14_002: 7271,
    Dulux_36RR_75_114: 7272,
    Dulux_36YY_59_230: 7273,
    Dulux_37BG_26_349: 7274,
    Dulux_37YY_38_594: 7275,
    Dulux_37YY_39_443: 7276,
    Dulux_37YY_61_867: 7277,
    Dulux_37YY_78_312: 7278,
    Dulux_37YY_79_086: 7279,
    Dulux_38BB_69_096: 7280,
    Dulux_38BG_30_352: 7281,
    Dulux_38GY_26_456: 7282,
    Dulux_38RB_15_086: 7283,
    Dulux_38RR_15_026: 7284,
    Dulux_38YR_17_442: 7285,
    Dulux_38YR_40_290: 7286,
    Dulux_38YY_72_117: 7287,
    Dulux_38YY_81_256: 7288,
    Dulux_38YY_85_096: 7289,
    Dulux_39BB_81_032: 7290,
    Dulux_39BG_21_339: 7291,
    Dulux_39GY_77_179: 7292,
    Dulux_39RR_07_029: 7293,
    Dulux_39YR_11_342: 7294,
    Dulux_39YY_52_691: 7295,
    Dulux_39YY_53_067: 7296,
    Dulux_39YY_71_413: 7297,
    Dulux_39YY_74_175: 7298,
    Dulux_39YY_77_091: 7299,
    Dulux_39YY_84_095: 7300,
    Dulux_39YY_85_046: 7301,
    Dulux_39YY_85_156: 7302,
    Dulux_40BB_83_017: 7303,
    Dulux_40GY_18_372: 7304,
    Dulux_40RB_36_264: 7305,
    Dulux_40RB_43_233: 7306,
    Dulux_40RR_57_045: 7307,
    Dulux_40YR_75_107: 7308,
    Dulux_40YY_38_107: 7309,
    Dulux_40YY_41_152: 7310,
    Dulux_40YY_41_603: 7311,
    Dulux_40YY_46_587: 7312,
    Dulux_40YY_49_546: 7313,
    Dulux_40YY_58_565: 7314,
    Dulux_40YY_64_903: 7315,
    Dulux_40YY_67_087: 7316,
    Dulux_40YY_67_196: 7317,
    Dulux_40YY_69_112: 7318,
    Dulux_40YY_69_666: 7319,
    Dulux_40YY_70_138: 7320,
    Dulux_40YY_74_056: 7321,
    Dulux_40YY_75_216: 7322,
    Dulux_40YY_77_267: 7323,
    Dulux_40YY_83_021: 7324,
    Dulux_40YY_83_043: 7325,
    Dulux_40YY_83_086: 7326,
    Dulux_40YY_83_107: 7327,
    Dulux_40YY_83_129: 7328,
    Dulux_40YY_83_150: 7329,
    Dulux_41GG_67_162: 7330,
    Dulux_41RB_19_322: 7331,
    Dulux_41RB_24_309: 7332,
    Dulux_41RB_30_290: 7333,
    Dulux_41YY_77_065: 7334,
    Dulux_41YY_82_071: 7335,
    Dulux_42BB_23_348: 7336,
    Dulux_42GG_08_250: 7337,
    Dulux_42GY_09_205: 7338,
    Dulux_42RB_14_320: 7339,
    Dulux_42RB_21_094: 7340,
    Dulux_42RB_53_176: 7341,
    Dulux_42RB_63_137: 7342,
    Dulux_42RR_26_194: 7343,
    Dulux_42YR_43_439: 7344,
    Dulux_42YY_64_745: 7345,
    Dulux_42YY_84_095: 7346,
    Dulux_42YY_87_084: 7347,
    Dulux_43BG_75_043: 7348,
    Dulux_43GY_24_566: 7349,
    Dulux_43RB_07_249: 7350,
    Dulux_43RB_09_077: 7351,
    Dulux_43RR_19_444: 7352,
    Dulux_43YY_65_687: 7353,
    Dulux_43YY_69_543: 7354,
    Dulux_43YY_71_540: 7355,
    Dulux_43YY_74_339: 7356,
    Dulux_43YY_81_051: 7357,
    Dulux_44BB_54_129: 7358,
    Dulux_44BB_62_134: 7359,
    Dulux_44GG_08_039: 7360,
    Dulux_44GG_12_299: 7361,
    Dulux_44YY_23_330: 7362,
    Dulux_44YY_65_034: 7363,
    Dulux_44YY_69_069: 7364,
    Dulux_44YY_69_140: 7365,
    Dulux_44YY_80_106: 7366,
    Dulux_44YY_84_042: 7367,
    Dulux_44YY_87_118: 7368,
    Dulux_45BB_18_339: 7369,
    Dulux_45BB_37_281: 7370,
    Dulux_45GG_81_022: 7371,
    Dulux_45GY_83_023: 7372,
    Dulux_45GY_83_149: 7373,
    Dulux_45YR_11_240: 7374,
    Dulux_45YR_83_076: 7375,
    Dulux_45YY_20_168: 7376,
    Dulux_45YY_61_368: 7377,
    Dulux_45YY_62_805: 7378,
    Dulux_45YY_65_334: 7379,
    Dulux_45YY_65_710: 7380,
    Dulux_45YY_66_512: 7381,
    Dulux_45YY_71_426: 7382,
    Dulux_45YY_73_519: 7383,
    Dulux_45YY_77_424: 7384,
    Dulux_45YY_82_098: 7385,
    Dulux_45YY_83_094: 7386,
    Dulux_45YY_83_125: 7387,
    Dulux_45YY_83_156: 7388,
    Dulux_45YY_83_250: 7389,
    Dulux_46BG_63_190: 7390,
    Dulux_46GG_31_446: 7391,
    Dulux_46GY_21_423: 7392,
    Dulux_46YR_12_287: 7393,
    Dulux_46YR_69_173: 7394,
    Dulux_46YY_53_062: 7395,
    Dulux_46YY_63_147: 7396,
    Dulux_47BB_74_091: 7397,
    Dulux_47BG_62_184: 7398,
    Dulux_47GG_57_246: 7399,
    Dulux_47RR_10_045: 7400,
    Dulux_47RR_33_395: 7401,
    Dulux_47RR_55_175: 7402,
    Dulux_47YR_18_085: 7403,
    Dulux_47YY_62_143: 7404,
    Dulux_47YY_86_047: 7405,
    Dulux_48BB_33_169: 7406,
    Dulux_48BB_56_162: 7407,
    Dulux_48BG_54_244: 7408,
    Dulux_48GG_19_309: 7409,
    Dulux_48YR_06_091: 7410,
    Dulux_48YR_09_077: 7411,
    Dulux_48YR_26_519: 7412,
    Dulux_48YY_12_123: 7413,
    Dulux_48YY_12_177: 7414,
    Dulux_48YY_73_573: 7415,
    Dulux_48YY_80_346: 7416,
    Dulux_49BB_14_046: 7417,
    Dulux_49BB_19_182: 7418,
    Dulux_49BB_51_186: 7419,
    Dulux_49BB_63_056: 7420,
    Dulux_49GG_52_001: 7421,
    Dulux_49GG_77_014: 7422,
    Dulux_49RR_17_416: 7423,
    Dulux_49RR_39_161: 7424,
    Dulux_49RR_50_250: 7425,
    Dulux_49YR_27_627: 7426,
    Dulux_49YR_59_226: 7427,
    Dulux_49YY_46_310: 7428,
    Dulux_49YY_54_251: 7429,
    Dulux_49YY_69_406: 7430,
    Dulux_49YY_75_130: 7431,
    Dulux_50BB_06_163: 7432,
    Dulux_50BB_08_257: 7433,
    Dulux_50BB_17_126: 7434,
    Dulux_50BB_18_276: 7435,
    Dulux_50BB_27_232: 7436,
    Dulux_50BB_39_188: 7437,
    Dulux_50BB_45_185: 7438,
    Dulux_50BB_54_079: 7439,
    Dulux_50BB_72_045: 7440,
    Dulux_50BB_83_006: 7441,
    Dulux_50BG_10_175: 7442,
    Dulux_50BG_11_123: 7443,
    Dulux_50BG_18_350: 7444,
    Dulux_50BG_19_144: 7445,
    Dulux_50BG_20_230: 7446,
    Dulux_50BG_30_235: 7447,
    Dulux_50BG_30_384: 7448,
    Dulux_50BG_32_114: 7449,
    Dulux_50BG_41_312: 7450,
    Dulux_50BG_44_094: 7451,
    Dulux_50BG_44_184: 7452,
    Dulux_50BG_62_133: 7453,
    Dulux_50BG_64_028: 7454,
    Dulux_50BG_74_020: 7455,
    Dulux_50BG_74_130: 7456,
    Dulux_50BG_76_023: 7457,
    Dulux_50BG_76_079: 7458,
    Dulux_50GG_05_063: 7459,
    Dulux_50GG_09_189: 7460,
    Dulux_50GG_28_273: 7461,
    Dulux_50GG_61_154: 7462,
    Dulux_50GG_63_042: 7463,
    Dulux_50GG_69_134: 7464,
    Dulux_50GG_71_180: 7465,
    Dulux_50GG_73_031: 7466,
    Dulux_50GG_75_092: 7467,
    Dulux_50GG_82_115: 7468,
    Dulux_50GG_83_011: 7469,
    Dulux_50GG_83_023: 7470,
    Dulux_50GG_83_034: 7471,
    Dulux_50GY_08_153: 7472,
    Dulux_50GY_15_289: 7473,
    Dulux_50GY_16_383: 7474,
    Dulux_50GY_18_178: 7475,
    Dulux_50GY_23_280: 7476,
    Dulux_50GY_26_155: 7477,
    Dulux_50GY_37_335: 7478,
    Dulux_50GY_39_536: 7479,
    Dulux_50GY_43_120: 7480,
    Dulux_50GY_44_248: 7481,
    Dulux_50GY_51_437: 7482,
    Dulux_50GY_52_263: 7483,
    Dulux_50GY_55_207: 7484,
    Dulux_50GY_65_084: 7485,
    Dulux_50GY_66_111: 7486,
    Dulux_50GY_70_192: 7487,
    Dulux_50GY_70_259: 7488,
    Dulux_50GY_72_012: 7489,
    Dulux_50GY_74_073: 7490,
    Dulux_50GY_75_122: 7491,
    Dulux_50GY_77_195: 7492,
    Dulux_50GY_83_040: 7493,
    Dulux_50GY_83_060: 7494,
    Dulux_50RB_09_156: 7495,
    Dulux_50RB_10_219: 7496,
    Dulux_50RB_13_107: 7497,
    Dulux_50RB_20_199: 7498,
    Dulux_50RB_34_153: 7499,
    Dulux_50RB_35_067: 7500,
    Dulux_50RB_48_051: 7501,
    Dulux_50RB_52_107: 7502,
    Dulux_50RB_66_066: 7503,
    Dulux_50RB_69_097: 7504,
    Dulux_50RB_73_024: 7505,
    Dulux_50RB_74_033: 7506,
    Dulux_50RB_83_005: 7507,
    Dulux_50RR_10_229: 7508,
    Dulux_50RR_12_305: 7509,
    Dulux_50RR_17_372: 7510,
    Dulux_50RR_19_203: 7511,
    Dulux_50RR_26_431: 7512,
    Dulux_50RR_32_029: 7513,
    Dulux_50RR_32_262: 7514,
    Dulux_50RR_49_195: 7515,
    Dulux_50RR_51_109: 7516,
    Dulux_50RR_54_018: 7517,
    Dulux_50RR_61_129: 7518,
    Dulux_50RR_65_065: 7519,
    Dulux_50RR_72_010: 7520,
    Dulux_50RR_74_048: 7521,
    Dulux_50RR_83_006: 7522,
    Dulux_50RR_83_029: 7523,
    Dulux_50RR_83_034: 7524,
    Dulux_50YR_07_162: 7525,
    Dulux_50YR_09_244: 7526,
    Dulux_50YR_12_406: 7527,
    Dulux_50YR_15_377: 7528,
    Dulux_50YR_16_127: 7529,
    Dulux_50YR_22_052: 7530,
    Dulux_50YR_23_365: 7531,
    Dulux_50YR_32_460: 7532,
    Dulux_50YR_47_057: 7533,
    Dulux_50YR_55_201: 7534,
    Dulux_50YR_62_008: 7535,
    Dulux_50YR_65_056: 7536,
    Dulux_50YR_66_091: 7537,
    Dulux_50YR_68_114: 7538,
    Dulux_50YR_73_022: 7539,
    Dulux_50YR_74_043: 7540,
    Dulux_50YR_75_111: 7541,
    Dulux_50YR_76_087: 7542,
    Dulux_50YR_78_064: 7543,
    Dulux_50YR_83_003: 7544,
    Dulux_50YR_83_020: 7545,
    Dulux_50YR_83_025: 7546,
    Dulux_50YR_83_035: 7547,
    Dulux_50YR_83_040: 7548,
    Dulux_50YY_37_519: 7549,
    Dulux_50YY_53_687: 7550,
    Dulux_50YY_60_538: 7551,
    Dulux_50YY_62_309: 7552,
    Dulux_50YY_65_454: 7553,
    Dulux_50YY_75_254: 7554,
    Dulux_50YY_77_173: 7555,
    Dulux_50YY_80_242: 7556,
    Dulux_50YY_83_029: 7557,
    Dulux_50YY_83_114: 7558,
    Dulux_50YY_83_171: 7559,
    Dulux_51BB_11_311: 7560,
    Dulux_51BB_27_310: 7561,
    Dulux_51GG_12_132: 7562,
    Dulux_51YR_48_101: 7563,
    Dulux_51YR_83_054: 7564,
    Dulux_51YY_61_792: 7565,
    Dulux_51YY_74_066: 7566,
    Dulux_51YY_78_444: 7567,
    Dulux_51YY_83_060: 7568,
    Dulux_51YY_84_121: 7569,
    Dulux_52BB_08_128: 7570,
    Dulux_52BG_38_320: 7571,
    Dulux_52YR_18_350: 7572,
    Dulux_52YR_21_567: 7573,
    Dulux_52YY_55_131: 7574,
    Dulux_52YY_72_661: 7575,
    Dulux_52YY_83_223: 7576,
    Dulux_52YY_89_117: 7577,
    Dulux_53BB_36_004: 7578,
    Dulux_53GG_50_360: 7579,
    Dulux_53RR_83_031: 7580,
    Dulux_53YR_17_504: 7581,
    Dulux_53YY_26_275: 7582,
    Dulux_53YY_77_064: 7583,
    Dulux_53YY_82_133: 7584,
    Dulux_53YY_83_348: 7585,
    Dulux_54BB_39_103: 7586,
    Dulux_54BB_66_088: 7587,
    Dulux_54BG_56_236: 7588,
    Dulux_54GG_16_017: 7589,
    Dulux_54GG_47_053: 7590,
    Dulux_54RB_78_038: 7591,
    Dulux_54RR_09_276: 7592,
    Dulux_54RR_52_260: 7593,
    Dulux_54YR_12_074: 7594,
    Dulux_54YR_22_344: 7595,
    Dulux_54YY_22_044: 7596,
    Dulux_54YY_46_065: 7597,
    Dulux_54YY_63_072: 7598,
    Dulux_54YY_69_747: 7599,
    Dulux_55BG_74_117: 7600,
    Dulux_55GG_46_244: 7601,
    Dulux_55RR_11_401: 7602,
    Dulux_55RR_75_106: 7603,
    Dulux_55YR_36_590: 7604,
    Dulux_55YR_83_024: 7605,
    Dulux_56BB_07_196: 7606,
    Dulux_56BG_23_355: 7607,
    Dulux_56BG_81_023: 7608,
    Dulux_56GG_64_258: 7609,
    Dulux_56GG_77_156: 7610,
    Dulux_56RB_09_302: 7611,
    Dulux_56YY_87_037: 7612,
    Dulux_57GY_28_292: 7613,
    Dulux_57RR_62_183: 7614,
    Dulux_57YR_27_226: 7615,
    Dulux_57YR_32_176: 7616,
    Dulux_57YY_86_073: 7617,
    Dulux_58BB_12_390: 7618,
    Dulux_58YR_49_379: 7619,
    Dulux_58YY_72_095: 7620,
    Dulux_58YY_88_180: 7621,
    Dulux_59GY_20_482: 7622,
    Dulux_59YR_53_163: 7623,
    Dulux_59YR_70_153: 7624,
    Dulux_60BG_17_341: 7625,
    Dulux_60GG_22_204: 7626,
    Dulux_60GG_79_056: 7627,
    Dulux_60RR_07_002: 7628,
    Dulux_60RR_62_086: 7629,
    Dulux_60YR_07_093: 7630,
    Dulux_60YR_08_186: 7631,
    Dulux_60YR_16_464: 7632,
    Dulux_60YR_24_439: 7633,
    Dulux_60YR_30_094: 7634,
    Dulux_60YR_33_047: 7635,
    Dulux_60YR_40_297: 7636,
    Dulux_60YR_40_423: 7637,
    Dulux_60YR_41_072: 7638,
    Dulux_60YR_55_271: 7639,
    Dulux_60YR_70_151: 7640,
    Dulux_60YR_75_075: 7641,
    Dulux_60YR_83_009: 7642,
    Dulux_60YR_83_017: 7643,
    Dulux_60YR_83_026: 7644,
    Dulux_60YR_83_034: 7645,
    Dulux_60YR_83_060: 7646,
    Dulux_60YY_28_443: 7647,
    Dulux_60YY_33_130: 7648,
    Dulux_60YY_34_461: 7649,
    Dulux_60YY_39_654: 7650,
    Dulux_60YY_47_608: 7651,
    Dulux_60YY_48_748: 7652,
    Dulux_60YY_62_755: 7653,
    Dulux_60YY_69_583: 7654,
    Dulux_60YY_71_409: 7655,
    Dulux_60YY_72_225: 7656,
    Dulux_60YY_77_332: 7657,
    Dulux_60YY_79_367: 7658,
    Dulux_60YY_80_288: 7659,
    Dulux_60YY_83_156: 7660,
    Dulux_60YY_83_187: 7661,
    Dulux_61BB_28_291: 7662,
    Dulux_61BG_68_049: 7663,
    Dulux_61GG_08_119: 7664,
    Dulux_61GY_11_019: 7665,
    Dulux_61GY_12_190: 7666,
    Dulux_61YR_60_282: 7667,
    Dulux_61YR_61_229: 7668,
    Dulux_61YY_39_443: 7669,
    Dulux_61YY_86_159: 7670,
    Dulux_61YY_89_040: 7671,
    Dulux_61YY_89_135: 7672,
    Dulux_62GY_18_260: 7673,
    Dulux_62RR_09_009: 7674,
    Dulux_62YR_13_217: 7675,
    Dulux_62YR_18_397: 7676,
    Dulux_62YR_22_051: 7677,
    Dulux_62YY_27_282: 7678,
    Dulux_62YY_83_382: 7679,
    Dulux_63GY_83_021: 7680,
    Dulux_63RR_19_405: 7681,
    Dulux_63RR_39_350: 7682,
    Dulux_63YR_26_584: 7683,
    Dulux_63YR_50_340: 7684,
    Dulux_63YY_53_710: 7685,
    Dulux_63YY_79_219: 7686,
    Dulux_63YY_80_051: 7687,
    Dulux_64BB_46_254: 7688,
    Dulux_64BG_78_058: 7689,
    Dulux_64RB_37_284: 7690,
    Dulux_64RB_55_192: 7691,
    Dulux_64RR_12_436: 7692,
    Dulux_64YY_10_021: 7693,
    Dulux_64YY_38_505: 7694,
    Dulux_64YY_39_108: 7695,
    Dulux_64YY_65_071: 7696,
    Dulux_64YY_83_058: 7697,
    Dulux_64YY_84_180: 7698,
    Dulux_65BG_17_353: 7699,
    Dulux_65RB_62_156: 7700,
    Dulux_65YR_11_146: 7701,
    Dulux_65YR_35_659: 7702,
    Dulux_65YY_27_444: 7703,
    Dulux_65YY_68_572: 7704,
    Dulux_65YY_70_540: 7705,
    Dulux_65YY_72_399: 7706,
    Dulux_65YY_79_118: 7707,
    Dulux_65YY_84_081: 7708,
    Dulux_65YY_87_039: 7709,
    Dulux_65YY_89_088: 7710,
    Dulux_65YY_90_062: 7711,
    Dulux_66BG_68_157: 7712,
    Dulux_66RR_67_091: 7713,
    Dulux_66YR_33_286: 7714,
    Dulux_66YY_83_272: 7715,
    Dulux_66YY_85_231: 7716,
    Dulux_66YY_88_114: 7717,
    Dulux_67BB_14_216: 7718,
    Dulux_67RB_75_030: 7719,
    Dulux_67YR_56_055: 7720,
    Dulux_67YR_77_081: 7721,
    Dulux_67YY_51_608: 7722,
    Dulux_67YY_88_044: 7723,
    Dulux_67YY_89_124: 7724,
    Dulux_68GG_53_098: 7725,
    Dulux_68YR_28_701: 7726,
    Dulux_68YY_16_179: 7727,
    Dulux_68YY_83_339: 7728,
    Dulux_69BB_23_271: 7729,
    Dulux_69BG_77_076: 7730,
    Dulux_69GY_47_391: 7731,
    Dulux_69YR_39_474: 7732,
    Dulux_70BB_09_241: 7733,
    Dulux_70BB_21_147: 7734,
    Dulux_70BB_28_080: 7735,
    Dulux_70BB_33_202: 7736,
    Dulux_70BB_35_108: 7737,
    Dulux_70BB_40_062: 7738,
    Dulux_70BB_44_144: 7739,
    Dulux_70BB_49_082: 7740,
    Dulux_70BB_55_044: 7741,
    Dulux_70BB_64_035: 7742,
    Dulux_70BB_65_056: 7743,
    Dulux_70BB_67_096: 7744,
    Dulux_70BB_73_020: 7745,
    Dulux_70BB_73_030: 7746,
    Dulux_70BB_73_035: 7747,
    Dulux_70BB_83_020: 7748,
    Dulux_70BG_07_086: 7749,
    Dulux_70BG_10_214: 7750,
    Dulux_70BG_13_300: 7751,
    Dulux_70BG_14_243: 7752,
    Dulux_70BG_24_380: 7753,
    Dulux_70BG_28_060: 7754,
    Dulux_70BG_31_332: 7755,
    Dulux_70BG_32_238: 7756,
    Dulux_70BG_40_050: 7757,
    Dulux_70BG_40_284: 7758,
    Dulux_70BG_44_129: 7759,
    Dulux_70BG_47_182: 7760,
    Dulux_70BG_53_164: 7761,
    Dulux_70BG_59_124: 7762,
    Dulux_70BG_67_126: 7763,
    Dulux_70BG_70_113: 7764,
    Dulux_70BG_70_131: 7765,
    Dulux_70GG_09_223: 7766,
    Dulux_70GG_39_088: 7767,
    Dulux_70GG_39_303: 7768,
    Dulux_70GG_60_251: 7769,
    Dulux_70GG_72_045: 7770,
    Dulux_70GG_83_023: 7771,
    Dulux_70GY_10_136: 7772,
    Dulux_70GY_11_300: 7773,
    Dulux_70GY_11_387: 7774,
    Dulux_70GY_13_324: 7775,
    Dulux_70GY_14_187: 7776,
    Dulux_70GY_27_154: 7777,
    Dulux_70GY_30_254: 7778,
    Dulux_70GY_38_330: 7779,
    Dulux_70GY_49_201: 7780,
    Dulux_70GY_63_098: 7781,
    Dulux_70GY_65_166: 7782,
    Dulux_70GY_66_200: 7783,
    Dulux_70GY_72_025: 7784,
    Dulux_70GY_73_074: 7785,
    Dulux_70GY_73_124: 7786,
    Dulux_70GY_74_149: 7787,
    Dulux_70GY_74_173: 7788,
    Dulux_70GY_83_060: 7789,
    Dulux_70GY_83_080: 7790,
    Dulux_70GY_83_100: 7791,
    Dulux_70RB_16_220: 7792,
    Dulux_70RB_18_117: 7793,
    Dulux_70RB_23_280: 7794,
    Dulux_70RB_31_090: 7795,
    Dulux_70RB_50_062: 7796,
    Dulux_70RB_65_044: 7797,
    Dulux_70RB_67_067: 7798,
    Dulux_70RB_83_017: 7799,
    Dulux_70RB_83_026: 7800,
    Dulux_70RR_10_140: 7801,
    Dulux_70RR_10_250: 7802,
    Dulux_70RR_13_233: 7803,
    Dulux_70RR_13_380: 7804,
    Dulux_70RR_16_116: 7805,
    Dulux_70RR_19_190: 7806,
    Dulux_70RR_24_096: 7807,
    Dulux_70RR_25_338: 7808,
    Dulux_70RR_32_139: 7809,
    Dulux_70RR_38_246: 7810,
    Dulux_70RR_43_104: 7811,
    Dulux_70RR_52_120: 7812,
    Dulux_70RR_57_070: 7813,
    Dulux_70RR_66_072: 7814,
    Dulux_70RR_73_025: 7815,
    Dulux_70RR_74_051: 7816,
    Dulux_70RR_83_040: 7817,
    Dulux_70YR_07_093: 7818,
    Dulux_70YR_08_186: 7819,
    Dulux_70YR_09_086: 7820,
    Dulux_70YR_12_077: 7821,
    Dulux_70YR_13_140: 7822,
    Dulux_70YR_18_184: 7823,
    Dulux_70YR_19_432: 7824,
    Dulux_70YR_31_135: 7825,
    Dulux_70YR_45_261: 7826,
    Dulux_70YR_46_069: 7827,
    Dulux_70YR_56_190: 7828,
    Dulux_70YR_65_054: 7829,
    Dulux_70YR_68_118: 7830,
    Dulux_70YR_83_026: 7831,
    Dulux_70YR_83_034: 7832,
    Dulux_70YY_09_175: 7833,
    Dulux_70YY_18_152: 7834,
    Dulux_70YY_21_335: 7835,
    Dulux_70YY_26_137: 7836,
    Dulux_70YY_34_180: 7837,
    Dulux_70YY_37_296: 7838,
    Dulux_70YY_46_160: 7839,
    Dulux_70YY_50_383: 7840,
    Dulux_70YY_53_638: 7841,
    Dulux_70YY_55_299: 7842,
    Dulux_70YY_65_090: 7843,
    Dulux_70YY_66_130: 7844,
    Dulux_70YY_66_265: 7845,
    Dulux_70YY_66_510: 7846,
    Dulux_70YY_70_209: 7847,
    Dulux_70YY_73_288: 7848,
    Dulux_70YY_75_124: 7849,
    Dulux_70YY_79_407: 7850,
    Dulux_70YY_83_037: 7851,
    Dulux_70YY_83_150: 7852,
    Dulux_71BB_10_202: 7853,
    Dulux_71GG_07_179: 7854,
    Dulux_71GY_59_307: 7855,
    Dulux_71GY_65_301: 7856,
    Dulux_71RR_58_199: 7857,
    Dulux_71YY_87_078: 7858,
    Dulux_72BB_07_288: 7859,
    Dulux_72RR_07_173: 7860,
    Dulux_72RR_13_253: 7861,
    Dulux_72RR_78_058: 7862,
    Dulux_73BB_16_259: 7863,
    Dulux_73BG_64_122: 7864,
    Dulux_73GY_56_241: 7865,
    Dulux_73RB_08_259: 7866,
    Dulux_73YR_32_063: 7867,
    Dulux_74BB_58_090: 7868,
    Dulux_74BG_61_206: 7869,
    Dulux_74BG_73_042: 7870,
    Dulux_74GG_60_059: 7871,
    Dulux_74GY_15_043: 7872,
    Dulux_74RR_05_092: 7873,
    Dulux_74RR_28_432: 7874,
    Dulux_74RR_76_023: 7875,
    Dulux_74YR_68_064: 7876,
    Dulux_74YR_71_141: 7877,
    Dulux_75GG_27_095: 7878,
    Dulux_75GG_77_065: 7879,
    Dulux_75GY_81_005: 7880,
    Dulux_75YR_18_393: 7881,
    Dulux_75YR_27_487: 7882,
    Dulux_75YR_64_102: 7883,
    Dulux_75YY_55_509: 7884,
    Dulux_75YY_87_137: 7885,
    Dulux_76BG_72_113: 7886,
    Dulux_76RR_40_294: 7887,
    Dulux_76YR_27_558: 7888,
    Dulux_76YY_27_439: 7889,
    Dulux_76YY_39_616: 7890,
    Dulux_77BG_24_246: 7891,
    Dulux_77BG_57_234: 7892,
    Dulux_77GG_46_139: 7893,
    Dulux_77GG_82_044: 7894,
    Dulux_77GY_32_058: 7895,
    Dulux_77GY_33_506: 7896,
    Dulux_77GY_68_066: 7897,
    Dulux_77RR_16_420: 7898,
    Dulux_77RR_67_177: 7899,
    Dulux_77YR_14_306: 7900,
    Dulux_77YR_26_391: 7901,
    Dulux_77YY_19_297: 7902,
    Dulux_77YY_47_629: 7903,
    Dulux_77YY_52_604: 7904,
    Dulux_77YY_86_032: 7905,
    Dulux_78BG_12_032: 7906,
    Dulux_78GG_15_104: 7907,
    Dulux_78GG_19_160: 7908,
    Dulux_78GG_19_378: 7909,
    Dulux_78GG_21_381: 7910,
    Dulux_78GG_72_138: 7911,
    Dulux_78GG_79_109: 7912,
    Dulux_78RB_08_163: 7913,
    Dulux_78RR_54_274: 7914,
    Dulux_78RR_71_148: 7915,
    Dulux_78YR_39_576: 7916,
    Dulux_78YR_74_155: 7917,
    Dulux_78YY_83_048: 7918,
    Dulux_79BG_27_391: 7919,
    Dulux_79BG_66_110: 7920,
    Dulux_79GG_27_362: 7921,
    Dulux_79GG_53_131: 7922,
    Dulux_79GG_75_125: 7923,
    Dulux_79GY_36_106: 7924,
    Dulux_79GY_57_120: 7925,
    Dulux_79GY_59_017: 7926,
    Dulux_79RB_76_076: 7927,
    Dulux_79YR_19_096: 7928,
    Dulux_79YR_76_064: 7929,
    Dulux_79YY_27_188: 7930,
    Dulux_80BB_08_225: 7931,
    Dulux_80BG_39_354: 7932,
    Dulux_80GG_08_135: 7933,
    Dulux_80GG_09_164: 7934,
    Dulux_80GG_12_182: 7935,
    Dulux_80GG_19_231: 7936,
    Dulux_80GG_39_220: 7937,
    Dulux_80GG_63_184: 7938,
    Dulux_80GG_67_036: 7939,
    Dulux_80GY_11_195: 7940,
    Dulux_80GY_12_245: 7941,
    Dulux_80GY_50_031: 7942,
    Dulux_80RR_07_260: 7943,
    Dulux_80RR_10_306: 7944,
    Dulux_80RR_77_083: 7945,
    Dulux_80YR_11_151: 7946,
    Dulux_80YR_13_325: 7947,
    Dulux_80YR_17_129: 7948,
    Dulux_80YR_19_378: 7949,
    Dulux_80YR_20_488: 7950,
    Dulux_80YR_21_118: 7951,
    Dulux_80YR_27_147: 7952,
    Dulux_80YR_31_508: 7953,
    Dulux_80YR_32_489: 7954,
    Dulux_80YR_34_468: 7955,
    Dulux_80YR_35_383: 7956,
    Dulux_80YR_45_427: 7957,
    Dulux_80YR_46_243: 7958,
    Dulux_80YR_55_266: 7959,
    Dulux_80YR_57_179: 7960,
    Dulux_80YR_65_185: 7961,
    Dulux_80YR_67_085: 7962,
    Dulux_80YR_74_043: 7963,
    Dulux_80YR_75_057: 7964,
    Dulux_80YR_76_086: 7965,
    Dulux_80YR_83_026: 7966,
    Dulux_80YY_75_423: 7967,
    Dulux_81BB_22_273: 7968,
    Dulux_81BB_29_221: 7969,
    Dulux_81BG_09_241: 7970,
    Dulux_81BG_17_262: 7971,
    Dulux_81BG_60_128: 7972,
    Dulux_81GG_67_099: 7973,
    Dulux_81GY_15_202: 7974,
    Dulux_81RB_75_080: 7975,
    Dulux_81RR_47_323: 7976,
    Dulux_81RR_51_067: 7977,
    Dulux_81YR_06_003: 7978,
    Dulux_81YR_38_111: 7979,
    Dulux_81YR_77_022: 7980,
    Dulux_81YR_85_004: 7981,
    Dulux_81YY_73_041: 7982,
    Dulux_81YY_81_016: 7983,
    Dulux_82BG_79_062: 7984,
    Dulux_82GG_12_289: 7985,
    Dulux_82GY_19_152: 7986,
    Dulux_82GY_75_111: 7987,
    Dulux_82RB_53_154: 7988,
    Dulux_82RR_10_097: 7989,
    Dulux_82RR_18_114: 7990,
    Dulux_82RR_76_111: 7991,
    Dulux_82YR_55_140: 7992,
    Dulux_82YR_81_106: 7993,
    Dulux_82YY_67_046: 7994,
    Dulux_82YY_74_446: 7995,
    Dulux_83BB_07_202: 7996,
    Dulux_83BB_27_352: 7997,
    Dulux_83BG_55_097: 7998,
    Dulux_83GY_33_173: 7999,
    Dulux_83RB_13_268: 8000,
    Dulux_83RR_12_377: 8001,
    Dulux_83YR_44_540: 8002,
    Dulux_83YR_54_381: 8003,
    Dulux_83YR_62_211: 8004,
    Dulux_83YY_45_055: 8005,
    Dulux_83YY_88_033: 8006,
    Dulux_83YY_89_055: 8007,
    Dulux_84BB_53_136: 8008,
    Dulux_84BG_18_143: 8009,
    Dulux_84BG_66_028: 8010,
    Dulux_84RB_60_175: 8011,
    Dulux_84RB_69_108: 8012,
    Dulux_84RR_05_082: 8013,
    Dulux_84YR_46_409: 8014,
    Dulux_84YR_49_139: 8015,
    Dulux_85BG_59_064: 8016,
    Dulux_85GG_76_039: 8017,
    Dulux_85GY_10_193: 8018,
    Dulux_85RB_53_237: 8019,
    Dulux_85RR_75_032: 8020,
    Dulux_85YR_32_167: 8021,
    Dulux_85YR_38_700: 8022,
    Dulux_85YR_60_336: 8023,
    Dulux_85YY_74_012: 8024,
    Dulux_85YY_86_166: 8025,
    Dulux_85YY_89_109: 8026,
    Dulux_86BB_15_237: 8027,
    Dulux_86BG_43_321: 8028,
    Dulux_86RB_47_274: 8029,
    Dulux_86YR_49_493: 8030,
    Dulux_86YR_70_136: 8031,
    Dulux_86YY_77_295: 8032,
    Dulux_87BB_80_036: 8033,
    Dulux_87RR_12_095: 8034,
    Dulux_87YR_12_005: 8035,
    Dulux_87YR_67_204: 8036,
    Dulux_87YY_13_208: 8037,
    Dulux_87YY_85_110: 8038,
    Dulux_88BG_08_179: 8039,
    Dulux_88GG_32_346: 8040,
    Dulux_88RB_37_328: 8041,
    Dulux_88RR_18_464: 8042,
    Dulux_88YY_66_447: 8043,
    Dulux_88YY_71_380: 8044,
    Dulux_89BG_70_116: 8045,
    Dulux_89BG_72_060: 8046,
    Dulux_89RB_72_119: 8047,
    Dulux_89RB_79_040: 8048,
    Dulux_89YY_62_494: 8049,
    Dulux_89YY_78_269: 8050,
    Dulux_89YY_80_039: 8051,
    Dulux_90BB_09_186: 8052,
    Dulux_90BB_19_165: 8053,
    Dulux_90BB_19_267: 8054,
    Dulux_90BB_21_220: 8055,
    Dulux_90BB_26_227: 8056,
    Dulux_90BB_32_126: 8057,
    Dulux_90BB_34_167: 8058,
    Dulux_90BB_46_132: 8059,
    Dulux_90BB_53_129: 8060,
    Dulux_90BB_62_139: 8061,
    Dulux_90BB_73_022: 8062,
    Dulux_90BB_83_011: 8063,
    Dulux_90BB_83_020: 8064,
    Dulux_90BG_08_075: 8065,
    Dulux_90BG_11_262: 8066,
    Dulux_90BG_14_337: 8067,
    Dulux_90BG_17_120: 8068,
    Dulux_90BG_21_302: 8069,
    Dulux_90BG_28_213: 8070,
    Dulux_90BG_30_073: 8071,
    Dulux_90BG_31_124: 8072,
    Dulux_90BG_35_068: 8073,
    Dulux_90BG_42_106: 8074,
    Dulux_90BG_44_049: 8075,
    Dulux_90BG_56_125: 8076,
    Dulux_90BG_63_043: 8077,
    Dulux_90BG_72_088: 8078,
    Dulux_90BG_72_100: 8079,
    Dulux_90GG_15_398: 8080,
    Dulux_90GG_28_133: 8081,
    Dulux_90GG_30_195: 8082,
    Dulux_90GG_38_242: 8083,
    Dulux_90GG_40_115: 8084,
    Dulux_90GG_43_338: 8085,
    Dulux_90GG_51_211: 8086,
    Dulux_90GG_57_146: 8087,
    Dulux_90GG_74_092: 8088,
    Dulux_90GG_74_108: 8089,
    Dulux_90GG_83_011: 8090,
    Dulux_90GG_83_057: 8091,
    Dulux_90GG_83_069: 8092,
    Dulux_90GY_08_187: 8093,
    Dulux_90GY_16_151: 8094,
    Dulux_90GY_16_354: 8095,
    Dulux_90GY_21_472: 8096,
    Dulux_90GY_28_319: 8097,
    Dulux_90GY_29_121: 8098,
    Dulux_90GY_33_408: 8099,
    Dulux_90GY_35_238: 8100,
    Dulux_90GY_36_453: 8101,
    Dulux_90GY_46_056: 8102,
    Dulux_90GY_47_328: 8103,
    Dulux_90GY_48_234: 8104,
    Dulux_90GY_54_334: 8105,
    Dulux_90GY_64_072: 8106,
    Dulux_90GY_65_275: 8107,
    Dulux_90GY_67_146: 8108,
    Dulux_90GY_70_221: 8109,
    Dulux_90GY_72_040: 8110,
    Dulux_90GY_73_059: 8111,
    Dulux_90GY_76_158: 8112,
    Dulux_90GY_82_028: 8113,
    Dulux_90GY_83_033: 8114,
    Dulux_90GY_83_098: 8115,
    Dulux_90GY_83_104: 8116,
    Dulux_90RB_08_113: 8117,
    Dulux_90RB_12_225: 8118,
    Dulux_90RB_23_228: 8119,
    Dulux_90RB_37_175: 8120,
    Dulux_90RB_68_085: 8121,
    Dulux_90RB_75_051: 8122,
    Dulux_90RB_83_015: 8123,
    Dulux_90RB_83_023: 8124,
    Dulux_90RB_83_026: 8125,
    Dulux_90RB_83_030: 8126,
    Dulux_90RR_11_257: 8127,
    Dulux_90RR_16_298: 8128,
    Dulux_90RR_16_386: 8129,
    Dulux_90RR_28_245: 8130,
    Dulux_90RR_31_100: 8131,
    Dulux_90RR_31_403: 8132,
    Dulux_90RR_35_060: 8133,
    Dulux_90RR_41_258: 8134,
    Dulux_90RR_52_214: 8135,
    Dulux_90RR_55_138: 8136,
    Dulux_90RR_58_177: 8137,
    Dulux_90RR_62_124: 8138,
    Dulux_90RR_64_025: 8139,
    Dulux_90RR_69_101: 8140,
    Dulux_90RR_73_027: 8141,
    Dulux_90RR_76_062: 8142,
    Dulux_90RR_83_009: 8143,
    Dulux_90RR_83_013: 8144,
    Dulux_90RR_83_021: 8145,
    Dulux_90RR_83_030: 8146,
    Dulux_90YR_06_001: 8147,
    Dulux_90YR_10_151: 8148,
    Dulux_90YR_19_487: 8149,
    Dulux_90YR_26_147: 8150,
    Dulux_90YR_31_605: 8151,
    Dulux_90YR_33_167: 8152,
    Dulux_90YR_34_084: 8153,
    Dulux_90YR_34_468: 8154,
    Dulux_90YR_34_561: 8155,
    Dulux_90YR_41_179: 8156,
    Dulux_90YR_41_472: 8157,
    Dulux_90YR_43_101: 8158,
    Dulux_90YR_46_346: 8159,
    Dulux_90YR_51_109: 8160,
    Dulux_90YR_53_132: 8161,
    Dulux_90YR_54_440: 8162,
    Dulux_90YR_55_266: 8163,
    Dulux_90YR_57_293: 8164,
    Dulux_90YR_59_108: 8165,
    Dulux_90YR_64_040: 8166,
    Dulux_90YR_64_166: 8167,
    Dulux_90YR_67_085: 8168,
    Dulux_90YR_72_159: 8169,
    Dulux_90YR_74_057: 8170,
    Dulux_90YR_77_115: 8171,
    Dulux_90YR_81_058: 8172,
    Dulux_90YR_83_044: 8173,
    Dulux_90YR_83_070: 8174,
    Dulux_90YY_07_093: 8175,
    Dulux_90YY_15_279: 8176,
    Dulux_90YY_19_075: 8177,
    Dulux_90YY_21_371: 8178,
    Dulux_90YY_35_304: 8179,
    Dulux_90YY_48_255: 8180,
    Dulux_90YY_48_500: 8181,
    Dulux_90YY_54_254: 8182,
    Dulux_90YY_58_424: 8183,
    Dulux_90YY_67_117: 8184,
    Dulux_90YY_69_419: 8185,
    Dulux_90YY_72_225: 8186,
    Dulux_90YY_83_107: 8187,
    Dulux_90YY_83_143: 8188,
    Dulux_90YY_83_179: 8189,
    Dulux_91BB_07_263: 8190,
    Dulux_91RR_51_304: 8191,
    Dulux_91YR_10_089: 8192,
    Dulux_91YY_23_374: 8193,
    Dulux_91YY_40_628: 8194,
    Dulux_91YY_82_235: 8195,
    Dulux_91YY_88_072: 8196,
    Dulux_92BG_08_031: 8197,
    Dulux_92GG_59_245: 8198,
    Dulux_92YY_46_608: 8199,
    Dulux_92YY_51_593: 8200,
    Dulux_92YY_59_547: 8201,
    Dulux_92YY_69_401: 8202,
    Dulux_93BG_18_066: 8203,
    Dulux_93GY_24_024: 8204,
    Dulux_93RB_27_376: 8205,
    Dulux_93RR_70_157: 8206,
    Dulux_93YR_22_305: 8207,
    Dulux_93YR_80_033: 8208,
    Dulux_93YR_86_030: 8209,
    Dulux_93YY_52_598: 8210,
    Dulux_93YY_89_012: 8211,
    Dulux_94RB_60_214: 8212,
    Dulux_94RR_28_490: 8213,
    Dulux_94YR_40_219: 8214,
    Dulux_94YY_83_072: 8215,
    Dulux_95BG_23_044: 8216,
    Dulux_95BG_49_025: 8217,
    Dulux_95GG_78_054: 8218,
    Dulux_95RB_56_237: 8219,
    Dulux_95RB_71_132: 8220,
    Dulux_95RR_07_271: 8221,
    Dulux_95RR_36_390: 8222,
    Dulux_95YY_39_329: 8223,
    Dulux_96RB_22_393: 8224,
    Dulux_96YR_09_033: 8225,
    Dulux_96YR_46_065: 8226,
    Dulux_96YR_46_632: 8227,
    Dulux_96YY_53_200: 8228,
    Dulux_96YY_66_036: 8229,
    Dulux_97GY_07_135: 8230,
    Dulux_97RB_77_086: 8231,
    Dulux_97YR_39_118: 8232,
    Dulux_97YR_54_511: 8233,
    Dulux_97YY_83_090: 8234,
    Dulux_98BG_45_237: 8235,
    Dulux_98YR_26_291: 8236,
    Dulux_98YR_53_235: 8237,
    Dulux_98YR_78_041: 8238,
    Dulux_99BG_22_432: 8239,
    Dulux_99BG_62_159: 8240,
    Dulux_99YR_23_456: 8241,
    Dulux_99YR_61_205: 8242,
    Dulux_99YR_63_283: 8243,
    Dulux_99YR_83_059: 8244,
    Dulux_99YR_85_075: 8245,
    Dulux_99YY_77_080: 8246,
    Dulux_99YY_82_124: 8247,
    Dulux_AbaloneSands: 8248,
    Dulux_AbsoluteWhite: 8249,
    Dulux_AcaiBerry: 8250,
    Dulux_AcornCap: 8251,
    Dulux_ActiveOrange: 8252,
    Dulux_AgedBronze: 8253,
    Dulux_AgedIvory: 8254,
    Dulux_AlabasterWhite: 8255,
    Dulux_Almond: 8256,
    Dulux_AlmondButter: 8257,
    Dulux_AlmondWhite: 8258,
    Dulux_AlmostBlack: 8259,
    Dulux_AlmostOyster: 8260,
    Dulux_Alpine: 8261,
    Dulux_AlpineFlowers: 8262,
    Dulux_AlpineForest: 8263,
    Dulux_AltaVista: 8264,
    Dulux_AmazonianGreen: 8265,
    Dulux_AmberSpirit: 8266,
    Dulux_AncientArtefact: 8267,
    Dulux_AncientSandstone: 8268,
    Dulux_Angora: 8269,
    Dulux_AngoraBlanket: 8270,
    Dulux_AntarcticStorm: 8271,
    Dulux_Antelope: 8272,
    Dulux_Appledore: 8273,
    Dulux_AppleWhite: 8274,
    Dulux_Apricot: 8275,
    Dulux_ApricotCrush: 8276,
    Dulux_ApricotWhite: 8277,
    Dulux_AprilPosy: 8278,
    Dulux_AqSpanishBrown: 8279,
    Dulux_AquaSash: 8280,
    Dulux_ArchivePapers: 8281,
    Dulux_ArcticPebble: 8282,
    Dulux_ArizonaTumbleweed: 8283,
    Dulux_ArtistsBrush: 8284,
    Dulux_AshRose: 8285,
    Dulux_AshWhite: 8286,
    Dulux_AtlasBlue: 8287,
    Dulux_Atmosphere: 8288,
    Dulux_AubergineKiss: 8289,
    Dulux_AuburnEmbers: 8290,
    Dulux_AutumnEmbrace: 8291,
    Dulux_Aviator: 8292,
    Dulux_Azalea: 8293,
    Dulux_Aztec: 8294,
    Dulux_BakedAubergine: 8295,
    Dulux_BakersFlour: 8296,
    Dulux_BallerinaDance: 8297,
    Dulux_Balsa: 8298,
    Dulux_Bamboo: 8299,
    Dulux_BambooStem: 8300,
    Dulux_BananaSplit: 8301,
    Dulux_BarleyWhite: 8302,
    Dulux_Barleywood: 8303,
    Dulux_BasicallyBlack: 8304,
    Dulux_BathstoneBeige: 8305,
    Dulux_BayHorse: 8306,
    Dulux_BayView: 8307,
    Dulux_BeachBlue: 8308,
    Dulux_BeachcombGrey: 8309,
    Dulux_BeachGrass: 8310,
    Dulux_BeachWalk: 8311,
    Dulux_BeaumontBlue: 8312,
    Dulux_Beaver: 8313,
    Dulux_BerryBlast: 8314,
    Dulux_BerryKiss: 8315,
    Dulux_BerryPop: 8316,
    Dulux_BerrySmoothie: 8317,
    Dulux_BerryWhip: 8318,
    Dulux_Billow: 8319,
    Dulux_BirchRoot: 8320,
    Dulux_BiscuitBeige: 8321,
    Dulux_Bison: 8322,
    Dulux_Black: 8323,
    Dulux_BlackAsh: 8324,
    Dulux_BlackberryBush: 8325,
    Dulux_BlackcurrantJam: 8326,
    Dulux_BlackOpal: 8327,
    Dulux_BlackthornBlue: 8328,
    Dulux_BlanketBox: 8329,
    Dulux_Bleaches: 10308,
    Dulux_BlissfulBlue: 8330,
    Dulux_BloodOrange: 8331,
    Dulux_BlossomTree: 8332,
    Dulux_BlossomWhite: 8333,
    Dulux_BlueAgave: 8334,
    Dulux_BlueBabe: 8335,
    Dulux_Bluebell: 8336,
    Dulux_Blueberry: 8337,
    Dulux_BlueberryIcing: 8338,
    Dulux_BlueberrySurprise: 8339,
    Dulux_BlueberryWhite: 8340,
    Dulux_BluebirdSkies: 8341,
    Dulux_BlueChalk: 8342,
    Dulux_BlueDelphinium: 8343,
    Dulux_BlueIncense: 8344,
    Dulux_BlueRibbon: 8345,
    Dulux_BlueSaturn: 8346,
    Dulux_BlueSlate: 8347,
    Dulux_BlueThistle: 8348,
    Dulux_BlueView: 8349,
    Dulux_BlushedPearl: 8350,
    Dulux_BlushPink: 8351,
    Dulux_BoathouseBlue: 8352,
    Dulux_BohoBlush: 8353,
    Dulux_Bombe: 8354,
    Dulux_BorrowedBlue: 8355,
    Dulux_Bracken: 8356,
    Dulux_Braemar: 8357,
    Dulux_BrambleRamble: 8358,
    Dulux_BrassBell: 8359,
    Dulux_BrassBuckle: 8360,
    Dulux_BraveGround: 8361,
    Dulux_BrightSkies: 8362,
    Dulux_Brownstone: 8363,
    Dulux_BrushedBuckle: 8364,
    Dulux_BrushedGold: 8365,
    Dulux_Buff: 8366,
    Dulux_BuriedTreasure: 8367,
    Dulux_BurnishedBrass: 8368,
    Dulux_BurnishedCopper: 8369,
    Dulux_ButterCup: 8370,
    Dulux_ButtercupBlast: 8371,
    Dulux_ButteredCorn: 8372,
    Dulux_Buttermilk: 8373,
    Dulux_ButterscotchSyrup: 8374,
    Dulux_CacaoNibs: 8375,
    Dulux_Calendula: 8376,
    Dulux_CaliforniaCool: 8377,
    Dulux_CaliforniaDays: 8378,
    Dulux_CalmClouds: 8379,
    Dulux_CalmingMeadow: 8380,
    Dulux_Cameo: 8381,
    Dulux_CandiedOrange: 8382,
    Dulux_CandleCream: 8383,
    Dulux_CandyCream: 8384,
    Dulux_Candytuft: 8385,
    Dulux_CannonBall: 8386,
    Dulux_CaperGreen: 8387,
    Dulux_CapeSalmon: 8388,
    Dulux_Capricorn: 8389,
    Dulux_CaramelCrunch: 8390,
    Dulux_CaramelFudge: 8391,
    Dulux_CaramelLatte: 8392,
    Dulux_CardamomPod: 8393,
    Dulux_CashewNut: 8394,
    Dulux_Catkin: 8395,
    Dulux_CedarGlow: 8396,
    Dulux_CeleryLeaf: 8397,
    Dulux_CeremonialBlue: 8398,
    Dulux_ChalkDust: 8399,
    Dulux_ChalkWhite: 8400,
    Dulux_Champagne: 8401,
    Dulux_ChampagneGlory: 8402,
    Dulux_Champignon: 10311,
    Dulux_CherishedGold: 8403,
    Dulux_CherishedRibbon: 8404,
    Dulux_CherryChocolate: 8405,
    Dulux_CherryPlum: 8406,
    Dulux_CherryTruffle: 8407,
    Dulux_ChicShadow: 8408,
    Dulux_ChiffonSilk: 8409,
    Dulux_ChilliPepper: 8410,
    Dulux_ChilternWhite: 8411,
    Dulux_ChinaWhite: 8412,
    Dulux_ChineseApple: 8413,
    Dulux_ChineseMulberry: 8414,
    Dulux_Chive: 8415,
    Dulux_ChocolateBombe: 8416,
    Dulux_ChocolateFountain: 8417,
    Dulux_Cinnamon: 8418,
    Dulux_CinnamonSprinkle: 8419,
    Dulux_CinnamonStick: 8420,
    Dulux_Cirrus: 8421,
    Dulux_Citrine: 8422,
    Dulux_CitronPeel: 8423,
    Dulux_CitrusSorbet: 8424,
    Dulux_CitrusZing: 8425,
    Dulux_CityFog: 8426,
    Dulux_ClearSkies: 8427,
    Dulux_CliffWalk: 8428,
    Dulux_ClockFace: 8429,
    Dulux_CloudedDawn: 8430,
    Dulux_CloudlessSky: 8431,
    Dulux_CloudyDreams: 8432,
    Dulux_CoastalBreeze: 8433,
    Dulux_CoastalGlow: 8434,
    Dulux_CoastalGrey: 8435,
    Dulux_CoastalMist: 8436,
    Dulux_CobaltEmbrace: 8437,
    Dulux_CobaltNight: 8438,
    Dulux_CobbleCove: 8439,
    Dulux_CocoaButter: 8440,
    Dulux_CocoaMist: 8441,
    Dulux_CocoaPod: 8442,
    Dulux_CommonDormouse: 8443,
    Dulux_CommonLand: 8444,
    Dulux_ConcreteGrey: 8445,
    Dulux_ConfettiPaper: 8446,
    Dulux_Conifer: 8447,
    Dulux_CookieDough: 8448,
    Dulux_CoolMarble: 8449,
    Dulux_CopenhagenBlue: 8450,
    Dulux_Copperbeech: 8451,
    Dulux_CopperBlush: 8452,
    Dulux_CopperBrown: 8453,
    Dulux_CopperGlow: 8454,
    Dulux_CoralCaress: 8455,
    Dulux_CoralCharm: 8456,
    Dulux_CoralFlair: 8457,
    Dulux_CoralLustre: 8458,
    Dulux_CoralPink: 8459,
    Dulux_CoralPolka: 8460,
    Dulux_CoralSplash: 8461,
    Dulux_Cornflower: 8462,
    Dulux_CornflowerBunch: 8463,
    Dulux_CornflowerWhite: 8464,
    Dulux_CornishClay: 8465,
    Dulux_CosmosFlower: 8466,
    Dulux_CosyCashmere: 8467,
    Dulux_CottonBreeze: 8468,
    Dulux_CottonSoft: 8469,
    Dulux_CottonThread: 8470,
    Dulux_CountryBoots: 8471,
    Dulux_CountryCream: 8472,
    Dulux_CountrySky: 8473,
    Dulux_CountryTweed: 8474,
    Dulux_CountyCream: 8475,
    Dulux_CowslipFlower: 8476,
    Dulux_CoyoteGrey: 8477,
    Dulux_CranberryCrunch: 8478,
    Dulux_Cream: 8479,
    Dulux_CreamBun: 8480,
    Dulux_CreamRose: 8481,
    Dulux_CroatianStones: 8482,
    Dulux_CrushedAloe: 8483,
    Dulux_CrushedChilli: 8484,
    Dulux_CucumberWater: 8485,
    Dulux_CustardCream: 8486,
    Dulux_CygnetFeather: 8487,
    Dulux_CyprusGreen: 8488,
    Dulux_DaffodilWhite: 8489,
    Dulux_DamsonDusk: 8490,
    Dulux_Dancetime: 8491,
    Dulux_DanishBlue: 8492,
    Dulux_DarkAcacia: 8493,
    Dulux_DarkAubergine: 8494,
    Dulux_DarkGarnet: 8495,
    Dulux_DarkHickory: 8496,
    Dulux_DarkMaple: 8497,
    Dulux_DarkPoplar: 8498,
    Dulux_DarkStone: 8499,
    Dulux_DawnZest: 8500,
    Dulux_DazzlingYellow: 8501,
    Dulux_DecadentDamson: 8502,
    Dulux_DeepestAmethyst: 8503,
    Dulux_DeepFossil: 8504,
    Dulux_DeepRouge: 8505,
    Dulux_DeepRusset: 8506,
    Dulux_DeepUltramarine: 8507,
    Dulux_DelftChina: 8508,
    Dulux_DelicateCornflower: 8509,
    Dulux_DelicateVeil: 8510,
    Dulux_DenimDrift: 8511,
    Dulux_DesertDusk: 8512,
    Dulux_DesertWind: 8513,
    Dulux_DewyLawn: 8514,
    Dulux_DHBlossom: 8515,
    Dulux_DHDrab: 8516,
    Dulux_DHGrassGreen: 8517,
    Dulux_DHIndigo: 8518,
    Dulux_DHLinenColour: 8519,
    Dulux_DHOxfordBlue_Heritage: 8520,
    Dulux_DHPearlColour: 8521,
    Dulux_DHSlate: 8522,
    Dulux_DHStone: 8523,
    Dulux_DHWhite: 8524,
    Dulux_Dieskau: 10310,
    Dulux_DippedChocolate: 8525,
    Dulux_Dollshouse: 8526,
    Dulux_Dolphin: 8527,
    Dulux_DomPedro: 8528,
    Dulux_Dove: 8529,
    Dulux_DoveWhite: 8530,
    Dulux_Dresden: 8531,
    Dulux_DriedLavender: 8532,
    Dulux_DriedRoses: 8533,
    Dulux_DriedSage: 8534,
    Dulux_DriftingCloud: 8535,
    Dulux_DrumHide: 8536,
    Dulux_Duckegg: 8537,
    Dulux_DuluxAmericanMahogany: 8538,
    Dulux_DuluxAntiqueMahogany: 8539,
    Dulux_DuluxAntiquePine: 8540,
    Dulux_DuluxAntiqueRosewood: 8541,
    Dulux_DuluxAntiqueWalnut: 8542,
    Dulux_DuluxBrazilianRosewood: 8543,
    Dulux_DuluxCherryMahogany: 8544,
    Dulux_DuluxEbony: 8545,
    Dulux_DuluxHeritageOak: 8546,
    Dulux_DuluxLightOak: 8547,
    Dulux_DuluxMahogany: 8548,
    Dulux_DuluxNewPine: 8549,
    Dulux_DuluxNewRosewood: 8550,
    Dulux_DuluxPine: 8551,
    Dulux_DuluxRichMahogany: 8552,
    Dulux_DuluxRichOak: 8553,
    Dulux_DuluxRichPine: 8554,
    Dulux_DuluxRichTeak: 8555,
    Dulux_DuluxRosewood: 8556,
    Dulux_DuluxTeak: 8557,
    Dulux_DuluxWalnut: 8558,
    Dulux_DuneGrass: 8559,
    Dulux_DuskyGem: 8560,
    Dulux_DustedFondant: 8561,
    Dulux_DustedHeather: 8562,
    Dulux_DustyDenim: 8563,
    Dulux_DynamiteRed: 8564,
    Dulux_EarlBlue: 8565,
    Dulux_EarthsCore: 8566,
    Dulux_EasternSilks: 8567,
    Dulux_EbonyForest: 8568,
    Dulux_EdelweissWhite: 8569,
    Dulux_EgyptianCotton: 8570,
    Dulux_ElderberryWine: 8571,
    Dulux_Elderflower: 8572,
    Dulux_ElderflowerTea: 8573,
    Dulux_ElectricStorm: 8574,
    Dulux_EmbassyPurple: 8575,
    Dulux_EmeraldGlade: 8576,
    Dulux_EmeraldSlate: 8577,
    Dulux_EmeraldStone: 8578,
    Dulux_Empathy: 8579,
    Dulux_EnglishBarn: 8580,
    Dulux_EnglishElm: 8581,
    Dulux_EnrichedEarths: 8582,
    Dulux_EvergladeForest: 8583,
    Dulux_Extravagance: 8584,
    Dulux_FadedBloom: 8585,
    Dulux_FadedDamson: 8586,
    Dulux_FadedIndigo: 8587,
    Dulux_FadedLeaf: 8588,
    Dulux_FadedPetal: 8589,
    Dulux_FadedSky: 8590,
    Dulux_Fairfields: 8591,
    Dulux_FallenBurr: 8592,
    Dulux_FallenWildflower: 8593,
    Dulux_FandangoFun: 8594,
    Dulux_FantasyLand: 8595,
    Dulux_FennelWhite: 8596,
    Dulux_FernGully: 8597,
    Dulux_FineCream: 8598,
    Dulux_FinestBurgundy: 8599,
    Dulux_FinestTurquoise: 8600,
    Dulux_FiresideEmbers: 8601,
    Dulux_FireWood: 8602,
    Dulux_FirForest: 8603,
    Dulux_FirstDawn: 8604,
    Dulux_FirstLeaves: 8605,
    Dulux_FitzroviaRed: 8606,
    Dulux_FjordBlue: 8607,
    Dulux_FlakeGrey: 8608,
    Dulux_FlamingoFlock: 8609,
    Dulux_Flax: 8610,
    Dulux_FlaxSeed: 8611,
    Dulux_Flint: 8612,
    Dulux_FlintArrow: 8613,
    Dulux_FloatingPetal: 8614,
    Dulux_FlorentineRed: 8615,
    Dulux_Florida: 8616,
    Dulux_FolkTales: 8617,
    Dulux_Fontana: 8618,
    Dulux_ForestDusks: 8619,
    Dulux_ForestFestival: 8620,
    Dulux_ForestGrey: 8621,
    Dulux_ForestMushroom: 8622,
    Dulux_ForestPine: 8623,
    Dulux_ForestShade: 8624,
    Dulux_ForgetMeNot: 8625,
    Dulux_Forsythia: 8626,
    Dulux_FortuneGreen: 8627,
    Dulux_FossilHunting: 8628,
    Dulux_FossilTrace: 8629,
    Dulux_Fragile: 8630,
    Dulux_FragileBlossom: 8631,
    Dulux_FragrantHerb: 8632,
    Dulux_FragrantPeony: 8633,
    Dulux_Francesca: 8634,
    Dulux_FreeDive: 8635,
    Dulux_FrenchOak: 8636,
    Dulux_FrenchTruffle: 8637,
    Dulux_FreshAloe: 8638,
    Dulux_FreshArtichoke: 8639,
    Dulux_FreshCitrusMint: 8640,
    Dulux_FreshDaisy: 8641,
    Dulux_FreshFlour: 8642,
    Dulux_FreshFoliage: 8643,
    Dulux_FreshPea: 8644,
    Dulux_FreshPine: 8645,
    Dulux_FreshPlaster: 8646,
    Dulux_FreshRosemary: 8647,
    Dulux_FreshStem: 8648,
    Dulux_FreshSurf: 8649,
    Dulux_FrostedDawn: 8650,
    Dulux_FrostedGlass: 8651,
    Dulux_FrostedGrape: 8652,
    Dulux_FrostedPapaya: 8653,
    Dulux_FrostedSteel: 8654,
    Dulux_GardenGrey: 8655,
    Dulux_Gardenia: 8656,
    Dulux_Garland: 8657,
    Dulux_GatedForest: 8658,
    Dulux_GentleFawn: 8659,
    Dulux_GentleLavender: 8660,
    Dulux_GentleMoon: 8661,
    Dulux_GingernutCrumb: 8662,
    Dulux_GlacialFlow: 8663,
    Dulux_GlacialSpring: 8664,
    Dulux_Goldcup: 8665,
    Dulux_GoldenBrick: 8666,
    Dulux_GoldenCookie: 8667,
    Dulux_GoldenEgg: 8668,
    Dulux_GoldenIvory: 8669,
    Dulux_GoldenLight: 8670,
    Dulux_GoldenSands: 8671,
    Dulux_GooseDown: 8672,
    Dulux_Goosewing: 8673,
    Dulux_GrasshopperGreen: 8674,
    Dulux_GrecianWhite: 8675,
    Dulux_GreenClay: 8676,
    Dulux_GreenEarth: 8677,
    Dulux_GreenMarl: 8678,
    Dulux_GreenOrchid: 8679,
    Dulux_GreenOxide: 8680,
    Dulux_GreenSlate: 8681,
    Dulux_Greyfriar: 8682,
    Dulux_GreySplendor: 8683,
    Dulux_GreyTaupe: 8684,
    Dulux_GreyWisp: 8685,
    Dulux_GroundNutmeg: 8686,
    Dulux_GuildGreen: 8687,
    Dulux_Gypsophila: 8688,
    Dulux_HamptonsSummer: 8689,
    Dulux_HarvestDusk: 8690,
    Dulux_HayLoft: 8691,
    Dulux_HazyMorning: 8692,
    Dulux_HealingSpice: 8693,
    Dulux_HeartWood: 8694,
    Dulux_Heather: 8695,
    Dulux_HeatherSolstice: 8696,
    Dulux_HempCloth: 8697,
    Dulux_Heron: 8698,
    Dulux_HighlandMarsh: 8699,
    Dulux_HighlandMist: 8700,
    Dulux_HighSummer: 8701,
    Dulux_Highwire: 8702,
    Dulux_Holly: 8703,
    Dulux_Hollybush: 8704,
    Dulux_HonestIndigo: 8705,
    Dulux_HoneyBeam: 8706,
    Dulux_HoneyBrown: 8707,
    Dulux_HoneyMango: 8708,
    Dulux_Honeymoon: 8709,
    Dulux_HoneyMustard: 8710,
    Dulux_HoneyNut: 8711,
    Dulux_Honeysuckle: 8712,
    Dulux_Hopsack: 8713,
    Dulux_HorizonView: 8714,
    Dulux_Hullabaloo: 8715,
    Dulux_IcedFrappe: 8716,
    Dulux_IcedGem: 8717,
    Dulux_IcingSugar: 8718,
    Dulux_ImminentDawn: 8719,
    Dulux_IncaOrange: 8720,
    Dulux_IndianSandstone: 8721,
    Dulux_IndianWhite: 8722,
    Dulux_IndigoShade: 8723,
    Dulux_InkWash: 8724,
    Dulux_InkWell: 8725,
    Dulux_InkyStone: 8726,
    Dulux_Iris: 8727,
    Dulux_IrisBouquet: 8728,
    Dulux_Ironstone: 8729,
    Dulux_Ivory: 8730,
    Dulux_IvoryLace: 8731,
    Dulux_IvyLeaf: 8732,
    Dulux_JadeWhite: 8733,
    Dulux_JapaneseBlossom: 8734,
    Dulux_JasmineBlush: 8735,
    Dulux_JasmineShimmer: 8736,
    Dulux_JasmineWhite: 8737,
    Dulux_Javelin: 8738,
    Dulux_JennyWren: 8739,
    Dulux_Jonquil: 8740,
    Dulux_JuicyGrape: 8741,
    Dulux_JuicyPear: 8742,
    Dulux_JungleLagoon: 8743,
    Dulux_JungleTrail: 8744,
    Dulux_Juniper: 8745,
    Dulux_JustWalnut: 8746,
    Dulux_KalahariSands: 8747,
    Dulux_KiwiCrush: 8748,
    Dulux_KiwiGreen: 8749,
    Dulux_KnottedTwine: 8750,
    Dulux_LabradorBrown: 8751,
    Dulux_LadyPenelope: 8752,
    Dulux_LagoonFalls: 8753,
    Dulux_LakeSunset: 8754,
    Dulux_LambsWool: 8755,
    Dulux_Larkspur: 8756,
    Dulux_Lavender: 8757,
    Dulux_LavenderChalk: 8758,
    Dulux_LavenderDrop: 8759,
    Dulux_LavenderFrost: 8760,
    Dulux_LavenderGrey: 8761,
    Dulux_LavenderQuartz: 8762,
    Dulux_LavishLilac: 8763,
    Dulux_LeadGrey: 8764,
    Dulux_LeadWhite: 8765,
    Dulux_LeapFrog: 8766,
    Dulux_LeatherCase: 8767,
    Dulux_LemonJester: 8768,
    Dulux_LemonPeel: 8769,
    Dulux_LemonPie: 8770,
    Dulux_LemonPunch: 8771,
    Dulux_LemonSlice: 8772,
    Dulux_LemonSpirit: 8773,
    Dulux_LemonSyllabub: 8774,
    Dulux_LemonTropics: 8775,
    Dulux_LemonZest: 8776,
    Dulux_LettersUnread: 8777,
    Dulux_Lido: 8778,
    Dulux_LightCobalt: 8779,
    Dulux_LightFrenchGrey: 8780,
    Dulux_LightTeal: 8781,
    Dulux_LilacEcho: 8782,
    Dulux_LilacFancy: 8783,
    Dulux_LilacGrey: 8784,
    Dulux_LilacOrchid: 8785,
    Dulux_LilacRose: 8786,
    Dulux_LilacSapphire: 8787,
    Dulux_LilacSkies: 8788,
    Dulux_LimeCordial: 8789,
    Dulux_LimeJelly: 8790,
    Dulux_Limelight: 8791,
    Dulux_LimePeel: 8792,
    Dulux_LimeSoda: 8793,
    Dulux_Limoncella: 8794,
    Dulux_Linden: 8795,
    Dulux_LinenWhite: 8796,
    Dulux_LinnetWhite: 8797,
    Dulux_Lizard: 8798,
    Dulux_Loganberry: 8799,
    Dulux_LostCoral: 8800,
    Dulux_LostLagoon: 8801,
    Dulux_LoveLetter: 8802,
    Dulux_LuckyPenny: 8803,
    Dulux_LunaLight: 8804,
    Dulux_LunarFalls: 8805,
    Dulux_LunarLanding: 8806,
    Dulux_LusciousLime: 8807,
    Dulux_LushGrass: 8808,
    Dulux_Mace: 8809,
    Dulux_Magnolia: 8810,
    Dulux_MaldiveDream: 8811,
    Dulux_MallardGreen: 8812,
    Dulux_Mallow: 8813,
    Dulux_MallowWhite: 8814,
    Dulux_MaltChocolate: 8815,
    Dulux_MaltedBarley: 8816,
    Dulux_MaltedCaramel: 8817,
    Dulux_ManukaHoneybee: 8818,
    Dulux_MaplewoodTrail: 8819,
    Dulux_MarbleWhite: 8820,
    Dulux_MarigoldCheer: 8821,
    Dulux_MarineSplash: 8822,
    Dulux_MaritimeTeal: 8823,
    Dulux_MarmaladePreserve: 8824,
    Dulux_MaskedBall: 8825,
    Dulux_MastersGold: 8826,
    Dulux_MatchaGrey: 8827,
    Dulux_Mauve: 8828,
    Dulux_MauveCloud: 8829,
    Dulux_MauveMist: 8830,
    Dulux_Meadowsweet: 8831,
    Dulux_MediterraneanGlaze: 8832,
    Dulux_MediterraneanGreen: 8833,
    Dulux_MellowMocha: 8834,
    Dulux_MellowMoss: 8835,
    Dulux_MelonSorbet: 8836,
    Dulux_Merlin: 8837,
    Dulux_Midnight: 8838,
    Dulux_MidnightGarden: 8839,
    Dulux_MidnightJazz: 8840,
    Dulux_MidnightSecret: 8841,
    Dulux_MidnightTeal: 8842,
    Dulux_MidUmber: 8843,
    Dulux_MidwinterTide: 8844,
    Dulux_MilledFlour: 8845,
    Dulux_MineralMist: 8846,
    Dulux_MineralMud: 8847,
    Dulux_MintedGrey: 8848,
    Dulux_MintMacaroon: 8849,
    Dulux_MintWhisper: 8850,
    Dulux_Mistress: 8851,
    Dulux_MistyLake: 8852,
    Dulux_MistyLawn: 8853,
    Dulux_MistyMirror: 8854,
    Dulux_MistyMorning: 8855,
    Dulux_MoleGrey: 10307,
    Dulux_MoltenYellow: 8856,
    Dulux_Monarch: 8857,
    Dulux_Monument: 10313,
    Dulux_MoonCloud: 8858,
    Dulux_MoonShimmer: 8859,
    Dulux_Moorland: 8860,
    Dulux_MorningBreeze: 8861,
    Dulux_MorningLight: 8862,
    Dulux_MorningOats: 8863,
    Dulux_MoroccanFlame: 8864,
    Dulux_MossyStone: 8865,
    Dulux_MostlyMoonstone: 8866,
    Dulux_MountainAir: 8867,
    Dulux_MountainMoss: 8868,
    Dulux_MouseTail: 8869,
    Dulux_MuddyPuddle: 8870,
    Dulux_MudLark: 8871,
    Dulux_MulberryBurst: 8872,
    Dulux_MustardBlanket: 8873,
    Dulux_MutedAmber: 8874,
    Dulux_MutedBlush: 8875,
    Dulux_MutedClay: 8876,
    Dulux_MutedMint: 8877,
    Dulux_MysteriousTeal: 8878,
    Dulux_MysticalNight: 8879,
    Dulux_MysticRivers: 8880,
    Dulux_Namadji: 10312,
    Dulux_NarrowLane: 8881,
    Dulux_NaturalBreeze: 8882,
    Dulux_NaturalCalico: 8883,
    Dulux_NaturalHessian: 8884,
    Dulux_NaturalSlate: 8885,
    Dulux_NaturalStone: 8886,
    Dulux_NaturalWicker: 8887,
    Dulux_NectarBlush: 8888,
    Dulux_Nectarine: 8889,
    Dulux_NeptuneSeas: 8890,
    Dulux_NewMeringue: 8891,
    Dulux_NightMoth: 8892,
    Dulux_NightSeas: 8893,
    Dulux_NobleGrey: 8894,
    Dulux_NordicHills: 8895,
    Dulux_NordicSeas: 8896,
    Dulux_NordicSky: 8897,
    Dulux_NordicSpa: 8898,
    Dulux_NotebookOrange: 8899,
    Dulux_NutCookie: 8900,
    Dulux_NutmegWhite: 8901,
    Dulux_NuttyCrunch: 8902,
    Dulux_OceanRipple: 8903,
    Dulux_OceanSapphire: 8904,
    Dulux_OceanStone: 8905,
    Dulux_Ochre: 8906,
    Dulux_OchreGlow: 8907,
    Dulux_OchreSands: 8908,
    Dulux_OchreWhite: 8909,
    Dulux_OldEnglishGreen: 8910,
    Dulux_OldTimeOlive: 8911,
    Dulux_Olive: 8912,
    Dulux_OliveGarden: 8913,
    Dulux_OliveTapanade: 8914,
    Dulux_OliveTree: 8915,
    Dulux_OpaqueHoney: 8916,
    Dulux_OrangeFizz: 8917,
    Dulux_Orchard: 8918,
    Dulux_OrchidWhite: 8919,
    Dulux_Orion: 8920,
    Dulux_OvertlyOlive: 8921,
    Dulux_OysterPearl: 8922,
    Dulux_Pageant: 8923,
    Dulux_PaleCream: 8924,
    Dulux_PaleJasmine: 8925,
    Dulux_PaleNutmeg: 8926,
    Dulux_PaleOlivine: 8927,
    Dulux_PaleOpal: 8928,
    Dulux_PalePeony: 8929,
    Dulux_PaleTaupe: 8930,
    Dulux_PaleThistle: 8931,
    Dulux_PaleWalnut: 8932,
    Dulux_PalmNight: 8933,
    Dulux_PanelWhite: 8934,
    Dulux_PaperChain: 8935,
    Dulux_PapyrusPaper: 8936,
    Dulux_ParrotsPlume: 8937,
    Dulux_PartyBalloons: 8938,
    Dulux_PassionFlower: 8939,
    Dulux_PastelGrey: 8940,
    Dulux_PatisseriePink: 8941,
    Dulux_PeachBlossom: 8942,
    Dulux_PeachPosset: 8943,
    Dulux_PeachSouffle: 8944,
    Dulux_PeanutButter: 8945,
    Dulux_PearlBarley: 8946,
    Dulux_Peasblossom: 8947,
    Dulux_PeaShoot: 8948,
    Dulux_PebbleGrey: 8949,
    Dulux_PebbleShore: 8950,
    Dulux_PebbleTrail: 8951,
    Dulux_PenFriend: 8952,
    Dulux_PeppermintCandy: 8953,
    Dulux_PeppermintRock: 8954,
    Dulux_PepperRed: 8955,
    Dulux_PerfectlyTaupe: 8956,
    Dulux_Petal: 8957,
    Dulux_PetalCaress: 8958,
    Dulux_PetalPerfection: 8959,
    Dulux_PewterPlate: 8960,
    Dulux_PianoWhite: 8961,
    Dulux_Pigeon: 8962,
    Dulux_PineappleSlice: 8963,
    Dulux_PineCone: 8964,
    Dulux_Pinefrost: 8965,
    Dulux_PineNeedle: 8966,
    Dulux_PinkGinger: 8967,
    Dulux_PinkHoneysuckle: 8968,
    Dulux_PinkLady: 8969,
    Dulux_PinkParchment: 8970,
    Dulux_PinkProse: 8971,
    Dulux_PinkSandstone: 8972,
    Dulux_PinkSkies: 8973,
    Dulux_PinkWafer: 8974,
    Dulux_PistachioCreme: 8975,
    Dulux_Plum: 8976,
    Dulux_PlumCompote: 8977,
    Dulux_PlumCustard: 8978,
    Dulux_PlumTruffle: 8979,
    Dulux_PoachedPeach: 8980,
    Dulux_PocketStone: 8981,
    Dulux_PoisonApple: 8982,
    Dulux_PoisonIvy: 8983,
    Dulux_PolishedPebble: 8984,
    Dulux_Pollen: 8985,
    Dulux_PollenYellow: 8986,
    Dulux_Pompadour: 8987,
    Dulux_Poppy: 8988,
    Dulux_PorcelainBlush: 8989,
    Dulux_PorcelainDoll: 8990,
    Dulux_Portland: 8991,
    Dulux_PottersPink: 8992,
    Dulux_PottersWheel: 8993,
    Dulux_PowderBlush: 8994,
    Dulux_PowderColour: 8995,
    Dulux_PowderyMint: 8996,
    Dulux_PralineMelt: 8997,
    Dulux_PreciousPeat: 8998,
    Dulux_PressedBlueberry: 8999,
    Dulux_PressedPetal: 9000,
    Dulux_PressedPutty: 9001,
    Dulux_PrettyPink: 9002,
    Dulux_PrimroseWhite: 9003,
    Dulux_PromQueen: 9004,
    Dulux_ProudPeacock: 9005,
    Dulux_PuginRed: 9006,
    Dulux_PumiceBrown: 9007,
    Dulux_PumiceGrey: 9008,
    Dulux_PurplePansy: 9009,
    Dulux_PurplePout: 9010,
    Dulux_PurpleSlate: 9011,
    Dulux_QuarryTile: 9012,
    Dulux_QuartzGrey: 9013,
    Dulux_RailCloth: 9014,
    Dulux_RainforestCanopy: 9015,
    Dulux_RainyDays: 9016,
    Dulux_Raisin: 9017,
    Dulux_RaisinCake: 9018,
    Dulux_RAL1000: 9019,
    Dulux_RAL1001: 9020,
    Dulux_RAL1002: 9021,
    Dulux_RAL1003: 9022,
    Dulux_RAL1004: 9023,
    Dulux_RAL1005: 9024,
    Dulux_RAL1006: 9025,
    Dulux_RAL1007: 9026,
    Dulux_RAL1011: 9027,
    Dulux_RAL1012: 9028,
    Dulux_RAL1013: 9029,
    Dulux_RAL1014: 9030,
    Dulux_RAL1015: 9031,
    Dulux_RAL1016: 9032,
    Dulux_RAL1017: 9033,
    Dulux_RAL1018: 9034,
    Dulux_RAL1019: 9035,
    Dulux_RAL1020: 9036,
    Dulux_RAL1021: 9037,
    Dulux_RAL1023: 9038,
    Dulux_RAL1024: 9039,
    Dulux_RAL1027: 9040,
    Dulux_RAL1028: 9041,
    Dulux_RAL1032: 9042,
    Dulux_RAL1033: 9043,
    Dulux_RAL1034: 9044,
    Dulux_RAL1037: 9045,
    Dulux_RAL2000: 9046,
    Dulux_RAL2001: 9047,
    Dulux_RAL2002: 9048,
    Dulux_RAL2003: 9049,
    Dulux_RAL2004: 9050,
    Dulux_RAL2008: 9051,
    Dulux_RAL2009: 9052,
    Dulux_RAL2010: 9053,
    Dulux_RAL2011: 9054,
    Dulux_RAL2012: 9055,
    Dulux_RAL3000: 9056,
    Dulux_RAL3001: 9057,
    Dulux_RAL3002: 9058,
    Dulux_RAL3003: 9059,
    Dulux_RAL3004: 9060,
    Dulux_RAL3005: 9061,
    Dulux_RAL3007: 9062,
    Dulux_RAL3009: 9063,
    Dulux_RAL3011: 9064,
    Dulux_RAL3012: 9065,
    Dulux_RAL3013: 9066,
    Dulux_RAL3014: 9067,
    Dulux_RAL3015: 9068,
    Dulux_RAL3016: 9069,
    Dulux_RAL3017: 9070,
    Dulux_RAL3018: 9071,
    Dulux_RAL3020: 9072,
    Dulux_RAL3022: 9073,
    Dulux_RAL3027: 9074,
    Dulux_RAL3031: 9075,
    Dulux_RAL4001: 9076,
    Dulux_RAL4002: 9077,
    Dulux_RAL4003: 9078,
    Dulux_RAL4004: 9079,
    Dulux_RAL4005: 9080,
    Dulux_RAL4006: 9081,
    Dulux_RAL4007: 9082,
    Dulux_RAL4008: 9083,
    Dulux_RAL4009: 9084,
    Dulux_RAL4010: 9085,
    Dulux_RAL5000: 9086,
    Dulux_RAL5001: 9087,
    Dulux_RAL5002: 9088,
    Dulux_RAL5003: 9089,
    Dulux_RAL5004: 9090,
    Dulux_RAL5005: 9091,
    Dulux_RAL5007: 9092,
    Dulux_RAL5008: 9093,
    Dulux_RAL5009: 9094,
    Dulux_RAL5010: 9095,
    Dulux_RAL5011: 9096,
    Dulux_RAL5012: 9097,
    Dulux_RAL5013: 9098,
    Dulux_RAL5014: 9099,
    Dulux_RAL5015: 9100,
    Dulux_RAL5017: 9101,
    Dulux_RAL5018: 9102,
    Dulux_RAL5019: 9103,
    Dulux_RAL5020: 9104,
    Dulux_RAL5021: 9105,
    Dulux_RAL5022: 9106,
    Dulux_RAL5023: 9107,
    Dulux_RAL5024: 9108,
    Dulux_RAL6000: 9109,
    Dulux_RAL6001: 9110,
    Dulux_RAL6002: 9111,
    Dulux_RAL6003: 9112,
    Dulux_RAL6004: 9113,
    Dulux_RAL6005: 9114,
    Dulux_RAL6006: 9115,
    Dulux_RAL6007: 9116,
    Dulux_RAL6008: 9117,
    Dulux_RAL6009: 9118,
    Dulux_RAL6010: 9119,
    Dulux_RAL6011: 9120,
    Dulux_RAL6012: 9121,
    Dulux_RAL6013: 9122,
    Dulux_RAL6014: 9123,
    Dulux_RAL6015: 9124,
    Dulux_RAL6016: 9125,
    Dulux_RAL6017: 9126,
    Dulux_RAL6018: 9127,
    Dulux_RAL6019: 9128,
    Dulux_RAL6020: 9129,
    Dulux_RAL6021: 9130,
    Dulux_RAL6022: 9131,
    Dulux_RAL6024: 9132,
    Dulux_RAL6025: 9133,
    Dulux_RAL6026: 9134,
    Dulux_RAL6027: 9135,
    Dulux_RAL6028: 9136,
    Dulux_RAL6029: 9137,
    Dulux_RAL6032: 9138,
    Dulux_RAL6033: 9139,
    Dulux_RAL6034: 9140,
    Dulux_RAL7000: 9141,
    Dulux_RAL7001: 9142,
    Dulux_RAL7002: 9143,
    Dulux_RAL7003: 9144,
    Dulux_RAL7004: 9145,
    Dulux_RAL7005: 9146,
    Dulux_RAL7006: 9147,
    Dulux_RAL7008: 9148,
    Dulux_RAL7009: 9149,
    Dulux_RAL7010: 9150,
    Dulux_RAL7011: 9151,
    Dulux_RAL7012: 9152,
    Dulux_RAL7013: 9153,
    Dulux_RAL7015: 9154,
    Dulux_RAL7016: 9155,
    Dulux_RAL7021: 9156,
    Dulux_RAL7022: 9157,
    Dulux_RAL7023: 9158,
    Dulux_RAL7024: 9159,
    Dulux_RAL7026: 9160,
    Dulux_RAL7030: 9161,
    Dulux_RAL7031: 9162,
    Dulux_RAL7032: 9163,
    Dulux_RAL7033: 9164,
    Dulux_RAL7034: 9165,
    Dulux_RAL7035: 9166,
    Dulux_RAL7036: 9167,
    Dulux_RAL7037: 9168,
    Dulux_RAL7038: 9169,
    Dulux_RAL7039: 9170,
    Dulux_RAL7040: 9171,
    Dulux_RAL7042: 9172,
    Dulux_RAL7043: 9173,
    Dulux_RAL7044: 9174,
    Dulux_RAL7045: 9175,
    Dulux_RAL7046: 9176,
    Dulux_RAL7047: 9177,
    Dulux_RAL8000: 9178,
    Dulux_RAL8001: 9179,
    Dulux_RAL8002: 9180,
    Dulux_RAL8003: 9181,
    Dulux_RAL8004: 9182,
    Dulux_RAL8007: 9183,
    Dulux_RAL8008: 9184,
    Dulux_RAL8011: 9185,
    Dulux_RAL8012: 9186,
    Dulux_RAL8014: 9187,
    Dulux_RAL8015: 9188,
    Dulux_RAL8016: 9189,
    Dulux_RAL8017: 9190,
    Dulux_RAL8019: 9191,
    Dulux_RAL8022: 9192,
    Dulux_RAL8023: 9193,
    Dulux_RAL8024: 9194,
    Dulux_RAL8025: 9195,
    Dulux_RAL8028: 9196,
    Dulux_RAL9001: 9197,
    Dulux_RAL9002: 9198,
    Dulux_RAL9003: 9199,
    Dulux_RAL9004: 9200,
    Dulux_RAL9005: 9201,
    Dulux_RAL9010: 9202,
    Dulux_RAL9011: 9203,
    Dulux_RAL9016: 9204,
    Dulux_RAL9017: 9205,
    Dulux_RAL9018: 9206,
    Dulux_Raspberry: 9207,
    Dulux_RaspberryBellini: 9208,
    Dulux_RaspberryDiva: 9209,
    Dulux_RaspberryRipple: 9210,
    Dulux_RaspberrySorbet: 9211,
    Dulux_Raven: 9212,
    Dulux_RavensFlight: 9213,
    Dulux_RawCashmere: 9214,
    Dulux_Razamatazz: 9215,
    Dulux_RedAcer: 9216,
    Dulux_RedcurrantGlory: 9217,
    Dulux_RedOchre: 9218,
    Dulux_RedRock: 9219,
    Dulux_RedRusset: 9220,
    Dulux_RedSand: 9221,
    Dulux_Regalia: 9222,
    Dulux_RegalPurple: 9223,
    Dulux_RegalSilk: 9224,
    Dulux_Regatta: 9225,
    Dulux_RestfulSlumber: 9226,
    Dulux_Rhino: 9227,
    Dulux_RhubarbCompote: 9228,
    Dulux_RichBerry: 9229,
    Dulux_RichBlack: 9230,
    Dulux_RichBlueberry: 9231,
    Dulux_RichEarth: 9232,
    Dulux_RichJuniper: 9233,
    Dulux_RichRoads: 9234,
    Dulux_RiverBed: 9235,
    Dulux_Riverbed_BS4800: 9236,
    Dulux_RiverPearl: 9237,
    Dulux_Riverstone: 9238,
    Dulux_RiverValley: 9239,
    Dulux_RoastedChestnut: 9240,
    Dulux_RoastedRed: 9241,
    Dulux_RocketFire: 9242,
    Dulux_RockingHorse: 9243,
    Dulux_RockpoolRipple: 9244,
    Dulux_RockSalt: 9245,
    Dulux_RocksaltRose: 9246,
    Dulux_RolledOats: 9247,
    Dulux_RomanticReverie: 9248,
    Dulux_RomanWhite: 9249,
    Dulux_RomneyWool: 9250,
    Dulux_RopeKnot: 9251,
    Dulux_RopeLadder: 9252,
    Dulux_RoseBark: 9253,
    Dulux_RoseCanopy: 9254,
    Dulux_RosemaryLeaf: 9255,
    Dulux_Rosepetal: 9256,
    Dulux_Rosetan: 9257,
    Dulux_Rosevale: 9258,
    Dulux_RoseWhite: 9259,
    Dulux_RougeNoir: 9260,
    Dulux_RoyalPeacock: 9261,
    Dulux_RubbleRoad: 9262,
    Dulux_RubyStarlet: 9263,
    Dulux_Rune: 9264,
    Dulux_RusticBrick: 9265,
    Dulux_Saddle: 9266,
    Dulux_SaddleBrown: 9267,
    Dulux_SafariSong: 9268,
    Dulux_SafariSpice: 9269,
    Dulux_SaffronSizzle: 9270,
    Dulux_Sage: 9271,
    Dulux_SageGreen: 9272,
    Dulux_SalsaMix: 9273,
    Dulux_Sandstone: 9274,
    Dulux_SandyShallows: 9275,
    Dulux_SandyShell: 9276,
    Dulux_SapphireSalute: 9277,
    Dulux_SapphireSplendour: 9278,
    Dulux_SashBlue: 9279,
    Dulux_SatchelTan: 9280,
    Dulux_SatsumaSpice: 9281,
    Dulux_SavanaBrown: 9282,
    Dulux_Savannah: 9283,
    Dulux_Scarab: 9284,
    Dulux_ScottishLoch: 9285,
    Dulux_Seafoam: 9286,
    Dulux_Seagrass: 9287,
    Dulux_SeaHolly: 9288,
    Dulux_SeaNettle: 9289,
    Dulux_SeashellGrey: 9290,
    Dulux_SeasonedOak: 9291,
    Dulux_Seine: 9292,
    Dulux_SereneWaters: 9293,
    Dulux_SettingStone: 9294,
    Dulux_ShadedGlen: 9295,
    Dulux_Shell: 9296,
    Dulux_ShellStories: 9297,
    Dulux_Sherwood: 9298,
    Dulux_ShiftingSands: 9299,
    Dulux_ShingleSteps: 9300,
    Dulux_SiberianSteppes: 9301,
    Dulux_SicilianLime: 9302,
    Dulux_Sierra: 9303,
    Dulux_SilkenClay: 9304,
    Dulux_SilverAsh: 9305,
    Dulux_SilverBirch: 9306,
    Dulux_SilverCloud: 9307,
    Dulux_SilverFern: 9308,
    Dulux_SilverLichen: 9309,
    Dulux_SilverRow: 9310,
    Dulux_SilverShingle: 9311,
    Dulux_SilverShores: 9312,
    Dulux_SimplyPearl: 9313,
    Dulux_SkyBlue: 9314,
    Dulux_SkyReflection: 9315,
    Dulux_SkyView: 9316,
    Dulux_SlateGreen: 9317,
    Dulux_SloeFlower: 9318,
    Dulux_SlumberSeed: 9319,
    Dulux_SmokeyQuartz: 9320,
    Dulux_SmokeySeas: 9321,
    Dulux_SmoothMaple: 9322,
    Dulux_SmoothPebble: 9323,
    Dulux_SnailTrail: 9324,
    Dulux_Snowman: 9325,
    Dulux_SnowTracks: 9326,
    Dulux_SnowySummit: 9327,
    Dulux_SoBlue: 9328,
    Dulux_SodaPink: 9329,
    Dulux_SoftApple: 9330,
    Dulux_SoftCoral: 9331,
    Dulux_SoftMuslin: 9332,
    Dulux_SoftPeach: 9333,
    Dulux_SoftPeriwinkle: 9334,
    Dulux_SoftStone: 9335,
    Dulux_SoftTruffle: 9336,
    Dulux_SomersetGreen: 9337,
    Dulux_SouthernBelle: 9338,
    Dulux_SpicedHoney: 9339,
    Dulux_SpicyPaprika: 9340,
    Dulux_SpidersWeb: 9341,
    Dulux_Spindrift: 9342,
    Dulux_SpinningWheel: 9343,
    Dulux_SpringBlush: 9344,
    Dulux_SpringCrocus: 9345,
    Dulux_SpringGlow: 9346,
    Dulux_SpringHyacinth: 9347,
    Dulux_Springleaf: 9348,
    Dulux_SpringRose: 9349,
    Dulux_SpringShoots: 9350,
    Dulux_SpunMohair: 9351,
    Dulux_StableGates: 9352,
    Dulux_StillWater: 9353,
    Dulux_StolenRose: 9354,
    Dulux_StoneGreen: 9355,
    Dulux_StonewashedBlue: 9356,
    Dulux_StormClearing: 9357,
    Dulux_StormDay: 9358,
    Dulux_StormSea: 9359,
    Dulux_StrawBale: 9360,
    Dulux_StrikingCyan: 9361,
    Dulux_Studio: 9362,
    Dulux_SulphurSunrise: 9363,
    Dulux_SummerBreeze: 9364,
    Dulux_SummerDamson: 9365,
    Dulux_SummerDusk: 9366,
    Dulux_SummerFizz: 9367,
    Dulux_SummerLinen: 9368,
    Dulux_SumptuousPlum: 9369,
    Dulux_SunbakedTerracotta: 9370,
    Dulux_SunblushPeach: 9371,
    Dulux_SunFlare: 9372,
    Dulux_SunnyLime: 9373,
    Dulux_SunsetKiss: 9374,
    Dulux_SunsetSands: 9375,
    Dulux_Surfmist: 10309,
    Dulux_SurrenderedSkies: 9376,
    Dulux_Swansdown: 9377,
    Dulux_SwedishWhite: 9378,
    Dulux_SweetBlueberry: 9379,
    Dulux_SweetCinnamon: 9380,
    Dulux_SweetCitrus: 9381,
    Dulux_SweetEmbrace: 9382,
    Dulux_SweetFondant: 9383,
    Dulux_SweetNougat: 9384,
    Dulux_SweetPea: 9385,
    Dulux_SweetPink: 9386,
    Dulux_SweetPlum: 9387,
    Dulux_SweetSundae: 9388,
    Dulux_TailorsChalk: 9389,
    Dulux_TangerineTwist: 9390,
    Dulux_Tawny: 9391,
    Dulux_TawnyOwl: 9392,
    Dulux_TealTension: 9393,
    Dulux_TealTouch: 9394,
    Dulux_TealVelvet: 9395,
    Dulux_TealVoyage: 9396,
    Dulux_Tearose: 9397,
    Dulux_TeaTree: 9398,
    Dulux_TemperedChocolate: 9399,
    Dulux_Terracotta: 9400,
    Dulux_TerracottaArmy: 9401,
    Dulux_TerraOmbra: 9402,
    Dulux_Thistledown: 9403,
    Dulux_ThunderClouds: 9404,
    Dulux_Tideway: 9405,
    Dulux_Timeless: 9406,
    Dulux_TingeOfSilver: 9407,
    Dulux_TissuePaper: 9408,
    Dulux_ToastedMeringue: 9409,
    Dulux_ToastyGrey: 9410,
    Dulux_Trafalgar: 9411,
    Dulux_TrafalgarGrey: 9412,
    Dulux_TranquilDawn: 9413,
    Dulux_TranquilDepths: 9414,
    Dulux_TranquilMist: 9415,
    Dulux_TreasureChest: 9416,
    Dulux_TreasuredCoral: 9417,
    Dulux_TreasuredMemory: 9418,
    Dulux_TudorBrown: 9419,
    Dulux_TumbledGlass: 9420,
    Dulux_TurloghGreen: 9421,
    Dulux_TurquoiseJewel: 9422,
    Dulux_Turtle: 9423,
    Dulux_TurtledoveGrey: 9424,
    Dulux_TuscanNights: 9425,
    Dulux_UrbanObsession: 9426,
    Dulux_UrbanSlate: 9427,
    Dulux_UrbanWalk: 9428,
    Dulux_Vandyke: 9429,
    Dulux_VanillaSkies: 9430,
    Dulux_VanillaSundae: 9431,
    Dulux_VanillaWhite: 9432,
    Dulux_VanillaWisp: 9433,
    Dulux_VeiledViolet: 9434,
    Dulux_VelvetCake: 9435,
    Dulux_VelvetRobe: 9436,
    Dulux_VenusFlytrap: 9437,
    Dulux_VerandaGreen: 9438,
    Dulux_Verona: 9439,
    Dulux_VeryBerry: 9440,
    Dulux_VeryVanilla: 9441,
    Dulux_Viking: 9442,
    Dulux_VillageMaze: 9443,
    Dulux_VillaMexicana: 9444,
    Dulux_VineLeaf: 9445,
    Dulux_VintageCoins: 9446,
    Dulux_VintageRose: 9447,
    Dulux_VintageSmoke: 9448,
    Dulux_Violet: 9449,
    Dulux_VioletDream: 9450,
    Dulux_VioletJewel: 9451,
    Dulux_VioletKiss: 9452,
    Dulux_VioletMorning: 9453,
    Dulux_VioletNight: 9454,
    Dulux_VioletStorm: 9455,
    Dulux_VioletWhite: 9456,
    Dulux_VoileWhite: 9457,
    Dulux_WarmAlmond: 9458,
    Dulux_WarmFlax: 9459,
    Dulux_WarmFoliage: 9460,
    Dulux_WarmGrey: 9461,
    Dulux_WarmPewter: 9462,
    Dulux_WarmStraw: 9463,
    Dulux_WaterSky: 9464,
    Dulux_WaveBlue: 9465,
    Dulux_WaxedKhaki: 9466,
    Dulux_WaxedWood: 9467,
    Dulux_WeatheredCopper: 9468,
    Dulux_WeatheredGlass: 9469,
    Dulux_WeatheredPenny: 9470,
    Dulux_Wellbeing: 9471,
    Dulux_WelshFlint: 9472,
    Dulux_WelshStone: 9473,
    Dulux_White_BS4800: 9474,
    Dulux_WhiteCotton: 9475,
    Dulux_WhiteDaisy: 9476,
    Dulux_WhiteDew: 9477,
    Dulux_WhiteMist: 9478,
    Dulux_WhiteWhisper: 9479,
    Dulux_Wild_Wonder_COTY23: 9480,
    Dulux_WildBlackberry: 9481,
    Dulux_WildCactus: 9482,
    Dulux_WildEucalyptus: 9483,
    Dulux_WildMushroom: 9484,
    Dulux_WildPoppy: 9485,
    Dulux_WildPrimrose: 9486,
    Dulux_WildThyme: 9487,
    Dulux_WildWonder: 9488,
    Dulux_Willow: 9489,
    Dulux_WillowTree: 9490,
    Dulux_WillowTwig: 9491,
    Dulux_WiltshireWhite: 9492,
    Dulux_WinsomeLily: 9493,
    Dulux_WinterAvenue: 9494,
    Dulux_WinterBlue: 9495,
    Dulux_WinterPumkin: 9496,
    Dulux_WinterRabbit: 9497,
    Dulux_WintersNight: 9498,
    Dulux_WintersSky: 9499,
    Dulux_WintersWell: 9500,
    Dulux_WiseDiamond: 9501,
    Dulux_WishboneWhite: 9502,
    Dulux_WisteriaCascade: 9503,
    Dulux_WoadWalk: 9504,
    Dulux_Woodash: 9505,
    Dulux_WoodedSolace: 9506,
    Dulux_WoodedWalk: 9507,
    Dulux_WoodlandMink: 9508,
    Dulux_WoodlandMist: 9509,
    Dulux_WoodlandTrail: 9510,
    Dulux_WovenHemp: 9511,
    Dulux_WovenNest: 9512,
    Dulux_WovenWillow: 9513,
    Dulux_WritersDesk: 9514,
    Dulux_WyomingGrass: 9515,
    Dulux_YorkWhite: 9516,
    Dulux_ZanzibarDream: 9517,
    Dulux_ZingyLime: 9518,
  },
  DunnEdwards: {
    DunnEdwards_Sahara: 1983,
  },
  DuraSeal_Stains: {
    DS_Stain_Jacobean: 11069,
    DS_Stain_RusticBeige: 10679,
    DS_Stain_WeatheredOak: 10634,
  },
  FloridaPaints: {
    FP_0006_LittleDove: 11070,
    FP_0017_LunaMoon: 11071,
    FP_0019_MysticFog: 11072,
    FP_0024_JustAboutWhite: 11073,
    FP_0190_VillageCrier: 11074,
    FP_0194_AugustMoon: 11075,
    FP_0199_SandyShoes: 11076,
    FP_0200_StonyField: 11077,
    FP_0211_LightLichen: 11078,
    FP_0214_Wildwood: 11079,
    FP_0230_HarrowGate: 11080,
    FP_0279_GardenCountry: 11081,
    FP_0355_TwinkleTwinkle: 11082,
    FP_0371_Fiorito: 11083,
    FP_0435_BigFish: 11084,
    FP_0442_Dowager: 11085,
    FP_0455_FavoredOne: 11086,
    FP_0464_KathleensGarden: 11087,
    FP_0471_MiracleBay: 11088,
    FP_0472_Micropolis: 11089,
    FP_0486_ParadiseCity: 11090,
    FP_0487_DeepSpace: 11091,
    FP_0490_BeaconFog: 11092,
    FP_0491_SmokyDay: 11093,
    FP_0494_DarkRiver: 11094,
    FP_0495_Breakwaters: 11095,
    FP_0497_RestfulRetreat: 11096,
    FP_0499_OceanMelody: 11097,
    FP_0507_DeepLagoon: 11098,
    FP_0510_SacredSpring: 11099,
    FP_0511_Cystern: 11100,
    FP_0514_Thunderstorm: 11101,
    FP_0515_SilentSea: 11102,
    FP_0523_Felicity: 11103,
    FP_0525_Marseilles: 11104,
    FP_0527_LondonRoad: 11105,
    FP_0528_Greybeard: 11337,
    FP_0529_BlackLicorice: 11106,
    FP_0530_Metro: 11107,
    FP_0539_PlaceOfDust: 11108,
    FP_0540_PraiseGiving: 11109,
    FP_0542_CaptainNemo: 11110,
    FP_0546_Paternoster: 11111,
    FP_0558_QueenAnnesLace: 11112,
    FP_0560_Awakening: 11113,
    FP_0562_SultryCastle: 11114,
    FP_0565_ElkSkin: 11115,
    FP_0572_PowerLunch: 11116,
    FP_0574_SharkFin: 11117,
    FP_0579_TurkishTower: 11118,
    FP_0581_Fossilized: 11119,
    FP_0582_PavedPath: 11120,
    FP_0584_TornadoWind: 11121,
    FP_0585_OysterCatch: 11122,
    FP_0599_FloridaWaters: 11123,
    FP_0600_MeltingGlacier: 11124,
    FP_0633_CapeCodBay: 11125,
    FP_0703_MountainMeadows: 11126,
    FP_0820_SignOfTheCrown: 11127,
    FP_1037_TrumpetFlower: 11128,
    FP_1039_PrettyParasol: 11129,
    FP_1229_EleanorAnn: 11130,
    FP_BenningtonGray: 11131,
    FP_Black: 11132,
    FP_DoveWing: 11133,
    FP_GreyCloud: 11134,
    FP_NavajoWhite: 11135,
    FP_R001_SlightlyHued: 11136,
    FP_R002_TipOfTheIceberg: 11137,
    FP_R003_SkiersView: 11138,
    FP_R005_FreshenedUp: 11139,
    FP_R008_SnowWhite: 11140,
    FP_R011_WhitePepper: 11141,
    FP_R018_CoalBlack: 11142,
    FP_R020_OnTheRoad: 11143,
    FP_R022_InTheDark: 11338,
    FP_R023_SpaceDive: 11144,
    FP_R034_WhiskeyBarrel: 11145,
    FP_R036_CaffeAmericana: 11146,
    FP_R045_AgedCedar: 11147,
    FP_R052_DurumWheat: 11148,
    FP_R055_Glacier: 11149,
    FP_R061_SilverShine: 11150,
    FP_R069_OnTheRocks: 11151,
    FP_R070_Artifact: 11152,
    FP_R071_FallenFir: 11153,
    FP_R072_RavenGrass: 11154,
    FP_R073_DuskCloud: 11155,
    FP_R074_DriedHydrangea: 11156,
    FP_R075_ShadyPier: 11157,
    FP_R076_FreshWater: 11158,
    FP_R078_LagoonLullaby: 11159,
    FP_R079_WinterAir: 11160,
    FP_R081_WhaleMigration: 11161,
    FP_R082_SpruceShadow: 11162,
    FP_R090_DarkAges: 11163,
    FP_R092_Ebb: 11164,
    FP_R095_MidnightSurf: 11165,
    FP_R100_WabiSabi: 11166,
    FP_R101_DeepWell: 11167,
    FP_R102_Chance: 11168,
    FP_R106_Violaceous: 11169,
    FP_R114_Mulberry: 11170,
    FP_R119_AfterParty: 11171,
    FP_R120_MissionFig: 11172,
    FP_ShadowGray: 11173,
    FP_StoneHarbor: 11174,
  },
  FoundrySiding: {
    Foundry_ArizonaClay_891: 4600,
    Foundry_Cocoa_248: 4601,
    Foundry_ColonialGrey_837: 4602,
    Foundry_DeepGranite_692: 4603,
    Foundry_Denim_888: 4604,
    Foundry_EasternGrey_258: 4605,
    Foundry_Eggshell_034: 4606,
    Foundry_ForestGreen_152: 4607,
    Foundry_GoldenStraw_816: 4608,
    Foundry_GraySkies_907: 4609,
    Foundry_HarvestWheat_832: 4610,
    Foundry_Ironstone_672: 4611,
    Foundry_LightMoss_112: 4612,
    Foundry_LiteKhaki_095: 4613,
    Foundry_MarineBlue_908: 4614,
    Foundry_MidnightCloud_889: 4615,
    Foundry_ModernSlate_941: 4616,
    Foundry_Moonlight_017: 4617,
    Foundry_MoonRock_836: 4618,
    Foundry_MusketBrown_594: 4619,
    Foundry_Oatmeal_069: 4620,
    Foundry_Oceanside_202: 4621,
    Foundry_ReclaimedCedar_890: 4622,
    Foundry_RedCedar_844: 4623,
    Foundry_Russet_278: 4624,
    Foundry_RusticBrown_838: 4625,
    Foundry_RusticCedar_819: 4626,
    Foundry_Sahara_048: 4627,
    Foundry_Sandalwood_831: 4628,
    Foundry_Shadow_008: 4629,
    Foundry_SmokeGrey_528: 4630,
    Foundry_Snow_123: 4631,
    Foundry_VanillaBean_814: 4632,
    Foundry_VintageTaupe_830: 4633,
  },
  Garaga: {
    Garaga_Almond: 2615,
    Garaga_Black: 2616,
    Garaga_BlackIce: 2617,
    Garaga_Brown: 2618,
    Garaga_Charcoal: 2619,
    Garaga_Claystone: 2620,
    Garaga_DarkSand: 2621,
    Garaga_DesertSand: 2622,
    Garaga_Evergreen: 2623,
    Garaga_IceWhite: 2624,
    Garaga_MokaBrown: 2625,
    Garaga_Sahara: 2626,
    Garaga_Sandstone: 2627,
    Garaga_Terrastone: 2628,
    Garaga_White: 2629,
  },
  Garage_Amarr: {
    Amarr_Almond: 6562,
    Amarr_Black: 6563,
    Amarr_CharcoalGray: 6564,
    Amarr_DarkBrown: 6565,
    Amarr_Sandtone: 6566,
    Amarr_Terratone: 6567,
    Amarr_TrueWhite: 6568,
    Amarr_WickerTan: 6569,
  },
  Garage_Clopay: {
    Almond: 10475,
    Beige: 10476,
    Black: 10477,
    Bronze: 10478,
    Brown: 10479,
    Burgundy: 10480,
    Charcoal: 10582,
    ChocolateBrown: 10481,
    Clay: 10482,
    DesertTan: 10483,
    Gray: 10484,
    HunterGreen: 10485,
    MochaBrown: 11339,
    NavyBlue: 10486,
    NewEnglandBlue: 10487,
    RusticRed: 10488,
    Sandtone: 10489,
    Taupe: 10490,
    Vanilla: 10491,
    White: 10492,
  },
  Garage_Colors: {
    GarageTaupe: 235,
    GarageWhite: 236,
    GarageWhiteMist: 1800,
  },
  Garage_DoorLink: {
    Garage_DoorLink_Almond: 10870,
    Garage_DoorLink_Black: 10871,
    Garage_DoorLink_Gray: 10872,
    Garage_DoorLink_White: 10873,
  },
  Garage_GeneralDoors: {
    Almond: 4643,
    ArticWhite: 4644,
    Black: 4645,
    Bronze: 4646,
    Brown: 4647,
    Cafe: 4648,
    DesertTan: 4649,
    Gray: 4650,
    Sandtone: 4651,
  },
  Garage_Hormann: {
    Hormann_Almond: 6482,
    Hormann_Black: 6483,
    Hormann_Brown: 6484,
    Hormann_DesertTan: 6485,
    Hormann_HunterGreen: 6486,
    Hormann_Sandstone: 6487,
    Hormann_Teratone: 6488,
    Hormann_White: 6489,
  },
  Garage_Martin: {
    Martin_Bronze: 10798,
    Martin_CarbonBlack: 10799,
    Martin_DarkBrown: 10800,
    Martin_DesertTaupe: 10801,
    Martin_LightAlmond: 10802,
    Martin_WhiteMist: 10803,
  },
  Garage_OverheadDoor: {
    Overhead_Almond: 10661,
    Overhead_Black: 10662,
    Overhead_Brown: 10663,
    Overhead_DesertTan: 10664,
    Overhead_ForestGreen: 10665,
    Overhead_Gray: 10666,
    Overhead_Sandstone: 10667,
    Overhead_TerraBronze: 10668,
    Overhead_White: 10669,
  },
  Garage_Windsor: {
    Windsor_Almond: 10956,
    Windsor_Black: 10957,
    Windsor_Brown: 10962,
    Windsor_DesertTan: 10963,
    Windsor_PolarWhite: 10958,
    Windsor_Sandstone: 10959,
    Windsor_SlateGray: 10964,
    Windsor_TerraBronze: 10965,
  },
  GeorgiaPacific: {
    GP_Almond: 11176,
    GP_ClayPlus: 11177,
    GP_Cream: 11178,
    GP_Gray: 11179,
    GP_Mist: 11180,
    GP_Olive: 11181,
    GP_Pearl: 11182,
    GP_Tan: 11183,
    GP_White: 11184,
  },
  Glidden: {
    Glidden_A0110_MountainMist: 1835,
    Glidden_A0129_WintersDay: 1836,
    Glidden_A0298_MochaTreat: 1837,
    Glidden_A0413_FudgeCookie: 1838,
    Glidden_A0443_Embrace: 1839,
    Glidden_A0551_Sonora: 1840,
    Glidden_A0577_Peachlight: 1841,
    Glidden_A0741_Bentwood: 1842,
    Glidden_A0744_LuminaryYellow: 1843,
    Glidden_A0752_SandDune: 1844,
    Glidden_A0863_EloquentIvory: 1845,
    Glidden_A0865_BellcourtCastle: 1846,
    Glidden_A0950_ArtichokeLeaf: 1847,
    Glidden_A0980_PlantationGreen: 1848,
    Glidden_A1134_StWilliamsStreet: 1849,
    Glidden_A1228_BermudaPool: 1850,
    Glidden_A1416_FinnishBlue: 1851,
    Glidden_A1441_MoonlightDrive: 1852,
    Glidden_A1813_ThatchedCottage: 1853,
    Glidden_A1817_Camelcoat: 1854,
    Glidden_A1826_DeaconsBench: 1855,
    Glidden_A1827_HaleVillage: 1856,
    Glidden_A1836_FossilGrey: 1857,
    Glidden_A1844_Manuscript: 1858,
    Glidden_A1848_OliveBrown: 1859,
    Glidden_A1868_KingsCanyonGrey: 1860,
    Glidden_A1892_MillersCove: 1861,
    Glidden_A1908_Etching: 1862,
    Glidden_A1924_Bicentennial: 1863,
    Glidden_A1945_GreatGrey: 1864,
    Glidden_A1952_MysterySound: 1865,
    Glidden_A2014_ObsidianGlass: 1866,
    Glidden_PPG0998_7_Undercover: 1984,
    Glidden_PPG1001_7_BlackMagic: 1985,
    Glidden_PPG1006_1_Gypsum: 1986,
    Glidden_PPG1006_2_Shark: 1987,
    Glidden_PPG1006_3_EarlyEvening: 1988,
    Glidden_PPG1007_4_HotStone: 1989,
    Glidden_PPG1007_6_CoolCharcoal: 1990,
    Glidden_PPG1010_6_UpInSmoke: 1991,
    Glidden_PPG1023_4_DesertDune: 1992,
    Glidden_PPG1024_4_MothGray: 1993,
    Glidden_PPG1025_1_CommercialWhite: 1994,
    Glidden_PPG1033_4_LightDrizzle: 1995,
    Glidden_PPG1041_7_Cavalry: 1996,
    Glidden_PPG1074_7_LittleBear: 1997,
  },
  Grout_ProVia: {
    Black: 10470,
    Brown: 10471,
    Buff: 10472,
    Gray: 10473,
    White: 10474,
  },
  GutterHelp: {
    Almond_140: 2132,
    Almond_794: 2133,
    AlmondCream_219: 2134,
    AntiqueIvory_105: 2135,
    AutumnLeaf_560: 2136,
    Black_200: 2137,
    Buckskin_224: 2138,
    Buckskin_841: 2139,
    Cactus_200: 2140,
    Champagne_827: 2141,
    Clay_238: 2142,
    Clay_807: 2143,
    Coppertone_780: 2144,
    CozyCottage_604: 2145,
    Cranberry_820: 2146,
    Cream_817: 2147,
    DarkBronze_339: 2148,
    DarkGray_301: 2149,
    DesertTan_327: 2150,
    EldridgeGray_605: 2151,
    ForestGreen_522: 2152,
    Galvalume_700: 2153,
    Granite_204: 2154,
    GrecianGreen_204: 2155,
    Heather_111: 2156,
    Herringbone_819: 2157,
    ImperialBrown_223: 2158,
    Ivory_901: 2159,
    IvyGreen_821: 2160,
    LightBronze_253: 2161,
    LightMaple_335: 2162,
    Linen_002: 2163,
    LowGlossWhite_130: 2164,
    Mocha_507: 2165,
    MusketBrown_250: 2166,
    Navy_521: 2167,
    Norwood_791: 2168,
    OliveGreen_173: 2169,
    PacificBlue_822: 2170,
    PearlGray_102: 2171,
    Pewter_175: 2172,
    Pewter_801: 2173,
    PrairieSand_538: 2174,
    RoyalBrown_202: 2175,
    Sable_538: 2176,
    Sand_793: 2177,
    SandstoneBeige_325: 2178,
    SandyBeige_177: 2179,
    ScotchRed_209: 2180,
    Shale_810: 2181,
    Shell_138: 2182,
    Snowmist_523: 2183,
    Sun_108: 2184,
    Terratone_360: 2185,
    Terratone_511: 2186,
    TuxedoGray_112: 2187,
    Wicker_712: 2188,
    Wicker_713: 2189,
    Wineberry_604: 2190,
    WoodlandGreen_214: 2191,
  },
  HaasDoor: {
    Almond: 2094,
    Bronze: 2095,
    Brown: 2096,
    CarbonBlack: 2097,
    Charcoal: 2098,
    EnglishOak: 10783,
    Espresso: 10784,
    Gray: 2099,
    Mahogany: 10785,
    PolarWhite: 2100,
    Sandstone: 2101,
    Walnut: 10869,
  },
  Harris: {
    Harris_H0052_SaxonBlue: 10988,
  },
  JamesHardie: {
    JH_1020_ArcticWhite: 249,
    JH_1030_WoodlandCream: 1925,
    JH_1520_TerraCotta: 1926,
    JH_2010_SailCloth: 1927,
    JH_2020_AutumnTan: 1928,
    JH_2030_KhakiBrown: 253,
    JH_2040_WinslowTaupe: 1929,
    JH_2520_CoralCoast: 1930,
    JH_3010_NavajoBeige: 256,
    JH_3020_SandstoneBeige: 1931,
    JH_3030_WoodstockBrown: 1932,
    JH_3520_AquaMarine: 1933,
    JH_4010_Cobblestone: 209,
    JH_4015_PearlGray: 211,
    JH_4020_MontereyTaupe: 210,
    JH_4030_TimberBark: 226,
    JH_4040_PebbleBrown: 1934,
    JH_4520_CoolBreeze: 1935,
    JH_5010_AlpineFrost: 1936,
    JH_5020_HeatheredMoss: 258,
    JH_5030_MountainSage: 255,
    JH_5520_PinkSand: 1937,
    JH_6010_SoftGreen: 1938,
    JH_6030_ParksidePine: 1939,
    JH_6040_ForestPine: 1940,
    JH_7010_LightMist: 254,
    JH_7020_BoothbayBlue: 203,
    JH_7030_EveningBlue: 250,
    JH_7040_OceanBlue: 1941,
    JH_7050_DeepOcean: 1942,
    JH_7090_GraySlate: 251,
    JH_8010_HarrisCream: 1943,
    JH_8020_TuscanGold: 1944,
    JH_8030_ChestnutBrown: 1945,
    JH_8070_RichEspresso: 1748,
    JH_8080_MulberryWine: 1946,
    JH_9010_TraditionalRed: 1947,
    JH_9020_CountrylaneRed: 1948,
    JH_9030_IronGray: 252,
    JH_9060_AgedPewter: 225,
    JH_9080_NightGray: 257,
    JH_CanyonClay: 1949,
    JH_CoastalFog: 10510,
    JH_FarmhouseWhite: 10508,
    JH_GraniteGrey: 1950,
    JH_IndustrialGray: 6494,
    JH_IronGray: 10583,
    JH_LostInGray: 6495,
    JH_Mag_BirchTree: 4471,
    JH_Mag_ChiseledGreen: 4472,
    JH_Mag_DriedEucalyptus: 4473,
    JH_Mag_ItsAboutThyme: 4474,
    JH_Mag_LastEmbers: 4475,
    JH_Mag_MidnightSoot: 4476,
    JH_Mag_Mudflats: 4477,
    JH_Mag_PepperyAsh: 4478,
    JH_Mag_RuggedPath: 4479,
    JH_Mag_RusticRoad: 4480,
    JH_Mag_SlateSteps: 4481,
    JH_Mag_StoneBeach: 4482,
    JH_Mag_StonePaver: 4483,
    JH_Mag_WanderingGreen: 4484,
    JH_Mag_WarmClay: 4485,
    JH_Mag_WeatheredCliffs: 4486,
    JH_MidnightBlack: 10464,
    JH_ShadowedWhite: 10507,
    JH_SierraBrown: 1951,
    JH_Statement_SmokeCanyon: 11318,
    JH_Woodtone_AspenRidge: 10397,
    JH_Woodtone_BlackCanyon: 10398,
    JH_Woodtone_CaribouTrails: 10399,
    JH_Woodtone_CascadeSlate: 10400,
    JH_Woodtone_CoastalGray: 10401,
    JH_Woodtone_MidnightTide: 10402,
    JH_Woodtone_MountainCedar: 10403,
    JH_Woodtone_OldCherry: 10404,
    JH_Woodtone_RiverRock: 10405,
    JH_Woodtone_RoastedWalnut: 10406,
    JH_Woodtone_Rosewood: 10407,
    JH_Woodtone_SandCastle: 10408,
    JH_Woodtone_StoneBlue: 10409,
    JH_Woodtone_SummerWheat: 10410,
    JH_Woodtone_WarmEspresso: 10411,
    JH_Woodtone_WhiteGranite: 10412,
    JH_Woodtone_WhiteRapids: 10413,
    JH_Woodtone_WinchesterBrown: 10414,
    JH_ZenBlue: 10509,
  },
  KellyMoore: {
    KM_407_Carbon: 2031,
    KM_417_OxfordBrown: 2032,
    KM_4903_ZincDust: 2033,
    KM_49681_ArcticWhite: 227,
    KM_5825_NotMyFault: 2034,
    KM_5826_VolcanicRock: 2035,
    KM_A81_EveningCityscape: 2036,
    KM_HLS4202_FrankLloydWhite: 2037,
    KM_HLS4208_WoosterSmoke: 2038,
    KM_W43_WhitestWhite: 2039,
  },
  Lonestar: {
    Lonestar_Black: 37,
    Lonestar_Linen: 38,
    Lonestar_TuxedoGray: 39,
  },
  LP_SmartSide: {
    LP_AbyssBlack: 1776,
    LP_CanyonBrown: 1777,
    LP_CavernSteel: 1778,
    LP_DesertStone: 1779,
    LP_GardenSage: 6514,
    LP_HarvestHoney: 6515,
    LP_MarshlandMoss: 1780,
    LP_MidnightShadow: 6516,
    LP_PrairieClay: 1781,
    LP_QuarryGray: 1782,
    LP_RapidsBlue: 1783,
    LP_RedwoodRed: 1784,
    LP_SandDunes: 1785,
    LP_ShorelineCream: 1786,
    LP_SnowscapeWhite: 1787,
    LP_SummitBlue: 1788,
    LP_TerraBrown: 1789,
    LP_TimberlandSuede: 1790,
    LP_TundraGray: 1791,
  },
  Masonite: {
    Masonite_Black: 4493,
    Masonite_Blue: 4494,
    Masonite_Brown: 4495,
    Masonite_Gray: 4496,
    Masonite_Red: 4497,
    Masonite_White: 4498,
  },
  McCormick: {
    McCormick_0027_WhiteFence: 10989,
    McCormick_0144_FilmNoir: 10990,
    McCormick_0186_ChristmasOrnament: 10991,
    McCormick_0214_Wildwood: 10992,
    McCormick_0221_BrownSuede: 10993,
    McCormick_0225_RomanRuins: 10994,
    McCormick_0233_DeepMarsh: 10563,
    McCormick_0336_SoftLeather: 10995,
    McCormick_0418_OnionSkin: 10564,
    McCormick_0422_EverlastingSage: 10565,
    McCormick_0423_EyeOfTheStorm: 10996,
    McCormick_0441_SlateStone: 10997,
    McCormick_0449_CannonBall: 10998,
    McCormick_0455_DeepShadow: 10573,
    McCormick_0479_StairwayToHeaven: 10999,
    McCormick_0480_DeepSeaShadow: 11000,
    McCormick_0487_DeepSpace: 11001,
    McCormick_0501_CalmInterlude: 11002,
    McCormick_0515_SilentSea: 11003,
    McCormick_0527_LondonRoad: 11004,
    McCormick_0528_Greybeard: 11005,
    McCormick_0543_NovemberStorms: 11006,
    McCormick_0557_Evermore: 11007,
    McCormick_0563_Vigilant: 11008,
    McCormick_0570_GreyLocks: 11009,
    McCormick_0573_Chintz: 11010,
    McCormick_0578_PhilosophicallySpeaking: 11011,
    McCormick_0579_TurkishTower: 11012,
    McCormick_0583_BillowingSmoke: 11017,
    McCormick_0634_DaySpa: 11013,
    McCormick_100_SuperWhite: 11014,
    McCormick_132_OceanPines: 10574,
    McCormick_200_Black: 10575,
    McCormick_202_FoxhallGreen: 10576,
    McCormick_215_CobblestoneGrey: 10577,
    McCormick_216_Hearthstone: 10578,
    McCormick_217_FarmhouseRed: 10579,
    McCormick_220_GeorgetownGreen: 10580,
    McCormick_227_Williamsburg: 10581,
    McCormick_470_SmokeyPewter: 11015,
    McCormick_488_FederalHill: 10566,
    McCormick_MAG008_TrueWhite: 10567,
  },
  Metal_ABC: {
    Metal_ABC_Almond: 10346,
    Metal_ABC_AshGray: 10347,
    Metal_ABC_BoneWhite: 10348,
    Metal_ABC_BrightWhite: 10349,
    Metal_ABC_BriteRed: 10350,
    Metal_ABC_Brownstone: 10351,
    Metal_ABC_BurnishedSlate: 10352,
    Metal_ABC_CharcoalGray: 10353,
    Metal_ABC_ClassicGreen: 10354,
    Metal_ABC_CobaltBlue: 10355,
    Metal_ABC_CoffeeBrown: 10356,
    Metal_ABC_ColonialRed: 10357,
    Metal_ABC_CopperMetallic: 10358,
    Metal_ABC_DeepGray: 10359,
    Metal_ABC_DesertSand: 10360,
    Metal_ABC_Evergreen: 10361,
    Metal_ABC_Galvalume: 10362,
    Metal_ABC_HarborBlue: 10363,
    Metal_ABC_HawaiianBlue: 10364,
    Metal_ABC_HighGlossWhite: 10365,
    Metal_ABC_IvyGreen: 10366,
    Metal_ABC_LightStone: 10367,
    Metal_ABC_MediumBronze: 10368,
    Metal_ABC_MidnightBlack: 10369,
    Metal_ABC_MidnightBronze: 10370,
    Metal_ABC_PacificBlue: 10371,
    Metal_ABC_PolarWhite: 10372,
    Metal_ABC_RusticRed: 10373,
    Metal_ABC_SaddleTan: 10374,
    Metal_ABC_ScarletRed: 10375,
    Metal_ABC_SlateGray: 10376,
    Metal_ABC_SnowWhite: 10377,
    Metal_ABC_StormGray: 10378,
    Metal_ABC_TrueBlack: 10379,
    Metal_ABC_Tundra: 10380,
    Metal_ABC_White: 10381,
    Metal_ABC_WineRed: 10382,
  },
  Metal_ACM: {
    Metal_ACM_Black: 10874,
    Metal_ACM_Frost: 10875,
  },
  Metal_AE: {
    Metal_AE_AshGray: 10744,
    Metal_AE_Berry: 10745,
    Metal_AE_Black: 10746,
    Metal_AE_BrightRed: 10747,
    Metal_AE_BurnishedSlate: 10748,
    Metal_AE_CharcoalGray: 10749,
    Metal_AE_DesertSand: 10750,
    Metal_AE_Evergreen: 10751,
    Metal_AE_GalleryBlue: 10752,
    Metal_AE_HawaiianBlue: 10753,
    Metal_AE_HunterGreen: 10754,
    Metal_AE_Ivory: 10755,
    Metal_AE_KokoBrown: 10756,
    Metal_AE_LightStone: 10757,
    Metal_AE_MetallicCopper: 10758,
    Metal_AE_PolarWhite: 10759,
    Metal_AE_RusticRed: 10760,
    Metal_AE_SaddleTan: 10761,
  },
  Metal_AFCORail: {
    Metal_AFCORail_Black: 11185,
    Metal_AFCORail_Bronze: 11186,
    Metal_AFCORail_Brown: 11187,
    Metal_AFCORail_Clay: 11188,
    Metal_AFCORail_White: 11189,
    Metal_AFCORail_Wicker: 11190,
  },
  Metal_Amerimax: {
    Metal_Amerimax_White: 11175,
  },
  Metal_ASC: {
    ASC_ColonialRed: 10681,
    ASC_DarkBronze: 10682,
    ASC_ForestGreen: 10683,
    ASC_LeafGreen: 10684,
    ASC_MatteBlack: 10685,
    ASC_MidnightBronze: 10686,
    ASC_OldTownGray: 10687,
    ASC_Parchment: 10688,
    ASC_Pebble: 10689,
    ASC_RegalBlue: 10690,
    ASC_RegalWhite: 10691,
    ASC_SageGreen: 10692,
    ASC_SierraTan: 10693,
    ASC_SlateGray: 10694,
    ASC_TahoeBlue: 10695,
    ASC_TerraCotta: 10696,
    ASC_Vintage: 10697,
    ASC_Walnut: 10698,
    ASC_WeatheredCopper: 10699,
    ASC_ZincGray: 10700,
  },
  Metal_BandA: {
    BandA_BarnRed: 11425,
    BandA_Black: 11426,
    BandA_BrightWhite: 11427,
    BandA_Brown: 11428,
    BandA_Burgundy: 11429,
    BandA_BurnishedSlate: 11430,
    BandA_Charcoal: 11431,
    BandA_Clay: 11432,
    BandA_CopperPenny: 11433,
    BandA_DarkRed: 11434,
    BandA_Evergreen: 11435,
    BandA_GalleryBlue: 11436,
    BandA_Gray: 11437,
    BandA_HawaiianBlue: 11438,
    BandA_InteriorWhite: 11439,
    BandA_LightStone: 11440,
    BandA_Tan: 11441,
  },
  Metal_BerridgeColors: {
    AgedBronze: 2048,
    Almond: 2049,
    AwardBlue: 2050,
    BristolBlue: 2051,
    Buckskin: 2052,
    Burgundy: 2053,
    CharcoalGrey: 2054,
    CityScape: 2055,
    ColonialRed: 2056,
    CopperBrown: 2057,
    DarkBronze: 2058,
    DeepRed: 2059,
    Evergreen: 2060,
    ForestGreen: 2061,
    HartfordGreen: 2062,
    HemlockGreen: 2063,
    MatteBlack: 2064,
    MediumBronze: 2065,
    NaturalWhite: 2066,
    Parchment: 2067,
    PatinaGreen: 2068,
    RoyalBlue: 2069,
    ShastaWhite: 2070,
    SierraTan: 2071,
    TealGreen: 2072,
    TerraCotta: 2073,
    ZincGrey: 2074,
  },
  Metal_CascadiaMetals: {
    CM_AntiqueLinen: 11367,
    CM_ApplianceWhite: 11368,
    CM_Black: 11369,
    CM_BoneWhite: 11370,
    CM_BriarwoodTan: 11371,
    CM_BrightRed: 11372,
    CM_BrightWhite: 11373,
    CM_Buckskin: 11374,
    CM_Burgundy: 11375,
    CM_CambridgeWhite: 11376,
    CM_Cashmere: 11377,
    CM_Charcoal: 11378,
    CM_CoffeeBrown: 11379,
    CM_DarkBrown: 11380,
    CM_DarkGraphite: 11381,
    CM_DarkGreen: 11382,
    CM_DarkRed: 11383,
    CM_DeepWaterGreen: 11384,
    CM_ForestGreen: 11385,
    CM_Gold: 11386,
    CM_HeronBlue: 11387,
    CM_IronOre: 11388,
    CM_LabradorBlue: 11389,
    CM_MelchersGreen: 11390,
    CM_MetroBrown: 11391,
    CM_MistGreen: 11392,
    CM_PacificTurquoise: 11393,
    CM_Pebblestone: 11394,
    CM_PolarWhite: 11395,
    CM_RegentGrey: 11396,
    CM_RoyalBlue: 11397,
    CM_SageGreen: 11398,
    CM_SapphireBlue: 11399,
    CM_SlateBlue: 11400,
    CM_SpruceGreen: 11401,
    CM_StoneGrey: 11402,
    CM_SurfWhite: 11403,
    CM_Tan: 11404,
    CM_TileRed: 11405,
    CM_Turquoise: 11406,
    CM_WhiteWhite: 11407,
    CM_Wicker: 11408,
  },
  Metal_CentralStatesColors: {
    CS_Alamo: 4499,
    CS_Basil: 4500,
    CS_Black: 4501,
    CS_Brilliant: 4502,
    CS_Brown: 4503,
    CS_Burgundy: 4504,
    CS_BurnishedSlate: 4505,
    CS_Charcoal: 4506,
    CS_Colony: 4507,
    CS_CopperMetallic: 4508,
    CS_CovertGreen: 4509,
    CS_Cream: 4510,
    CS_Crimson: 4511,
    CS_CrimsonRed: 4512,
    CS_DarkBrown: 4513,
    CS_DeepRed: 4514,
    CS_Desert: 4515,
    CS_Forest: 4516,
    CS_Gallery: 4517,
    CS_Granite: 4518,
    CS_GraniteClay: 4519,
    CS_Gray: 4520,
    CS_HickoryMoss: 4521,
    CS_Hunter: 4522,
    CS_Ivory: 4523,
    CS_LightStone: 4524,
    CS_Linen: 4525,
    CS_LunarGray: 4526,
    CS_Mineral: 4527,
    CS_Ocean: 4528,
    CS_Onyx: 4529,
    CS_Pewter: 4530,
    CS_Polar: 4531,
    CS_Roma: 4532,
    CS_Rustic: 4533,
    CS_Sienna: 4534,
    CS_Sierra: 4535,
    CS_Suede: 4536,
    CS_Sumatra: 4537,
    CS_Tan: 4538,
    CS_Taupe: 4539,
    CS_TrueBlack: 4540,
  },
  Metal_CMG: {
    CMG_Almond: 11266,
    CMG_AntiqueIvory: 11267,
    CMG_AshGray: 11268,
    CMG_BoneWhite: 11269,
    CMG_BrightWhite: 11270,
    CMG_Burgundy: 11271,
    CMG_BurnishedSlate: 11272,
    CMG_CharcoalGray: 11273,
    CMG_Cityscape: 11274,
    CMG_ClassicGreen: 11275,
    CMG_ColonialRed: 11276,
    CMG_DarkBronze: 11277,
    CMG_DeepBlack: 11222,
    CMG_ExtraDarkBronze: 11278,
    CMG_HartfordGreen: 11279,
    CMG_HemlockGreen: 11280,
    CMG_MansardBrown: 11281,
    CMG_MatteBlack: 10966,
    CMG_MediumBronze: 11282,
    CMG_MusketGray: 11283,
    CMG_PebbleClay: 11284,
    CMG_RegalRed: 11285,
    CMG_RoyalBlue: 11286,
    CMG_Sandstone: 11287,
    CMG_SierraTan: 11288,
    CMG_SlateBlue: 11289,
    CMG_SlateGray: 11290,
    CMG_StoneWhite: 11291,
    CMG_Teal: 11292,
    CMG_TerraCotta: 11293,
  },
  Metal_ColorKlad: {
    ColorKlad_AgedCopper: 11294,
    ColorKlad_Almond: 11295,
    ColorKlad_AshGray: 11296,
    ColorKlad_BannerRed: 11297,
    ColorKlad_Black: 11298,
    ColorKlad_BoneWhite: 11299,
    ColorKlad_CharcoalGray: 10924,
    ColorKlad_ClassicGreen: 11300,
    ColorKlad_ColonialRed: 11301,
    ColorKlad_DarkBronze: 11302,
    ColorKlad_DoveGray: 11303,
    ColorKlad_HartfordGreen: 11304,
    ColorKlad_MansardBrown: 11305,
    ColorKlad_MediumBronze: 11306,
    ColorKlad_MusketGray: 11307,
    ColorKlad_PatinaGreen: 11308,
    ColorKlad_RegalWhite: 11309,
    ColorKlad_RoyalBlue: 11310,
    ColorKlad_Sandstone: 11311,
    ColorKlad_SierraTan: 11312,
    ColorKlad_SlateBlue: 11313,
    ColorKlad_SlateGray: 11314,
    ColorKlad_Snowdrift: 11315,
    ColorKlad_StoneWhite: 11316,
    ColorKlad_TerraCotta: 11317,
  },
  Metal_Colors: {
    BurnishedSlate: 4470,
    Charcoal: 178,
    Kabul: 247,
    OldLavender: 248,
    Slate: 179,
    White: 183,
  },
  Metal_DrexelColors: {
    Drexel_AgedBronze: 10511,
    Drexel_Almond: 10512,
    Drexel_AntiqueBronze: 10513,
    Drexel_Black: 10514,
    Drexel_BoneWhite: 10515,
    Drexel_Buckskin: 10516,
    Drexel_Burgundy: 10517,
    Drexel_BurnishedSlate: 10518,
    Drexel_Charcoal: 10519,
    Drexel_Cityscape: 10520,
    Drexel_ColonialRed: 10521,
    Drexel_CopperPenny: 10555,
    Drexel_DarkBronze: 10522,
    Drexel_Evergreen: 10523,
    Drexel_ForestGreen: 10524,
    Drexel_Graphite: 10525,
    Drexel_HartfordGreen: 10526,
    Drexel_HemlockGreen: 10527,
    Drexel_InterstateBlue: 10528,
    Drexel_IronOre: 10529,
    Drexel_MansardBrown: 10530,
    Drexel_MediumBronze: 10531,
    Drexel_MidnightBronze: 10532,
    Drexel_MilitaryBlue: 10533,
    Drexel_MusketGray: 10534,
    Drexel_Onyx: 10535,
    Drexel_PacificBlue: 10536,
    Drexel_PatinaGreen: 10537,
    Drexel_RegalWhite: 10538,
    Drexel_Sandstone: 10539,
    Drexel_SierraTan: 10540,
    Drexel_SlateGray: 10541,
    Drexel_StoneWhite: 10542,
    Drexel_Teal: 10543,
    Drexel_TerraCotta: 10544,
  },
  Metal_Englert: {
    Englert_CharcoalGray: 10568,
    Englert_DarkBronze: 10569,
    Englert_HartfordGreen: 10570,
    Englert_MatteBlack: 10571,
    Englert_MediumBronze: 10572,
    Englert_SlateGrey: 11016,
  },
  Metal_Everlast: {
    Almond: 10428,
    BoneWhite: 10429,
    Burgundy: 10430,
    BurnishedSlate: 10431,
    Charcoal: 10432,
    Cityscape: 10433,
    ClassicBronze: 10434,
    ColonialRed: 10435,
    DarkBronze: 10436,
    DarkGray: 10437,
    ForestGreen: 10438,
    GalleryBlue: 10439,
    HartfordGreen: 10440,
    MansardBrown: 10441,
    MatteBlack: 10442,
    MetallicChampagne: 10443,
    MetallicCopper: 10444,
    MetallicSilver: 10445,
    PatinaGreen: 10446,
    RegalRed: 10447,
    Sandstone: 10448,
    SierraTan: 10449,
    SlateBlue: 10450,
    SlateGray: 10451,
    StoneWhite: 10452,
    TerraCotta: 10453,
  },
  Metal_Fabral: {
    Fabral_Almond: 11341,
    Fabral_BoneWhite: 11342,
    Fabral_BrightSilverS66: 11343,
    Fabral_Charcoal: 11344,
    Fabral_ClassicGreen: 11345,
    Fabral_DarkBronze: 11346,
    Fabral_DoveGray: 11347,
    Fabral_MatteBlack: 11348,
    Fabral_MediumBronze: 11349,
    Fabral_RegalWhite: 11350,
    Fabral_Sandstone: 11351,
    Fabral_SlateGray: 11352,
    Fabral_SurreyBeige: 11353,
  },
  Metal_HomeRail: {
    HomeRail_Black: 11022,
    HomeRail_Linen: 11023,
    HomeRail_Sable: 11024,
    HomeRail_Silver: 11025,
    HomeRail_White: 11026,
    HomeRail_YardBronze: 11027,
  },
  Metal_JetMetals: {
    JM_AgedBronze: 11223,
    JM_AgedCopper: 11224,
    JM_Almond: 11225,
    JM_AntiqueBronze: 11226,
    JM_AwardBlue: 11227,
    JM_Black: 11228,
    JM_BoneWhite: 11229,
    JM_BuckSkin: 11230,
    JM_Burgundy: 11231,
    JM_CardinalRed: 11232,
    JM_Champagne: 11233,
    JM_Charcoal: 11234,
    JM_Cityscape: 11235,
    JM_ColonialRed: 11236,
    JM_CopperPenny: 11237,
    JM_DarkBronze: 11238,
    JM_ForestGreen: 11239,
    JM_Galvalume: 11240,
    JM_Granite: 11241,
    JM_HartfordGreen: 11242,
    JM_HemlockGreen: 11243,
    JM_InterstateBlue: 11244,
    JM_IronOre: 11245,
    JM_MansardBrown: 11246,
    JM_MediumBronze: 11247,
    JM_MidnightBronze: 11248,
    JM_MilitaryBlue: 11249,
    JM_MusketGray: 11250,
    JM_PacificBlue: 11251,
    JM_PatinaGreen: 11252,
    JM_Sandstone: 11253,
    JM_SierraTan: 11254,
    JM_Silver: 11255,
    JM_SlateGray: 11256,
    JM_StoneWhite: 11257,
    JM_Teal: 11258,
    JM_TerraCotta: 11259,
    JM_Zinc: 11260,
  },
  Metal_MBCI: {
    MBCI_TrueBlack: 10804,
  },
  Metal_McElroy: {
    McElroy_MatteBlack: 10642,
    McElroy_PatricianBronze: 10643,
    McElroy_Sandstone: 10644,
    McElroy_SlateGray: 10645,
  },
  Metal_MetalRoofingSystems: {
    MRS_DarkBronze: 10862,
    MRS_MatteBlack: 10863,
  },
  Metal_Mueller: {
    Mueller_CharcoalGray: 10636,
    Mueller_MatteBlack: 10637,
    Mueller_SilverMetallic: 10638,
  },
  Metal_PAC: {
    PAC_BlackAluminum: 10557,
    PAC_BoneWhite: 10558,
    PAC_Charcoal: 10559,
    PAC_DarkBronze: 10560,
    PAC_RegalWhite: 10561,
    PAC_StoneWhite: 10562,
  },
  Metal_ProSnap: {
    ProSnap_CharcoalGray: 10876,
  },
  Metal_ProVia: {
    ProVia_Briarwood: 10646,
    ProVia_Pepperwood: 10647,
    ProVia_Shadewood: 10648,
  },
  Metal_Scheffield: {
    Sheffield_AshGray: 10925,
    Sheffield_Burgundy: 10926,
    Sheffield_BurnishedSlate: 10927,
    Sheffield_CharcoalGray: 10928,
    Sheffield_ColonialRed: 10929,
    Sheffield_DarkBronze: 10930,
    Sheffield_DoveGray: 10931,
    Sheffield_Evergreen: 10932,
    Sheffield_HartfordGreen: 10933,
    Sheffield_HemlockGreen: 10934,
    Sheffield_MansardBrown: 10935,
    Sheffield_MatteBlack: 10936,
    Sheffield_MediumBronze: 10937,
    Sheffield_PatinaGreen: 10938,
    Sheffield_RegalBlue: 10939,
    Sheffield_RegalRed: 10940,
    Sheffield_RegalWhite: 10941,
    Sheffield_Sandstone: 10942,
    Sheffield_SierraTan: 10943,
    Sheffield_SlateBlue: 10944,
    Sheffield_SlateGray: 10945,
    Sheffield_SolarWhite: 10946,
    Sheffield_StoneWhite: 10947,
    Sheffield_SurreyBeige: 10948,
    Sheffield_TerraCotta: 10949,
  },
  Metal_SchellColors: {
    Champagne: 2026,
    CharcoalGray: 2027,
    MatteBlack: 2028,
    SilverMetallic: 2029,
    SlateBlue: 2030,
  },
  Metal_SpectraPro: {
    SpectraPro_Black: 11261,
    SpectraPro_Bronze: 11262,
    SpectraPro_ForestGreen: 11263,
    SpectraPro_LowGlossWhite: 11264,
    SpectraPro_MusketBrown: 11265,
  },
  Metal_WesternStatesColors: {
    PVDF_Almond: 4432,
    PVDF_AshGray: 4433,
    PVDF_BoneWhite: 4434,
    PVDF_BurnishedSlate: 4435,
    PVDF_Champagne: 4436,
    PVDF_CharcoalGray: 4437,
    PVDF_ClassicGreen: 4438,
    PVDF_ColonialRed: 4439,
    PVDF_CopperPenny: 4440,
    PVDF_DarkBronze: 4441,
    PVDF_DesertTan: 4442,
    PVDF_DolphinGray: 4443,
    PVDF_DoveGray: 4444,
    PVDF_GunMetalGray: 4445,
    PVDF_MansardBrown: 4446,
    PVDF_MatteBlack: 4447,
    PVDF_MediumBronze: 4448,
    PVDF_RegalBlue: 4449,
    PVDF_RegalRed: 4450,
    PVDF_RegalWhite: 4451,
    PVDF_RoyalBlue: 4452,
    PVDF_Sandstone: 4453,
    PVDF_SilverMetallic: 4454,
    PVDF_SlateBlue: 4455,
    PVDF_SlateGray: 4456,
    PVDF_TerraCotta: 4457,
    PVDF_ZincMetallic: 4458,
  },
  MetalPowder_Colors: {
    AntiqueIvory: 42,
    Black: 43,
    Bronze: 1982,
    Slate: 44,
    Terratone: 45,
    VenetianBronze: 2237,
    White: 46,
  },
  MidAmerica: {
    MA001_White: 10627,
    MA002_Black: 10628,
    MA008_Clay: 11325,
    MA010_MusketBrown: 11326,
    MA018_TuxedoGrey: 10680,
    MA027_BurgundyRed: 11327,
    MA028_ForestGreen: 11328,
    MA030_Paintable: 11329,
    MA036_ClassicBlue: 11330,
    MA078_Wineberry: 11331,
    MA116_MidnightBlue: 11332,
    MA385_FrenchRoast: 11333,
    MA419_StormCloud: 10762,
    MA471_TreatedCedar: 11334,
    MA945_Platinum: 11335,
  },
  Monier: {
    Monier_Aniseed: 9519,
    Monier_Babylon: 9520,
    Monier_Barramundi: 9521,
    Monier_Chilli: 9522,
    Monier_MistGrey: 9523,
    Monier_Saffron: 9524,
    Monier_SaltSpray: 9525,
    Monier_Sambuca: 9526,
    Monier_Seashell: 9527,
    Monier_WildRice: 9528,
  },
  Mortar_GeneralShale: {
    GS_Mortar_Black: 10916,
    GS_Mortar_Buff: 10917,
    GS_Mortar_Gray: 10918,
    GS_Mortar_Red: 10919,
    GS_Mortar_White: 10920,
  },
  MW_SherwinWilliamsStains: {
    MW1173_Black: 10707,
    MW409_Carbon: 10465,
    MW415_TidalWood: 10466,
    MW437_CountryPine: 10467,
    MW439_Walnut: 10468,
    MW459_Sagamore: 10469,
  },
  Norandex: {
    Norandex_Almond: 1739,
    Norandex_Beige: 6496,
    Norandex_Cactus: 6497,
    Norandex_CarbonBrown: 6570,
    Norandex_Champagne: 6498,
    Norandex_Cream: 6499,
    Norandex_DeepWater: 6571,
    Norandex_Evergreen: 1740,
    Norandex_Fern: 6500,
    Norandex_Firebrick: 6572,
    Norandex_Granite: 6501,
    Norandex_Graphite: 6502,
    Norandex_Khaki: 6503,
    Norandex_Linen: 1741,
    Norandex_MaverickBrown: 6504,
    Norandex_Mocha: 6505,
    Norandex_MusketBrown: 1742,
    Norandex_Myrtle: 6573,
    Norandex_Olive: 6506,
    Norandex_RoyalBrown: 1743,
    Norandex_Russet: 6507,
    Norandex_RusticCedar: 10877,
    Norandex_Sandstone: 1744,
    Norandex_Seaport: 6508,
    Norandex_Sierra: 1745,
    Norandex_Silver: 6509,
    Norandex_Smoke: 6510,
    Norandex_SteelBlue: 6511,
    Norandex_Tan: 1747,
    Norandex_Tumbleweed: 6512,
    Norandex_Wedgewood: 6513,
    Norandex_Wheat: 10878,
    Norandex_White: 1746,
  },
  Olympic: {
    Olympic_A172_WinterWheat: 1867,
    Olympic_B522_Serenity: 1868,
    Olympic_C142_HeavyCream: 1869,
    Olympic_C143_SpicedVinegar: 1870,
    Olympic_C155_TimberBeam: 1871,
    Olympic_C212_Shoreland: 1872,
    Olympic_C243_SombreroTan: 1873,
    Olympic_C316_WarmMahogany: 1874,
    Olympic_C373_CanyonPink: 1875,
    Olympic_C612_SeaSprite: 1876,
    Olympic_C624_PineRidge: 1877,
    Olympic_C646_RoyalHunterGreen: 1878,
    Olympic_D144_OysterShell: 1879,
    Olympic_D161_WhisperingWind: 1880,
    Olympic_D216_Kodiak: 1881,
    Olympic_D564_Feldspar: 1882,
    Olympic_D565_LavaGray: 1883,
    Olympic_D645_Submarine: 1884,
    Olympic_D673_Balsam: 1885,
    Olympic_D681_RainCloud: 1886,
  },
  Omega_Stucco: {
    O1C020_Snow: 10639,
    O1C035_Quake: 10640,
    O1C315_Featherly: 10641,
    OP010_OmegaWhite: 2192,
    OP012_Chenille: 2193,
    OP015_BirchWhite: 2194,
    OP018_Coconut: 2195,
    OP020_Ivory: 2196,
    OP035_Cloud: 2197,
    OP056_PearlyGrey: 2198,
    OP069_TrueGrey: 2199,
    OP221_HarvestGold: 2200,
    OP232_Sonoma: 2201,
    OP233_Chimayo: 2202,
    OP236_AntiqueGreen: 2203,
    OP237_RockGreen: 2204,
    OP240_JetGrey: 2205,
    OP241_Cobblestone: 2206,
    OP242_Mist: 2207,
    OP243_CastleRock: 2208,
    OP244_Wolf: 2209,
    OP245_Shoreline: 2210,
    OP246_RoyalTaupe: 2211,
    OP247_CoolGrey: 2212,
    OP248_ArticIce: 2213,
    OP249_MorningFog: 2214,
    OP250_Bone: 2215,
    OP251_Lace: 2216,
    OP400_TavernTaupe: 2217,
    OP401_BarnSwallow: 2218,
    OP405_SurreyBeige: 2219,
    OP409_ToffeeCrunch: 2220,
    OP412_BisonBeige: 2221,
    OP414_CloudCover: 2222,
    OP415_OnionSkin: 2223,
    OP416_SafariTan: 2224,
    OP419_LightToast: 2225,
    OP420_FloralWhite: 2226,
    OP422_GreatWall: 2227,
    OP426_StillCreek: 2228,
    OP429_SierraLeone: 2229,
    OP430_Mocha: 2230,
    OP432_MilkyQuartz: 2231,
    OP433_PrairieDog: 2232,
    OP434_VanillaCream: 2233,
    OP435_Butterscotch: 2234,
    OP437_RoughKhaki: 2235,
    OP438_MojaveSunset: 2236,
  },
  PaintSpare_Colors: {
    Beige: 143,
    Beige1: 190,
    CharcoalGray: 145,
    Clay: 191,
    Cream: 147,
    Gray: 152,
    Gray1: 202,
    Linen: 155,
    Moonshine: 158,
    SatinSilver: 164,
    Slate: 166,
    Slate1: 195,
    TH1: 137,
    TH2: 167,
    TH3: 138,
    TH4: 168,
    TH5: 139,
    White: 188,
    White1: 207,
    WhiteBright: 189,
    Wicker: 201,
  },
  PlyGem: {
    PlyGem_AutumnBeige: 4587,
    PlyGem_Black: 1998,
    PlyGem_BlackwatchGreen: 4541,
    PlyGem_Blue: 4542,
    Plygem_Briarwood: 4652,
    PlyGem_Briarwood: 1999,
    PlyGem_Brown: 4543,
    PlyGem_CharcoalGray: 2000,
    PlyGem_ClassicCream: 4588,
    PlyGem_CoastalBlue: 184,
    PlyGem_DarkBerry: 4544,
    PlyGem_DarkBronze: 2001,
    PlyGem_DarkNavy: 4545,
    PlyGem_DarkSpruce: 4546,
    PlyGem_DoverWhite: 2002,
    PlyGem_Flint: 4589,
    PlyGem_GeorgianGray: 4590,
    PlyGem_Granite: 10786,
    PlyGem_Gray: 4547,
    PlyGem_Green: 4548,
    PlyGem_HeritageLinen: 4591,
    PlyGem_IrishThistle: 4592,
    PlyGem_IslandPearl: 4593,
    PlyGem_MasticAlmond: 4549,
    PlyGem_MasticAlpineForest: 4550,
    PlyGem_MasticAutumnHarvest: 4551,
    PlyGem_MasticBrandyWood: 4552,
    PlyGem_MasticBrunswick: 2102,
    PlyGem_MasticCameo: 2085,
    PlyGem_MasticCapeGrey: 4553,
    PlyGem_MasticCedar: 4554,
    PlyGem_MasticColonialYellow: 10763,
    PlyGem_MasticCornSilk: 4555,
    PlyGem_MasticDeepCavern: 4556,
    PlyGem_MasticDeepGranite: 4557,
    PlyGem_MasticDesertSand: 2103,
    PlyGem_MasticEnglishWedgewood: 2104,
    PlyGem_MasticEverest: 2086,
    PlyGem_MasticHarborGray: 4558,
    PlyGem_MasticLakeshoreFern: 10764,
    PlyGem_MasticLinen: 2087,
    PlyGem_MasticMistyShadow: 2088,
    PlyGem_MasticModernIron: 2089,
    PlyGem_MasticMontanaSuede: 2105,
    PlyGem_MasticNaturalSlate: 4559,
    PlyGem_MasticNewportBay: 4560,
    PlyGem_MasticPebblestoneClay: 2090,
    PlyGem_MasticPortsmouthBlue: 4561,
    PlyGem_MasticQuietWillow: 2091,
    PlyGem_MasticRedBrick: 4562,
    PlyGem_MasticRedCedar: 4563,
    PlyGem_MasticRockHarbor: 4564,
    PlyGem_MasticRuggedCanyon: 4565,
    PlyGem_MasticRussetRed: 2092,
    PlyGem_MasticSage: 4566,
    PlyGem_MasticSandtone: 4567,
    PlyGem_MasticScottishThistle510: 2106,
    PlyGem_MasticSilverGrey: 4568,
    PlyGem_MasticTerraCotta: 4569,
    PlyGem_MasticTimber: 4570,
    PlyGem_MasticTuscanOlive: 4571,
    PlyGem_MasticVictorianGrey: 2107,
    PlyGem_MasticWalnut: 4572,
    PlyGem_MasticWhite: 2093,
    PlyGem_MasticWicker: 4573,
    PlyGem_MittenBP_Ash: 2108,
    PlyGem_MusketBrown: 2003,
    PlyGem_NaturalAlmond: 2004,
    PlyGem_PebblestoneClay: 4574,
    PlyGem_Peppercorn: 4575,
    Plygem_Pewter: 4653,
    PlyGem_Red: 4576,
    PlyGem_RichMocha: 4594,
    Plygem_Sagebrook: 4654,
    PlyGem_SandDollar: 4577,
    PlyGem_Sandstone: 2005,
    PlyGem_Sandtone: 4595,
    PlyGem_SandyTan: 2006,
    PlyGem_SavannahBlue: 4596,
    PlyGem_SilverMist: 4597,
    PlyGem_SouthernCypress: 4598,
    PlyGem_SpanishMoss: 4578,
    PlyGem_SpanishOlive: 4599,
    PlyGem_StoneMountainClay: 2007,
    PlyGem_SW_EvergreenFog: 4579,
    PlyGem_SW_GaleForce: 4580,
    PlyGem_SW_UrbanBronze: 4581,
    Plygem_Teak: 4655,
    PlyGem_TerraBronze: 2008,
    PlyGem_TerraBrown: 4582,
    PlyGem_Terratone: 2009,
    Plygem_TwilightShadow: 4656,
    PlyGem_VineyardRed: 4583,
    Plygem_VintageDublin: 10556,
    Plygem_Wedgewood: 4657,
    PlyGem_WhisperingTimber: 4584,
    PlyGem_White: 2010,
    PlyGem_Wicker: 2011,
    PlyGem_Winestone: 4585,
    PlyGem_WoodlandRetreat: 4586,
  },
  PPG: {
    PPG0993_1_Peregrine: 2271,
    PPG0993_2_Train: 2272,
    PPG0993_3_GoslingGray: 2273,
    PPG0993_4_GraySuit: 2274,
    PPG0993_5_SuperheroGray: 2275,
    PPG0993_6_OldSilk: 2276,
    PPG0993_7_MoodySky: 2277,
    PPG0994_1_AfraidOfTheDark: 2278,
    PPG0994_2_PittsburghGray: 2279,
    PPG0994_3_HalfDome: 2280,
    PPG0994_4_Hippopotamus: 2281,
    PPG0994_5_SteelCurtain: 2282,
    PPG0994_6_HuskyGray: 2283,
    PPG0994_7_Pencilpoint: 2284,
    PPG0995_1_ShadedWhisper: 2285,
    PPG0995_2_AncientCloud: 2286,
    PPG0995_3_SilverBand: 2287,
    PPG0995_4_PigeonFeather: 2288,
    PPG0995_5_BurnishedBlade: 2289,
    PPG0995_6_CitySkyline: 2290,
    PPG0995_7_StarlessSky: 2291,
    PPG0996_1_ShiningScale: 2292,
    PPG0996_2_SteelyGaze: 2293,
    PPG0996_3_StatueGarden: 2294,
    PPG0996_4_CloudySlate: 2295,
    PPG0996_5_Steamship: 2296,
    PPG0996_6_SlateMine: 2297,
    PPG0996_7_SummerShadow: 2298,
    PPG0997_1_AlleghenyRiver: 2299,
    PPG0997_2_FeltedWool: 2300,
    PPG0997_3_FreshGranite: 2301,
    PPG0997_4_Precipitation: 2302,
    PPG0997_5_PlayingPossum: 2303,
    PPG0997_6_IndustrialRevolution: 2304,
    PPG0997_7_BlackWidow: 2305,
    PPG0998_1_CottonTail: 2306,
    PPG0998_2_HikersParadise: 2307,
    PPG0998_3_Kalispell: 2308,
    PPG0998_4_Shadowy: 2309,
    PPG0998_5_MtRainier: 2310,
    PPG0998_6_OnTheEdge: 2311,
    PPG0998_7_Undercover: 2312,
    PPG0999_1_InTheCloud: 2313,
    PPG0999_2_RabbitsEar: 2314,
    PPG0999_3_BoulderCreek: 2315,
    PPG0999_4_SteepedTea: 2316,
    PPG0999_5_SweaterWeather: 2317,
    PPG0999_6_StolenRock: 2318,
    PPG0999_7_DarkWoods: 2319,
    PPG10_01_Oceania: 2662,
    PPG10_02_SorcerersSpell: 2663,
    PPG10_03_TwilightStroll: 2664,
    PPG10_04_Polaris: 2665,
    PPG10_05_OysterWhite: 2666,
    PPG10_06_Thunderbolt: 2667,
    PPG10_07_BayOfFundy: 2668,
    PPG10_08_GaleForce: 2669,
    PPG10_09_SoothingSapphire: 2670,
    PPG10_10_HatterasGray: 2671,
    PPG10_11_Seastone: 2672,
    PPG10_12_CoolGray: 2673,
    PPG10_13_Foretell: 2674,
    PPG10_14_Stormy: 2675,
    PPG10_15_Quest: 2676,
    PPG10_16_Artifact: 2677,
    PPG10_17_BlueOpal: 2678,
    PPG10_18_Debonaire: 2679,
    PPG10_19_FavoriteFlannel: 2680,
    PPG10_20_CoastOfMaine: 2681,
    PPG10_21_Acceleration: 2682,
    PPG10_22_LicenseToDream: 2683,
    PPG10_23_AsterPetal: 2684,
    PPG10_24_Inevitable: 2685,
    PPG10_25_WintersBreath: 2686,
    PPG10_26_SimplyElegant: 2687,
    PPG10_27_Tradewinds: 2688,
    PPG10_28_Peace: 2689,
    PPG10_29_DustyAqua: 2690,
    PPG10_30_NiagaraMist: 2691,
    PPG10_31_WhiteClover: 2692,
    PPG10_32_BlueTang: 2693,
    PPG1000_1_DustBunny: 2320,
    PPG1000_2_RockyRoad: 2321,
    PPG1000_3_Fieldstone: 2322,
    PPG1000_4_WinterCocoa: 2323,
    PPG1000_5_BearCub: 2324,
    PPG1000_6_Thunderstruck: 2325,
    PPG1000_7_ChocolateLab: 2326,
    PPG1001_1_DelicateWhite: 2327,
    PPG1001_2_Aria: 2328,
    PPG1001_3_ThinIce: 2329,
    PPG1001_4_Flagstone: 2330,
    PPG1001_5_DoverGray: 2331,
    PPG1001_6_KnightsArmor: 2332,
    PPG1001_7_BlackMagic: 2333,
    PPG1002_1_SilverFeather: 2334,
    PPG1002_2_ArcticCotton: 2335,
    PPG1002_3_CoolSlate: 2336,
    PPG1002_4_GrayMarble: 2337,
    PPG1002_5_AntiqueSilver: 2338,
    PPG1002_6_GibraltarGray: 2339,
    PPG1002_7_PhantomMist: 2340,
    PPG1003_1_FallChill: 2341,
    PPG1003_2_Balanced: 2342,
    PPG1003_3_SilverBells: 2343,
    PPG1003_4_Equilibrium: 2344,
    PPG1003_5_ShiningArmor: 2345,
    PPG1003_6_CrackedSlate: 2346,
    PPG1003_7_Blackhearth: 2347,
    PPG1004_1_GoToGray: 2348,
    PPG1004_2_FreeReign: 2349,
    PPG1004_3_Hush: 2350,
    PPG1004_4_SilverService: 2351,
    PPG1004_5_PewterMug: 2352,
    PPG1004_6_PhantomHue: 2353,
    PPG1004_7_BlackElegance: 2354,
    PPG1005_1_DuskyDawn: 2355,
    PPG1005_2_Elusion: 2356,
    PPG1005_3_GrayShadows: 2357,
    PPG1005_4_SlatePebble: 2358,
    PPG1005_5_ElephantGray: 2359,
    PPG1005_6_OswegoTea: 2360,
    PPG1005_7_DarkGranite: 2361,
    PPG1006_1_Gypsum: 2362,
    PPG1006_2_Shark: 2363,
    PPG1006_3_EarlyEvening: 2364,
    PPG1006_4_Mercurial: 2365,
    PPG1006_5_SoSublime: 2366,
    PPG1006_6_Deconstruction: 2367,
    PPG1006_7_Metropolis: 2368,
    PPG1007_1_WillowSprings: 2369,
    PPG1007_2_SwirlingSmoke: 2370,
    PPG1007_3_GhostWriter: 2371,
    PPG1007_4_HotStone: 2372,
    PPG1007_5_LazyAfternoon: 2373,
    PPG1007_6_CoolCharcoal: 2374,
    PPG1007_7_Bark: 2375,
    PPG1008_1_Focus: 2376,
    PPG1008_2_StormsComing: 2377,
    PPG1008_3_Greyhound: 2378,
    PPG1008_4_GrayByMe: 2379,
    PPG1008_5_RollerCoaster: 2380,
    PPG1008_6_Artillery: 2381,
    PPG1008_7_StonesThrow: 2382,
    PPG1009_1_TundraFrost: 2383,
    PPG1009_2_Tornado: 2384,
    PPG1009_3_SolitaryState: 2385,
    PPG1009_4_GrayStone: 2386,
    PPG1009_5_PhoenixFossil: 2387,
    PPG1009_6_Armory: 2388,
    PPG1009_7_Licorice: 2389,
    PPG1010_1_Pegasus: 2390,
    PPG1010_2_Fog: 2391,
    PPG1010_3_Solstice: 2392,
    PPG1010_4_SteppingStone: 2393,
    PPG1010_5_Downpour: 2394,
    PPG1010_6_UpInSmoke: 2395,
    PPG1010_7_Zombie: 2396,
    PPG1011_1_PacificPearl: 2397,
    PPG1011_2_Elemental: 2398,
    PPG1011_3_Stargazer: 2399,
    PPG1011_4_Ufo: 2400,
    PPG1011_5_Improbable: 2401,
    PPG1011_6_GlazedGranite: 2402,
    PPG1011_7_Onyx: 2403,
    PPG1012_1_IcyBay: 2404,
    PPG1012_2_InvernessGray: 2405,
    PPG1012_3_Tinsel: 2406,
    PPG1012_4_GrayFrost: 2407,
    PPG1012_5_SteepleGray: 2408,
    PPG1012_6_VolcanicAsh: 2409,
    PPG1012_7_BlackForest: 2410,
    PPG1013_1_Radisson: 2411,
    PPG1013_2_SpringThaw: 2412,
    PPG1013_3_Whirlwind: 2413,
    PPG1013_4_SilverCharm: 2414,
    PPG1013_5_VictorianPewter: 2415,
    PPG1013_6_GrayFlannel: 2416,
    PPG1013_7_Napoleon: 2417,
    PPG1014_1_GlacialIce: 2418,
    PPG1014_2_GrayWhisper: 2419,
    PPG1014_3_SilverScreen: 2420,
    PPG1014_4_JackRabbit: 2421,
    PPG1014_5_GrayViolet: 2422,
    PPG1014_6_EagleEye: 2423,
    PPG1014_7_BlackWalnut: 2424,
    PPG1015_1_VanillaMilkshake: 2425,
    PPG1015_2_StoneQuarry: 2426,
    PPG1015_3_Warmstone: 2427,
    PPG1015_4_Subdued: 2428,
    PPG1015_5_Heliotrope: 2429,
    PPG1015_6_GraniteBoulder: 2430,
    PPG1015_7_Mustang: 2431,
    PPG1016_1_BerryFrost: 2432,
    PPG1016_2_BlossomPink: 2433,
    PPG1016_3_CheerfulHeart: 2434,
    PPG1016_4_ForeverFairytale: 2435,
    PPG1016_5_IrisMauve: 2436,
    PPG1016_6_Woodchuck: 2437,
    PPG1016_7_SpicedWine: 2438,
    PPG1017_1_Touchable: 2439,
    PPG1017_2_FirstKiss: 2440,
    PPG1017_3_FondMemory: 2441,
    PPG1017_4_RiveterRose: 2442,
    PPG1017_5_CinnamonToast: 2443,
    PPG1017_6_BoldBrandy: 2444,
    PPG1017_7_ChocolatePretzel: 2445,
    PPG1018_1_SteelMe: 2446,
    PPG1018_2_MyAlibi: 2447,
    PPG1018_3_CityStreet: 2448,
    PPG1018_4_WintersNap: 2449,
    PPG1018_5_Talavera: 2450,
    PPG1018_6_Flipper: 2451,
    PPG1018_7_Sarsaparilla: 2452,
    PPG1019_1_ToastedMarshmallow: 2453,
    PPG1019_2_InTheBuff: 2454,
    PPG1019_3_Legendary: 2455,
    PPG1019_4_SimmeringSmoke: 2456,
    PPG1019_5_WildWilderness: 2457,
    PPG1019_6_TattleTail: 2458,
    PPG1019_7_Intrigue: 2459,
    PPG1020_1_AtriumWhite: 2460,
    PPG1020_2_MaybeMushroom: 2461,
    PPG1020_3_Whippet: 2462,
    PPG1020_4_ElCapitan: 2463,
    PPG1020_5_EarlGray: 2464,
    PPG1020_6_WickerBasket: 2465,
    PPG1020_7_Dolce: 2466,
    PPG1021_1_MountainGray: 2467,
    PPG1021_2_Synchronicity: 2468,
    PPG1021_3_Discover: 2469,
    PPG1021_4_Diversion: 2470,
    PPG1021_5_Thunderbird: 2471,
    PPG1021_6_Curlew: 2472,
    PPG1021_7_CabinFever: 2473,
    PPG1022_1_Hourglass: 2474,
    PPG1022_2_Intuitive: 2475,
    PPG1022_3_SilverDollar: 2476,
    PPG1022_4_RockSlide: 2477,
    PPG1022_5_EiffelTower: 2478,
    PPG1022_6_Granite: 2479,
    PPG1022_7_StarAnise: 2480,
    PPG1023_1_Oatmeal: 2481,
    PPG1023_2_CoolConcrete: 2482,
    PPG1023_3_Ashen: 2483,
    PPG1023_4_DesertDune: 2484,
    PPG1023_5_StoneGray: 2485,
    PPG1023_6_ClamShell: 2486,
    PPG1023_7_AfternoonTea: 2487,
    PPG1024_1_OffWhite: 2488,
    PPG1024_2_AntiqueWhite: 2489,
    PPG1024_3_CrushedSilk: 2490,
    PPG1024_4_MothGray: 2491,
    PPG1024_5_StonehengeGreige: 2492,
    PPG1024_6_Patches: 2493,
    PPG1024_7_FriarsBrown: 2494,
    PPG1025_1_CommercialWhite: 2495,
    PPG1025_2_SilentSmoke: 2496,
    PPG1025_3_Whiskers: 2497,
    PPG1025_4_Sharkskin: 2498,
    PPG1025_5_DarkAsh: 2499,
    PPG1025_6_SleepingGiant: 2500,
    PPG1025_7_CoffeeBean: 2501,
    PPG1026_1_Namaste: 2502,
    PPG1026_2_Sanctuary: 2503,
    PPG1026_3_Easy: 2504,
    PPG1026_4_Karma: 2505,
    PPG1026_5_Gristmill: 2506,
    PPG1026_6_BronzeStatue: 2507,
    PPG1026_7_HipWaders: 2508,
    PPG1027_1_Cocoon: 2509,
    PPG1027_2_SkippingStone: 2510,
    PPG1027_3_HeavyHammock: 2511,
    PPG1027_4_OliveGray: 2512,
    PPG1027_5_RattanPalm: 2513,
    PPG1027_6_Conservation: 2514,
    PPG1027_7_Grapevine: 2515,
    PPG1028_1_HintOfPine: 2516,
    PPG1028_2_WithATwist: 2517,
    PPG1028_3_PineCrush: 2518,
    PPG1028_4_SmokySlate: 2519,
    PPG1028_5_AutumnGray: 2520,
    PPG1028_6_Momentum: 2521,
    PPG1028_7_WalnutGrove: 2522,
    PPG1029_1_SilveryMoon: 2523,
    PPG1029_2_VeilOfDusk: 2524,
    PPG1029_3_FrenchGrayLinen: 2525,
    PPG1029_4_PhotoGray: 2526,
    PPG1029_5_Meander: 2527,
    PPG1029_6_Organic: 2528,
    PPG1029_7_PlungePool: 2529,
    PPG1030_1_Brainstorm: 2530,
    PPG1030_2_PalePine: 2531,
    PPG1030_3_MellowMood: 2532,
    PPG1030_4_Edamame: 2533,
    PPG1030_5_Mesmerize: 2534,
    PPG1030_6_PositivelyPalm: 2535,
    PPG1030_7_DoubleDuty: 2536,
    PPG1031_1_MixOrMatch: 2537,
    PPG1031_2_MistyMeadow: 2538,
    PPG1031_3_WanderingWillow: 2539,
    PPG1031_4_Restoration: 2540,
    PPG1031_5_SeaweedWrap: 2541,
    PPG1031_6_Nevergreen: 2542,
    PPG1031_7_Osiris: 2543,
    PPG1032_1_MetallicMist: 2544,
    PPG1032_2_HurricaneHaze: 2545,
    PPG1032_3_OliveIt: 2546,
    PPG1032_4_Sylvan: 2547,
    PPG1032_5_Tortuga: 2548,
    PPG1032_6_KingsCourt: 2549,
    PPG1032_7_MossRock: 2550,
    PPG1033_1_SaltyBreeze: 2551,
    PPG1033_2_WaywardWillow: 2552,
    PPG1033_3_SilentStorm: 2553,
    PPG1033_4_LightDrizzle: 2554,
    PPG1033_5_GrayHeron: 2555,
    PPG1033_6_GunmetalGray: 2556,
    PPG1033_7_CharcoalSmoke: 2557,
    PPG1034_1_MorningSong: 2558,
    PPG1034_2_Honesty: 2559,
    PPG1034_3_PristinePetal: 2560,
    PPG1034_4_MistySurf: 2561,
    PPG1034_5_AquaSmoke: 2562,
    PPG1034_6_BlueBlood: 2563,
    PPG1034_7_MountainPine: 2564,
    PPG1035_1_WateryBlue: 2565,
    PPG1035_2_SkyDiving: 2566,
    PPG1035_3_BlueByYou: 2567,
    PPG1035_4_SymphonyOfBlue: 2568,
    PPG1035_5_PuddleJumper: 2569,
    PPG1035_6_Superstition: 2570,
    PPG1035_7_Obsidian: 2571,
    PPG1036_1_GrayGlimpse: 2572,
    PPG1036_2_WinterChill: 2573,
    PPG1036_3_NauticalStar: 2574,
    PPG1036_4_AfterTheStorm: 2575,
    PPG1036_5_RoughRide: 2576,
    PPG1036_6_Phantom: 2577,
    PPG1036_7_MostlyMetal: 2578,
    PPG1037_1_SeaFrost: 2579,
    PPG1037_2_SkySplash: 2580,
    PPG1037_3_SpecialDelivery: 2581,
    PPG1037_4_Symmetry: 2582,
    PPG1037_5_NightRendezvous: 2583,
    PPG1037_6_Mysterious: 2584,
    PPG1037_7_Witchcraft: 2585,
    PPG1038_1_EveningMist: 2586,
    PPG1038_2_Dewdrop: 2587,
    PPG1038_3_WintersBreath: 2588,
    PPG1038_4_SmokeScreen: 2589,
    PPG1038_5_Feldspar: 2590,
    PPG1038_6_LavaGray: 2591,
    PPG1038_7_MidnightHour: 2592,
    PPG1039_1_GhostWhisperer: 2593,
    PPG1039_2_MaidenMist: 2594,
    PPG1039_3_MirrorMirror: 2595,
    PPG1039_4_Pachyderm: 2596,
    PPG1039_5_GarrisonGray: 2597,
    PPG1039_6_InTheShadows: 2598,
    PPG1039_7_HighSalute: 2599,
    PPG1040_1_Zen: 2600,
    PPG1040_2_Keepsakes: 2601,
    PPG1040_3_OceanDrive: 2602,
    PPG1040_4_SetInStone: 2603,
    PPG1040_5_LostAtSea: 2604,
    PPG1040_6_FreedomFound: 2605,
    PPG1040_7_Goblin: 2606,
    PPG1041_1_MoonlitSnow: 2607,
    PPG1041_2_CityLights: 2608,
    PPG1041_3_BillowingClouds: 2609,
    PPG1041_4_BlueDolphin: 2610,
    PPG1041_5_Quicksilver: 2611,
    PPG1041_6_SheffieldGray: 2612,
    PPG1041_7_Cavalry: 2613,
    PPG1042_1_CallaLily: 2614,
    PPG1042_2_WinterHaven: 2694,
    PPG1042_3_OceanDream: 2695,
    PPG1042_4_BlueBeard: 2696,
    PPG1042_5_PropheticSea: 2697,
    PPG1042_6_BlueZephyr: 2698,
    PPG1042_7_Admiralty: 2699,
    PPG1043_1_Snowbank: 2700,
    PPG1043_2_Moondance: 2701,
    PPG1043_3_WaywardWinds: 2702,
    PPG1043_4_GlisteningGray: 2703,
    PPG1043_5_FlannelPajamas: 2704,
    PPG1043_6_AlleyCat: 2705,
    PPG1043_7_BlackFlame: 2706,
    PPG1044_1_LoveBird: 2707,
    PPG1044_2_MauveWisp: 2708,
    PPG1044_3_TintedRosewood: 2709,
    PPG1044_4_Mauvelous: 2710,
    PPG1044_5_WinsomeRose: 2711,
    PPG1044_6_WildStrawberry: 2712,
    PPG1044_7_WildPlum: 2713,
    PPG1045_1_MagicalMoonlight: 2714,
    PPG1045_2_BarelyRose: 2715,
    PPG1045_3_SantolinaBlooms: 2716,
    PPG1045_4_PinkPotion: 2717,
    PPG1045_5_KeepsakeRose: 2718,
    PPG1045_6_WildGeranium: 2719,
    PPG1045_7_ChilledWine: 2720,
    PPG1046_1_MilkAndCookies: 2721,
    PPG1046_2_MagicMoments: 2722,
    PPG1046_3_OldMissionPink: 2723,
    PPG1046_4_HighSociety: 2724,
    PPG1046_5_GothicAmethyst: 2725,
    PPG1046_6_VelvetSlipper: 2726,
    PPG1046_7_PurpleBasil: 2727,
    PPG1047_1_ForeverFaithful: 2728,
    PPG1047_2_LostLove: 2729,
    PPG1047_3_JustGorgeous: 2730,
    PPG1047_4_Ancestral: 2731,
    PPG1047_5_CoffeeCustard: 2732,
    PPG1047_6_ChooChoo: 2733,
    PPG1047_7_CarobChip: 2734,
    PPG1048_1_LaurensLace: 2735,
    PPG1048_2_SilkSheets: 2736,
    PPG1048_3_RoseCloud: 2737,
    PPG1048_4_RoseStain: 2738,
    PPG1048_5_CoffeeRose: 2739,
    PPG1048_6_ChocolateSparkle: 2740,
    PPG1048_7_Gooseberry: 2741,
    PPG1049_1_SnowyMount: 2742,
    PPG1049_2_SweetBianca: 2743,
    PPG1049_3_Nostalgia: 2744,
    PPG1049_4_LightheartedRose: 2745,
    PPG1049_5_MauveMadness: 2746,
    PPG1049_6_Cabernet: 2747,
    PPG1049_7_RedRedWine: 2748,
    PPG1050_1_BarePink: 2749,
    PPG1050_2_PinkPail: 2750,
    PPG1050_3_LoveInAMist: 2751,
    PPG1050_4_MadagascarPink: 2752,
    PPG1050_5_BriarRose: 2753,
    PPG1050_6_HeartsContent: 2754,
    PPG1050_7_Magenta: 2755,
    PPG1051_1_CozyCottage: 2756,
    PPG1051_2_PinkCardoon: 2757,
    PPG1051_3_StrawberryMousse: 2758,
    PPG1051_4_PinkClayPot: 2759,
    PPG1051_5_Cranberry: 2760,
    PPG1051_6_Grenadine: 2761,
    PPG1051_7_Apple_A_Day: 2762,
    PPG1052_1_GingerCream: 2763,
    PPG1052_2_BrandyAlexander: 2764,
    PPG1052_3_Strawflower: 2765,
    PPG1052_4_FloralTapestry: 2766,
    PPG1052_5_HorizonGlow: 2767,
    PPG1052_6_MesaRed: 2768,
    PPG1052_7_RubyLips: 2769,
    PPG1053_1_CowsMilk: 2770,
    PPG1053_2_ShangriLa: 2771,
    PPG1053_3_PowderedPetals: 2772,
    PPG1053_4_RadiantRouge: 2773,
    PPG1053_5_BrandySnaps: 2774,
    PPG1053_6_ClayRidge: 2775,
    PPG1053_7_BurgundyWine: 2776,
    PPG1054_1_WinterWedding: 2777,
    PPG1054_2_SweetTruffle: 2778,
    PPG1054_3_Whirligig: 2779,
    PPG1054_4_TeaTime: 2780,
    PPG1054_5_TawnyMushroom: 2781,
    PPG1054_6_OakwoodBrown: 2782,
    PPG1054_7_ChocolateEclair: 2783,
    PPG1055_1_FreshDough: 2784,
    PPG1055_2_HawaiianShell: 2785,
    PPG1055_3_RoseHip: 2786,
    PPG1055_4_Pepperberry: 2787,
    PPG1055_5_CinnamonDiamonds: 2788,
    PPG1055_6_BarnDoor: 2789,
    PPG1055_7_Bordeaux: 2790,
    PPG1056_1_SeaAnemone: 2791,
    PPG1056_2_Romeo: 2792,
    PPG1056_3_AshesOfRoses: 2793,
    PPG1056_4_RaffiaCream: 2794,
    PPG1056_5_EarthRose: 2795,
    PPG1056_6_FireWeed: 2796,
    PPG1056_7_BrickDust: 2797,
    PPG1057_1_MacadamiaNut: 2798,
    PPG1057_2_CoolMelon: 2799,
    PPG1057_3_RosePetal: 2800,
    PPG1057_4_CoralCove: 2801,
    PPG1057_5_ChiliPepper: 2802,
    PPG1057_6_SiennaRed: 2803,
    PPG1057_7_BurningBush: 2804,
    PPG1058_1_Potpourri: 2805,
    PPG1058_2_CameoPeach: 2806,
    PPG1058_3_TangyTaffy: 2807,
    PPG1058_4_MesaPink: 2808,
    PPG1058_5_Sunstone: 2809,
    PPG1058_6_PizzaPie: 2810,
    PPG1058_7_AutumnRidge: 2811,
    PPG1059_1_ApricotCream: 2812,
    PPG1059_2_BirthdayCake: 2813,
    PPG1059_3_Reindeer: 2814,
    PPG1059_4_Parfait: 2815,
    PPG1059_5_FerrisWheel: 2816,
    PPG1059_6_CanyonStone: 2817,
    PPG1059_7_SweetSpiceberry: 2818,
    PPG1060_1_WinterPeach: 2819,
    PPG1060_2_ChinaSilk: 2820,
    PPG1060_3_KangarooPaw: 2821,
    PPG1060_4_VelveteenCrush: 2822,
    PPG1060_5_BedfordBrown: 2823,
    PPG1060_6_RaspberryTruffle: 2824,
    PPG1060_7_WarmMahogany: 2825,
    PPG1061_1_IrishCream: 2826,
    PPG1061_2_WistfulBeige: 2827,
    PPG1061_3_BelleOfTheBall: 2828,
    PPG1061_4_JustRosey: 2829,
    PPG1061_5_CappucinoBombe: 2830,
    PPG1061_6_SafariBrown: 2831,
    PPG1061_7_Bigfoot: 2832,
    PPG1062_1_ButterIcing: 2833,
    PPG1062_2_CoralCream: 2834,
    PPG1062_3_GingerShortbread: 2835,
    PPG1062_4_Sandpaper: 2836,
    PPG1062_5_BigCypress: 2837,
    PPG1062_6_AppleBrownBetty: 2838,
    PPG1062_7_WarmWassail: 2839,
    PPG1063_1_PoloTan: 2840,
    PPG1063_2_SpiceCookie: 2841,
    PPG1063_3_PaleCoral: 2842,
    PPG1063_4_GeorgiaPeach: 2843,
    PPG1063_5_OrangeEssential: 2844,
    PPG1063_6_CrushedCinnamon: 2845,
    PPG1063_7_AncientCopper: 2846,
    PPG1064_1_Aubergine: 2847,
    PPG1064_2_PinkChablis: 2848,
    PPG1064_3_TexasRose: 2849,
    PPG1064_4_PeachBeige: 2850,
    PPG1064_5_HollandTile: 2851,
    PPG1064_6_SaharaSun: 2852,
    PPG1064_7_RumRaisin: 2853,
    PPG1065_1_ChantillyLace: 2854,
    PPG1065_2_Fiesta: 2855,
    PPG1065_3_Honeysweet: 2856,
    PPG1065_4_SweetPeach: 2857,
    PPG1065_5_LongWeekend: 2858,
    PPG1065_6_Cinnabar: 2859,
    PPG1065_7_CedarChest: 2860,
    PPG1066_1_SiestaSands: 2861,
    PPG1066_2_SlightlyPeach: 2862,
    PPG1066_3_CoolCantaloupe: 2863,
    PPG1066_4_Adorable: 2864,
    PPG1066_5_CopperTrail: 2865,
    PPG1066_6_Amaretto: 2866,
    PPG1066_7_BakedBean: 2867,
    PPG1067_1_PineHutch: 2868,
    PPG1067_2_Boardwalk: 2869,
    PPG1067_3_AuNaturel: 2870,
    PPG1067_4_Thankfully: 2871,
    PPG1067_5_CopperBeech: 2872,
    PPG1067_6_WarmUp: 2873,
    PPG1067_7_BurledRedwood: 2874,
    PPG1068_1_SweetGardenia: 2875,
    PPG1068_2_Sablewood: 2876,
    PPG1068_3_SultanSand: 2877,
    PPG1068_4_LazySummer: 2878,
    PPG1068_5_TerrazzoTan: 2879,
    PPG1068_6_Nutmeg: 2880,
    PPG1068_7_SpicedCider: 2881,
    PPG1069_1_Nosegay: 2882,
    PPG1069_2_Scotchtone: 2883,
    PPG1069_3_Starfish: 2884,
    PPG1069_4_OrangeMaple: 2885,
    PPG1069_5_HoneyGraham: 2886,
    PPG1069_6_FoxfireBrown: 2887,
    PPG1069_7_CinnamonSpice: 2888,
    PPG1070_1_CanyonPeach: 2889,
    PPG1070_2_BlushBeige: 2890,
    PPG1070_3_BeachVibes: 2891,
    PPG1070_4_ClayFire: 2892,
    PPG1070_5_HitchingPost: 2893,
    PPG1070_6_GingerSpice: 2894,
    PPG1070_7_CinnamonStick: 2895,
    PPG1071_1_SouthPeak: 2896,
    PPG1071_2_Enjoy: 2897,
    PPG1071_3_ChampagneWishes: 2898,
    PPG1071_4_CinnamonIce: 2899,
    PPG1071_5_CoolClay: 2900,
    PPG1071_6_PrairieFire: 2901,
    PPG1071_7_SpicedCinnamon: 2902,
    PPG1072_1_AlmondRoca: 2903,
    PPG1072_2_SandyBeach: 2904,
    PPG1072_3_WildRice: 2905,
    PPG1072_4_TaupeTapestry: 2906,
    PPG1072_5_TatteredTeddy: 2907,
    PPG1072_6_SuedeLeather: 2908,
    PPG1072_7_BirdHouseBrown: 2909,
    PPG1073_1_LotusPetal: 2910,
    PPG1073_2_MaltedMilk: 2911,
    PPG1073_3_PaleTaupe: 2912,
    PPG1073_4_Pueblo: 2913,
    PPG1073_5_Tanglewood: 2914,
    PPG1073_6_DerbyBrown: 2915,
    PPG1073_7_Fudge: 2916,
    PPG1074_1_PearlsAndLace: 2917,
    PPG1074_2_MoroccanMoonlight: 2918,
    PPG1074_3_BermudaSand: 2919,
    PPG1074_4_Notorious: 2920,
    PPG1074_5_PepperedPecan: 2921,
    PPG1074_6_CaramelizedWalnut: 2922,
    PPG1074_7_LittleBear: 2923,
    PPG1075_1_LinenRuffle: 2924,
    PPG1075_2_AlmondMilk: 2925,
    PPG1075_3_CasualElegance: 2926,
    PPG1075_4_Thumper: 2927,
    PPG1075_5_RanchMink: 2928,
    PPG1075_6_PoppyPods: 2929,
    PPG1075_7_FudgeTruffle: 2930,
    PPG1076_1_FuzzyUnicorn: 2931,
    PPG1076_2_Ash: 2932,
    PPG1076_3_GottaHaveIt: 2933,
    PPG1076_4_CuppaCoffee: 2934,
    PPG1076_5_Locomotion: 2935,
    PPG1076_6_Warrior: 2936,
    PPG1076_7_GroundCoffee: 2937,
    PPG1077_1_BerkshireLace: 2938,
    PPG1077_2_Sandpiper: 2939,
    PPG1077_3_Persuasion: 2940,
    PPG1077_4_WeatheredWood: 2941,
    PPG1077_5_ChocolateMoment: 2942,
    PPG1077_6_SaltedPretzel: 2943,
    PPG1077_7_CoffeeHouse: 2944,
    PPG1078_1_CreamPuff: 2945,
    PPG1078_2_WaterChestnut: 2946,
    PPG1078_3_Comfort: 2947,
    PPG1078_4_Kangaroo: 2948,
    PPG1078_5_Confidence: 2949,
    PPG1078_6_CocoaDelight: 2950,
    PPG1078_7_ChocolateRipple: 2951,
    PPG1079_1_StringOfPearls: 2952,
    PPG1079_2_StoneHarbor: 2953,
    PPG1079_3_CocoaCream: 2954,
    PPG1079_4_Transcend: 2955,
    PPG1079_5_Cocoloco: 2956,
    PPG1079_6_CaravelBrown: 2957,
    PPG1079_7_Molasses: 2958,
    PPG1080_1_OatmealCookie: 2959,
    PPG1080_2_PumpkinCream: 2960,
    PPG1080_3_NutmegGlow: 2961,
    PPG1080_4_SiestaDreams: 2962,
    PPG1080_5_WheatToast: 2963,
    PPG1080_6_CinnamonCrunch: 2964,
    PPG1080_7_SlipperyStone: 2965,
    PPG1081_1_ElegantIvory: 2966,
    PPG1081_2_BeachyKeen: 2967,
    PPG1081_3_MyLove: 2968,
    PPG1081_4_CinnamonFrost: 2969,
    PPG1081_5_FireDust: 2970,
    PPG1081_6_CinnamonTwist: 2971,
    PPG1081_7_CopperPot: 2972,
    PPG1082_1_Honeysuckle: 2973,
    PPG1082_2_Shoreland: 2974,
    PPG1082_3_IceCreamCone: 2975,
    PPG1082_4_WeatheredSandstone: 2976,
    PPG1082_5_Doeskin: 2977,
    PPG1082_6_CowboyHat: 2978,
    PPG1082_7_Ginger: 2979,
    PPG1083_1_Percale: 2980,
    PPG1083_2_EuroLinen: 2981,
    PPG1083_3_OakBuff: 2982,
    PPG1083_4_MalibuDune: 2983,
    PPG1083_5_CheddarBiscuit: 2984,
    PPG1083_6_CaramelKiss: 2985,
    PPG1083_7_Bourbon: 2986,
    PPG1084_1_SugarSoap: 2987,
    PPG1084_2_OnionPowder: 2988,
    PPG1084_3_Sourdough: 2989,
    PPG1084_4_HappyTrails: 2990,
    PPG1084_5_CoffeeKiss: 2991,
    PPG1084_6_CocoaPecan: 2992,
    PPG1084_7_MapleSyrup: 2993,
    PPG1085_1_BlankCanvas: 2994,
    PPG1085_2_BoneWhite: 2995,
    PPG1085_3_SeriouslySand: 2996,
    PPG1085_4_BestBeige: 2997,
    PPG1085_5_SauteedMushroom: 2998,
    PPG1085_6_HatBoxBrown: 2999,
    PPG1085_7_FigBranches: 3000,
    PPG1086_1_Horseradish: 3001,
    PPG1086_2_BrandiedPears: 3002,
    PPG1086_3_AlmondCream: 3003,
    PPG1086_4_PonyTail: 3004,
    PPG1086_5_EarthyOcher: 3005,
    PPG1086_6_CoffeeWithCream: 3006,
    PPG1086_7_CocoaCupcake: 3007,
    PPG1087_1_MadonnaLily: 3008,
    PPG1087_2_Pearl: 3009,
    PPG1087_3_AntiqueParchment: 3010,
    PPG1087_4_Chalkware: 3011,
    PPG1087_5_CrackerBitz: 3012,
    PPG1087_6_BreadBasket: 3013,
    PPG1087_7_ChewyCaramel: 3014,
    PPG1088_1_AngelFood: 3015,
    PPG1088_2_Ethereal: 3016,
    PPG1088_3_SugaredPears: 3017,
    PPG1088_4_SplashOfHoney: 3018,
    PPG1088_5_Outback: 3019,
    PPG1088_6_CoolCopper: 3020,
    PPG1088_7_SaharaSplendor: 3021,
    PPG1089_1_PitaBread: 3022,
    PPG1089_2_MagnoliaSpray: 3023,
    PPG1089_3_ChaiTeaLatte: 3024,
    PPG1089_4_FaintFawn: 3025,
    PPG1089_5_BleachedMaple: 3026,
    PPG1089_6_HoneyHaven: 3027,
    PPG1089_7_CaramelizedPecan: 3028,
    PPG1090_1_MagnoliaBlossom: 3029,
    PPG1090_2_SpiceIsNice: 3030,
    PPG1090_3_HoneyBunny: 3031,
    PPG1090_4_DropsOfHoney: 3032,
    PPG1090_5_GoodLife: 3033,
    PPG1090_6_Allegro: 3034,
    PPG1090_7_SugarMaple: 3035,
    PPG1091_1_Candlewick: 3036,
    PPG1091_2_CrescentMoon: 3037,
    PPG1091_3_Limitless: 3038,
    PPG1091_4_Halo: 3039,
    PPG1091_5_MoreMaple: 3040,
    PPG1091_6_TanYourHide: 3041,
    PPG1091_7_LookAtMe: 3042,
    PPG1092_1_QueenAnnesLace: 3043,
    PPG1092_2_MesaBeige: 3044,
    PPG1092_3_TuscanBread: 3045,
    PPG1092_4_CraftsmanGold: 3046,
    PPG1092_5_WelcomeHome: 3047,
    PPG1092_6_ItWorks: 3048,
    PPG1092_7_WeatheredWicker: 3049,
    PPG1093_1_PerfectSolution: 3050,
    PPG1093_2_Soleil: 3051,
    PPG1093_3_Hearth: 3052,
    PPG1093_4_Somber: 3053,
    PPG1093_5_Antiquity: 3054,
    PPG1093_6_TangledTwine: 3055,
    PPG1093_7_TattleTan: 3056,
    PPG1094_1_Irresistible: 3057,
    PPG1094_2_Loofah: 3058,
    PPG1094_3_BirchBeige: 3059,
    PPG1094_4_Crepe: 3060,
    PPG1094_5_GoldenGranola: 3061,
    PPG1094_6_Imagine: 3062,
    PPG1094_7_MolassesCookie: 3063,
    PPG1095_1_ParchmentPaper: 3064,
    PPG1095_2_GlazedPears: 3065,
    PPG1095_3_AlmondBrittle: 3066,
    PPG1095_4_GoldenEcru: 3067,
    PPG1095_5_ApplesauceCake: 3068,
    PPG1095_6_Chicory: 3069,
    PPG1095_7_ShakerPeg: 3070,
    PPG1096_1_InstantRelief: 3071,
    PPG1096_2_MoroccoSand: 3072,
    PPG1096_3_CookieDough: 3073,
    PPG1096_4_RealSimple: 3074,
    PPG1096_5_CreamyCaramel: 3075,
    PPG1096_6_TimberBeam: 3076,
    PPG1096_7_SeasonedAcorn: 3077,
    PPG1097_1_ColdFoam: 3078,
    PPG1097_2_SouthernBreeze: 3079,
    PPG1097_3_ToastedAlmond: 3080,
    PPG1097_4_DustyTrail: 3081,
    PPG1097_5_StonyCreek: 3082,
    PPG1097_6_RainBarrel: 3083,
    PPG1097_7_OliveWood: 3084,
    PPG1098_1_MilkPaint: 3085,
    PPG1098_2_HeavyCream: 3086,
    PPG1098_3_SandFossil: 3087,
    PPG1098_4_SpicedVinegar: 3088,
    PPG1098_5_Jute: 3089,
    PPG1098_6_Tweed: 3090,
    PPG1098_7_MuddyRiver: 3091,
    PPG1099_1_AlwaysAlmond: 3092,
    PPG1099_2_VanillaLove: 3093,
    PPG1099_3_LovelyLinen: 3094,
    PPG1099_4_SubtleSuede: 3095,
    PPG1099_5_ToastedSesame: 3096,
    PPG1099_6_IcedCappuccino: 3097,
    PPG1099_7_FavoriteFudge: 3098,
    PPG11_01_Demeter: 3099,
    PPG11_02_TaintedGold: 3100,
    PPG11_03_Grassroots: 3101,
    PPG11_04_CountryStyle: 3102,
    PPG11_05_OldTimesSake: 3103,
    PPG11_06_SafariScene: 3104,
    PPG11_07_Gobbledygook: 3105,
    PPG11_08_OliveOrchard: 3106,
    PPG11_09_MistyMoor: 3107,
    PPG11_10_InTheDale: 3108,
    PPG11_11_TotallyTickled: 3109,
    PPG11_12_SecretScribbles: 3110,
    PPG11_13_SparrowSong: 3111,
    PPG11_14_LeafyRomaine: 3112,
    PPG11_15_WistfulWalk: 3113,
    PPG11_16_SpinachSalad: 3114,
    PPG11_17_MossyGold: 3115,
    PPG11_18_FoggyBeach: 3116,
    PPG11_19_DistantValley: 3117,
    PPG11_20_ScottishMoor: 3118,
    PPG11_21_Breezeway: 3119,
    PPG11_22_NorthernLandscape: 3120,
    PPG11_23_Edamame: 3121,
    PPG11_24_SmokeySage: 3122,
    PPG11_25_PlungePool: 3123,
    PPG11_26_Wilderness: 3124,
    PPG11_27_Safari: 3125,
    PPG11_28_OnlyOregano: 3126,
    PPG11_29_GreenGrayMist: 3127,
    PPG11_30_LivelyIvy: 3128,
    PPG11_31_ThimbleberryLeaf: 3129,
    PPG11_32_Tapenade: 3130,
    PPG1100_1_MotherOfPearl: 3131,
    PPG1100_2_AdobeWhite: 3132,
    PPG1100_3_BakedBread: 3133,
    PPG1100_4_SailorsKnot: 3134,
    PPG1100_5_SweetSparrow: 3135,
    PPG1100_6_TwistedTail: 3136,
    PPG1100_7_PaddleWheel: 3137,
    PPG1101_1_ChinaWhite: 3138,
    PPG1101_2_SugarCookie: 3139,
    PPG1101_3_Stylish: 3140,
    PPG1101_4_RockCliffs: 3141,
    PPG1101_5_BearHug: 3142,
    PPG1101_6_LeatherLoafers: 3143,
    PPG1101_7_Lemur: 3144,
    PPG1102_1_EnduringIce: 3145,
    PPG1102_2_FossilStone: 3146,
    PPG1102_3_DancingDolphin: 3147,
    PPG1102_4_PrairieDust: 3148,
    PPG1102_5_SaddleSoap: 3149,
    PPG1102_6_Woodbridge: 3150,
    PPG1102_7_PineCone: 3151,
    PPG1103_1_IvoryTower: 3152,
    PPG1103_2_AlmondPaste: 3153,
    PPG1103_3_SoftSuede: 3154,
    PPG1103_4_EarthyCane: 3155,
    PPG1103_5_Rattan: 3156,
    PPG1103_6_WoolTweed: 3157,
    PPG1103_7_TwigBasket: 3158,
    PPG1104_1_WhiteRock: 3159,
    PPG1104_2_AbbeyWhite: 3160,
    PPG1104_3_DesertedBeach: 3161,
    PPG1104_4_SandyPail: 3162,
    PPG1104_5_CoolCamel: 3163,
    PPG1104_6_RusticRanch: 3164,
    PPG1104_7_Outrigger: 3165,
    PPG1105_1_CreamyWhite: 3166,
    PPG1105_2_FuzzySheep: 3167,
    PPG1105_3_CaramelizedPears: 3168,
    PPG1105_4_Foothills: 3169,
    PPG1105_5_AppalachianTrail: 3170,
    PPG1105_6_BuffaloHide: 3171,
    PPG1105_7_GracefulGazelle: 3172,
    PPG1106_1_MaidenHair: 3173,
    PPG1106_2_Upbeat: 3174,
    PPG1106_3_AutumnGlow: 3175,
    PPG1106_4_TurnersYellow: 3176,
    PPG1106_5_ButterscotchBliss: 3177,
    PPG1106_6_AmarettoSours: 3178,
    PPG1106_7_ButterscotchRipple: 3179,
    PPG1107_1_Minimal: 3180,
    PPG1107_2_Joyful: 3181,
    PPG1107_3_TurningOakleaf: 3182,
    PPG1107_4_Demeter: 3183,
    PPG1107_5_TropicalSiesta: 3184,
    PPG1107_6_GloriousGold: 3185,
    PPG1107_7_GoldenField: 3186,
    PPG1108_1_OysterCracker: 3187,
    PPG1108_2_SilkStar: 3188,
    PPG1108_3_ButterCookie: 3189,
    PPG1108_4_WaywardWind: 3190,
    PPG1108_5_SpicyMustard: 3191,
    PPG1108_6_ShutterBug: 3192,
    PPG1108_7_Obsession: 3193,
    PPG1109_1_SlicesOfHappy: 3194,
    PPG1109_2_StarBright: 3195,
    PPG1109_3_TwinkleToes: 3196,
    PPG1109_4_CitrusYellow: 3197,
    PPG1109_5_SplitPeaSoup: 3198,
    PPG1109_6_WoolenMittens: 3199,
    PPG1109_7_AutumnFestival: 3200,
    PPG1110_1_SeptemberMorn: 3201,
    PPG1110_2_SubtleSunshine: 3202,
    PPG1110_3_SereneScene: 3203,
    PPG1110_4_SecretSafari: 3204,
    PPG1110_5_Gremlin: 3205,
    PPG1110_6_OffTheGrid: 3206,
    PPG1110_7_PeasPlease: 3207,
    PPG1111_1_PrairieWinds: 3208,
    PPG1111_2_Bamboo: 3209,
    PPG1111_3_Safari: 3210,
    PPG1111_4_Nettle: 3211,
    PPG1111_5_PineappleSage: 3212,
    PPG1111_6_PickledOkra: 3213,
    PPG1111_7_SphagnumMoss: 3214,
    PPG1112_1_LittleLamb: 3215,
    PPG1112_2_CozyCream: 3216,
    PPG1112_3_OnlyOatmeal: 3217,
    PPG1112_4_BeachDune: 3218,
    PPG1112_5_WoolenVest: 3219,
    PPG1112_6_WillowTree: 3220,
    PPG1112_7_RussianOlive: 3221,
    PPG1113_1_IMissYou: 3222,
    PPG1113_2_SilverSage: 3223,
    PPG1113_3_NorthernLandscape: 3224,
    PPG1113_4_GreenGrayMist: 3225,
    PPG1113_5_SweetAnnie: 3226,
    PPG1113_6_GreenBriar: 3227,
    PPG1113_7_OliveGreen: 3228,
    PPG1114_1_Featherstone: 3229,
    PPG1114_2_RiverReed: 3230,
    PPG1114_3_CanaryGrass: 3231,
    PPG1114_4_CressGreen: 3232,
    PPG1114_5_PeaSoup: 3233,
    PPG1114_6_BronzeGreen: 3234,
    PPG1114_7_AutumnFern: 3235,
    PPG1115_1_ReallyRain: 3236,
    PPG1115_2_SageSplash: 3237,
    PPG1115_3_SlowDance: 3238,
    PPG1115_4_SageSplendor: 3239,
    PPG1115_5_PineTrail: 3240,
    PPG1115_6_PaidInFull: 3241,
    PPG1115_7_GratefullyGrass: 3242,
    PPG1116_1_JustPerfect: 3243,
    PPG1116_2_MoreMelon: 3244,
    PPG1116_3_ForgiveQuickly: 3245,
    PPG1116_4_MistyMoor: 3246,
    PPG1116_5_GraciousGlow: 3247,
    PPG1116_6_LoveliestLeaves: 3248,
    PPG1116_7_FrogsLegs: 3249,
    PPG1117_1_DelicateDaisy: 3250,
    PPG1117_2_Awareness: 3251,
    PPG1117_3_Charming: 3252,
    PPG1117_4_FloralBouquet: 3253,
    PPG1117_5_BeachBag: 3254,
    PPG1117_6_DoNotDisturb: 3255,
    PPG1117_7_EnoughIsEnough: 3256,
    PPG1118_1_MoreMint: 3257,
    PPG1118_2_AprilShowers: 3258,
    PPG1118_3_TrueToYou: 3259,
    PPG1118_4_Jitterbug: 3260,
    PPG1118_5_AlwaysApple: 3261,
    PPG1118_6_VintageVibe: 3262,
    PPG1118_7_Lucky: 3263,
    PPG1119_1_MagicalMelon: 3264,
    PPG1119_2_FountainFrolic: 3265,
    PPG1119_3_BeachGrass: 3266,
    PPG1119_4_DancingKite: 3267,
    PPG1119_5_FancyFlirt: 3268,
    PPG1119_6_GoldenGrass: 3269,
    PPG1119_7_GladeGreen: 3270,
    PPG1120_1_MentalNote: 3271,
    PPG1120_2_Gratitude: 3272,
    PPG1120_3_GreatJoy: 3273,
    PPG1120_4_PistachioPudding: 3274,
    PPG1120_5_Harmonious: 3275,
    PPG1120_6_LusciousLime: 3276,
    PPG1120_7_MintLeaves: 3277,
    PPG1121_1_Milkweed: 3278,
    PPG1121_2_LimeSpritz: 3279,
    PPG1121_3_PaleMossGreen: 3280,
    PPG1121_4_QuakingGrass: 3281,
    PPG1121_5_Guacamole: 3282,
    PPG1121_6_MossPointGreen: 3283,
    PPG1121_7_GlobeArtichoke: 3284,
    PPG1122_1_WhiteSmoke: 3285,
    PPG1122_2_LimeWash: 3286,
    PPG1122_3_PicklingSpice: 3287,
    PPG1122_4_BahiaGrass: 3288,
    PPG1122_5_Dill: 3289,
    PPG1122_6_Oregano: 3290,
    PPG1122_7_Oakmoss: 3291,
    PPG1123_1_Ageless: 3292,
    PPG1123_2_MagicalStardust: 3293,
    PPG1123_3_WildWheat: 3294,
    PPG1123_4_OnlyOlive: 3295,
    PPG1123_5_Envy: 3296,
    PPG1123_6_PlayingHooky: 3297,
    PPG1123_7_RustlingLeaves: 3298,
    PPG1124_1_TouchOfLime: 3299,
    PPG1124_2_PaleVista: 3300,
    PPG1124_3_FrostyPine: 3301,
    PPG1124_4_LightSage: 3302,
    PPG1124_5_CavernMoss: 3303,
    PPG1124_6_DarkSage: 3304,
    PPG1124_7_GrapeLeaves: 3305,
    PPG1125_1_RainCloud: 3306,
    PPG1125_2_WhiteSage: 3307,
    PPG1125_3_WhisperingPine: 3308,
    PPG1125_4_OliveSprig: 3309,
    PPG1125_5_Hemlock: 3310,
    PPG1125_6_ToyTankGreen: 3311,
    PPG1125_7_Pinetop: 3312,
    PPG1126_1_SterlingShadow: 3313,
    PPG1126_2_TwilightTwist: 3314,
    PPG1126_3_PinchOfPistachio: 3315,
    PPG1126_4_SideKick: 3316,
    PPG1126_5_ZebraGrass: 3317,
    PPG1126_6_PineGarland: 3318,
    PPG1126_7_AllAboutOlive: 3319,
    PPG1127_1_LimeDaiquiri: 3320,
    PPG1127_2_LiberatedLime: 3321,
    PPG1127_3_MerryMusic: 3322,
    PPG1127_4_Gargoyle: 3323,
    PPG1127_5_Shebang: 3324,
    PPG1127_6_WinningTicket: 3325,
    PPG1127_7_FreshBasil: 3326,
    PPG1128_1_Anonymous: 3327,
    PPG1128_2_FrivolousFolly: 3328,
    PPG1128_3_LifeLesson: 3329,
    PPG1128_4_Balsam: 3330,
    PPG1128_5_GreenTeaLeaf: 3331,
    PPG1128_6_ThymeGreen: 3332,
    PPG1128_7_CastleStone: 3333,
    PPG1129_1_CloudyDay: 3334,
    PPG1129_2_FallingStar: 3335,
    PPG1129_3_Castaway: 3336,
    PPG1129_4_CoastalCrush: 3337,
    PPG1129_5_FarmFresh: 3338,
    PPG1129_6_LotteryWinnings: 3339,
    PPG1129_7_EvergreenBoughs: 3340,
    PPG1130_1_SummerRain: 3341,
    PPG1130_2_MintWafer: 3342,
    PPG1130_3_StAugustine: 3343,
    PPG1130_4_LimeTaffy: 3344,
    PPG1130_5_PearCactus: 3345,
    PPG1130_6_MossRing: 3346,
    PPG1130_7_MountainForest: 3347,
    PPG1131_1_GreenWhisper: 3348,
    PPG1131_2_HerbalMist: 3349,
    PPG1131_3_Dreamcatcher: 3350,
    PPG1131_4_FrenchMarket: 3351,
    PPG1131_5_ChattyCricket: 3352,
    PPG1131_6_SucculentLeaves: 3353,
    PPG1131_7_CloverLeaf: 3354,
    PPG1132_1_ClairDeLune: 3355,
    PPG1132_2_Solitaire: 3356,
    PPG1132_3_TaffyTwist: 3357,
    PPG1132_4_GrandGusto: 3358,
    PPG1132_5_Plumosa: 3359,
    PPG1132_6_MallardGreen: 3360,
    PPG1132_7_Brunswick: 3361,
    PPG1133_1_Icicle: 3362,
    PPG1133_2_Tenderness: 3363,
    PPG1133_3_Limelight: 3364,
    PPG1133_4_SilverLeaf: 3365,
    PPG1133_5_SlateGreen: 3366,
    PPG1133_6_PaintedTurtle: 3367,
    PPG1133_7_RoyalHunterGreen: 3368,
    PPG1134_1_HydrangeaFloret: 3369,
    PPG1134_2_TidalFoam: 3370,
    PPG1134_3_PineFrost: 3371,
    PPG1134_4_PineWhisper: 3372,
    PPG1134_5_BirchForest: 3373,
    PPG1134_6_EnglishIvy: 3374,
    PPG1134_7_PineForest: 3375,
    PPG1135_1_PoeticLicense: 3376,
    PPG1135_2_MorningRush: 3377,
    PPG1135_3_SecretCrush: 3378,
    PPG1135_4_AquamarineDream: 3379,
    PPG1135_5_ParadiseFound: 3380,
    PPG1135_6_CalabashClash: 3381,
    PPG1135_7_Obligation: 3382,
    PPG1136_1_SeaPearl: 3383,
    PPG1136_2_Rainsong: 3384,
    PPG1136_3_MorningBreeze: 3385,
    PPG1136_4_BlueShamrock: 3386,
    PPG1136_5_SpruceShade: 3387,
    PPG1136_6_DwarfSpruce: 3388,
    PPG1136_7_DarkGreenVelvet: 3389,
    PPG1137_1_SpringRain: 3390,
    PPG1137_2_NorthernLights: 3391,
    PPG1137_3_Waterscape: 3392,
    PPG1137_4_Copenhagen: 3393,
    PPG1137_5_SilverLaurel: 3394,
    PPG1137_6_SalalLeaves: 3395,
    PPG1137_7_BlackSpruce: 3396,
    PPG1138_1_CactusBlossom: 3397,
    PPG1138_2_Geyser: 3398,
    PPG1138_3_CrystalOasis: 3399,
    PPG1138_4_Donnegal: 3400,
    PPG1138_5_PineRidge: 3401,
    PPG1138_6_ChristmasIvy: 3402,
    PPG1138_7_MidnightClover: 3403,
    PPG1139_1_SummerBreeze: 3404,
    PPG1139_2_MaltedMint: 3405,
    PPG1139_3_GreenSilk: 3406,
    PPG1139_4_Catnip: 3407,
    PPG1139_5_Sheffield: 3408,
    PPG1139_6_CountryClub: 3409,
    PPG1139_7_BilliardGreen: 3410,
    PPG1140_1_Echo: 3411,
    PPG1140_2_SweetNothings: 3412,
    PPG1140_3_Tarreyton: 3413,
    PPG1140_4_KeyLargo: 3414,
    PPG1140_5_DerbyGreen: 3415,
    PPG1140_6_Pinehurst: 3416,
    PPG1140_7_PeacockGreen: 3417,
    PPG1141_1_IceFloe: 3418,
    PPG1141_2_GreenWave: 3419,
    PPG1141_3_Cassiopeia: 3420,
    PPG1141_4_CaribbeanGreen: 3421,
    PPG1141_5_TreasureIsle: 3422,
    PPG1141_6_Carlisle: 3423,
    PPG1141_7_DeepVeridian: 3424,
    PPG1142_1_PeacefulNight: 3425,
    PPG1142_2_BigSky: 3426,
    PPG1142_3_VeridianGreen: 3427,
    PPG1142_4_PitterPatter: 3428,
    PPG1142_5_Catalina: 3429,
    PPG1142_6_JerichoJade: 3430,
    PPG1142_7_EmpressTeal: 3431,
    PPG1143_1_DelicateMist: 3432,
    PPG1143_2_BlueLullaby: 3433,
    PPG1143_3_SeaSprite: 3434,
    PPG1143_4_ParakeetPete: 3435,
    PPG1143_5_Yucca: 3436,
    PPG1143_6_SmokyEmerald: 3437,
    PPG1143_7_HollyLeaf: 3438,
    PPG1144_1_MorningFog: 3439,
    PPG1144_2_ThunderBay: 3440,
    PPG1144_3_BabblingBrook: 3441,
    PPG1144_4_HollyGlen: 3442,
    PPG1144_5_GreenGranite: 3443,
    PPG1144_6_EveningEmerald: 3444,
    PPG1144_7_CrystalBall: 3445,
    PPG1145_1_RainDrop: 3446,
    PPG1145_2_JackFrost: 3447,
    PPG1145_3_CavePearl: 3448,
    PPG1145_4_BlueWillow: 3449,
    PPG1145_5_Scarborough: 3450,
    PPG1145_6_JuniperBerry: 3451,
    PPG1145_7_NightWatch: 3452,
    PPG1146_1_MildMint: 3453,
    PPG1146_2_SpringMist: 3454,
    PPG1146_3_JulepGreen: 3455,
    PPG1146_4_FrostyGlade: 3456,
    PPG1146_5_Palmetto: 3457,
    PPG1146_6_LuckyShamrock: 3458,
    PPG1146_7_EmeraldPool: 3459,
    PPG1147_1_CameoGreen: 3460,
    PPG1147_2_MountainDew: 3461,
    PPG1147_3_MistyAqua: 3462,
    PPG1147_4_AquaFiesta: 3463,
    PPG1147_5_TealBayou: 3464,
    PPG1147_6_JadeJewel: 3465,
    PPG1147_7_TahitianTreat: 3466,
    PPG1148_1_MeadowsweetMist: 3467,
    PPG1148_2_PistachioCream: 3468,
    PPG1148_3_CosmicRays: 3469,
    PPG1148_4_LazyRiver: 3470,
    PPG1148_5_CathedralGlass: 3471,
    PPG1148_6_ViningIvy: 3472,
    PPG1148_7_DeepEmerald: 3473,
    PPG1149_1_AlpineBlue: 3474,
    PPG1149_2_HighSierra: 3475,
    PPG1149_3_ScandinavianSky: 3476,
    PPG1149_4_MountainStream: 3477,
    PPG1149_5_Baritone: 3478,
    PPG1149_6_AzaleaLeaf: 3479,
    PPG1149_7_BlueBayberry: 3480,
    PPG1150_1_AquaSparkle: 3481,
    PPG1150_2_WaterLily: 3482,
    PPG1150_3_EvergladeMist: 3483,
    PPG1150_4_KingstonAqua: 3484,
    PPG1150_5_AcapulcoCliffs: 3485,
    PPG1150_6_Bermuda: 3486,
    PPG1150_7_CaribbeanSplash: 3487,
    PPG1151_1_Beachcomber: 3488,
    PPG1151_2_Embellishment: 3489,
    PPG1151_3_MidsummersDream: 3490,
    PPG1151_4_CrystalLake: 3491,
    PPG1151_5_AquaBlue: 3492,
    PPG1151_6_Adventure: 3493,
    PPG1151_7_JamaicanDream: 3494,
    PPG1152_1_SubtleBlue: 3495,
    PPG1152_2_Breakwater: 3496,
    PPG1152_3_Graceful: 3497,
    PPG1152_4_Americana: 3498,
    PPG1152_5_GraniteFalls: 3499,
    PPG1152_6_Brigade: 3500,
    PPG1152_7_ShimmeringSea: 3501,
    PPG1153_1_IceCastles: 3502,
    PPG1153_2_Artemesia: 3503,
    PPG1153_3_BlueSmoke: 3504,
    PPG1153_4_Chambray: 3505,
    PPG1153_5_ChalkyBlue: 3506,
    PPG1153_6_SilentNight: 3507,
    PPG1153_7_SailorsCoat: 3508,
    PPG1154_1_ShootingStar: 3509,
    PPG1154_2_Aloof: 3510,
    PPG1154_3_DartmoorMist: 3511,
    PPG1154_4_Twinkle: 3512,
    PPG1154_5_SereneStream: 3513,
    PPG1154_6_PrussianBlue: 3514,
    PPG1154_7_RegattaBay: 3515,
    PPG1155_1_SummerShower: 3516,
    PPG1155_2_Prelude: 3517,
    PPG1155_3_SimplyElegant: 3518,
    PPG1155_4_Constellation: 3519,
    PPG1155_5_DresdenDream: 3520,
    PPG1155_6_CanyonBlue: 3521,
    PPG1155_7_BlueLava: 3522,
    PPG1156_1_AustrianIce: 3523,
    PPG1156_2_BitOfHeaven: 3524,
    PPG1156_3_AlwaysBlue: 3525,
    PPG1156_4_AmericanAnthem: 3526,
    PPG1156_5_SmokeBlue: 3527,
    PPG1156_6_MountainLake: 3528,
    PPG1156_7_CelestialBlue: 3529,
    PPG1157_1_Glassine: 3530,
    PPG1157_2_BluePearl: 3531,
    PPG1157_3_Sonata: 3532,
    PPG1157_4_Arabella: 3533,
    PPG1157_5_Vanity: 3534,
    PPG1157_6_CosmicDust: 3535,
    PPG1157_7_BlueFlame: 3536,
    PPG1158_1_BabysBreath: 3537,
    PPG1158_2_MagicWand: 3538,
    PPG1158_3_BlueBows: 3539,
    PPG1158_4_SereneSea: 3540,
    PPG1158_5_Cosmopolitan: 3541,
    PPG1158_6_BlueOasis: 3542,
    PPG1158_7_StunningSapphire: 3543,
    PPG1159_1_Filigree: 3544,
    PPG1159_2_CalmSea: 3545,
    PPG1159_3_HeavenlyBlue: 3546,
    PPG1159_4_WaldenPond: 3547,
    PPG1159_5_StormyRidge: 3548,
    PPG1159_6_Animation: 3549,
    PPG1159_7_SingingTheBlues: 3550,
    PPG1160_1_HarborMist: 3551,
    PPG1160_2_Magical: 3552,
    PPG1160_3_Rendezvous: 3553,
    PPG1160_4_Kaleidoscope: 3554,
    PPG1160_5_BlueBeads: 3555,
    PPG1160_6_ChinesePorcelain: 3556,
    PPG1160_7_BlueTang: 3557,
    PPG1161_1_Cityscape: 3558,
    PPG1161_2_CEstLaVie: 3559,
    PPG1161_3_Everlasting: 3560,
    PPG1161_4_BluePromise: 3561,
    PPG1161_5_ShipsHarbor: 3562,
    PPG1161_6_StarryNight: 3563,
    PPG1161_7_BrilliantBlue: 3564,
    PPG1162_1_HarborLight: 3565,
    PPG1162_2_Stratosphere: 3566,
    PPG1162_3_BlueThistle: 3567,
    PPG1162_4_AlaskanBlue: 3568,
    PPG1162_5_ShrinkingViolet: 3569,
    PPG1162_6_TeenyBikini: 3570,
    PPG1162_7_Dragonfly: 3571,
    PPG1163_1_ElusiveBlue: 3572,
    PPG1163_2_MemoryLane: 3573,
    PPG1163_3_PageantSong: 3574,
    PPG1163_4_SterlingSilver: 3575,
    PPG1163_5_SilverBlueberry: 3576,
    PPG1163_6_BlueFjord: 3577,
    PPG1163_7_BlueberryPie: 3578,
    PPG1164_1_Windswept: 3579,
    PPG1164_2_Iceberg: 3580,
    PPG1164_3_BlusteryDay: 3581,
    PPG1164_4_Dreamy: 3582,
    PPG1164_5_BlueberryMuffin: 3583,
    PPG1164_6_BlueCloud: 3584,
    PPG1164_7_AnnapolisBlue: 3585,
    PPG1165_1_JanuaryDawn: 3586,
    PPG1165_2_TwinkleBlue: 3587,
    PPG1165_3_NorthernExposure: 3588,
    PPG1165_4_Innuendo: 3589,
    PPG1165_5_EveningHush: 3590,
    PPG1165_6_StainedGlass: 3591,
    PPG1165_7_VictoryBlue: 3592,
    PPG1166_1_BrightStar: 3593,
    PPG1166_2_AsterPetal: 3594,
    PPG1166_3_BlueOpal: 3595,
    PPG1166_4_FreshViolet: 3596,
    PPG1166_5_Kimono: 3597,
    PPG1166_6_BlueOdyssey: 3598,
    PPG1166_7_DaringIndigo: 3599,
    PPG1167_1_ArcticDawn: 3600,
    PPG1167_2_WindsorHaze: 3601,
    PPG1167_3_Debonaire: 3602,
    PPG1167_4_LovelyLilac: 3603,
    PPG1167_5_SkysailBlue: 3604,
    PPG1167_6_BlueberryPatch: 3605,
    PPG1167_7_BlueJewel: 3606,
    PPG1168_1_MoonLily: 3607,
    PPG1168_2_CumberlandFog: 3608,
    PPG1168_3_PaleViolet: 3609,
    PPG1168_4_LilacTime: 3610,
    PPG1168_5_VioletAura: 3611,
    PPG1168_6_GrapeHaze: 3612,
    PPG1168_7_EgyptianViolet: 3613,
    PPG1169_1_WindsweptBeach: 3614,
    PPG1169_2_RareOrchid: 3615,
    PPG1169_3_GlacierPearl: 3616,
    PPG1169_4_TimelessLilac: 3617,
    PPG1169_5_VioletVerbena: 3618,
    PPG1169_6_GreatGrape: 3619,
    PPG1169_7_RoyalHyacinth: 3620,
    PPG1170_1_WaterIris: 3621,
    PPG1170_2_MonetsLavender: 3622,
    PPG1170_3_VioletShadow: 3623,
    PPG1170_4_SpringLilac: 3624,
    PPG1170_5_FreshLavender: 3625,
    PPG1170_6_WildWisteria: 3626,
    PPG1170_7_RomanViolet: 3627,
    PPG1171_1_SilentDelight: 3628,
    PPG1171_2_LittleDipper: 3629,
    PPG1171_3_IrradiantIris: 3630,
    PPG1171_4_Cosmic: 3631,
    PPG1171_5_CottonFlannel: 3632,
    PPG1171_6_OldMillBlue: 3633,
    PPG1171_7_Chinaberry: 3634,
    PPG1172_1_SnowStorm: 3635,
    PPG1172_2_WinterMorn: 3636,
    PPG1172_3_JamSession: 3637,
    PPG1172_4_AshGrove: 3638,
    PPG1172_5_TinLizzie: 3639,
    PPG1172_6_Silverado: 3640,
    PPG1172_7_Blackberry: 3641,
    PPG1173_1_VioletEcho: 3642,
    PPG1173_2_FebruaryFrost: 3643,
    PPG1173_3_FrostedLilac: 3644,
    PPG1173_4_Silverberry: 3645,
    PPG1173_5_PurpleSurf: 3646,
    PPG1173_6_PlumShade: 3647,
    PPG1173_7_MagicSpell: 3648,
    PPG1174_1_OrchidBlossom: 3649,
    PPG1174_2_VioletWhimsey: 3650,
    PPG1174_3_SilverChalice: 3651,
    PPG1174_4_Cloudberry: 3652,
    PPG1174_5_SmokyGrape: 3653,
    PPG1174_6_PurpleRain: 3654,
    PPG1174_7_RoyalIndigo: 3655,
    PPG1175_1_VioletHush: 3656,
    PPG1175_2_PaleOrchid: 3657,
    PPG1175_3_LavenderHaze: 3658,
    PPG1175_4_WildLilac: 3659,
    PPG1175_5_FrenchViolet: 3660,
    PPG1175_6_PurpleGrapes: 3661,
    PPG1175_7_ImperialPurple: 3662,
    PPG1176_1_Peekaboo: 3663,
    PPG1176_2_OrchidLane: 3664,
    PPG1176_3_DuskyLilac: 3665,
    PPG1176_4_PurpleEssence: 3666,
    PPG1176_5_VioletEclipse: 3667,
    PPG1176_6_Mirabella: 3668,
    PPG1176_7_PerfectlyPurple: 3669,
    PPG1177_1_OrchidPetal: 3670,
    PPG1177_2_LittleLilac: 3671,
    PPG1177_3_ShyViolet: 3672,
    PPG1177_4_LavishLavender: 3673,
    PPG1177_5_PalePlum: 3674,
    PPG1177_6_GrapeJelly: 3675,
    PPG1177_7_PansyPetal: 3676,
    PPG1178_1_LavenderTwilight: 3677,
    PPG1178_2_WineFrost: 3678,
    PPG1178_3_PaleMauve: 3679,
    PPG1178_4_SoftAmethyst: 3680,
    PPG1178_5_PalisadeOrchid: 3681,
    PPG1178_6_BlackberryJam: 3682,
    PPG1178_7_RoyalPlum: 3683,
    PPG1179_1_MistyMorn: 3684,
    PPG1179_2_SmokyOrchid: 3685,
    PPG1179_3_SilverMauve: 3686,
    PPG1179_4_RoseMarble: 3687,
    PPG1179_5_Ashberry: 3688,
    PPG1179_6_VictorianPlum: 3689,
    PPG1179_7_LovePotion: 3690,
    PPG1180_1_VioletVapor: 3691,
    PPG1180_2_RajahRose: 3692,
    PPG1180_3_SummerClover: 3693,
    PPG1180_4_LightMulberry: 3694,
    PPG1180_5_MauveMagic: 3695,
    PPG1180_6_FloweringRaspberry: 3696,
    PPG1180_7_MagicMagenta: 3697,
    PPG1181_1_CandyMix: 3698,
    PPG1181_2_BrittanysBow: 3699,
    PPG1181_3_MountainLaurel: 3700,
    PPG1181_4_TickledPink: 3701,
    PPG1181_5_RoseGlory: 3702,
    PPG1181_6_ParisPink: 3703,
    PPG1181_7_PanamaRose: 3704,
    PPG1182_1_FullBloom: 3705,
    PPG1182_2_Taffy: 3706,
    PPG1182_3_PalePrimrose: 3707,
    PPG1182_4_GardenParty: 3708,
    PPG1182_5_Primrose: 3709,
    PPG1182_6_GeraniumPink: 3710,
    PPG1182_7_FuchsiaFlock: 3711,
    PPG1183_1_Ballerina: 3712,
    PPG1183_2_Beauteous: 3713,
    PPG1183_3_RoseMelody: 3714,
    PPG1183_4_Brandywine: 3715,
    PPG1183_5_Razzberries: 3716,
    PPG1183_6_CherryPink: 3717,
    PPG1183_7_HeartsDesire: 3718,
    PPG1184_1_Gaiety: 3719,
    PPG1184_2_PleasingPink: 3720,
    PPG1184_3_PowderRose: 3721,
    PPG1184_4_PinkPunch: 3722,
    PPG1184_5_CherryBrandy: 3723,
    PPG1184_6_KennysKiss: 3724,
    PPG1184_7_CaliforniaWine: 3725,
    PPG1185_1_Fresco: 3726,
    PPG1185_2_KendallRose: 3727,
    PPG1185_3_PreciousPink: 3728,
    PPG1185_4_PrimroseGarden: 3729,
    PPG1185_5_BleedingHeart: 3730,
    PPG1185_6_CranberrySplash: 3731,
    PPG1185_7_CalypsoBerry: 3732,
    PPG1186_1_LoversKnot: 3733,
    PPG1186_2_PinkySwear: 3734,
    PPG1186_3_JaguarRose: 3735,
    PPG1186_4_PinkFlambe: 3736,
    PPG1186_5_Obsessed: 3737,
    PPG1186_6_SalsaDiane: 3738,
    PPG1186_7_RedLicorice: 3739,
    PPG1187_1_ScentedValentine: 3740,
    PPG1187_2_Adorbs: 3741,
    PPG1187_3_SilverStrawberry: 3742,
    PPG1187_4_RiverRouge: 3743,
    PPG1187_5_RedCedar: 3744,
    PPG1187_6_Bonfire: 3745,
    PPG1187_7_RedGumball: 3746,
    PPG1188_1_BurstYourBubble: 3747,
    PPG1188_2_FrostedTulip: 3748,
    PPG1188_3_Rosewine: 3749,
    PPG1188_4_SalmonPink: 3750,
    PPG1188_5_SiestaRose: 3751,
    PPG1188_6_Briquette: 3752,
    PPG1188_7_BurntRed: 3753,
    PPG1189_1_FloralLinen: 3754,
    PPG1189_2_PinkSangria: 3755,
    PPG1189_3_RosePink: 3756,
    PPG1189_4_RivieraRose: 3757,
    PPG1189_5_SmokedSalmon: 3758,
    PPG1189_6_WetCoral: 3759,
    PPG1189_7_TeaberryBlossom: 3760,
    PPG1190_1_LimogePink: 3761,
    PPG1190_2_BalletSlipper: 3762,
    PPG1190_3_SoniaRose: 3763,
    PPG1190_4_SoftSalmon: 3764,
    PPG1190_5_Cranapple: 3765,
    PPG1190_6_Firecracker: 3766,
    PPG1190_7_RumPunch: 3767,
    PPG1191_1_SummerLily: 3768,
    PPG1191_2_PeachTone: 3769,
    PPG1191_3_PeachAsh: 3770,
    PPG1191_4_CoralBlush: 3771,
    PPG1191_5_Freckles: 3772,
    PPG1191_6_CajunSpice: 3773,
    PPG1191_7_GlowingFirelight: 3774,
    PPG1192_1_ChampagneIce: 3775,
    PPG1192_2_Peachskin: 3776,
    PPG1192_3_ChicPeach: 3777,
    PPG1192_4_NewClay: 3778,
    PPG1192_5_OpalFire: 3779,
    PPG1192_6_SummerSunset: 3780,
    PPG1192_7_Tabasco: 3781,
    PPG1193_1_ScallopedShell: 3782,
    PPG1193_2_FlamingoPeach: 3783,
    PPG1193_3_CameoRose: 3784,
    PPG1193_4_SweetAngel: 3785,
    PPG1193_5_CoralSerenade: 3786,
    PPG1193_6_RusticPottery: 3787,
    PPG1193_7_CinnamonStone: 3788,
    PPG1194_1_JasmineFlower: 3789,
    PPG1194_2_LaMinuet: 3790,
    PPG1194_3_Ambrosia: 3791,
    PPG1194_4_SweetSheba: 3792,
    PPG1194_5_WarmWelcome: 3793,
    PPG1194_6_ClayPot: 3794,
    PPG1194_7_OrangeVermillion: 3795,
    PPG1195_1_PaleEcru: 3796,
    PPG1195_2_PeachEverlasting: 3797,
    PPG1195_3_MelonPink: 3798,
    PPG1195_4_CrabBisque: 3799,
    PPG1195_5_CoralSilk: 3800,
    PPG1195_6_IndianaClay: 3801,
    PPG1195_7_FieldPoppy: 3802,
    PPG1196_1_Peachtree: 3803,
    PPG1196_2_MelonIce: 3804,
    PPG1196_3_Dreamsicle: 3805,
    PPG1196_4_ShrimpBoat: 3806,
    PPG1196_5_CopperRiver: 3807,
    PPG1196_6_ChineseLantern: 3808,
    PPG1196_7_OrangePoppy: 3809,
    PPG1197_1_TangeloCream: 3810,
    PPG1197_2_LightPeach: 3811,
    PPG1197_3_Bisque: 3812,
    PPG1197_4_ShrimpToast: 3813,
    PPG1197_5_OrangeMarmalade: 3814,
    PPG1197_6_FallLeaf: 3815,
    PPG1197_7_CarmelizedOrange: 3816,
    PPG1198_1_PecanSandie: 3817,
    PPG1198_2_BuddingPeach: 3818,
    PPG1198_3_CitrusSachet: 3819,
    PPG1198_4_OrangeLiqueur: 3820,
    PPG1198_5_CarrotCake: 3821,
    PPG1198_6_TigerTail: 3822,
    PPG1198_7_SesameCrunch: 3823,
    PPG1199_1_Alyssa: 3824,
    PPG1199_2_PeachShortcake: 3825,
    PPG1199_3_SpicedOrange: 3826,
    PPG1199_4_HushPuppy: 3827,
    PPG1199_5_CinnamonBrandy: 3828,
    PPG1199_6_BrownClay: 3829,
    PPG1199_7_FragrantCloves: 3830,
    PPG12_01_CornSilk: 3831,
    PPG12_02_CordonBleu: 3832,
    PPG12_03_SunSalutation: 3833,
    PPG12_04_BulletinBoard: 3834,
    PPG12_05_WinterWheat: 3835,
    PPG12_06_Lira: 3836,
    PPG12_07_WavesOfGrain: 3837,
    PPG12_08_BoldButterscotch: 3838,
    PPG12_09_RiceCake: 3839,
    PPG12_10_Millet: 3840,
    PPG12_11_AntiqueCream: 3841,
    PPG12_12_TrueBlonde: 3842,
    PPG12_13_CamelTan: 3843,
    PPG12_14_CraftsmanGold: 3844,
    PPG12_15_Hearth: 3845,
    PPG12_16_DesertCamel: 3846,
    PPG12_17_TuscanSun: 3847,
    PPG12_18_Hayloft: 3848,
    PPG12_19_Antiquity: 3849,
    PPG12_20_CanvasSatchel: 3850,
    PPG12_21_Foothills: 3851,
    PPG12_22_AppalachianTrail: 3852,
    PPG12_23_TurningOakleaf: 3853,
    PPG12_24_GatheringField: 3854,
    PPG12_25_ToTheRescue: 3855,
    PPG12_26_AssateagueSand: 3856,
    PPG12_27_Soleil: 3857,
    PPG12_28_AtTheBeach: 3858,
    PPG12_29_FamilyTies: 3859,
    PPG12_30_Baguette: 3860,
    PPG12_31_NeutralBeige: 3861,
    PPG12_32_SandcastleSymphony: 3862,
    PPG1200_1_ChinaDoll: 3863,
    PPG1200_2_SourpatchPeach: 3864,
    PPG1200_3_Siesta: 3865,
    PPG1200_4_OrangeClay: 3866,
    PPG1200_5_GeorgianLeather: 3867,
    PPG1200_6_GingerRoot: 3868,
    PPG1200_7_Mincemeat: 3869,
    PPG1201_1_UptownTaupe: 3870,
    PPG1201_2_TeaBiscuit: 3871,
    PPG1201_3_PeachDarling: 3872,
    PPG1201_4_GentleDoe: 3873,
    PPG1201_5_PumpkinPatch: 3874,
    PPG1201_6_Gingerbread: 3875,
    PPG1201_7_LuckyPenny: 3876,
    PPG1202_1_VanillaTan: 3877,
    PPG1202_2_PeachSurprise: 3878,
    PPG1202_3_CrispWonTon: 3879,
    PPG1202_4_CaramelIce: 3880,
    PPG1202_5_BuffaloTrail: 3881,
    PPG1202_6_PoloPony: 3882,
    PPG1202_7_GingerBeer: 3883,
    PPG1203_1_SpunCotton: 3884,
    PPG1203_2_Mimosa: 3885,
    PPG1203_3_PeachDip: 3886,
    PPG1203_4_GingerPeach: 3887,
    PPG1203_5_Zing: 3888,
    PPG1203_6_Goldfish: 3889,
    PPG1203_7_Cornucopia: 3890,
    PPG1204_1_SpiceIvory: 3891,
    PPG1204_2_VanillaWafer: 3892,
    PPG1204_3_CreamyCustard: 3893,
    PPG1204_4_Doodle: 3894,
    PPG1204_5_ChunkOfCheddar: 3895,
    PPG1204_6_GoldenOpportunity: 3896,
    PPG1204_7_MangoMargarita: 3897,
    PPG1205_1_CombedCotton: 3898,
    PPG1205_2_SoftCream: 3899,
    PPG1205_3_BarelyButter: 3900,
    PPG1205_4_HoneyBee: 3901,
    PPG1205_5_EveningGlow: 3902,
    PPG1205_6_HoneyPot: 3903,
    PPG1205_7_FallGold: 3904,
    PPG1206_1_LotusFlower: 3905,
    PPG1206_2_SilkSails: 3906,
    PPG1206_3_ShinySilk: 3907,
    PPG1206_4_Sawdust: 3908,
    PPG1206_5_SpicedButternut: 3909,
    PPG1206_6_FuzzyNavel: 3910,
    PPG1206_7_Rise_N_Shine: 3911,
    PPG1207_1_CandlelitBeige: 3912,
    PPG1207_2_GoldenMushroom: 3913,
    PPG1207_3_HoneyBeige: 3914,
    PPG1207_4_ToffeeCrunch: 3915,
    PPG1207_5_LionsMane: 3916,
    PPG1207_6_Allspice: 3917,
    PPG1207_7_CiderToddy: 3918,
    PPG1208_1_Accolade: 3919,
    PPG1208_2_SpiceDelight: 3920,
    PPG1208_3_BelgianWaffle: 3921,
    PPG1208_4_GoldBuff: 3922,
    PPG1208_5_BrownMustard: 3923,
    PPG1208_6_MayanTreasure: 3924,
    PPG1208_7_GothicGold: 3925,
    PPG1209_1_SatinWeave: 3926,
    PPG1209_2_Sausalito: 3927,
    PPG1209_3_DustyYellow: 3928,
    PPG1209_4_YukonGold: 3929,
    PPG1209_5_YellowConeflower: 3930,
    PPG1209_6_BrassMesh: 3931,
    PPG1209_7_MeccaGold: 3932,
    PPG1210_1_CrispCandlelight: 3933,
    PPG1210_2_GentleGlow: 3934,
    PPG1210_3_Visionary: 3935,
    PPG1210_4_MaybeMaui: 3936,
    PPG1210_5_BrightIdea: 3937,
    PPG1210_6_VaVaVoom: 3938,
    PPG1210_7_CurrySauce: 3939,
    PPG1211_1_GoodGraces: 3940,
    PPG1211_2_HeavenlyHaze: 3941,
    PPG1211_3_EasyOnTheEyes: 3942,
    PPG1211_4_TwinkleLittleStar: 3943,
    PPG1211_5_Firelight: 3944,
    PPG1211_6_BeachParty: 3945,
    PPG1211_7_BeDaring: 3946,
    PPG1212_1_CapriCream: 3947,
    PPG1212_2_BananaPudding: 3948,
    PPG1212_3_Sunbeam: 3949,
    PPG1212_4_LazyDaizy: 3950,
    PPG1212_5_CitrusPunch: 3951,
    PPG1212_6_AcornSquash: 3952,
    PPG1212_7_Flirtatious: 3953,
    PPG1213_1_SailCloth: 3954,
    PPG1213_2_BlondeBeauty: 3955,
    PPG1213_3_Butter: 3956,
    PPG1213_4_GoldenStraw: 3957,
    PPG1213_5_Calabash: 3958,
    PPG1213_6_DillyDally: 3959,
    PPG1213_7_CrushedPineapple: 3960,
    PPG1214_1_CakeBatter: 3961,
    PPG1214_2_GoldenFleece: 3962,
    PPG1214_3_BananaBrulee: 3963,
    PPG1214_4_ButterflyBush: 3964,
    PPG1214_5_ForsythiaBlossom: 3965,
    PPG1214_6_GoldenHour: 3966,
    PPG1214_7_Yarrow: 3967,
    PPG1215_1_ClearYellow: 3968,
    PPG1215_2_BrightLaughter: 3969,
    PPG1215_3_PineappleDelight: 3970,
    PPG1215_4_CanaryYellow: 3971,
    PPG1215_5_GoldenYarrow: 3972,
    PPG1215_6_GrassDaisy: 3973,
    PPG1215_7_Pollination: 3974,
    PPG1216_1_MorningGlow: 3975,
    PPG1216_2_CoolYellow: 3976,
    PPG1216_3_SpringBlossom: 3977,
    PPG1216_4_LemonPepper: 3978,
    PPG1216_5_FreshLemonade: 3979,
    PPG1216_6_CitrusSpice: 3980,
    PPG1216_7_GoneGiddy: 3981,
    PPG1217_1_Giggle: 3982,
    PPG1217_2_LimitedLime: 3983,
    PPG1217_3_HipHop: 3984,
    PPG1217_4_MermaidTears: 3985,
    PPG1217_5_LimeSplash: 3986,
    PPG1217_6_GreenGecko: 3987,
    PPG1217_7_SlapHappy: 3988,
    PPG1218_1_OhDahling: 3989,
    PPG1218_2_MysticMelon: 3990,
    PPG1218_3_LivelyLaugh: 3991,
    PPG1218_4_ForceOfNature: 3992,
    PPG1218_5_Parachute: 3993,
    PPG1218_6_MachineGreen: 3994,
    PPG1218_7_BeYourself: 3995,
    PPG1219_1_PlainAndSimple: 3996,
    PPG1219_2_Daydream: 3997,
    PPG1219_3_Curious: 3998,
    PPG1219_4_GoodyGumdrop: 3999,
    PPG1219_5_BoogieBlast: 4000,
    PPG1219_6_Hopscotch: 4001,
    PPG1219_7_Lichen: 4002,
    PPG1220_1_Memoir: 4003,
    PPG1220_2_PassionatePause: 4004,
    PPG1220_3_LotsOfBubbles: 4005,
    PPG1220_4_HighHopes: 4006,
    PPG1220_5_CleanNCrisp: 4007,
    PPG1220_6_GlowWorm: 4008,
    PPG1220_7_Mojo: 4009,
    PPG1221_1_AloeEssence: 4010,
    PPG1221_2_QuietRain: 4011,
    PPG1221_3_MellowMint: 4012,
    PPG1221_4_Faith: 4013,
    PPG1221_5_LivinLarge: 4014,
    PPG1221_6_BeSpontaneous: 4015,
    PPG1221_7_FunkyFrog: 4016,
    PPG1222_1_LimeMeringue: 4017,
    PPG1222_2_HoneydewMelon: 4018,
    PPG1222_3_AloeVera: 4019,
    PPG1222_4_LettuceAlone: 4020,
    PPG1222_5_LimeGreen: 4021,
    PPG1222_6_Asparagus: 4022,
    PPG1222_7_AntiqueMoss: 4023,
    PPG1223_1_GreenTease: 4024,
    PPG1223_2_LilyPond: 4025,
    PPG1223_3_LimeFlip: 4026,
    PPG1223_4_BleachedSpruce: 4027,
    PPG1223_5_HeartyHosta: 4028,
    PPG1223_6_GrassyMeadow: 4029,
    PPG1223_7_AntiqueGreen: 4030,
    PPG1224_1_AlaskanMist: 4031,
    PPG1224_2_SpearmintStick: 4032,
    PPG1224_3_ChilledMint: 4033,
    PPG1224_4_LantanaLime: 4034,
    PPG1224_5_AlmostAloe: 4035,
    PPG1224_6_CelerySprig: 4036,
    PPG1224_7_GreenPear: 4037,
    PPG1225_1_HintOfMint: 4038,
    PPG1225_2_DewmistDelight: 4039,
    PPG1225_3_Applemint: 4040,
    PPG1225_4_LimeSorbet: 4041,
    PPG1225_5_MayApple: 4042,
    PPG1225_6_BermudaGrass: 4043,
    PPG1225_7_LeapFrog: 4044,
    PPG1226_1_TintOfGreen: 4045,
    PPG1226_2_PeppermintPatty: 4046,
    PPG1226_3_SpriteTwist: 4047,
    PPG1226_4_HeathGreen: 4048,
    PPG1226_5_GardenMint: 4049,
    PPG1226_6_BasilPesto: 4050,
    PPG1226_7_BlarneyStone: 4051,
    PPG1227_1_SeaMist: 4052,
    PPG1227_2_SweetPea: 4053,
    PPG1227_3_MountainMint: 4054,
    PPG1227_4_CrystalGem: 4055,
    PPG1227_5_AragonGreen: 4056,
    PPG1227_6_Beanstalk: 4057,
    PPG1227_7_GreenGloss: 4058,
    PPG1228_1_MaggiesMagic: 4059,
    PPG1228_2_JadeSpell: 4060,
    PPG1228_3_FloweringCactus: 4061,
    PPG1228_4_GreenBalloon: 4062,
    PPG1228_5_LaurelWreath: 4063,
    PPG1228_6_Leprechaun: 4064,
    PPG1228_7_IvyLeague: 4065,
    PPG1229_1_Wintergreen: 4066,
    PPG1229_2_WintergreenMint: 4067,
    PPG1229_3_AlmostAqua: 4068,
    PPG1229_4_TropicalTide: 4069,
    PPG1229_5_Aloha: 4070,
    PPG1229_6_CongoGreen: 4071,
    PPG1229_7_CarolinaGreen: 4072,
    PPG1230_1_TropicalDream: 4073,
    PPG1230_2_Serendipity: 4074,
    PPG1230_3_Whirlpool: 4075,
    PPG1230_4_PaleJade: 4076,
    PPG1230_5_JewelWeed: 4077,
    PPG1230_6_MiamiJade: 4078,
    PPG1230_7_MedievalForest: 4079,
    PPG1231_1_HallowedHush: 4080,
    PPG1231_2_SwanLake: 4081,
    PPG1231_3_Minerva: 4082,
    PPG1231_4_TropicalHoliday: 4083,
    PPG1231_5_ArtesianWell: 4084,
    PPG1231_6_AzureTide: 4085,
    PPG1231_7_RomanticIsle: 4086,
    PPG1232_1_IceBlue: 4087,
    PPG1232_2_Cascade: 4088,
    PPG1232_3_SilentRipple: 4089,
    PPG1232_4_IsleRoyale: 4090,
    PPG1232_5_TintOfTurquoise: 4091,
    PPG1232_6_GrecianIsle: 4092,
    PPG1232_7_TorridTurquoise: 4093,
    PPG1233_1_FreeSpirit: 4094,
    PPG1233_2_Seaspray: 4095,
    PPG1233_3_PaleSeafoam: 4096,
    PPG1233_4_SeascapeGreen: 4097,
    PPG1233_5_TropicalSplash: 4098,
    PPG1233_6_MontegoBay: 4099,
    PPG1233_7_RivieraParadise: 4100,
    PPG1234_1_AquaTint: 4101,
    PPG1234_2_Plateau: 4102,
    PPG1234_3_AquaWhisper: 4103,
    PPG1234_4_FlingGreen: 4104,
    PPG1234_5_BiscayBay: 4105,
    PPG1234_6_SeaFantasy: 4106,
    PPG1234_7_HypnoticSea: 4107,
    PPG1235_1_KissMeKate: 4108,
    PPG1235_2_BluePhlox: 4109,
    PPG1235_3_Galactica: 4110,
    PPG1235_4_IdyllicIsle: 4111,
    PPG1235_5_BlueCalypso: 4112,
    PPG1235_6_SafeHarbor: 4113,
    PPG1235_7_BiminiBlue: 4114,
    PPG1236_1_Breathless: 4115,
    PPG1236_2_EnchantedEvening: 4116,
    PPG1236_3_SurfsUp: 4117,
    PPG1236_4_OceanCruise: 4118,
    PPG1236_5_HighDive: 4119,
    PPG1236_6_JamaicanSea: 4120,
    PPG1236_7_MediterraneanBlue: 4121,
    PPG1237_1_Bashful: 4122,
    PPG1237_2_DiamondBlue: 4123,
    PPG1237_3_Ariel: 4124,
    PPG1237_4_HorizonHaze: 4125,
    PPG1237_5_MysticBlue: 4126,
    PPG1237_6_Bellflower: 4127,
    PPG1237_7_Neptune: 4128,
    PPG1238_1_Airy: 4129,
    PPG1238_2_Goddess: 4130,
    PPG1238_3_FlemishBlue: 4131,
    PPG1238_4_HarborSky: 4132,
    PPG1238_5_Hush_A_Bye: 4133,
    PPG1238_6_BluePaisley: 4134,
    PPG1238_7_PortAuPrince: 4135,
    PPG1239_1_Wavecrest: 4136,
    PPG1239_2_DucksEggBlue: 4137,
    PPG1239_3_WindsorWay: 4138,
    PPG1239_4_SalemBlue: 4139,
    PPG1239_5_QuietNight: 4140,
    PPG1239_6_NorthSea: 4141,
    PPG1239_7_RaveRegatta: 4142,
    PPG1240_1_OceanBreeze: 4143,
    PPG1240_2_NiagaraFalls: 4144,
    PPG1240_3_Songbird: 4145,
    PPG1240_4_XavierBlue: 4146,
    PPG1240_5_Sorcerer: 4147,
    PPG1240_6_NewportBlue: 4148,
    PPG1240_7_CobaltGlaze: 4149,
    PPG1241_1_FirstLight: 4150,
    PPG1241_2_VitaminSea: 4151,
    PPG1241_3_SweetDreams: 4152,
    PPG1241_4_Windjammer: 4153,
    PPG1241_5_MagicalMerlin: 4154,
    PPG1241_6_ElectricBlue: 4155,
    PPG1241_7_CobaltStone: 4156,
    PPG1242_1_FirstFrost: 4157,
    PPG1242_2_TouchOfBlue: 4158,
    PPG1242_3_VivaLaBleu: 4159,
    PPG1242_4_Overcast: 4160,
    PPG1242_5_KingTriton: 4161,
    PPG1242_6_Planetarium: 4162,
    PPG1242_7_SuddenlySapphire: 4163,
    PPG1243_1_SweetIllusion: 4164,
    PPG1243_2_HauntingHue: 4165,
    PPG1243_3_SetSail: 4166,
    PPG1243_4_VictoriaBlue: 4167,
    PPG1243_5_BlueDart: 4168,
    PPG1243_6_RoyalPlume: 4169,
    PPG1243_7_RainbowBright: 4170,
    PPG1244_1_Abyss: 4171,
    PPG1244_2_BlueSilk: 4172,
    PPG1244_3_Valor: 4173,
    PPG1244_4_BoudoirBlue: 4174,
    PPG1244_5_BlueberryPopover: 4175,
    PPG1244_6_NocturneShade: 4176,
    PPG1244_7_FlorentineLapis: 4177,
    PPG1245_1_OrchidWhisper: 4178,
    PPG1245_2_PaleLilac: 4179,
    PPG1245_3_SweetEmily: 4180,
    PPG1245_4_LilacSachet: 4181,
    PPG1245_5_BlueHyacinth: 4182,
    PPG1245_6_KingsRobe: 4183,
    PPG1245_7_CrushedVelvet: 4184,
    PPG1246_1_VioletIce: 4185,
    PPG1246_2_WeepingWisteria: 4186,
    PPG1246_3_GlobeThistle: 4187,
    PPG1246_4_FrenchLilac: 4188,
    PPG1246_5_MysticIris: 4189,
    PPG1246_6_VioletsAreBlue: 4190,
    PPG1246_7_BlueCalico: 4191,
    PPG1247_1_OrchidMist: 4192,
    PPG1247_2_GuardianAngel: 4193,
    PPG1247_3_MistyViolet: 4194,
    PPG1247_4_PurpleDragon: 4195,
    PPG1247_5_GrapeArbor: 4196,
    PPG1247_6_PurpleRhapsody: 4197,
    PPG1247_7_Eggplant: 4198,
    PPG1248_1_Coronation: 4199,
    PPG1248_2_IrisIsle: 4200,
    PPG1248_3_VelvetScarf: 4201,
    PPG1248_4_LilacBreeze: 4202,
    PPG1248_5_Puturple: 4203,
    PPG1248_6_MagicCarpet: 4204,
    PPG1248_7_ReignOverMe: 4205,
    PPG1249_1_VioletVogue: 4206,
    PPG1249_2_LavenderVista: 4207,
    PPG1249_3_GrapeGlimmer: 4208,
    PPG1249_4_WindsorPurple: 4209,
    PPG1249_5_PurpleStatice: 4210,
    PPG1249_6_GrapePopsicle: 4211,
    PPG1249_7_CleopatrasGown: 4212,
    PPG1250_1_AngoraPink: 4213,
    PPG1250_2_LilacFrost: 4214,
    PPG1250_3_SyrianViolet: 4215,
    PPG1250_4_SeaLavender: 4216,
    PPG1250_5_PlumPerfect: 4217,
    PPG1250_6_BellHeather: 4218,
    PPG1250_7_RoyalLilac: 4219,
    PPG1251_1_DreamDust: 4220,
    PPG1251_2_Tiara: 4221,
    PPG1251_3_SonoraRose: 4222,
    PPG1251_4_PinkPeony: 4223,
    PPG1251_5_MoorlandHeather: 4224,
    PPG1251_6_MulberryBush: 4225,
    PPG1251_7_GrapeJuice: 4226,
    PPG1252_1_LavenderPearl: 4227,
    PPG1252_2_HeavenSent: 4228,
    PPG1252_3_DesertDawn: 4229,
    PPG1252_4_SweetAlyssum: 4230,
    PPG1252_5_ChateauRose: 4231,
    PPG1252_6_DaphneRose: 4232,
    PPG1252_7_BermudaOnion: 4233,
    PPG13_01_PomegranatePunch: 4234,
    PPG13_02_CherokeeRed: 4235,
    PPG13_03_BurgundyWine: 4236,
    PPG13_04_Merlot: 4237,
    PPG13_05_OldBurgundy: 4238,
    PPG13_06_Chianti: 4239,
    PPG13_07_EnchantingEggplant: 4240,
    PPG13_08_PositivelyPurple: 4241,
    PPG13_09_CrushedTomatoes: 4242,
    PPG13_10_CandyApple: 4243,
    PPG13_11_MadeiraRed: 4244,
    PPG13_12_CrazedCranberry: 4245,
    PPG13_13_RoastedPepper: 4246,
    PPG13_14_HeartsAfire: 4247,
    PPG13_15_BingeWatch: 4248,
    PPG13_16_Blaze: 4249,
    PPG13_17_PurpleParlor: 4250,
    PPG13_18_PinotNoir: 4251,
    PPG13_19_PurpleDusk: 4252,
    PPG13_20_PageantPansy: 4253,
    PPG13_21_Blackberry: 4254,
    PPG13_22_Silverado: 4255,
    PPG13_23_AmethystHaze: 4256,
    PPG13_24_MagicDust: 4257,
    PPG13_25_DaringIndigo: 4258,
    PPG13_26_BlueLava: 4259,
    PPG13_27_PlymouthBlue: 4260,
    PPG13_28_CaribbeanHoliday: 4261,
    PPG13_29_AntiqueSlate: 4262,
    PPG13_30_SeaGlass: 4263,
    PPG13_31_StillSearching: 4264,
    PPG13_32_EmeraldCity: 4265,
    PPG14_01_ShadowTaupe: 4266,
    PPG14_02_NutShell: 4267,
    PPG14_03_Seagull: 4268,
    PPG14_04_CityStreet: 4269,
    PPG14_05_DarkAsNight: 4270,
    PPG14_06_WinterFeather: 4271,
    PPG14_07_ScotchMist: 4272,
    PPG14_08_Horseradish: 4273,
    PPG14_09_RockCliffs: 4274,
    PPG14_10_SummerWheat: 4275,
    PPG14_11_Static: 4276,
    PPG14_12_JewelWhite: 4277,
    PPG14_13_OysterShell: 4278,
    PPG14_14_SummerSuede: 4279,
    PPG14_15_FrenchCream: 4280,
    PPG14_16_WinterMood: 4281,
    PPG14_17_Armadillo: 4282,
    PPG14_18_Gaia: 4283,
    PPG14_19_AlpacaWool: 4284,
    PPG14_20_Purity: 4285,
    PPG14_21_WheatSheaf: 4286,
    PPG14_22_BoneWhite: 4287,
    PPG14_23_Edelweiss: 4288,
    PPG14_24_DogwoodBlossom: 4289,
    PPG14_25_FishermansNet: 4290,
    PPG14_26_Hideaway: 4291,
    PPG14_27_TrueKhaki: 4292,
    PPG14_28_Aldabra: 4293,
    PPG14_29_MothGray: 4294,
    PPG14_30_GrayBeige: 4295,
    PPG14_31_Paraffin: 4296,
    PPG14_32_OstrichFeather: 4297,
    PPG15_01_MaisonDeCampagne: 4298,
    PPG15_02_AppleButter: 4299,
    PPG15_03_BroncoBrown: 4300,
    PPG15_04_YosemiteTrailhead: 4301,
    PPG15_05_MacaroonCream: 4302,
    PPG15_06_WhiteChip: 4303,
    PPG15_07_YorkIvory: 4304,
    PPG15_08_BurntIvory: 4305,
    PPG15_09_Antelope: 4306,
    PPG15_10_PetalumaDust: 4307,
    PPG15_11_Rabbit: 4308,
    PPG15_12_Kangaroo: 4309,
    PPG15_13_ChocolateTruffle: 4310,
    PPG15_14_Leather: 4311,
    PPG15_15_CoffeeKiss: 4312,
    PPG15_16_BestBeige: 4313,
    PPG15_17_ElephantGray: 4314,
    PPG15_18_Introspective: 4315,
    PPG15_19_RapidRock: 4316,
    PPG15_20_GhostShip: 4317,
    PPG15_21_Curlew: 4318,
    PPG15_22_Pumpernickel: 4319,
    PPG15_23_Chestnut: 4320,
    PPG15_24_FrenchToast: 4321,
    PPG15_25_Stonington: 4322,
    PPG15_26_ToastedAlmond: 4323,
    PPG15_27_BotanyBeige: 4324,
    PPG15_28_GreatGray: 4325,
    PPG15_29_ElCapitan: 4326,
    PPG15_30_RoastedChestnut: 4327,
    PPG15_31_BeigeTellin: 4328,
    PPG15_32_Portabella: 4329,
    PPG16_01_SombreroTan: 4330,
    PPG16_02_SummerSpice: 4331,
    PPG16_03_BurningSand: 4332,
    PPG16_04_Capuccino: 4333,
    PPG16_05_CaramelSugar: 4334,
    PPG16_06_RedRockFalls: 4335,
    PPG16_07_SouthernWood: 4336,
    PPG16_08_AntiqueMahogany: 4337,
    PPG16_09_LinenTint: 4338,
    PPG16_10_Hummus: 4339,
    PPG16_11_ApolloGold: 4340,
    PPG16_12_ItalianSaffron: 4341,
    PPG16_13_PumpkinSpice: 4342,
    PPG16_14_BranMuffin: 4343,
    PPG16_15_BrownBasket: 4344,
    PPG16_16_TreasureHunt: 4345,
    PPG16_17_TudorBeige: 4346,
    PPG16_18_CoveredWagon: 4347,
    PPG16_19_Broomstick: 4348,
    PPG16_20_BronzeEucalyptus: 4349,
    PPG16_21_FreshPraline: 4350,
    PPG16_22_Chaparral: 4351,
    PPG16_23_TampicoBrown: 4352,
    PPG16_24_ChocolateCroissant: 4353,
    PPG16_25_MapleGranola: 4354,
    PPG16_26_ClayFire: 4355,
    PPG16_27_CopperTrail: 4356,
    PPG16_28_CrushedCinnamon: 4357,
    PPG16_29_HuntClubRed: 4358,
    PPG16_30_MutedCopper: 4359,
    PPG16_31_RichClay: 4360,
    PPG16_32_RedClay: 4361,
    PPG17_01_Suenos: 4362,
    PPG17_02_Cenote: 4363,
    PPG17_03_HaciendaTalavera: 4364,
    PPG17_04_Kimono: 4365,
    PPG17_05_BlueCalico: 4366,
    PPG17_06_MagicalMoment: 4367,
    PPG17_07_CrowningGlory: 4368,
    PPG17_08_HeatherGlen: 4369,
    PPG17_09_FlorentinePink: 4370,
    PPG17_10_TuttiFrutti: 4371,
    PPG17_11_Cerise: 4372,
    PPG17_12_Granada: 4373,
    PPG17_13_BurntRed: 4374,
    PPG17_14_BleedingHeart: 4375,
    PPG17_15_RusticPottery: 4376,
    PPG17_16_CandyCorn: 4377,
    PPG17_17_Mariposa: 4378,
    PPG17_18_SolDeYucatan: 4379,
    PPG17_19_OroDeMaya: 4380,
    PPG17_20_Tesoros: 4381,
    PPG17_21_SorbeteDeMelon: 4382,
    PPG17_22_Dynamo: 4383,
    PPG17_23_Cazuela: 4384,
    PPG17_24_CopperPenny: 4385,
    PPG17_25_GotTheGiggles: 4386,
    PPG17_26_WillowHerb: 4387,
    PPG17_27_FernGlow: 4388,
    PPG17_28_LeafMeBe: 4389,
    PPG17_29_SanJuanSpritz: 4390,
    PPG17_30_DinnerMint: 4391,
    PPG17_31_CaribbeanCrush: 4392,
    PPG17_32_TealWeMeetAgain: 4393,
    PPG18_01_CrumbCookie: 4394,
    PPG18_02_RiverRock: 4395,
    PPG18_03_GreyMauve: 4396,
    PPG18_04_Luxurious: 4397,
    PPG18_05_Awakening: 4398,
    PPG18_06_MexicaliRose: 4399,
    PPG18_07_LusciousLilac: 4400,
    PPG18_08_SmokyQuartz: 4401,
    PPG18_09_GarlicClove: 4402,
    PPG18_10_LotusPetal: 4403,
    PPG18_11_PastelPaper: 4404,
    PPG18_12_GranddadsGirl: 4405,
    PPG18_13_BeigeLlama: 4406,
    PPG18_14_SpiceBeige: 4407,
    PPG18_15_ShrimpSalad: 4408,
    PPG18_16_SalmonEggs: 4409,
    PPG18_17_JustBlush: 4410,
    PPG18_18_RoseBlush: 4411,
    PPG18_19_CrushedRoses: 4412,
    PPG18_20_Thornberry: 4413,
    PPG18_21_MoodyMauve: 4414,
    PPG18_22_MakeMineMauve: 4415,
    PPG18_23_BerriesAndCream: 4416,
    PPG18_24_PurpleCabbage: 4417,
    PPG18_25_Belleek: 4418,
    PPG18_26_PeachBrick: 4419,
    PPG18_27_PeachBeauty: 4420,
    PPG18_28_Adorable: 4421,
    PPG18_29_Emberglo: 4422,
    PPG18_30_LushRose: 4423,
    PPG18_31_RaspberryRipple: 4424,
    PPG18_32_BerryPicking: 4425,
  },
  Richwood: {
    Richwood_Black: 185,
    Richwood_SpanishMoss: 186,
  },
  Rollex: {
    Rollex_Almond5: 40,
    Rollex_BrightWhite: 41,
  },
  RoyalBuilding: {
    Royal_Almond: 10806,
    Royal_AlmostMidnight: 11191,
    Royal_AntiqueBrown: 10807,
    Royal_AspenWhite: 11192,
    Royal_Beige: 10808,
    Royal_Black: 10809,
    Royal_BlueGray: 11028,
    Royal_Bone: 11193,
    Royal_BrownStone: 11029,
    Royal_BurgundyRed: 11030,
    Royal_Cactus: 10810,
    Royal_Canyon: 11194,
    Royal_Carbon: 11195,
    Royal_Cashmere: 10811,
    Royal_Charcoal: 10812,
    Royal_Chocolate: 10813,
    Royal_ClassicBlue: 11031,
    Royal_Clay: 10814,
    Royal_CommercialBrown: 10815,
    Royal_CountryBeige: 11196,
    Royal_Cypress: 11032,
    Royal_Driftwood: 11197,
    Royal_Eclipse: 11033,
    Royal_Espresso: 11198,
    Royal_Flagstone: 11034,
    Royal_ForestGreen: 10816,
    Royal_FrenchRoast: 11035,
    Royal_Granite: 11036,
    Royal_Graphite: 11199,
    Royal_Gray: 10817,
    Royal_Greystone: 11200,
    Royal_HarvardSlate: 11037,
    Royal_Heather: 11038,
    Royal_HeritageBlue: 11039,
    Royal_Indigo: 11201,
    Royal_Ironstone: 10818,
    Royal_Ivory: 10819,
    Royal_LighthouseRed: 11202,
    Royal_Linen: 10820,
    Royal_MarineBlue: 11040,
    Royal_MediumBrown: 10821,
    Royal_MetropolitanGray: 11203,
    Royal_MidnightBlue: 11041,
    Royal_MidnightSurf: 11042,
    Royal_Mocha: 11204,
    Royal_Moss: 10822,
    Royal_MusketBrown: 11043,
    Royal_Nantucket: 11205,
    Royal_Oceanside: 11206,
    Royal_Paintable: 11044,
    Royal_Pearl: 11207,
    Royal_PebbleClay: 10823,
    Royal_Platinum: 11045,
    Royal_Polaris: 11208,
    Royal_Redwood: 11046,
    Royal_Regatta: 11209,
    Royal_Riverway: 11047,
    Royal_Rockslide: 11048,
    Royal_Rye: 11210,
    Royal_Saddle: 11211,
    Royal_Sand: 10824,
    Royal_Sandstone: 10825,
    Royal_Shamrock: 11049,
    Royal_SilverMist: 11050,
    Royal_Slate: 11212,
    Royal_SmokyAsh: 11213,
    Royal_SoftMaple: 11051,
    Royal_Spruce: 11214,
    Royal_Sterling: 11052,
    Royal_StoneHarbor: 11215,
    Royal_Storm: 11053,
    Royal_StormCloud: 11054,
    Royal_Timber: 10826,
    Royal_ToastedAlmond: 11055,
    Royal_TreatedCedar: 11056,
    Royal_TreeMoss: 11057,
    Royal_TuxedoGrey: 11058,
    Royal_UniversalBrown: 10827,
    Royal_UrbanBronze: 11059,
    Royal_VintageCream: 11060,
    Royal_Walnut: 11061,
    Royal_WeatheredGray: 11062,
    Royal_Wedgewood: 11063,
    Royal_Wheat: 11216,
    Royal_White: 10828,
    Royal_Wicker: 10829,
    Royal_Wineberry: 11064,
  },
  Schell_Colors: {
    Schell_AspenWhite: 2016,
    Schell_Black: 2017,
    Schell_BrightWhite: 2018,
    Schell_Clay: 2019,
    Schell_Driftwood: 2020,
    Schell_Greystone: 2021,
    Schell_Indigo: 2022,
    Schell_MidnightBlue: 2023,
    Schell_Polaris: 2024,
    Schell_White: 2025,
  },
  SherwinWilliams: {
    HGSW_0024_CurioGray: 4658,
    HGSW_0026_RachelPink: 4659,
    HGSW_0045_AntiquarianBrown: 4660,
    HGSW_0048_BunglehouseBlue: 4661,
    HGSW_0053_Porcelain: 4662,
    HGSW_0060_Alexandrite: 4663,
    HGSW_0068_CopenBlue: 4664,
    HGSW_1013_Gooseberrie: 4665,
    HGSW_1014_VictoriaRose: 4666,
    HGSW_1015_RoseePink: 4667,
    HGSW_1016_IrresistibleKiss: 4668,
    HGSW_1017_PliePink: 4669,
    HGSW_1021_Framboise: 4670,
    HGSW_1022_SaskatoonBerry: 4671,
    HGSW_1023_HeartsContent: 4672,
    HGSW_1024_CherishedPink: 4673,
    HGSW_1025_RaspberryCreme: 4674,
    HGSW_1031_Cerise: 4675,
    HGSW_1033_VeryCherry: 4676,
    HGSW_1034_DreamingPink: 4677,
    HGSW_1035_SakuraPetal: 4678,
    HGSW_1036_CabbageRoses: 4679,
    HGSW_1037_Priscilla: 4680,
    HGSW_1046_GetPinked: 4681,
    HGSW_1047_EnchantingPink: 4682,
    HGSW_1052_ShowStopper: 4683,
    HGSW_1053_CandyHeart: 4684,
    HGSW_1054_RobustPink: 4685,
    HGSW_1055_Amaryllis: 4686,
    HGSW_1056_EverythingPink: 4687,
    HGSW_1057_CachetPink: 4688,
    HGSW_1061_RemingtonRed: 4689,
    HGSW_1062_RedTanager: 4690,
    HGSW_1064_BloomingCoral: 4691,
    HGSW_1065_DishyCoral: 4692,
    HGSW_1066_SweetyPink: 4693,
    HGSW_1067_PrettiestPink: 4694,
    HGSW_1071_VictoriousRed: 4695,
    HGSW_1072_RubyRedSlippers: 4696,
    HGSW_1074_CoralReef: 4697,
    HGSW_1075_CoralOdyssey: 4698,
    HGSW_1076_IndulgentPeach: 4699,
    HGSW_1077_CoralPerfection: 4700,
    HGSW_1081_ScotchBonnetPepper: 4701,
    HGSW_1082_Peppery: 4702,
    HGSW_1084_LeiFlower: 4703,
    HGSW_1085_ModernCoral: 4704,
    HGSW_1086_FloraFauna: 4705,
    HGSW_1087_AndromedaPink: 4706,
    HGSW_1092_RowanBerries: 4707,
    HGSW_1093_KnockoutOrange: 4708,
    HGSW_1094_PinkRanunculus: 4709,
    HGSW_1095_ClassicCoral: 4710,
    HGSW_1096_SweetAsAPeach: 4711,
    HGSW_1097_PeachArtemesia: 4712,
    HGSW_1103_RobustOrange: 4713,
    HGSW_1104_Emberglow: 4714,
    HGSW_1105_PeachPreserves: 4715,
    HGSW_1111_OptimisticOrange: 4716,
    HGSW_1116_PowderPeach: 4717,
    HGSW_1117_ProvincialPeach: 4718,
    HGSW_1121_PumpkinCurry: 4719,
    HGSW_1122_CopperPlaya: 4720,
    HGSW_1123_OutgoingOrange: 4721,
    HGSW_1125_SignetMarigold: 4722,
    HGSW_1126_PaleApricot: 4723,
    HGSW_1127_PeachSabayon: 4724,
    HGSW_1134_HeirloomCarrot: 4725,
    HGSW_1135_AniseOrange: 4726,
    HGSW_1136_FragrantNectarine: 4727,
    HGSW_1137_BountifulPeach: 4728,
    HGSW_1152_HeritageGold: 4729,
    HGSW_1153_AmeliasWings: 4730,
    HGSW_1154_MellowMango: 4731,
    HGSW_1155_FreshForsythia: 4732,
    HGSW_1157_SpringNectar: 4733,
    HGSW_1161_ModYellow: 4734,
    HGSW_1162_SummerSunflower: 4735,
    HGSW_1163_GeographicYellow: 4736,
    HGSW_1164_Afternoon: 4737,
    HGSW_1165_Flutterbye: 4738,
    HGSW_1167_StonewyckeIvory: 4739,
    HGSW_1171_GeometricYellow: 4740,
    HGSW_1172_GlitteratiGold: 4741,
    HGSW_1173_PalladianGold: 4742,
    HGSW_1174_UntamedYellow: 4743,
    HGSW_1175_Outrigger: 4744,
    HGSW_1177_LemonChiffonade: 4745,
    HGSW_1181_Cadence: 4746,
    HGSW_1182_GriffinGold: 4747,
    HGSW_1183_DutchTulip: 4748,
    HGSW_1184_DaffodilHill: 4749,
    HGSW_1185_YellowShell: 4750,
    HGSW_1186_LiltingLily: 4751,
    HGSW_1187_TintOfHoney: 4752,
    HGSW_1196_ButterUp: 4753,
    HGSW_1197_CottonTwill: 4754,
    HGSW_1201_AubussonGold: 4755,
    HGSW_1202_GoldMarket: 4756,
    HGSW_1204_SimplyJoyful: 4757,
    HGSW_1206_Solaria: 4758,
    HGSW_1212_DashingGold: 4759,
    HGSW_1213_Instigate: 4760,
    HGSW_1214_GoldDoubloons: 4761,
    HGSW_1215_DottyYellow: 4762,
    HGSW_1216_YellowSongbird: 4763,
    HGSW_1217_BlanchedYellow: 4764,
    HGSW_1221_LimeBlast: 4765,
    HGSW_1222_Alchemist: 4766,
    HGSW_1223_GameChanger: 4767,
    HGSW_1224_GingerWasabi: 4768,
    HGSW_1227_LemonMintLeaf: 4769,
    HGSW_1231_AloeGreenTea: 4770,
    HGSW_1232_Venomous: 4771,
    HGSW_1233_Fernwood: 4772,
    HGSW_1235_Frolic: 4773,
    HGSW_1236_Limelite: 4774,
    HGSW_1237_WhiteCitrus: 4775,
    HGSW_1241_GreenVerge: 4776,
    HGSW_1243_Parakeet: 4777,
    HGSW_1244_Plankton: 4778,
    HGSW_1245_FieldsGreens: 4779,
    HGSW_1246_SoftAvocado: 4780,
    HGSW_1247_SpringBuds: 4781,
    HGSW_1261_RainforestCanopy: 4782,
    HGSW_1262_LandscapePalm: 4783,
    HGSW_1263_OrganicGreen: 4784,
    HGSW_1264_EastlandGreen: 4785,
    HGSW_1265_OwensGreen: 4786,
    HGSW_1266_GreenSavvy: 4787,
    HGSW_1281_PottersShed: 4788,
    HGSW_1283_WelshGreen: 4789,
    HGSW_1284_MoodyGreen: 4790,
    HGSW_1285_HeatherGreen: 4791,
    HGSW_1286_PotteryGlaze: 4792,
    HGSW_1287_MistedMint: 4793,
    HGSW_1291_DaringJade: 4794,
    HGSW_1293_TenderSeedling: 4795,
    HGSW_1294_CohesiveGreen: 4796,
    HGSW_1295_Homegrown: 4797,
    HGSW_1296_CucumberChutney: 4798,
    HGSW_1297_GreenWhimsy: 4799,
    HGSW_1302_GreenEscarpment: 4800,
    HGSW_1303_TropicalCay: 4801,
    HGSW_1304_CotswoldGreen: 4802,
    HGSW_1305_TigerEyes: 4803,
    HGSW_1306_Refresh: 4804,
    HGSW_1307_Aqueous: 4805,
    HGSW_1312_MerryTeal: 4806,
    HGSW_1314_CooledBlue: 4807,
    HGSW_1315_GeyserMist: 4808,
    HGSW_1316_CoastalAqua: 4809,
    HGSW_1317_TameTeal: 4810,
    HGSW_1321_DeepBlueOcean: 4811,
    HGSW_1322_FederatedBlue: 4812,
    HGSW_1323_PursuitOfTeal: 4813,
    HGSW_1324_ForeAndAft: 4814,
    HGSW_1325_BlueMacaroon: 4815,
    HGSW_1326_BlueIris: 4816,
    HGSW_1327_Swimming: 4817,
    HGSW_1331_BlueNile: 4818,
    HGSW_1332_RightAsRain: 4819,
    HGSW_1333_SeptemberSkies: 4820,
    HGSW_1334_RaptureBlue: 4821,
    HGSW_1335_BreezyAqua: 4822,
    HGSW_1336_Cay: 4823,
    HGSW_1341_Amalfi: 4824,
    HGSW_1343_BlueBicycle: 4825,
    HGSW_1344_AboveTheWaves: 4826,
    HGSW_1345_VintageAqua: 4827,
    HGSW_1346_LapidaryBlue: 4828,
    HGSW_1347_GalacticLite: 4829,
    HGSW_1351_ConvergentBlue: 4830,
    HGSW_1352_AdriaticAzure: 4831,
    HGSW_1353_Capri: 4832,
    HGSW_1354_TealEndeavor: 4833,
    HGSW_1356_GlacierBasin: 4834,
    HGSW_1357_SolarSail: 4835,
    HGSW_1361_JayBlue: 4836,
    HGSW_1362_BlueAzores: 4837,
    HGSW_1363_SomethingBorrowed: 4838,
    HGSW_1364_NorthHollandBlue: 4839,
    HGSW_1365_BlueDiscovery: 4840,
    HGSW_1366_RivuletPath: 4841,
    HGSW_1367_SnowMountain: 4842,
    HGSW_1372_BlueClematis: 4843,
    HGSW_1373_OrionBlue: 4844,
    HGSW_1374_StoneMountainBlue: 4845,
    HGSW_1376_SomethingBlue: 4846,
    HGSW_1377_ArialView: 4847,
    HGSW_1382_ArrestingBlue: 4848,
    HGSW_1383_Scanda: 4849,
    HGSW_1385_SuffolkBlue: 4850,
    HGSW_1386_BlissfulBlue: 4851,
    HGSW_1387_Icebreaker: 4852,
    HGSW_1391_DelftPottery: 4853,
    HGSW_1392_VitalBlue: 4854,
    HGSW_1394_PembrokeBlue: 4855,
    HGSW_1395_SweetLavender: 4856,
    HGSW_1396_CelestialSkies: 4857,
    HGSW_1397_Melodious: 4858,
    HGSW_1401_Quark: 4859,
    HGSW_1402_LavenderFields: 4860,
    HGSW_1403_PurplePeonies: 4861,
    HGSW_1404_GentryViolet: 4862,
    HGSW_1405_Bedazzled: 4863,
    HGSW_1407_GalaxyPurple: 4864,
    HGSW_1411_Amethystina: 4865,
    HGSW_1412_VioletObsession: 4866,
    HGSW_1413_Serenade: 4867,
    HGSW_1415_BeverlyLilac: 4868,
    HGSW_1416_VioletCache: 4869,
    HGSW_1417_PurplePotential: 4870,
    HGSW_1421_ImpulsivePurple: 4871,
    HGSW_1422_OpulantPurple: 4872,
    HGSW_1423_AlliumBlooms: 4873,
    HGSW_1425_Magical: 4874,
    HGSW_1426_HazeyPurple: 4875,
    HGSW_1427_LilacFrost: 4876,
    HGSW_1431_Anthology: 4877,
    HGSW_1432_PrettyPurple: 4878,
    HGSW_1434_VioletRoyale: 4879,
    HGSW_1435_PurpleRegalia: 4880,
    HGSW_1436_EuphoricLilac: 4881,
    HGSW_1437_MattePurple: 4882,
    HGSW_1441_TricornBlack: 4883,
    HGSW_1443_NevermoreGrey: 4884,
    HGSW_1445_MorningFog: 4885,
    HGSW_1446_Latitude: 4886,
    HGSW_1447_OlympusWhite: 4887,
    HGSW_1452_JaggedGranite: 4888,
    HGSW_1453_SteelyGray: 4889,
    HGSW_1454_Monochrome: 4890,
    HGSW_1456_StoneEagle: 4891,
    HGSW_1457_Icicle: 4892,
    HGSW_1461_NoLimits: 4893,
    HGSW_1462_WebGray: 4894,
    HGSW_1463_Software: 4895,
    HGSW_1464_FlannelGrey: 4896,
    HGSW_1465_ContemporaryGrey: 4897,
    HGSW_1466_Online: 4898,
    HGSW_1467_GrayScreen: 4899,
    HGSW_1472_SlateTile: 4900,
    HGSW_1473_PortsmouthLanding: 4901,
    HGSW_1474_CobblestoneArch: 4902,
    HGSW_1475_SteelPiling: 4903,
    HGSW_1476_GreySanctuary: 4904,
    HGSW_1477_GlacialStream: 4905,
    HGSW_1481_Carbonized: 4906,
    HGSW_1482_GrizzleGray: 4907,
    HGSW_1483_ArmitageGrey: 4908,
    HGSW_1484_KatabaticWinds: 4909,
    HGSW_1485_EssexGrey: 4910,
    HGSW_1486_Windstorm: 4911,
    HGSW_1487_Passive: 4912,
    HGSW_1491_Peppercorn: 4913,
    HGSW_1492_ThunderClap: 4914,
    HGSW_1494_Pussywillow: 4915,
    HGSW_1495_ModernistGray: 4916,
    HGSW_1496_StoneIsle: 4917,
    HGSW_1501_RockBottom: 4918,
    HGSW_1502_ObsidianGlass: 4919,
    HGSW_1503_TimeAndSpace: 4920,
    HGSW_1504_Fossilized: 4921,
    HGSW_1505_Wormwood: 4922,
    HGSW_1506_MagneticGray: 4923,
    HGSW_1507_LaplandIce: 4924,
    HGSW_1668_PineappleCream: 4925,
    HGSW_2023_RubyLane: 4926,
    HGSW_2024_PlumeriaBlossom: 4927,
    HGSW_2025_MythicMauve: 4928,
    HGSW_2026_MauveRose: 4929,
    HGSW_2027_DowningPink: 4930,
    HGSW_2032_Passionate: 4931,
    HGSW_2033_RussetPink: 4932,
    HGSW_2034_MochaMauve: 4933,
    HGSW_2035_FrenchHeather: 4934,
    HGSW_2036_AllisonsPink: 4935,
    HGSW_2037_MadAboutPink: 4936,
    HGSW_2042_Impulsive: 4937,
    HGSW_2043_Redbud: 4938,
    HGSW_2044_MamasKisses: 4939,
    HGSW_2045_MemorableRose: 4940,
    HGSW_2046_LotusFlower: 4941,
    HGSW_2047_CharmingPink: 4942,
    HGSW_2051_WoodlandStrawberry: 4943,
    HGSW_2053_RuddyRose: 4944,
    HGSW_2054_PoseyPink: 4945,
    HGSW_2055_RomanticMauve: 4946,
    HGSW_2057_ShimmeryPink: 4947,
    HGSW_2061_Fireweed: 4948,
    HGSW_2062_BurntScarlet: 4949,
    HGSW_2064_Coralbelle: 4950,
    HGSW_2065_PeekabooCoral: 4951,
    HGSW_2066_MellowCoral: 4952,
    HGSW_2067_Romance: 4953,
    HGSW_2071_FiredBrick: 4954,
    HGSW_2073_NouveauRed: 4955,
    HGSW_2074_PinkCinnamon: 4956,
    HGSW_2075_SalmonRiverRun: 4957,
    HGSW_2076_PinkGlamour: 4958,
    HGSW_2077_QuaintPeche: 4959,
    HGSW_2081_LustreRed: 4960,
    HGSW_2083_BronwynRust: 4961,
    HGSW_2085_PavePeach: 4962,
    HGSW_2086_PeachMaison: 4963,
    HGSW_2087_CandiedPeach: 4964,
    HGSW_2092_WarmSienna: 4965,
    HGSW_2093_TerracottaPot: 4966,
    HGSW_2094_HeatheredOrange: 4967,
    HGSW_2095_SundriedTerra: 4968,
    HGSW_2096_CountrysideBlush: 4969,
    HGSW_2097_GreccoPeach: 4970,
    HGSW_2101_CopperMountain: 4971,
    HGSW_2103_Armagnac: 4972,
    HGSW_2104_StudioCopper: 4973,
    HGSW_2105_OrangePatina: 4974,
    HGSW_2106_TintedApricot: 4975,
    HGSW_2107_HalifaxOrange: 4976,
    HGSW_2113_ElegantOrange: 4977,
    HGSW_2114_Harvested: 4978,
    HGSW_2115_ShinyPenny: 4979,
    HGSW_2116_SonyaOrange: 4980,
    HGSW_2117_FreshPeach: 4981,
    HGSW_2121_CopperKettle: 4982,
    HGSW_2126_HoneyedGinger: 4983,
    HGSW_2127_CashmereGlow: 4984,
    HGSW_2131_BourbonButterscotch: 4985,
    HGSW_2132_EssentialGold: 4986,
    HGSW_2133_Honeycomb: 4987,
    HGSW_2135_Tetragold: 4988,
    HGSW_2136_TrellisYellow: 4989,
    HGSW_2137_CameoCreme: 4990,
    HGSW_2141_FrenchMustard: 4991,
    HGSW_2142_LunaGold: 4992,
    HGSW_2143_CelebrationGold: 4993,
    HGSW_2144_AnjouPear: 4994,
    HGSW_2146_DoyleGold: 4995,
    HGSW_2152_SmokeyTopaz: 4996,
    HGSW_2153_ButcherPaper: 4997,
    HGSW_2155_TotallyTan: 4998,
    HGSW_2157_BackToBasics: 4999,
    HGSW_2161_QuirkyGold: 5000,
    HGSW_2162_BoscPear: 5001,
    HGSW_2167_Napery: 5002,
    HGSW_2171_RelicBronze: 5003,
    HGSW_2172_Chamois: 5004,
    HGSW_2173_ManneredGold: 5005,
    HGSW_2174_GrecianGold: 5006,
    HGSW_2175_RestrainedGold: 5007,
    HGSW_2176_Blonde: 5008,
    HGSW_2177_Ivoire: 5009,
    HGSW_2182_Cardboard: 5010,
    HGSW_2183_Baguette: 5011,
    HGSW_2184_HandcraftedBrown: 5012,
    HGSW_2185_Camelback: 5013,
    HGSW_2186_WholeWheat: 5014,
    HGSW_2187_BelievableBuff: 5015,
    HGSW_2191_Antiquarium: 5016,
    HGSW_2192_Hazellwood: 5017,
    HGSW_2194_PiecesOfEight: 5018,
    HGSW_2195_EtruscanGold: 5019,
    HGSW_2196_Honeygold: 5020,
    HGSW_2197_GleefulYellow: 5021,
    HGSW_2202_YellowLichen: 5022,
    HGSW_2203_GoldenMystery: 5023,
    HGSW_2204_Antiquity: 5024,
    HGSW_2205_IndependentGold: 5025,
    HGSW_2206_MossVine: 5026,
    HGSW_2207_LucentYellow: 5027,
    HGSW_2211_AdmiralBronze: 5028,
    HGSW_2213_RainforestFloor: 5029,
    HGSW_2214_OlivineCrystal: 5030,
    HGSW_2215_MythicGreen: 5031,
    HGSW_2216_WheatGrass: 5032,
    HGSW_2217_AncestralGold: 5033,
    HGSW_2221_SaguaroCactus: 5034,
    HGSW_2222_RuralGreen: 5035,
    HGSW_2223_GreenGumTree: 5036,
    HGSW_2225_AvocadoFruit: 5037,
    HGSW_2226_HeartsOfPalm: 5038,
    HGSW_2227_RiceFields: 5039,
    HGSW_2232_NaturalHabitat: 5040,
    HGSW_2233_MountainMoss: 5041,
    HGSW_2234_RyegrassSeed: 5042,
    HGSW_2235_NapaCabbage: 5043,
    HGSW_2236_Kiwifruit: 5044,
    HGSW_2237_Celery: 5045,
    HGSW_2241_BackNine: 5046,
    HGSW_2242_GardenSpot: 5047,
    HGSW_2243_IntoTheGreen: 5048,
    HGSW_2244_TremontGarden: 5049,
    HGSW_2247_CucumberWater: 5050,
    HGSW_2251_TeeShot: 5051,
    HGSW_2252_ForresterGreen: 5052,
    HGSW_2254_ChatfieldGreen: 5053,
    HGSW_2255_Haven: 5054,
    HGSW_2256_MelancholoyMint: 5055,
    HGSW_2257_TwinklyGreen: 5056,
    HGSW_2262_MatchPlay: 5057,
    HGSW_2263_BackcountryGreen: 5058,
    HGSW_2264_ItalianBasil: 5059,
    HGSW_2265_CoastalSeaglass: 5060,
    HGSW_2266_BotanyGreen: 5061,
    HGSW_2267_MellowMint: 5062,
    HGSW_2271_FreshArugala: 5063,
    HGSW_2272_ChoppedCilantro: 5064,
    HGSW_2273_SugarSnapPea: 5065,
    HGSW_2275_NurtureGreen: 5066,
    HGSW_2276_CommunityGarden: 5067,
    HGSW_2277_ModMint: 5068,
    HGSW_2281_WildernessTrail: 5069,
    HGSW_2283_Cultivar: 5070,
    HGSW_2284_WeatheringCopper: 5071,
    HGSW_2285_Restful: 5072,
    HGSW_2286_PalePatina: 5073,
    HGSW_2287_MistOnTheMoors: 5074,
    HGSW_2291_GreenTartan: 5075,
    HGSW_2292_Jadepool: 5076,
    HGSW_2295_VarigatedVinca: 5077,
    HGSW_2296_Aloe: 5078,
    HGSW_2297_Breaktime: 5079,
    HGSW_2301_BucolicGreen: 5080,
    HGSW_2302_Cloverfields: 5081,
    HGSW_2304_ComposedTeal: 5082,
    HGSW_2305_SaltMarshes: 5083,
    HGSW_2306_CeladonPottery: 5084,
    HGSW_2307_Waterscape: 5085,
    HGSW_2311_EmeraldShore: 5086,
    HGSW_2312_IslandTime: 5087,
    HGSW_2313_BaysideBlue: 5088,
    HGSW_2314_DrizzlingRain: 5089,
    HGSW_2315_WornTurquoise: 5090,
    HGSW_2316_Watery: 5091,
    HGSW_2317_Tidewater: 5092,
    HGSW_2321_SonoranTeal: 5093,
    HGSW_2322_TurquoiseCay: 5094,
    HGSW_2323_Cloudburst: 5095,
    HGSW_2324_ReflectingPool: 5096,
    HGSW_2327_MintToBe: 5097,
    HGSW_2331_OceansideBlue: 5098,
    HGSW_2332_BarrierReef: 5099,
    HGSW_2333_Beachcomber: 5100,
    HGSW_2334_ElCaribe: 5101,
    HGSW_2336_CoolLaguna: 5102,
    HGSW_2337_PristineSkies: 5103,
    HGSW_2341_TresBlue: 5104,
    HGSW_2342_MermaidsTale: 5105,
    HGSW_2343_SplendorBlue: 5106,
    HGSW_2344_SwimmingHole: 5107,
    HGSW_2345_InfinityFalls: 5108,
    HGSW_2347_CaughtInTheRain: 5109,
    HGSW_2351_Aqualuxe: 5110,
    HGSW_2352_HighlandLoch: 5111,
    HGSW_2353_ManitouBlue: 5112,
    HGSW_2354_OpenSeas: 5113,
    HGSW_2355_Seafarer: 5114,
    HGSW_2357_CrescentBlue: 5115,
    HGSW_2361_NarragansettNavy: 5116,
    HGSW_2362_GeorgianBay: 5117,
    HGSW_2363_EbbTide: 5118,
    HGSW_2365_ResoluteBlue: 5119,
    HGSW_2366_ColdRiver: 5120,
    HGSW_2367_CrystalStream: 5121,
    HGSW_2371_LongHorizon: 5122,
    HGSW_2372_EarthwiseBlue: 5123,
    HGSW_2373_BluePatchwork: 5124,
    HGSW_2375_SoulSeeker: 5125,
    HGSW_2376_Contemplative: 5126,
    HGSW_2382_Denim: 5127,
    HGSW_2383_SportyBlue: 5128,
    HGSW_2385_NotableHue: 5129,
    HGSW_2386_HonestBlue: 5130,
    HGSW_2387_TeenseyBubbles: 5131,
    HGSW_2391_CourtlyBlue: 5132,
    HGSW_2393_SearchingBlue: 5133,
    HGSW_2394_FragrantLavender: 5134,
    HGSW_2395_BlueSlumber: 5135,
    HGSW_2397_IcelandicBlue: 5136,
    HGSW_2401_PurpleMidnight: 5137,
    HGSW_2402_RococcoViolet: 5138,
    HGSW_2403_PurpleThrush: 5139,
    HGSW_2405_DippedInViolet: 5140,
    HGSW_2406_CandiedLavender: 5141,
    HGSW_2407_OrchidBrite: 5142,
    HGSW_2411_AmethystGlass: 5143,
    HGSW_2412_VioletTwilight: 5144,
    HGSW_2413_PurplePeacock: 5145,
    HGSW_2415_AshViolet: 5146,
    HGSW_2416_TwirlingGirl: 5147,
    HGSW_2417_SplashOfLilac: 5148,
    HGSW_2423_TarasViolet: 5149,
    HGSW_2424_BerryCreme: 5150,
    HGSW_2425_WisteriaTree: 5151,
    HGSW_2426_PixiePlum: 5152,
    HGSW_2427_SugarPlumbed: 5153,
    HGSW_2431_GrownUpGrape: 5154,
    HGSW_2432_PrincipalGrape: 5155,
    HGSW_2433_PlumDandy: 5156,
    HGSW_2435_Thistle: 5157,
    HGSW_2436_FurtiveMauve: 5158,
    HGSW_2437_Plumscicle: 5159,
    HGSW_2441_SeaOtter: 5160,
    HGSW_2442_Tynewood: 5161,
    HGSW_2443_Mink: 5162,
    HGSW_2444_HighlandGrey: 5163,
    HGSW_2445_IntuitiveGray: 5164,
    HGSW_2447_Grayish: 5165,
    HGSW_2451_Sealskin: 5166,
    HGSW_2457_BasaltPowder: 5167,
    HGSW_2461_WellbredBrown: 5168,
    HGSW_2462_StoneStatue: 5169,
    HGSW_2463_ElegantTaupe: 5170,
    HGSW_2465_FunctionalGray: 5171,
    HGSW_2466_RequisiteGray: 5172,
    HGSW_2467_Alpaca: 5173,
    HGSW_2472_WeatherWorn: 5174,
    HGSW_2474_TerminalTaupe: 5175,
    HGSW_2475_PerfectGreige: 5176,
    HGSW_2476_AdleyGrey: 5177,
    HGSW_2477_GhostPines: 5178,
    HGSW_2481_VanDykeBrown: 5179,
    HGSW_2482_Elemental: 5180,
    HGSW_2483_VirtualTaupe: 5181,
    HGSW_2484_PebblePathway: 5182,
    HGSW_2485_GristmillGreige: 5183,
    HGSW_2486_BalancedBeige: 5184,
    HGSW_2487_AccessibleBeige: 5185,
    HGSW_2491_TurkishCoffee: 5186,
    HGSW_2492_TikiHut: 5187,
    HGSW_2493_FalconTaupe: 5188,
    HGSW_2495_LambskinBeige: 5189,
    HGSW_2496_BungalowBeige: 5190,
    HGSW_2497_CalicoCream: 5191,
    HGSW_2501_DarkBronzetone: 5192,
    HGSW_2503_CaribouBrown: 5193,
    HGSW_2504_TruffleOil: 5194,
    HGSW_2506_LinwoodSands: 5195,
    HGSW_2735_Rockweed: 5196,
    HGSW_3011_BlackberryBramble: 5197,
    HGSW_3012_Ravenwood: 5198,
    HGSW_3013_PlumDelia: 5199,
    HGSW_3015_MaevesMauve: 5200,
    HGSW_3016_SweetenedPlum: 5201,
    HGSW_3017_PersianPearl: 5202,
    HGSW_3021_RougeRemix: 5203,
    HGSW_3022_KingsIslandBrown: 5204,
    HGSW_3024_CocoaBerrie: 5205,
    HGSW_3025_HenleyPlum: 5206,
    HGSW_3026_ArtsyPink: 5207,
    HGSW_3027_WhiteTruffle: 5208,
    HGSW_3031_IgneousRock: 5209,
    HGSW_3032_CocoaIsland: 5210,
    HGSW_3034_RoanChestnut: 5211,
    HGSW_3035_EmergingTaupe: 5212,
    HGSW_3036_SweetBeige: 5213,
    HGSW_3037_SoftPutty: 5214,
    HGSW_3041_DyingEmber: 5215,
    HGSW_3043_CanyonArroyo: 5216,
    HGSW_3044_RuggedCoast: 5217,
    HGSW_3046_SashaySand: 5218,
    HGSW_3047_PinkPhenomenon: 5219,
    HGSW_3051_TavernOak: 5220,
    HGSW_3052_ReindeerHerd: 5221,
    HGSW_3054_FieryHue: 5222,
    HGSW_3055_IntimateTan: 5223,
    HGSW_3056_ClassicBeige: 5224,
    HGSW_3057_MaltedMilk: 5225,
    HGSW_3061_BackInTheSaddle: 5226,
    HGSW_3062_BrevityBrown: 5227,
    HGSW_3063_WoodsyHollow: 5228,
    HGSW_3064_RelaxedVibe: 5229,
    HGSW_3065_BalticBirch: 5230,
    HGSW_3066_SocialCall: 5231,
    HGSW_3071_MocaJava: 5232,
    HGSW_3072_Aspinwall: 5233,
    HGSW_3073_RusticStoneware: 5234,
    HGSW_3074_Ledgestone: 5235,
    HGSW_3075_SereneTan: 5236,
    HGSW_3077_SimplifyBeige: 5237,
    HGSW_3081_JumpingJava: 5238,
    HGSW_3082_CobbleBrown: 5239,
    HGSW_3083_WoodVessel: 5240,
    HGSW_3084_MarketMushroom: 5241,
    HGSW_3085_UtterlyBeige: 5242,
    HGSW_3086_DiverseBeige: 5243,
    HGSW_3087_RealistBeige: 5244,
    HGSW_3091_MutedMahogany: 5245,
    HGSW_3092_ReclaimedWood: 5246,
    HGSW_3093_BambooFiber: 5247,
    HGSW_3094_AdirondackChair: 5248,
    HGSW_3095_TweedJacket: 5249,
    HGSW_3096_StrawTote: 5250,
    HGSW_3097_HitTheBeach: 5251,
    HGSW_3101_BrownAptitude: 5252,
    HGSW_3102_AnorakBrown: 5253,
    HGSW_3104_HuntGather: 5254,
    HGSW_3105_BombayBeach: 5255,
    HGSW_3106_FamiliarBeige: 5256,
    HGSW_3107_LightweightBeige: 5257,
    HGSW_3111_Kaffee: 5258,
    HGSW_3113_Portabello: 5259,
    HGSW_3115_SandsOfTime: 5260,
    HGSW_3116_CommonThread: 5261,
    HGSW_3117_SandDollar: 5262,
    HGSW_3121_ZaharaBrown: 5263,
    HGSW_3125_TrailsideTan: 5264,
    HGSW_3127_LaidbackBeige: 5265,
    HGSW_3134_CraggyDesert: 5266,
    HGSW_3136_Almeria: 5267,
    HGSW_3137_Almondine: 5268,
    HGSW_3141_HawkeyeBrown: 5269,
    HGSW_3143_Hopsack: 5270,
    HGSW_3144_ToastedOat: 5271,
    HGSW_3145_Latte: 5272,
    HGSW_3146_NomadicDesert: 5273,
    HGSW_3147_KilimBeige: 5274,
    HGSW_3151_CommonGrounds: 5275,
    HGSW_3152_Kilndried: 5276,
    HGSW_3153_SorrentoValley: 5277,
    HGSW_3155_TangledTan: 5278,
    HGSW_3156_ClothStone: 5279,
    HGSW_3157_VanillaSugar: 5280,
    HGSW_3162_OldTowne: 5281,
    HGSW_3163_TranquilTan: 5282,
    HGSW_3164_DromedaryCamel: 5283,
    HGSW_3165_FlaxSeed: 5284,
    HGSW_3166_DiamondWeave: 5285,
    HGSW_3167_AridSands: 5286,
    HGSW_3171_PinewoodForest: 5287,
    HGSW_3172_ScottishOak: 5288,
    HGSW_3173_DapperTan: 5289,
    HGSW_3176_Macadamia: 5290,
    HGSW_3177_SofterTan: 5291,
    HGSW_3182_OldeGold: 5292,
    HGSW_3183_QuiverTan: 5293,
    HGSW_3184_CarrolltonKhaki: 5294,
    HGSW_3185_UniversalKhaki: 5295,
    HGSW_3186_RelaxedKhaki: 5296,
    HGSW_3187_Unravelled: 5297,
    HGSW_3192_Artefact: 5298,
    HGSW_3193_Burlap: 5299,
    HGSW_3194_BalancedTan: 5300,
    HGSW_3195_HarmonicTan: 5301,
    HGSW_3196_Ecru: 5302,
    HGSW_3197_Netsuke: 5303,
    HGSW_3201_CattailReed: 5304,
    HGSW_3202_OvenBaked: 5305,
    HGSW_3203_ArroyoValley: 5306,
    HGSW_3204_ElkRun: 5307,
    HGSW_3206_TexasTumbleweed: 5308,
    HGSW_3207_Pulpwood: 5309,
    HGSW_3211_OliveTapas: 5310,
    HGSW_3212_HighTea: 5311,
    HGSW_3213_LodgepolePine: 5312,
    HGSW_3214_Fenland: 5313,
    HGSW_3215_FavoriteTan: 5314,
    HGSW_3216_WhiteRamie: 5315,
    HGSW_3221_Subterranean: 5316,
    HGSW_3222_Cocoon: 5317,
    HGSW_3225_Chatroom: 5318,
    HGSW_3226_WindsweptCliff: 5319,
    HGSW_3227_SedateGray: 5320,
    HGSW_3231_VineyardVine: 5321,
    HGSW_3233_ConduitGrey: 5322,
    HGSW_3235_SvelteSage: 5323,
    HGSW_3237_AncientMarble: 5324,
    HGSW_3241_UrbanGarden: 5325,
    HGSW_3242_GerminatingGreen: 5326,
    HGSW_3243_LichenLiverwort: 5327,
    HGSW_3245_ClarySage: 5328,
    HGSW_3246_SoftenedGreen: 5329,
    HGSW_3247_LiveableGreen: 5330,
    HGSW_3251_CorianderOlive: 5331,
    HGSW_3252_FreshBalsam: 5332,
    HGSW_3253_PrivilegeGreen: 5333,
    HGSW_3255_CoastalPlain: 5334,
    HGSW_3256_Contented: 5335,
    HGSW_3257_FilmyGreen: 5336,
    HGSW_3261_Shadegrown: 5337,
    HGSW_3263_FarmToTable: 5338,
    HGSW_3264_HuntersPointe: 5339,
    HGSW_3265_EscapeGray: 5340,
    HGSW_3266_WoodyRosemary: 5341,
    HGSW_3267_TurningPointe: 5342,
    HGSW_3271_BatterseaBronze: 5343,
    HGSW_3273_StationGray: 5344,
    HGSW_3274_MarshGrasses: 5345,
    HGSW_3275_RareGray: 5346,
    HGSW_3276_PhantomForest: 5347,
    HGSW_3277_PlayItCool: 5348,
    HGSW_3282_WoodlandLichen: 5349,
    HGSW_3283_Retreat: 5350,
    HGSW_3284_Thorntree: 5351,
    HGSW_3286_ComfortGray: 5352,
    HGSW_3287_SeaSalt: 5353,
    HGSW_3291_Jasper: 5354,
    HGSW_3292_GreenPasture: 5355,
    HGSW_3293_ValiantBlue: 5356,
    HGSW_3294_BlueSeagrass: 5357,
    HGSW_3295_DesertLake: 5358,
    HGSW_3296_RiceTerrace: 5359,
    HGSW_3301_Oceanus: 5360,
    HGSW_3302_Riverway: 5361,
    HGSW_3303_TreeSwallow: 5362,
    HGSW_3304_AquaReservoir: 5363,
    HGSW_3305_InterestingAqua: 5364,
    HGSW_3306_RacingTheRain: 5365,
    HGSW_3307_TradewindBlue: 5366,
    HGSW_3311_Archipelago: 5367,
    HGSW_3313_Aquamarined: 5368,
    HGSW_3314_MarinePark: 5369,
    HGSW_3315_Groundwater: 5370,
    HGSW_3316_FalklandBlue: 5371,
    HGSW_3317_DelicateDelia: 5372,
    HGSW_3321_BlueMidnight: 5373,
    HGSW_3322_BlueMystery: 5374,
    HGSW_3323_NordicBleu: 5375,
    HGSW_3324_Debonair: 5376,
    HGSW_3325_BlueMountaintop: 5377,
    HGSW_3326_FreshIdea: 5378,
    HGSW_3327_CrispBlue: 5379,
    HGSW_3331_DarkNight: 5380,
    HGSW_3332_TempestSkies: 5381,
    HGSW_3334_SomersetGrey: 5382,
    HGSW_3335_SilverShadows: 5383,
    HGSW_3336_SilverSalvia: 5384,
    HGSW_3337_Watermarked: 5385,
    HGSW_3341_SpectralIndigo: 5386,
    HGSW_3342_SeaCreature: 5387,
    HGSW_3343_BlueJasmine: 5388,
    HGSW_3344_ByTheSea: 5389,
    HGSW_3345_BehindBlueEyes: 5390,
    HGSW_3346_TranquilVibe: 5391,
    HGSW_3347_MoonlitPath: 5392,
    HGSW_3351_Naval: 5393,
    HGSW_3352_NorthernPike: 5394,
    HGSW_3353_BracingBlue: 5395,
    HGSW_3355_Aleutian: 5396,
    HGSW_3356_OceansSide: 5397,
    HGSW_3357_Upward: 5398,
    HGSW_3362_SweepingRock: 5399,
    HGSW_3363_StormCloud: 5400,
    HGSW_3364_BabblingBrooke: 5401,
    HGSW_3365_SeaIslandCotton: 5402,
    HGSW_3366_Krypton: 5403,
    HGSW_3367_NorthStar: 5404,
    HGSW_3372_MercuryPeak: 5405,
    HGSW_3373_SpecialGray: 5406,
    HGSW_3374_ChilledPurple: 5407,
    HGSW_3376_HeavenSent: 5408,
    HGSW_3377_ChaseTheMoonlite: 5409,
    HGSW_3381_WildRide: 5410,
    HGSW_3382_StunningShade: 5411,
    HGSW_3383_SensuousGray: 5412,
    HGSW_3384_ArtfulTwist: 5413,
    HGSW_3385_FaunaPop: 5414,
    HGSW_3391_OceanicTrench: 5415,
    HGSW_3392_ShadowHue: 5416,
    HGSW_3393_SmokyPurple: 5417,
    HGSW_3394_GreatGreige: 5418,
    HGSW_3395_DreamInPurple: 5419,
    HGSW_3396_Refracted: 5420,
    HGSW_3397_GossamerSilk: 5421,
    HGSW_3401_PlumBrown: 5422,
    HGSW_3402_ExpressivePlum: 5423,
    HGSW_3404_HandsomePlum: 5424,
    HGSW_3405_OneFineDay: 5425,
    HGSW_3406_HighNote: 5426,
    HGSW_3407_SensitiveTint: 5427,
    HGSW_3411_WineryRed: 5428,
    HGSW_3412_DurablePlum: 5429,
    HGSW_3413_CoirFibre: 5430,
    HGSW_3415_Coopersmith: 5431,
    HGSW_3416_HintOfCrimson: 5432,
    HGSW_3417_ChasteMauve: 5433,
    HGSW_3421_FertileSoil: 5434,
    HGSW_3422_Ranchland: 5435,
    HGSW_3423_AlderBranch: 5436,
    HGSW_3424_WovenLinen: 5437,
    HGSW_3425_FeltedGray: 5438,
    HGSW_3426_ArchitecturalGray: 5439,
    HGSW_3431_Otter: 5440,
    HGSW_3432_LessBrown: 5441,
    HGSW_3433_BenevolentBeige: 5442,
    HGSW_3435_TrulyTaupe: 5443,
    HGSW_3436_TemperateTaupe: 5444,
    HGSW_3437_HandspunYarn: 5445,
    HGSW_3441_Foothills: 5446,
    HGSW_3442_CoastlineTan: 5447,
    HGSW_3443_Domaine: 5448,
    HGSW_3445_StoneLion: 5449,
    HGSW_3446_Loggia: 5450,
    HGSW_3451_Sable: 5451,
    HGSW_3452_ResortTan: 5452,
    HGSW_3454_Outerbanks: 5453,
    HGSW_3455_KhakiShade: 5454,
    HGSW_3457_MaisonBlanche: 5455,
    HGSW_3462_Quagmire: 5456,
    HGSW_3464_StackedStone: 5457,
    HGSW_3465_FalseCreekGreige: 5458,
    HGSW_3466_AnewGray: 5459,
    HGSW_3467_AgreeableGray: 5460,
    HGSW_3471_BlackFox: 5461,
    HGSW_3472_Aviatrix: 5462,
    HGSW_3473_Dovetail: 5463,
    HGSW_3475_DorianGray: 5464,
    HGSW_3476_MindfulGray: 5465,
    HGSW_3477_ReposeGray: 5466,
    HGSW_3481_UrbaneBronze: 5467,
    HGSW_3482_Porpoise: 5468,
    HGSW_3483_Anonymous: 5469,
    HGSW_3484_CurlingWillow: 5470,
    HGSW_3485_IntellectualGray: 5471,
    HGSW_3487_WintersweetGrey: 5472,
    HGSW_3492_FundamentalBrown: 5473,
    HGSW_3493_AdaptiveShade: 5474,
    HGSW_3494_WaterburyClay: 5475,
    HGSW_3497_UsefulGray: 5476,
    HGSW_3502_Habitat: 5477,
    HGSW_3505_Intertwined: 5478,
    HGSW_3506_MuslinBolt: 5479,
    HGSW_3507_OysterBar: 5480,
    HGSW_4001_FundamentalWhite: 5481,
    HGSW_4002_WhiteGallery: 5482,
    HGSW_4003_WhiteBatten: 5483,
    HGSW_4004_IconicWhite: 5484,
    HGSW_4005_ExtraWhite: 5485,
    HGSW_4006_PureWhite: 5486,
    HGSW_4007_OrigamiWhite: 5487,
    HGSW_4011_AestheticWhite: 5488,
    HGSW_4012_NaturalChoice: 5489,
    HGSW_4013_WhiteDuck: 5490,
    HGSW_4014_ShojiWhite: 5491,
    HGSW_4017_NeutralWhite: 5492,
    HGSW_4018_CanvasTan: 5493,
    HGSW_4019_NaturalTan: 5494,
    HGSW_4020_DotToDot: 5495,
    HGSW_4023_IncredibleWhite: 5496,
    HGSW_4024_EiderWhite: 5497,
    HGSW_4025_BelgianWhite: 5498,
    HGSW_4026_OxfordWhite: 5499,
    HGSW_4027_WhiteCotton: 5500,
    HGSW_4028_Citilite: 5501,
    HGSW_4030_GreekVilla: 5502,
    HGSW_4031_Alabaster: 5503,
    HGSW_4032_DoverWhite: 5504,
    HGSW_4033_Creamy: 5505,
    HGSW_4034_MilkBloom: 5506,
    HGSW_4035_SaltCrystal: 5507,
    HGSW_4037_Monogramme: 5508,
    HGSW_4038_Vanillin: 5509,
    HGSW_4040_CapeIvory: 5510,
    HGSW_4042_CreamedWhite: 5511,
    HGSW_4043_PureLinen: 5512,
    HGSW_4044_DivineWhite: 5513,
    HGSW_4045_HimalayanSalt: 5514,
    HGSW_4046_NavajoWhite: 5515,
    HGSW_4047_AntiqueWhite: 5516,
    HGSW_4048_Muslin: 5517,
    HGSW_4049_CasualWhite: 5518,
    HGSW_4050_TalcPowder: 5519,
    HGSW_4051_WhiteCore: 5520,
    HGSW_4052_BohemianLace: 5521,
    HGSW_4053_Storyteller: 5522,
    HGSW_4054_MercerWhite: 5523,
    HGSW_4055_TimelessWhite: 5524,
    HGSW_4056_SterlingWhite: 5525,
    HGSW_4057_NebulousWhite: 5526,
    HGSW_4058_IcyBreeze: 5527,
    HGSW_4059_CeleryRoot: 5528,
    HGSW_4060_Nuance: 5529,
    HGSW_4061_RareRadiant: 5530,
    HGSW_4062_Snowbound: 5531,
    HGSW_4063_Marshmallow: 5532,
    HGSW_4067_NiceWhite: 5533,
    HGSW_4069_IbisWhite: 5534,
    HGSW_4071_GorgeousWhite: 5535,
    HGSW_4072_IntricateIvory: 5536,
    HGSW_4073_ChoiceCream: 5537,
    HGSW_4074_SoftlyWhite: 5538,
    HGSW_4075_Downy: 5539,
    HGSW_6001_Grayish: 5540,
    HGSW_6003_ProperGray: 5541,
    HGSW_6004_Mink: 5542,
    HGSW_6005_Folkstone: 5543,
    HGSW_6006_BlackBean: 5544,
    HGSW_6009_Imagine: 5545,
    HGSW_6010_FlexibleGray: 5546,
    HGSW_6011_Chinchilla: 5547,
    HGSW_6012_BrowseBrown: 5548,
    HGSW_6013_BitterChocolate: 5549,
    HGSW_6015_VaguelyMauve: 5550,
    HGSW_6016_ChaiseMauve: 5551,
    HGSW_6017_Intuitive: 5552,
    HGSW_6018_Enigma: 5553,
    HGSW_6019_PoetryPlum: 5554,
    HGSW_6020_Marooned: 5555,
    HGSW_6022_Breathless: 5556,
    HGSW_6023_InsightfulRose: 5557,
    HGSW_6024_DressyRose: 5558,
    HGSW_6025_Socialite: 5559,
    HGSW_6026_RiverRouge: 5560,
    HGSW_6027_Cordovan: 5561,
    HGSW_6029_WhiteTruffle: 5562,
    HGSW_6030_ArtisticTaupe: 5563,
    HGSW_6031_Glamour: 5564,
    HGSW_6033_BateauBrown: 5565,
    HGSW_6034_DarkAuburn: 5566,
    HGSW_6036_Angora: 5567,
    HGSW_6037_TemperateTaupe: 5568,
    HGSW_6038_TrulyTaupe: 5569,
    HGSW_6039_PoisedTaupe: 5570,
    HGSW_6040_Nutshell: 5571,
    HGSW_6041_Otter: 5572,
    HGSW_6043_UnfussyBeige: 5573,
    HGSW_6044_Doeskin: 5574,
    HGSW_6045_EmergingTaupe: 5575,
    HGSW_6047_HotCocoa: 5576,
    HGSW_6048_TerraBrun: 5577,
    HGSW_6049_GorgeousWhite: 5578,
    HGSW_6050_AbaloneShell: 5579,
    HGSW_6051_SashaySand: 5580,
    HGSW_6053_ReddenedEarth: 5581,
    HGSW_6055_FieryBrown: 5582,
    HGSW_6057_MaltedMilk: 5583,
    HGSW_6058_LikeableSand: 5584,
    HGSW_6059_InterfaceTan: 5585,
    HGSW_6061_Tanbark: 5586,
    HGSW_6062_VintageLeather: 5587,
    HGSW_6063_NiceWhite: 5588,
    HGSW_6065_BonaFideBeige: 5589,
    HGSW_6066_SandTrap: 5590,
    HGSW_6067_Mocha: 5591,
    HGSW_6068_BrevityBrown: 5592,
    HGSW_6069_FrenchRoast: 5593,
    HGSW_6071_PopularGray: 5594,
    HGSW_6072_VersatileGray: 5595,
    HGSW_6073_PerfectGreige: 5596,
    HGSW_6075_GarretGray: 5597,
    HGSW_6076_TurkishCoffee: 5598,
    HGSW_6078_RealistBeige: 5599,
    HGSW_6079_DiverseBeige: 5600,
    HGSW_6080_UtterlyBeige: 5601,
    HGSW_6081_DownHome: 5602,
    HGSW_6082_CobbleBrown: 5603,
    HGSW_6083_Sable: 5604,
    HGSW_6085_SimplifyBeige: 5605,
    HGSW_6087_TrustyTan: 5606,
    HGSW_6088_Nuthatch: 5607,
    HGSW_6089_Grounded: 5608,
    HGSW_6090_Java: 5609,
    HGSW_6092_LightweightBeige: 5610,
    HGSW_6093_FamiliarBeige: 5611,
    HGSW_6094_SensationalSand: 5612,
    HGSW_6096_JuteBrown: 5613,
    HGSW_6097_SturdyBrown: 5614,
    HGSW_6099_SandDollar: 5615,
    HGSW_6100_PracticalBeige: 5616,
    HGSW_6101_SandsOfTime: 5617,
    HGSW_6102_Portabello: 5618,
    HGSW_6104_Kaffee: 5619,
    HGSW_6105_DivineWhite: 5620,
    HGSW_6106_KilimBeige: 5621,
    HGSW_6107_NomadicDesert: 5622,
    HGSW_6108_Latte: 5623,
    HGSW_6109_Hopsack: 5624,
    HGSW_6111_CoconutHusk: 5625,
    HGSW_6113_InteractiveCream: 5626,
    HGSW_6115_TotallyTan: 5627,
    HGSW_6116_TatamiTan: 5628,
    HGSW_6117_SmokeyTopaz: 5629,
    HGSW_6119_AntiqueWhite: 5630,
    HGSW_6120_BelievableBuff: 5631,
    HGSW_6121_WholeWheat: 5632,
    HGSW_6122_Camelback: 5633,
    HGSW_6123_Baguette: 5634,
    HGSW_6124_Cardboard: 5635,
    HGSW_6126_NavajoWhite: 5636,
    HGSW_6127_Ivoire: 5637,
    HGSW_6128_Blonde: 5638,
    HGSW_6129_RestrainedGold: 5639,
    HGSW_6130_ManneredGold: 5640,
    HGSW_6131_Chamois: 5641,
    HGSW_6132_RelicBronze: 5642,
    HGSW_6133_Muslin: 5643,
    HGSW_6134_Netsuke: 5644,
    HGSW_6135_Ecru: 5645,
    HGSW_6136_HarmonicTan: 5646,
    HGSW_6137_Burlap: 5647,
    HGSW_6138_Artifact: 5648,
    HGSW_6140_ModerateWhite: 5649,
    HGSW_6141_SofterTan: 5650,
    HGSW_6142_Macadamia: 5651,
    HGSW_6144_DapperTan: 5652,
    HGSW_6145_ThatchBrown: 5653,
    HGSW_6146_Umber: 5654,
    HGSW_6148_WoolSkein: 5655,
    HGSW_6149_RelaxedKhaki: 5656,
    HGSW_6150_UniversalKhaki: 5657,
    HGSW_6151_QuiverTan: 5658,
    HGSW_6152_SuperiorBronze: 5659,
    HGSW_6154_Nacre: 5660,
    HGSW_6156_Ramie: 5661,
    HGSW_6157_FavoriteTan: 5662,
    HGSW_6158_Sawdust: 5663,
    HGSW_6159_HighTea: 5664,
    HGSW_6160_BestBronze: 5665,
    HGSW_6162_AncientMarble: 5666,
    HGSW_6164_SvelteSage: 5667,
    HGSW_6165_ConnectedGray: 5668,
    HGSW_6167_GardenGate: 5669,
    HGSW_6169_SedateGray: 5670,
    HGSW_6170_TechnoGray: 5671,
    HGSW_6171_Chatroom: 5672,
    HGSW_6173_Cocoon: 5673,
    HGSW_6176_LiveableGreen: 5674,
    HGSW_6177_SoftenedGreen: 5675,
    HGSW_6178_ClarySage: 5676,
    HGSW_6179_Artichoke: 5677,
    HGSW_6180_Oakmoss: 5678,
    HGSW_6181_SecretGarden: 5679,
    HGSW_6182_EtherealWhite: 5680,
    HGSW_6183_ConservativeGray: 5681,
    HGSW_6184_AustereGray: 5682,
    HGSW_6185_EscapeGray: 5683,
    HGSW_6186_DriedThyme: 5684,
    HGSW_6188_Shadegrown: 5685,
    HGSW_6190_FilmyGreen: 5686,
    HGSW_6191_Contented: 5687,
    HGSW_6192_CoastalPlain: 5688,
    HGSW_6193_PrivilegeGreen: 5689,
    HGSW_6194_Basil: 5690,
    HGSW_6195_RockGarden: 5691,
    HGSW_6197_AloofGray: 5692,
    HGSW_6198_SensibleHue: 5693,
    HGSW_6199_RareGray: 5694,
    HGSW_6200_LinkGray: 5695,
    HGSW_6202_CastIron: 5696,
    HGSW_6204_SeaSalt: 5697,
    HGSW_6205_ComfortGray: 5698,
    HGSW_6207_Retreat: 5699,
    HGSW_6208_PewterGreen: 5700,
    HGSW_6212_Quietude: 5701,
    HGSW_6213_HalcyonGreen: 5702,
    HGSW_6214_Underseas: 5703,
    HGSW_6215_RockyRiver: 5704,
    HGSW_6216_Jasper: 5705,
    HGSW_6218_Tradewind: 5706,
    HGSW_6219_Rain: 5707,
    HGSW_6220_InterestingAqua: 5708,
    HGSW_6221_MoodyBlue: 5709,
    HGSW_6222_Riverway: 5710,
    HGSW_6223_StillWater: 5711,
    HGSW_6224_MountainAir: 5712,
    HGSW_6225_SleepyBlue: 5713,
    HGSW_6226_LanguidBlue: 5714,
    HGSW_6227_Meditative: 5715,
    HGSW_6228_Refuge: 5716,
    HGSW_6230_Rainstorm: 5717,
    HGSW_6232_Misty: 5718,
    HGSW_6233_SamovarSilver: 5719,
    HGSW_6234_UncertainGray: 5720,
    HGSW_6236_GraysHarbor: 5721,
    HGSW_6237_DarkNight: 5722,
    HGSW_6238_Icicle: 5723,
    HGSW_6239_Upward: 5724,
    HGSW_6240_WindyBlue: 5725,
    HGSW_6241_Aleutian: 5726,
    HGSW_6242_BracingBlue: 5727,
    HGSW_6243_Distance: 5728,
    HGSW_6244_Naval: 5729,
    HGSW_6246_NorthStar: 5730,
    HGSW_6247_Krypton: 5731,
    HGSW_6248_Jubilee: 5732,
    HGSW_6249_StormCloud: 5733,
    HGSW_6250_GranitePeak: 5734,
    HGSW_6252_IceCube: 5735,
    HGSW_6253_OlympusWhite: 5736,
    HGSW_6254_LazyGray: 5737,
    HGSW_6255_MorningFog: 5738,
    HGSW_6256_SeriousGray: 5739,
    HGSW_6258_TricornBlack: 5740,
    HGSW_6260_UniqueGray: 5741,
    HGSW_6261_SwankyGray: 5742,
    HGSW_6262_MysteriousMauve: 5743,
    HGSW_6263_ExclusivePlum: 5744,
    HGSW_6264_Midnight: 5745,
    HGSW_6265_QuixoticPlum: 5746,
    HGSW_6267_SensitiveTint: 5747,
    HGSW_6268_VeiledViolet: 5748,
    HGSW_6269_BeguilingMauve: 5749,
    HGSW_6271_ExpressivePlum: 5750,
    HGSW_6272_PlumBrown: 5751,
    HGSW_6274_Destiny: 5752,
    HGSW_6275_FashionableGray: 5753,
    HGSW_6277_SpecialGray: 5754,
    HGSW_6278_CloakGray: 5755,
    HGSW_6281_Wallflower: 5756,
    HGSW_6282_MauveFinery: 5757,
    HGSW_6283_Thistle: 5758,
    HGSW_6284_PlumDandy: 5759,
    HGSW_6285_GrapeHarvest: 5760,
    HGSW_6286_MatureGrape: 5761,
    HGSW_6295_Demure: 5762,
    HGSW_6296_FadingRose: 5763,
    HGSW_6297_RoseEmbroidery: 5764,
    HGSW_6298_Concerto: 5765,
    HGSW_6302_Innocence: 5766,
    HGSW_6303_RoseColored: 5767,
    HGSW_6304_PressedFlower: 5768,
    HGSW_6305_RamblingRose: 5769,
    HGSW_6306_Cordial: 5770,
    HGSW_6309_CharmingPink: 5771,
    HGSW_6310_LotusFlower: 5772,
    HGSW_6311_MemorableRose: 5773,
    HGSW_6312_Redbud: 5774,
    HGSW_6313_KirschRed: 5775,
    HGSW_6316_RosyOutlook: 5776,
    HGSW_6318_ResoundingRose: 5777,
    HGSW_6319_Reddish: 5778,
    HGSW_6321_RedBay: 5779,
    HGSW_6323_Romance: 5780,
    HGSW_6324_MellowCoral: 5781,
    HGSW_6325_ConstantCoral: 5782,
    HGSW_6327_BoldBrick: 5783,
    HGSW_6328_Fireweed: 5784,
    HGSW_6330_QuaintPeche: 5785,
    HGSW_6331_SmokySalmon: 5786,
    HGSW_6332_CoralIsland: 5787,
    HGSW_6333_Foxy: 5788,
    HGSW_6335_FiredBrick: 5789,
    HGSW_6337_SpunSugar: 5790,
    HGSW_6338_WarmingPeach: 5791,
    HGSW_6339_Persimmon: 5792,
    HGSW_6340_BakedClay: 5793,
    HGSW_6342_SpicyHue: 5794,
    HGSW_6344_PeachFuzz: 5795,
    HGSW_6345_SumptuousPeach: 5796,
    HGSW_6346_FameOrange: 5797,
    HGSW_6347_Chrysanthemum: 5798,
    HGSW_6348_Reynard: 5799,
    HGSW_6349_Pennywise: 5800,
    HGSW_6350_IntricateIvory: 5801,
    HGSW_6351_SweetOrange: 5802,
    HGSW_6352_SoftApricot: 5803,
    HGSW_6353_ChivalryCopper: 5804,
    HGSW_6354_Armagnac: 5805,
    HGSW_6356_CopperMountain: 5806,
    HGSW_6357_ChoiceCream: 5807,
    HGSW_6358_Creamery: 5808,
    HGSW_6359_Sociable: 5809,
    HGSW_6360_FolksyGold: 5810,
    HGSW_6361_Autumnal: 5811,
    HGSW_6365_CachetCream: 5812,
    HGSW_6366_AmbitiousAmber: 5813,
    HGSW_6371_Vanillin: 5814,
    HGSW_6372_InvitingIvory: 5815,
    HGSW_6373_Harvester: 5816,
    HGSW_6375_Honeycomb: 5817,
    HGSW_6376_GoldCoast: 5818,
    HGSW_6377_Butterscotch: 5819,
    HGSW_6380_HumbleGold: 5820,
    HGSW_6381_AnjouPear: 5821,
    HGSW_6382_CeremonialGold: 5822,
    HGSW_6383_GoldenRule: 5823,
    HGSW_6384_CutTheMustard: 5824,
    HGSW_6385_DoverWhite: 5825,
    HGSW_6386_Napery: 5826,
    HGSW_6390_BoscPear: 5827,
    HGSW_6391_GallantGold: 5828,
    HGSW_6393_ConvivialYellow: 5829,
    HGSW_6394_Sequin: 5830,
    HGSW_6395_Alchemy: 5831,
    HGSW_6397_Nankeen: 5832,
    HGSW_6398_SconceGold: 5833,
    HGSW_6400_LucentYellow: 5834,
    HGSW_6401_IndependentGold: 5835,
    HGSW_6402_Antiquity: 5836,
    HGSW_6403_EscapadeGold: 5837,
    HGSW_6404_Grandiose: 5838,
    HGSW_6407_AncestralGold: 5839,
    HGSW_6408_WheatGrass: 5840,
    HGSW_6409_EdgyGold: 5841,
    HGSW_6410_Brassy: 5842,
    HGSW_6412_EminentBronze: 5843,
    HGSW_6414_RicePaddy: 5844,
    HGSW_6415_HeartsOfPalm: 5845,
    HGSW_6417_TupeloTree: 5846,
    HGSW_6418_RuralGreen: 5847,
    HGSW_6419_Saguaro: 5848,
    HGSW_6421_Celery: 5849,
    HGSW_6422_Shagreen: 5850,
    HGSW_6423_Ryegrass: 5851,
    HGSW_6424_TansyGreen: 5852,
    HGSW_6425_RelentlessOlive: 5853,
    HGSW_6428_Honeydew: 5854,
    HGSW_6431_Leapfrog: 5855,
    HGSW_6432_GardenSpot: 5856,
    HGSW_6433_Inverness: 5857,
    HGSW_6435_GratifyingGreen: 5858,
    HGSW_6436_BonsaiTint: 5859,
    HGSW_6437_Haven: 5860,
    HGSW_6439_Greenfield: 5861,
    HGSW_6440_Courtyard: 5862,
    HGSW_6442_SupremeGreen: 5863,
    HGSW_6443_Relish: 5864,
    HGSW_6444_LoungeGreen: 5865,
    HGSW_6445_GardenGrove: 5866,
    HGSW_6446_Arugula: 5867,
    HGSW_6449_TopiaryTint: 5868,
    HGSW_6450_EasyGreen: 5869,
    HGSW_6451_NurtureGreen: 5870,
    HGSW_6452_Inland: 5871,
    HGSW_6453_Cilantro: 5872,
    HGSW_6454_Shamrock: 5873,
    HGSW_6456_SlowGreen: 5874,
    HGSW_6457_KindGreen: 5875,
    HGSW_6458_Restful: 5876,
    HGSW_6459_Jadite: 5877,
    HGSW_6461_IsleOfPines: 5878,
    HGSW_6463_Breaktime: 5879,
    HGSW_6464_Aloe: 5880,
    HGSW_6465_Spearmint: 5881,
    HGSW_6467_KendalGreen: 5882,
    HGSW_6468_HuntClub: 5883,
    HGSW_6470_Waterscape: 5884,
    HGSW_6471_Hazel: 5885,
    HGSW_6472_Composed: 5886,
    HGSW_6474_RagingSea: 5887,
    HGSW_6475_CountrySquire: 5888,
    HGSW_6477_Tidewater: 5889,
    HGSW_6478_Watery: 5890,
    HGSW_6479_Drizzle: 5891,
    HGSW_6480_Lagoon: 5892,
    HGSW_6481_GreenBay: 5893,
    HGSW_6482_CapeVerde: 5894,
    HGSW_6484_MeanderBlue: 5895,
    HGSW_6486_ReflectingPool: 5896,
    HGSW_6487_Cloudburst: 5897,
    HGSW_6488_GrandCanal: 5898,
    HGSW_6489_ReallyTeal: 5899,
    HGSW_6491_OpenAir: 5900,
    HGSW_6492_Jetstream: 5901,
    HGSW_6493_Ebbtide: 5902,
    HGSW_6494_Lakeshore: 5903,
    HGSW_6495_GreatFalls: 5904,
    HGSW_6496_Oceanside: 5905,
    HGSW_6498_ByteBlue: 5906,
    HGSW_6500_OpenSeas: 5907,
    HGSW_6501_ManitouBlue: 5908,
    HGSW_6502_LochBlue: 5909,
    HGSW_6503_Bosporus: 5910,
    HGSW_6505_Atmospheric: 5911,
    HGSW_6506_VastSky: 5912,
    HGSW_6507_ResoluteBlue: 5913,
    HGSW_6508_SecureBlue: 5914,
    HGSW_6509_GeorgianBay: 5915,
    HGSW_6510_LoyalBlue: 5916,
    HGSW_6513_TakeFive: 5917,
    HGSW_6514_Respite: 5918,
    HGSW_6515_LeisureBlue: 5919,
    HGSW_6516_DownPour: 5920,
    HGSW_6517_Regatta: 5921,
    HGSW_6519_HintingBlue: 5922,
    HGSW_6520_HonestBlue: 5923,
    HGSW_6521_NotableHue: 5924,
    HGSW_6522_SportyBlue: 5925,
    HGSW_6523_Denim: 5926,
    HGSW_6526_Icelandic: 5927,
    HGSW_6527_BlissfulBlue: 5928,
    HGSW_6528_Cosmos: 5929,
    HGSW_6529_Scanda: 5930,
    HGSW_6530_RevelBlue: 5931,
    HGSW_6533_MildBlue: 5932,
    HGSW_6535_Solitude: 5933,
    HGSW_6536_SearchingBlue: 5934,
    HGSW_6538_Dignified: 5935,
    HGSW_6540_StarryNight: 5936,
    HGSW_6541_Daydream: 5937,
    HGSW_6542_VesperViolet: 5938,
    HGSW_6543_SoulfulBlue: 5939,
    HGSW_6544_Mesmerize: 5940,
    HGSW_6545_MajesticPurple: 5941,
    HGSW_6547_SilverPeony: 5942,
    HGSW_6548_GrapeMist: 5943,
    HGSW_6549_AshViolet: 5944,
    HGSW_6550_Mythical: 5945,
    HGSW_6551_PurplePassage: 5946,
    HGSW_6552_Dewberry: 5947,
    HGSW_6554_LiteLavender: 5948,
    HGSW_6555_Enchant: 5949,
    HGSW_6556_ObiLilac: 5950,
    HGSW_6557_WoodViolet: 5951,
    HGSW_6561_Teaberry: 5952,
    HGSW_6562_Irresistible: 5953,
    HGSW_6563_Rosebay: 5954,
    HGSW_6564_RedClover: 5955,
    HGSW_6565_GrandeurPlum: 5956,
    HGSW_6566_Framboise: 5957,
    HGSW_6570_HautePink: 5958,
    HGSW_6571_Cyclamen: 5959,
    HGSW_6572_RubyShade: 5960,
    HGSW_6573_Juneberry: 5961,
    HGSW_6575_Priscilla: 5962,
    HGSW_6576_AzaleaFlower: 5963,
    HGSW_6577_JaipurPink: 5964,
    HGSW_6578_Tuberose: 5965,
    HGSW_6579_GalaPink: 5966,
    HGSW_6580_Cerise: 5967,
    HGSW_6582_ImpatiensPetal: 5968,
    HGSW_6583_InThePink: 5969,
    HGSW_6589_Alyssum: 5970,
    HGSW_6590_Loveable: 5971,
    HGSW_6591_Amaryllis: 5972,
    HGSW_6592_Grenadine: 5973,
    HGSW_6593_CoralBells: 5974,
    HGSW_6596_BellaPink: 5975,
    HGSW_6597_Hopeful: 5976,
    HGSW_6598_DishyCoral: 5977,
    HGSW_6599_Begonia: 5978,
    HGSW_6601_Tanager: 5979,
    HGSW_6603_Oleander: 5980,
    HGSW_6604_YouthfulCoral: 5981,
    HGSW_6605_Charisma: 5982,
    HGSW_6606_CoralReef: 5983,
    HGSW_6608_RaveRed: 5984,
    HGSW_6610_KoralKicks: 5985,
    HGSW_6611_Jovial: 5986,
    HGSW_6612_RavishingCoral: 5987,
    HGSW_6613_LeiFlower: 5988,
    HGSW_6615_Peppery: 5989,
    HGSW_6617_Blushing: 5990,
    HGSW_6618_CosmeticPeach: 5991,
    HGSW_6619_Sockeye: 5992,
    HGSW_6620_Rejuvenate: 5993,
    HGSW_6621_Emotional: 5994,
    HGSW_6622_HeartyOrange: 5995,
    HGSW_6626_Sunset: 5996,
    HGSW_6627_Emberglow: 5997,
    HGSW_6628_RobustOrange: 5998,
    HGSW_6631_NaivePeach: 5999,
    HGSW_6632_NeighborlyPeach: 6000,
    HGSW_6638_FlatteringPeach: 6001,
    HGSW_6639_AvidApricot: 6002,
    HGSW_6641_OutgoingOrange: 6003,
    HGSW_6642_RhumbaOrange: 6004,
    HGSW_6643_Yam: 6005,
    HGSW_6652_Flan: 6006,
    HGSW_6653_DeliciousMelon: 6007,
    HGSW_6654_SurpriseAmber: 6008,
    HGSW_6655_AdventureOrange: 6009,
    HGSW_6666_EnjoyableYellow: 6010,
    HGSW_6668_Sunrise: 6011,
    HGSW_6669_Yarrow: 6012,
    HGSW_6670_GoldCrest: 6013,
    HGSW_6673_BananaCream: 6014,
    HGSW_6675_Afternoon: 6015,
    HGSW_6676_Butterfield: 6016,
    HGSW_6677_Goldenrod: 6017,
    HGSW_6678_Sunflower: 6018,
    HGSW_6680_FriendlyYellow: 6019,
    HGSW_6681_ButterUp: 6020,
    HGSW_6686_LemonChiffon: 6021,
    HGSW_6688_Solaria: 6022,
    HGSW_6689_Overjoy: 6023,
    HGSW_6691_GlitzyGold: 6024,
    HGSW_6692_Auric: 6025,
    HGSW_6693_Lily: 6026,
    HGSW_6694_GladYellow: 6027,
    HGSW_6695_Midday: 6028,
    HGSW_6696_QuiltGold: 6029,
    HGSW_6697_Nugget: 6030,
    HGSW_6698_KingdomGold: 6031,
    HGSW_6699_CrispyGold: 6032,
    HGSW_6701_Moonraker: 6033,
    HGSW_6702_LivelyYellow: 6034,
    HGSW_6703_Frolic: 6035,
    HGSW_6704_HepGreen: 6036,
    HGSW_6705_HighStrung: 6037,
    HGSW_6706_OffbeatGreen: 6038,
    HGSW_6708_Springtime: 6039,
    HGSW_6709_Gleeful: 6040,
    HGSW_6710_MelangeGreen: 6041,
    HGSW_6711_Parakeet: 6042,
    HGSW_6713_Verdant: 6043,
    HGSW_6730_Romaine: 6044,
    HGSW_6731_Picnic: 6045,
    HGSW_6732_OrganicGreen: 6046,
    HGSW_6733_Grasshopper: 6047,
    HGSW_6734_Espalier: 6048,
    HGSW_6736_JocularGreen: 6049,
    HGSW_6737_Kiwi: 6050,
    HGSW_6738_Vegan: 6051,
    HGSW_6739_EcoGreen: 6052,
    HGSW_6741_Derbyshire: 6053,
    HGSW_6743_MintCondition: 6054,
    HGSW_6744_RecliningGreen: 6055,
    HGSW_6745_LarkGreen: 6056,
    HGSW_6746_Julep: 6057,
    HGSW_6748_Greens: 6058,
    HGSW_6750_Waterfall: 6059,
    HGSW_6751_Refresh: 6060,
    HGSW_6752_Larchmere: 6061,
    HGSW_6753_JargonJade: 6062,
    HGSW_6754_Ionian: 6063,
    HGSW_6757_TameTeal: 6064,
    HGSW_6758_Aqueduct: 6065,
    HGSW_6759_CooledBlue: 6066,
    HGSW_6761_ThermalSpring: 6067,
    HGSW_6764_Swimming: 6068,
    HGSW_6765_Spa: 6069,
    HGSW_6766_Mariner: 6070,
    HGSW_6767_Aquarium: 6071,
    HGSW_6768_Gulfstream: 6072,
    HGSW_6769_MaxiTeal: 6073,
    HGSW_6772_Cay: 6074,
    HGSW_6773_RaptureBlue: 6075,
    HGSW_6774_Freshwater: 6076,
    HGSW_6775_Briny: 6077,
    HGSW_6776_BlueNile: 6078,
    HGSW_6778_AviaryBlue: 6079,
    HGSW_6779_LiquidBlue: 6080,
    HGSW_6780_Nautilus: 6081,
    HGSW_6781_JamaicaBay: 6082,
    HGSW_6783_Amalfi: 6083,
    HGSW_6785_QuenchBlue: 6084,
    HGSW_6786_Cloudless: 6085,
    HGSW_6787_Fountain: 6086,
    HGSW_6788_Capri: 6087,
    HGSW_6789_BlueMosque: 6088,
    HGSW_6790_AdriaticSea: 6089,
    HGSW_6792_MinorBlue: 6090,
    HGSW_6793_Bluebell: 6091,
    HGSW_6794_Flyway: 6092,
    HGSW_6795_MajorBlue: 6093,
    HGSW_6796_BluePlate: 6094,
    HGSW_6797_JayBlue: 6095,
    HGSW_6799_Soar: 6096,
    HGSW_6800_SomethingBlue: 6097,
    HGSW_6801_RegaleBlue: 6098,
    HGSW_6802_Jacaranda: 6099,
    HGSW_6803_Danube: 6100,
    HGSW_6806_RhythmicBlue: 6101,
    HGSW_6807_WondrousBlue: 6102,
    HGSW_6808_Celestial: 6103,
    HGSW_6809_Lobelia: 6104,
    HGSW_6810_Lupine: 6105,
    HGSW_6811_HonorableBlue: 6106,
    HGSW_6813_WishfulBlue: 6107,
    HGSW_6815_AwesomeViolet: 6108,
    HGSW_6816_Dahlia: 6109,
    HGSW_6817_Gentian: 6110,
    HGSW_6818_ValiantViolet: 6111,
    HGSW_6820_InspiredLilac: 6112,
    HGSW_6821_PotentiallyPurple: 6113,
    HGSW_6822_Wisteria: 6114,
    HGSW_6823_BravePurple: 6115,
    HGSW_6824_Forgetmenot: 6116,
    HGSW_6825_IzmirPurple: 6117,
    HGSW_6827_Elation: 6118,
    HGSW_6828_RhapsodyLilac: 6119,
    HGSW_6829_Magical: 6120,
    HGSW_6830_Kismet: 6121,
    HGSW_6831_Clematis: 6122,
    HGSW_6832_ImpulsivePurple: 6123,
    HGSW_6834_Spangle: 6124,
    HGSW_6835_EuphoricLilac: 6125,
    HGSW_6836_NovelLilac: 6126,
    HGSW_6837_Baroness: 6127,
    HGSW_6838_VigorousViolet: 6128,
    HGSW_6839_KimonoViolet: 6129,
    HGSW_6883_RaucousOrange: 6130,
    HGSW_6900_OptimisticYellow: 6131,
    HGSW_6901_Daffodil: 6132,
    HGSW_6903_Cheerful: 6133,
    HGSW_6908_FunYellow: 6134,
    HGSW_6910_Daisy: 6135,
    HGSW_6911_ConfidentYellow: 6136,
    HGSW_6913_FunkyYellow: 6137,
    HGSW_6914_EyeCatching: 6138,
    HGSW_6915_Citronella: 6139,
    HGSW_6988_BohemianBlack: 6140,
    HGSW_6990_Caviar: 6141,
    HGSW_7000_IbisWhite: 6142,
    HGSW_7001_Marshmallow: 6143,
    HGSW_7002_Downy: 6144,
    HGSW_7003_ToqueWhite: 6145,
    HGSW_7004_Snowbound: 6146,
    HGSW_7005_PureWhite: 6147,
    HGSW_7006_ExtraWhite: 6148,
    HGSW_7007_CeilingBrightWhite: 6149,
    HGSW_7008_Alabaster: 6150,
    HGSW_7009_PearlyWhite: 6151,
    HGSW_7010_WhiteDuck: 6152,
    HGSW_7011_NaturalChoice: 6153,
    HGSW_7012_Creamy: 6154,
    HGSW_7014_EiderWhite: 6155,
    HGSW_7015_ReposeGray: 6156,
    HGSW_7016_MindfulGray: 6157,
    HGSW_7017_DorianGray: 6158,
    HGSW_7018_Dovetail: 6159,
    HGSW_7019_GauntletGray: 6160,
    HGSW_7020_BlackFox: 6161,
    HGSW_7022_Alpaca: 6162,
    HGSW_7023_RequisiteGray: 6163,
    HGSW_7024_FunctionalGray: 6164,
    HGSW_7025_Backdrop: 6165,
    HGSW_7026_Griffin: 6166,
    HGSW_7027_HickorySmoke: 6167,
    HGSW_7028_IncredibleWhite: 6168,
    HGSW_7029_AgreeableGray: 6169,
    HGSW_7030_AnewGray: 6170,
    HGSW_7031_MegaGreige: 6171,
    HGSW_7033_BrainstormBronze: 6172,
    HGSW_7035_AestheticWhite: 6173,
    HGSW_7036_AccessibleBeige: 6174,
    HGSW_7037_BalancedBeige: 6175,
    HGSW_7038_TonyTaupe: 6176,
    HGSW_7039_VirtualTaupe: 6177,
    HGSW_7040_Smokehouse: 6178,
    HGSW_7041_VanDykeBrown: 6179,
    HGSW_7042_ShojiWhite: 6180,
    HGSW_7043_WorldlyGray: 6181,
    HGSW_7045_IntellectualGray: 6182,
    HGSW_7046_Anonymous: 6183,
    HGSW_7047_Porpoise: 6184,
    HGSW_7048_UrbaneBronze: 6185,
    HGSW_7049_Nuance: 6186,
    HGSW_7050_UsefulGray: 6187,
    HGSW_7053_AdaptiveShade: 6188,
    HGSW_7054_OakLeafBrown: 6189,
    HGSW_7057_SilverStrand: 6190,
    HGSW_7058_MagneticGray: 6191,
    HGSW_7059_UnusualGray: 6192,
    HGSW_7060_AttitudeGray: 6193,
    HGSW_7061_NightOwl: 6194,
    HGSW_7062_RockBottom: 6195,
    HGSW_7063_NebulousWhite: 6196,
    HGSW_7064_Passive: 6197,
    HGSW_7065_Argos: 6198,
    HGSW_7066_GrayMatters: 6199,
    HGSW_7067_Cityscape: 6200,
    HGSW_7068_GrizzleGray: 6201,
    HGSW_7069_IronOre: 6202,
    HGSW_7071_GrayScreen: 6203,
    HGSW_7072_Online: 6204,
    HGSW_7073_NetworkGray: 6205,
    HGSW_7074_Software: 6206,
    HGSW_7075_WebGray: 6207,
    HGSW_7076_Cyberspace: 6208,
    HGSW_7080_QuestGray: 6209,
    HGSW_7081_SensuousGray: 6210,
    HGSW_7082_StunningShade: 6211,
    HGSW_7083_Darkroom: 6212,
    HGSW_7102_WhiteFlour: 6213,
    HGSW_7104_CottonWhite: 6214,
    HGSW_7504_KeystoneGray: 6215,
    HGSW_7505_ManorHouse: 6216,
    HGSW_7506_Loggia: 6217,
    HGSW_7507_StoneLion: 6218,
    HGSW_7508_TavernTaupe: 6219,
    HGSW_7509_TikiHut: 6220,
    HGSW_7511_BungalowBeige: 6221,
    HGSW_7512_PavilionBeige: 6222,
    HGSW_7513_Sanderling: 6223,
    HGSW_7514_Foothills: 6224,
    HGSW_7515_HomesteadBrown: 6225,
    HGSW_7517_RiversEdge: 6226,
    HGSW_7526_MaisonBlanche: 6227,
    HGSW_7529_SandBeach: 6228,
    HGSW_7531_CanvasTan: 6229,
    HGSW_7533_KhakiShade: 6230,
    HGSW_7534_Outerbanks: 6231,
    HGSW_7542_Naturel: 6232,
    HGSW_7543_AvenueTan: 6233,
    HGSW_7544_Fenland: 6234,
    HGSW_7545_Pier: 6235,
    HGSW_7550_ResortTan: 6236,
    HGSW_7551_GreekVilla: 6237,
    HGSW_7555_Patience: 6238,
    HGSW_7556_Creme: 6239,
    HGSW_7558_MediciIvory: 6240,
    HGSW_7559_DecorWhite: 6241,
    HGSW_7562_RomanColumn: 6242,
    HGSW_7564_PolarBear: 6243,
    HGSW_7565_OysterBar: 6244,
    HGSW_7566_WesthighlandWhite: 6245,
    HGSW_7567_NaturalTan: 6246,
    HGSW_7568_NeutralGround: 6247,
    HGSW_7569_Stucco: 6248,
    HGSW_7570_EgretWhite: 6249,
    HGSW_7571_CasaBlanca: 6250,
    HGSW_7572_LotusPod: 6251,
    HGSW_7578_Borscht: 6252,
    HGSW_7586_StolenKiss: 6253,
    HGSW_7588_ShowStopper: 6254,
    HGSW_7589_HabaneroChile: 6255,
    HGSW_7591_RedBarn: 6256,
    HGSW_7600_Bolero: 6257,
    HGSW_7602_IndigoBatik: 6258,
    HGSW_7621_Silvermist: 6259,
    HGSW_7624_SlateTile: 6260,
    HGSW_7636_OrigamiWhite: 6261,
    HGSW_7638_JoggingPath: 6262,
    HGSW_7639_EtherealMood: 6263,
    HGSW_7641_CollonadeGray: 6264,
    HGSW_7643_Pussywillow: 6265,
    HGSW_7646_FirstStar: 6266,
    HGSW_7652_MineralDeposit: 6267,
    HGSW_7657_Tinsmith: 6268,
    HGSW_7659_Gris: 6269,
    HGSW_7660_EarlGrey: 6270,
    HGSW_7661_Reflection: 6271,
    HGSW_7663_MonorailSilver: 6272,
    HGSW_7664_SteelyGray: 6273,
    HGSW_7665_WallStreet: 6274,
    HGSW_7674_Peppercorn: 6275,
    HGSW_7675_Sealskin: 6276,
    HGSW_7688_Sundew: 6277,
    HGSW_7693_Stonebriar: 6278,
    HGSW_7694_DromedaryCamel: 6279,
    HGSW_7701_CavernClay: 6280,
    HGSW_7702_SpicedCider: 6281,
    HGSW_7709_CopperPot: 6282,
    HGSW_7719_FrescoCream: 6283,
    HGSW_7727_KoiPond: 6284,
    HGSW_7734_OliveGrove: 6285,
    HGSW_7740_MessengerBag: 6286,
    HGSW_7745_MuddledBasil: 6287,
    HGSW_7747_RecycledGlass: 6288,
    HGSW_7757_HighReflectiveWhite: 6289,
    HGSW_9001_AudreysBlush: 6290,
    HGSW_9002_CarleysRose: 6291,
    HGSW_9003_RitasRouge: 6292,
    HGSW_9004_CoralRose: 6293,
    HGSW_9005_CoralClay: 6294,
    HGSW_9006_RojoDust: 6295,
    HGSW_9007_MelosoMelon: 6296,
    HGSW_9010_WindsweptCanyon: 6297,
    HGSW_9011_SunBleachedOchre: 6298,
    HGSW_9012_PolvoDeOro: 6299,
    HGSW_9013_OldenAmber: 6300,
    HGSW_9014_PollenPowder: 6301,
    HGSW_9017_SunnyVeranda: 6302,
    HGSW_9018_HoneyBees: 6303,
    HGSW_9019_GoldenPlumeria: 6304,
    HGSW_9020_RayoDeSol: 6305,
    HGSW_9024_VintageGold: 6306,
    HGSW_9025_CorianderPowder: 6307,
    HGSW_9026_TarnishedTrumpet: 6308,
    HGSW_9027_PaleMoss: 6309,
    HGSW_9028_DustedOlive: 6310,
    HGSW_9029_CoolAvocado: 6311,
    HGSW_9031_Primavera: 6312,
    HGSW_9033_OhPistachio: 6313,
    HGSW_9035_FrostedEmerald: 6314,
    HGSW_9036_RetroMint: 6315,
    HGSW_9037_BabyBokChoy: 6316,
    HGSW_9038_CucuzzaVerde: 6317,
    HGSW_9039_Broccoflower: 6318,
    HGSW_9040_ResedaGreen: 6319,
    HGSW_9041_ParisianPatina: 6320,
    HGSW_9043_Aquastone: 6321,
    HGSW_9044_LittleBlueBox: 6322,
    HGSW_9045_BoraBoraShore: 6323,
    HGSW_9046_GentleAquamarine: 6324,
    HGSW_9047_AfterTheRain: 6325,
    HGSW_9049_SkyFall: 6326,
    HGSW_9050_VintageVessel: 6327,
    HGSW_9051_Aquaverde: 6328,
    HGSW_9054_LittleBoyBlu: 6329,
    HGSW_9056_FrenchMoire: 6330,
    HGSW_9057_Aquitaine: 6331,
    HGSW_9058_SecretCove: 6332,
    HGSW_9059_SilkenPeacock: 6333,
    HGSW_9060_ConnorsLakefront: 6334,
    HGSW_9061_RestAssured: 6335,
    HGSW_9066_Agapanthus: 6336,
    HGSW_9072_DriedLavender: 6337,
    HGSW_9075_BerryCream: 6338,
    HGSW_9078_CocoaBerry: 6339,
    HGSW_9079_VelvetyChestnut: 6340,
    HGSW_9080_HushedAuburn: 6341,
    HGSW_9081_RedendPoint: 6342,
    HGSW_9082_ChocolatePowder: 6343,
    HGSW_9083_DustedTruffle: 6344,
    HGSW_9084_CocoaWhip: 6345,
    HGSW_9085_TouchOfSand: 6346,
    HGSW_9086_CoolBeige: 6347,
    HGSW_9087_SmokyBeige: 6348,
    HGSW_9088_Utaupeia: 6349,
    HGSW_9089_LlamaWool: 6350,
    HGSW_9090_Caraibe: 6351,
    HGSW_9091_Halfcaff: 6352,
    HGSW_9092_IcedMocha: 6353,
    HGSW_9094_PlayaArenoso: 6354,
    HGSW_9096_BeigeIntenso: 6355,
    HGSW_9100_UmberRust: 6356,
    HGSW_9101_AuNaturale: 6357,
    HGSW_9102_Quinoa: 6358,
    HGSW_9104_WovenWicker: 6359,
    HGSW_9108_DoubleLatte: 6360,
    HGSW_9109_NaturalLinen: 6361,
    HGSW_9110_Malabar: 6362,
    HGSW_9111_AntlerVelvet: 6363,
    HGSW_9113_Mudslide: 6364,
    HGSW_9114_FallenLeaves: 6365,
    HGSW_9115_CowboyBoots: 6366,
    HGSW_9117_UrbanJungle: 6367,
    HGSW_9118_TarnishedTreasure: 6368,
    HGSW_9119_DirtyMartini: 6369,
    HGSW_9120_TumblinTumbleweed: 6370,
    HGSW_9122_DriedEdamame: 6371,
    HGSW_9123_BarroVerde: 6372,
    HGSW_9124_VerdeMarron: 6373,
    HGSW_9125_OlivaOscuro: 6374,
    HGSW_9130_EvergreenFog: 6375,
    HGSW_9131_CornwallSlate: 6376,
    HGSW_9132_AcaciaHaze: 6377,
    HGSW_9133_JasperStone: 6378,
    HGSW_9134_Delft: 6379,
    HGSW_9135_Whirlpool: 6380,
    HGSW_9136_Lullaby: 6381,
    HGSW_9137_NieblaAzul: 6382,
    HGSW_9138_Stardew: 6383,
    HGSW_9139_Debonair: 6384,
    HGSW_9140_BlusterySky: 6385,
    HGSW_9141_Waterloo: 6386,
    HGSW_9142_MoscowMidnight: 6387,
    HGSW_9143_Cadet: 6388,
    HGSW_9144_Moonmist: 6389,
    HGSW_9145_SleepyHollow: 6390,
    HGSW_9146_FadedFlaxflower: 6391,
    HGSW_9147_FavoriteJeans: 6392,
    HGSW_9148_SmokyAzurite: 6393,
    HGSW_9149_InkyBlue: 6394,
    HGSW_9150_EndlessSea: 6395,
    HGSW_9152_LetItRain: 6396,
    HGSW_9153_MoonlitOrchid: 6397,
    HGSW_9155_SlateViolet: 6398,
    HGSW_9156_GrisMorado: 6399,
    HGSW_9157_AutumnOrchid: 6400,
    HGSW_9159_AugerShell: 6401,
    HGSW_9162_AfricanGray: 6402,
    HGSW_9163_TinLizzie: 6403,
    HGSW_9164_IllusiveGreen: 6404,
    HGSW_9166_DriftOfMist: 6405,
    HGSW_9167_PolishedConcrete: 6406,
    HGSW_9169_ChaturaGray: 6407,
    HGSW_9171_FeltedWool: 6408,
    HGSW_9172_StudioClay: 6409,
    HGSW_9174_MothWing: 6410,
    HGSW_9176_DressBlues: 6411,
    HGSW_9177_SaltyDog: 6412,
    SW_0001_MulberrySilk: 280,
    SW_0002_ChelseaMauve: 281,
    SW_0003_CabbageRose: 282,
    SW_0004_RoseBrocade: 283,
    SW_0005_DeepestMauve: 284,
    SW_0006_ToileRed: 285,
    SW_0007_DecorousAmber: 286,
    SW_0008_CajunRed: 287,
    SW_0009_EastlakeGold: 288,
    SW_0010_Wickerwork: 289,
    SW_0011_CrewelTan: 290,
    SW_0012_EmpireGold: 291,
    SW_0013_MajolicaGreen: 292,
    SW_0014_SheratonSage: 293,
    SW_0015_GalleryGreen: 294,
    SW_0016_BilliardGreen: 295,
    SW_0017_Calico: 296,
    SW_0018_TealStencil: 297,
    SW_0019_FestoonAqua: 298,
    SW_0020_PeacockPlume: 299,
    SW_0021_QueenAnneLilac: 300,
    SW_0022_PatchworkPlum: 301,
    SW_0023_PewterTankard: 302,
    SW_0024_CurioGray: 259,
    SW_0025_Rosedust: 303,
    SW_0026_RachelPink: 304,
    SW_0027_AristocratPeach: 305,
    SW_0028_CaenStone: 306,
    SW_0029_Acanthus: 307,
    SW_0030_ColonialYellow: 308,
    SW_0031_DutchTileBlue: 309,
    SW_0032_NeedlepointNavy: 310,
    SW_0033_RembrandtRuby: 311,
    SW_0034_RoycroftRose: 312,
    SW_0035_IndianWhite: 313,
    SW_0036_BuckramBinding: 314,
    SW_0037_MorrisRoomGrey: 315,
    SW_0038_LibraryPewter: 316,
    SW_0039_PortraitTone: 317,
    SW_0040_RoycroftAdobe: 318,
    SW_0041_DardHunterGreen: 319,
    SW_0042_RuskinRoomGreen: 320,
    SW_0043_PeristyleBrass: 321,
    SW_0044_HubbardSquash: 322,
    SW_0045_AntiquarianBrown: 323,
    SW_0046_WhiteHyacinth: 324,
    SW_0047_StudioBlueGreen: 325,
    SW_0048_BunglehouseBlue: 326,
    SW_0049_SilverGray: 327,
    SW_0050_ClassicLightBuff: 328,
    SW_0051_ClassicIvory: 329,
    SW_0052_PearlGray: 330,
    SW_0053_Porcelain: 331,
    SW_0054_TwilightGray: 68,
    SW_0055_LightFrenchGray: 69,
    SW_0056_ClassicSand: 332,
    SW_0057_ChineseRed: 333,
    SW_0058_JazzAgeCoral: 334,
    SW_0059_Frostwork: 335,
    SW_0060_Alexandrite: 336,
    SW_0061_SalonRose: 337,
    SW_0062_StudioMauve: 338,
    SW_0063_BlueSky: 339,
    SW_0064_BluePeacock: 340,
    SW_0065_VogueGreen: 341,
    SW_0066_CascadeGreen: 342,
    SW_0067_BelvedereCream: 343,
    SW_0068_CopenBlue: 344,
    SW_0069_RoseTan: 345,
    SW_0070_PinkShadow: 346,
    SW_0071_Orchid: 347,
    SW_0072_DeepMaroon: 348,
    SW_0073_Chartreuse: 349,
    SW_0074_RadiantLilac: 350,
    SW_0075_HolidayTurquoise: 351,
    SW_0076_Appleblossom: 352,
    SW_0077_ClassicFrenchGray: 353,
    SW_0078_SunbeamYellow: 354,
    SW_0079_PinkyBeige: 355,
    SW_0080_PinkFlamingo: 356,
    SW_1015_SkylineSteel: 234,
    SW_1030_SculptureGray: 1731,
    SW_1666_VenetianYellow: 357,
    SW_1667_IcyLemonade: 358,
    SW_1668_PineappleCream: 359,
    SW_2704_Merlot: 360,
    SW_2735_Rockweed: 361,
    SW_2739_CharcoalBlue: 362,
    SW_2740_MineralGray: 363,
    SW_2801_RookwoodDarkRed: 364,
    SW_2802_RookwoodRed: 365,
    SW_2803_RookwoodTerraCotta: 366,
    SW_2804_RenwickRoseBeige: 367,
    SW_2805_RenwickBeige: 368,
    SW_2806_RookwoodBrown: 369,
    SW_2807_RookwoodMediumBrown: 370,
    SW_2808_RookwoodDarkBrown: 371,
    SW_2809_RookwoodShutterGreen: 71,
    SW_2810_RookwoodSashGreen: 372,
    SW_2811_RookwoodBlueGreen: 373,
    SW_2812_RookwoodJade: 374,
    SW_2813_DowningStraw: 375,
    SW_2814_RookwoodAntiqueGold: 376,
    SW_2815_RenwickOlive: 377,
    SW_2816_RookwoodDarkGreen: 378,
    SW_2817_RookwoodAmber: 379,
    SW_2818_RenwickHeather: 380,
    SW_2819_DowningSlate: 381,
    SW_2820_DowningEarth: 382,
    SW_2821_DowningStone: 383,
    SW_2822_DowningSand: 260,
    SW_2823_RookwoodClay: 384,
    SW_2824_RenwickGoldenOak: 385,
    SW_2826_ColonialRevivalGreenStone: 386,
    SW_2827_ColonialRevivalStone: 387,
    SW_2828_ColonialRevivalTan: 388,
    SW_2829_ClassicalWhite: 389,
    SW_2831_ClassicalGold: 390,
    SW_2832_ColonialRevivalGray: 391,
    SW_2833_RoycroftVellum: 392,
    SW_2834_BirdseyeMaple: 393,
    SW_2835_CraftsmanBrown: 394,
    SW_2836_QuartersawnOak: 395,
    SW_2837_AuroraBrown: 396,
    SW_2838_PolishedMahogany: 397,
    SW_2839_RoycroftCopperRed: 398,
    SW_2840_HammeredSilver: 154,
    SW_2841_WeatheredShingle: 399,
    SW_2842_RoycroftSuede: 400,
    SW_2843_RoycroftBrass: 401,
    SW_2844_RoycroftMistGray: 261,
    SW_2845_BunglehouseGray: 402,
    SW_2846_RoycroftBronzeGreen: 403,
    SW_2847_RoycroftBottleGreen: 404,
    SW_2848_RoycroftPewter: 405,
    SW_2849_WestchesterGray: 406,
    SW_2850_ChelseaGray: 407,
    SW_2851_SageGreenLight: 408,
    SW_2853_NewColonialYellow: 409,
    SW_2854_CaribbeanCoral: 410,
    SW_2855_SycamoreTan: 411,
    SW_2856_FairfaxBrown: 412,
    SW_2857_PeaceYellow: 413,
    SW_2858_HarvestGold: 414,
    SW_2859_Beige: 415,
    SW_2860_Sage: 416,
    SW_2861_Avocado: 417,
    SW_2863_PowderBlue: 418,
    SW_2865_ClassicalYellow: 419,
    SW_3022_BlackAlder: 4426,
    SW_3063_Charcoal: 1754,
    SW_3079_Stone: 4492,
    SW_6000_Snowfall: 420,
    SW_6001_Grayish: 153,
    SW_6002_EssentialGray: 421,
    SW_6003_ProperGray: 422,
    SW_6004_Mink: 423,
    SW_6005_Folkstone: 424,
    SW_6006_BlackBean: 72,
    SW_6007_SmartWhite: 425,
    SW_6008_IndividualWhite: 426,
    SW_6009_Imagine: 73,
    SW_6010_FlexibleGray: 427,
    SW_6011_Chinchilla: 428,
    SW_6012_BrowseBrown: 429,
    SW_6013_BitterChocolate: 430,
    SW_6015_VaguelyMauve: 431,
    SW_6016_ChaiseMauve: 432,
    SW_6017_Intuitive: 433,
    SW_6018_Enigma: 434,
    SW_6019_PoetryPlum: 435,
    SW_6020_Marooned: 436,
    SW_6021_DreamyWhite: 437,
    SW_6022_Breathless: 438,
    SW_6023_InsightfulRose: 439,
    SW_6024_DressyRose: 440,
    SW_6025_Socialite: 441,
    SW_6026_RiverRouge: 442,
    SW_6027_Cordovan: 443,
    SW_6028_CulturedPearl: 444,
    SW_6029_WhiteTruffle: 445,
    SW_6030_ArtisticTaupe: 446,
    SW_6031_Glamour: 447,
    SW_6032_DutchCocoa: 448,
    SW_6033_BateauBrown: 449,
    SW_6034_ArrestingAuburn: 450,
    SW_6035_GauzyWhite: 451,
    SW_6036_Angora: 452,
    SW_6037_TemperateTaupe: 453,
    SW_6038_TrulyTaupe: 454,
    SW_6039_PoisedTaupe: 455,
    SW_6040_LessBrown: 74,
    SW_6041_Otter: 456,
    SW_6042_HushWhite: 457,
    SW_6043_UnfussyBeige: 458,
    SW_6044_Doeskin: 459,
    SW_6045_EmergingTaupe: 460,
    SW_6046_SwingBrown: 461,
    SW_6047_HotCocoa: 462,
    SW_6048_TerraBrun: 463,
    SW_6049_GorgeousWhite: 464,
    SW_6050_AbaloneShell: 465,
    SW_6051_SashaySand: 466,
    SW_6052_Sandbank: 467,
    SW_6053_ReddenedEarth: 468,
    SW_6054_CanyonClay: 469,
    SW_6055_FieryBrown: 470,
    SW_6056_PoliteWhite: 471,
    SW_6057_MaltedMilk: 472,
    SW_6058_LikeableSand: 473,
    SW_6059_InterfaceTan: 474,
    SW_6060_MoroccanBrown: 475,
    SW_6061_Tanbark: 476,
    SW_6062_RuggedBrown: 477,
    SW_6063_NiceWhite: 478,
    SW_6064_Reticence: 479,
    SW_6065_BonaFideBeige: 480,
    SW_6066_SandTrap: 481,
    SW_6067_Mocha: 482,
    SW_6068_BrevityBrown: 483,
    SW_6069_FrenchRoast: 484,
    SW_6070_HeronPlume: 485,
    SW_6071_PopularGray: 486,
    SW_6072_VersatileGray: 487,
    SW_6073_PerfectGreige: 488,
    SW_6074_SpaldingGray: 489,
    SW_6075_GarretGray: 490,
    SW_6076_TurkishCoffee: 491,
    SW_6077_EverydayWhite: 492,
    SW_6078_RealistBeige: 493,
    SW_6079_DiverseBeige: 494,
    SW_6080_UtterlyBeige: 495,
    SW_6081_DownHome: 496,
    SW_6082_CobbleBrown: 497,
    SW_6083_Sable: 498,
    SW_6084_ModestWhite: 499,
    SW_6085_SimplifyBeige: 500,
    SW_6086_SandDune: 501,
    SW_6087_TrustyTan: 502,
    SW_6088_Nuthatch: 503,
    SW_6089_Grounded: 504,
    SW_6090_Java: 505,
    SW_6091_ReliableWhite: 506,
    SW_6092_LightweightBeige: 507,
    SW_6093_FamiliarBeige: 508,
    SW_6094_SensationalSand: 509,
    SW_6095_Toasty: 510,
    SW_6096_JuteBrown: 511,
    SW_6097_SturdyBrown: 512,
    SW_6098_PacerWhite: 513,
    SW_6099_SandDollar: 514,
    SW_6100_PracticalBeige: 515,
    SW_6101_SandsofTime: 516,
    SW_6102_Portabello: 517,
    SW_6103_TeaChest: 518,
    SW_6104_Kaffee: 519,
    SW_6105_DivineWhite: 520,
    SW_6106_KilimBeige: 521,
    SW_6107_NomadicDesert: 522,
    SW_6108_Latte: 523,
    SW_6109_Hopsack: 524,
    SW_6110_SteadyBrown: 525,
    SW_6111_CoconutHusk: 526,
    SW_6112_Biscuit: 527,
    SW_6113_InteractiveCream: 528,
    SW_6114_Bagel: 529,
    SW_6115_TotallyTan: 530,
    SW_6116_TatamiTan: 531,
    SW_6117_SmokeyTopaz: 532,
    SW_6118_LeatherBound: 533,
    SW_6119_AntiqueWhite: 534,
    SW_6120_BelievableBuff: 535,
    SW_6121_WholeWheat: 536,
    SW_6122_Camelback: 537,
    SW_6123_Baguette: 538,
    SW_6124_Cardboard: 539,
    SW_6125_CraftPaper: 540,
    SW_6126_NavajoWhite: 541,
    SW_6127_Ivoire: 542,
    SW_6128_Blonde: 543,
    SW_6129_RestrainedGold: 544,
    SW_6130_ManneredGold: 545,
    SW_6131_Chamois: 546,
    SW_6132_RelicBronze: 547,
    SW_6133_Muslin: 548,
    SW_6134_Netsuke: 549,
    SW_6135_Ecru: 550,
    SW_6136_HarmonicTan: 551,
    SW_6137_Burlap: 552,
    SW_6138_Artifact: 553,
    SW_6139_MossyGold: 554,
    SW_6140_ModerateWhite: 555,
    SW_6141_SofterTan: 556,
    SW_6142_Macadamia: 557,
    SW_6143_BasketBeige: 558,
    SW_6144_DapperTan: 559,
    SW_6145_ThatchBrown: 560,
    SW_6146_Umber: 561,
    SW_6147_PandaWhite: 562,
    SW_6148_WoolSkein: 563,
    SW_6149_RelaxedKhaki: 564,
    SW_6150_UniversalKhaki: 565,
    SW_6151_QuiverTan: 566,
    SW_6152_SuperiorBronze: 567,
    SW_6153_ProtegeBronze: 568,
    SW_6154_Nacre: 569,
    SW_6155_RiceGrain: 570,
    SW_6156_Ramie: 571,
    SW_6157_FavoriteTan: 572,
    SW_6158_Sawdust: 573,
    SW_6159_HighTea: 574,
    SW_6160_BestBronze: 575,
    SW_6161_NonchalantWhite: 576,
    SW_6162_AncientMarble: 577,
    SW_6163_Grassland: 578,
    SW_6164_SvelteSage: 579,
    SW_6165_ConnectedGray: 580,
    SW_6166_Eclipse: 581,
    SW_6167_GardenGate: 582,
    SW_6168_ModerneWhite: 583,
    SW_6169_SedateGray: 584,
    SW_6170_TechnoGray: 585,
    SW_6171_Chatroom: 586,
    SW_6172_Hardware: 587,
    SW_6173_Cocoon: 588,
    SW_6174_Andiron: 589,
    SW_6175_Sagey: 590,
    SW_6176_LiveableGreen: 591,
    SW_6177_SoftenedGreen: 592,
    SW_6178_ClarySage: 593,
    SW_6179_Artichoke: 594,
    SW_6180_Oakmoss: 595,
    SW_6181_SecretGarden: 596,
    SW_6182_EtherealWhite: 597,
    SW_6183_ConservativeGray: 598,
    SW_6184_AustereGray: 262,
    SW_6185_EscapeGray: 599,
    SW_6186_DriedThyme: 600,
    SW_6187_Rosemary: 601,
    SW_6188_ShadeGrown: 602,
    SW_6189_Opaline: 603,
    SW_6190_FilmyGreen: 604,
    SW_6191_Contented: 605,
    SW_6192_CoastalPlain: 606,
    SW_6193_PrivilegeGreen: 607,
    SW_6194_Basil: 608,
    SW_6195_RockGarden: 609,
    SW_6196_FrostyWhite: 610,
    SW_6197_AloofGray: 611,
    SW_6198_SensibleHue: 612,
    SW_6199_RareGray: 613,
    SW_6200_LinkGray: 614,
    SW_6201_Thunderous: 615,
    SW_6202_CastIron: 616,
    SW_6203_SpareWhite: 617,
    SW_6204_SeaSalt: 618,
    SW_6205_ComfortGray: 619,
    SW_6206_OysterBay: 620,
    SW_6207_Retreat: 621,
    SW_6208_PewterGreen: 75,
    SW_6209_RipeOlive: 622,
    SW_6210_WindowPane: 623,
    SW_6211_Rainwashed: 624,
    SW_6212_Quietude: 625,
    SW_6213_HalcyonGreen: 626,
    SW_6214_Underseas: 627,
    SW_6215_RockyRiver: 628,
    SW_6216_Jasper: 629,
    SW_6217_Topsail: 630,
    SW_6218_Tradewind: 631,
    SW_6219_Rain: 632,
    SW_6220_InterestingAqua: 633,
    SW_6221_MoodyBlue: 634,
    SW_6222_Riverway: 635,
    SW_6223_StillWater: 636,
    SW_6224_MountainAir: 159,
    SW_6225_SleepyBlue: 637,
    SW_6226_LanguidBlue: 638,
    SW_6227_Meditative: 639,
    SW_6228_Refuge: 640,
    SW_6229_TempeStar: 641,
    SW_6230_Rainstorm: 263,
    SW_6231_RockCandy: 642,
    SW_6232_Misty: 643,
    SW_6233_SamovarSilver: 644,
    SW_6234_UncertainGray: 645,
    SW_6235_FoggyDay: 76,
    SW_6236_GraysHarbor: 204,
    SW_6237_DarkNight: 646,
    SW_6238_Icicle: 647,
    SW_6239_Upward: 648,
    SW_6240_WindyBlue: 649,
    SW_6241_Aleutian: 650,
    SW_6242_BracingBlue: 651,
    SW_6243_Distance: 652,
    SW_6244_Naval: 653,
    SW_6245_Quicksilver: 654,
    SW_6246_NorthStar: 655,
    SW_6247_Krypton: 656,
    SW_6248_Jubilee: 657,
    SW_6249_StormCloud: 658,
    SW_6250_GranitePeak: 659,
    SW_6251_Outerspace: 660,
    SW_6252_IceCube: 661,
    SW_6253_OlympusWhite: 662,
    SW_6254_LazyGray: 79,
    SW_6255_MorningFog: 663,
    SW_6256_SeriousGray: 664,
    SW_6257_Gibraltar: 151,
    SW_6258_TricornBlack: 169,
    SW_6259_SpatialWhite: 665,
    SW_6260_UniqueGray: 666,
    SW_6261_SwankyGray: 667,
    SW_6262_MysteriousMauve: 668,
    SW_6263_ExclusivePlum: 669,
    SW_6264_Midnight: 670,
    SW_6265_QuixoticPlum: 671,
    SW_6267_SensitiveTint: 672,
    SW_6268_VeiledViolet: 673,
    SW_6269_BeguilingMauve: 674,
    SW_6270_Soulmate: 675,
    SW_6271_ExpressivePlum: 676,
    SW_6272_PlumBrown: 677,
    SW_6274_Destiny: 678,
    SW_6275_FashionableGray: 679,
    SW_6276_MysticalShade: 680,
    SW_6277_SpecialGray: 681,
    SW_6278_CloakGray: 682,
    SW_6279_BlackSwan: 683,
    SW_6281_Wallflower: 684,
    SW_6282_MauveFinery: 685,
    SW_6283_Thistle: 686,
    SW_6284_PlumDandy: 687,
    SW_6285_GrapeHarvest: 688,
    SW_6286_MatureGrape: 689,
    SW_6288_Rosebud: 690,
    SW_6289_Delightful: 691,
    SW_6290_Rose: 692,
    SW_6291_MossRose: 693,
    SW_6292_BerryBush: 694,
    SW_6293_FabulousGrape: 695,
    SW_6295_Demure: 696,
    SW_6296_FadingRose: 697,
    SW_6297_RoseEmbroidery: 698,
    SW_6298_Concerto: 699,
    SW_6299_AgedWine: 700,
    SW_6300_Burgundy: 701,
    SW_6302_Innocence: 702,
    SW_6303_RoseColored: 703,
    SW_6304_PressedFlower: 704,
    SW_6305_RamblingRose: 705,
    SW_6306_Cordial: 706,
    SW_6307_FineWine: 707,
    SW_6309_CharmingPink: 708,
    SW_6310_LotusFlower: 709,
    SW_6311_MemorableRose: 710,
    SW_6312_Redbud: 711,
    SW_6313_KirschRed: 712,
    SW_6314_LuxuriousRed: 713,
    SW_6316_RosyOutlook: 714,
    SW_6317_GraciousRose: 715,
    SW_6318_ResoundingRose: 716,
    SW_6319_Reddish: 717,
    SW_6320_BravadoRed: 718,
    SW_6321_RedBay: 719,
    SW_6322_IntimateWhite: 720,
    SW_6323_Romance: 721,
    SW_6324_MellowCoral: 722,
    SW_6325_ConstantCoral: 723,
    SW_6326_HennaShade: 724,
    SW_6327_BoldBrick: 725,
    SW_6328_Fireweed: 726,
    SW_6329_FaintCoral: 727,
    SW_6330_QuaintPeche: 728,
    SW_6331_SmokySalmon: 729,
    SW_6332_CoralIsland: 730,
    SW_6333_Foxy: 731,
    SW_6334_FlowerPot: 732,
    SW_6335_FiredBrick: 733,
    SW_6336_NearlyPeach: 734,
    SW_6337_SpunSugar: 735,
    SW_6338_WarmingPeach: 736,
    SW_6339_Persimmon: 737,
    SW_6340_BakedClay: 738,
    SW_6341_RedCent: 739,
    SW_6342_SpicyHue: 740,
    SW_6343_AlluringWhite: 741,
    SW_6344_PeachFuzz: 742,
    SW_6345_SumptuousPeach: 743,
    SW_6346_FameOrange: 744,
    SW_6347_Chrysanthemum: 745,
    SW_6348_Reynard: 746,
    SW_6349_Pennywise: 747,
    SW_6350_IntricateIvory: 748,
    SW_6351_SweetOrange: 749,
    SW_6352_SoftApricot: 750,
    SW_6353_ChivalryCopper: 751,
    SW_6354_Armagnac: 752,
    SW_6355_Truepenny: 753,
    SW_6356_CopperMountain: 754,
    SW_6357_ChoiceCream: 755,
    SW_6358_Creamery: 756,
    SW_6359_Sociable: 757,
    SW_6360_FolksyGold: 758,
    SW_6361_Autumnal: 759,
    SW_6362_Tigereye: 760,
    SW_6363_Gingery: 761,
    SW_6364_Eggwhite: 762,
    SW_6365_CachetCream: 763,
    SW_6366_AmbitiousAmber: 764,
    SW_6367_VivaGold: 765,
    SW_6368_BakeliteGold: 766,
    SW_6369_Tassel: 767,
    SW_6370_SaucyGold: 768,
    SW_6371_Vanillin: 769,
    SW_6372_InvitingIvory: 770,
    SW_6373_Harvester: 771,
    SW_6374_Torchlight: 772,
    SW_6375_Honeycomb: 773,
    SW_6376_GoldCoast: 774,
    SW_6377_Butterscotch: 775,
    SW_6378_CrispLinen: 776,
    SW_6379_JerseyCream: 777,
    SW_6380_HumbleGold: 778,
    SW_6381_AnjouPear: 779,
    SW_6382_CeremonialGold: 780,
    SW_6383_GoldenRule: 781,
    SW_6384_CuttheMustard: 782,
    SW_6385_DoverWhite: 148,
    SW_6386_Napery: 783,
    SW_6387_CompatibleCream: 784,
    SW_6388_GoldenFleece: 785,
    SW_6389_Butternut: 786,
    SW_6390_BoscPear: 787,
    SW_6391_GallantGold: 788,
    SW_6392_VitalYellow: 789,
    SW_6393_ConvivialYellow: 790,
    SW_6394_Sequin: 791,
    SW_6395_Alchemy: 792,
    SW_6396_DifferentGold: 793,
    SW_6397_Nankeen: 794,
    SW_6398_SconceGold: 795,
    SW_6399_Chamomile: 796,
    SW_6400_LucentYellow: 797,
    SW_6401_IndependentGold: 798,
    SW_6402_Antiquity: 799,
    SW_6403_EscapadeGold: 800,
    SW_6404_Grandiose: 801,
    SW_6405_FerventBrass: 802,
    SW_6406_IonicIvory: 803,
    SW_6407_AncestralGold: 804,
    SW_6408_WheatGrass: 805,
    SW_6409_EdgyGold: 806,
    SW_6410_Brassy: 807,
    SW_6411_BengalGrass: 808,
    SW_6412_EminentBronze: 809,
    SW_6413_RestorationIvory: 810,
    SW_6414_RicePaddy: 811,
    SW_6415_HeartsofPalm: 812,
    SW_6416_SassyGreen: 813,
    SW_6417_TupeloTree: 814,
    SW_6418_RuralGreen: 815,
    SW_6419_Saguaro: 816,
    SW_6420_QueenAnnesLace: 817,
    SW_6421_Celery: 818,
    SW_6422_Shagreen: 819,
    SW_6423_Ryegrass: 820,
    SW_6424_TansyGreen: 821,
    SW_6425_RelentlessOlive: 822,
    SW_6426_BasqueGreen: 823,
    SW_6427_Sprout: 824,
    SW_6428_Honeydew: 825,
    SW_6429_BaizeGreen: 826,
    SW_6430_GreatGreen: 827,
    SW_6431_Leapfrog: 828,
    SW_6432_GardenSpot: 829,
    SW_6433_Inverness: 830,
    SW_6434_SpinachWhite: 831,
    SW_6435_GratifyingGreen: 832,
    SW_6436_BonsaiTint: 833,
    SW_6437_Haven: 834,
    SW_6438_Dill: 835,
    SW_6439_Greenfield: 836,
    SW_6440_Courtyard: 837,
    SW_6441_WhiteMint: 838,
    SW_6442_SupremeGreen: 839,
    SW_6443_Relish: 840,
    SW_6444_LoungeGreen: 841,
    SW_6445_GardenGrove: 842,
    SW_6446_Arugula: 843,
    SW_6447_Evergreens: 844,
    SW_6449_TopiaryTint: 845,
    SW_6450_EasyGreen: 846,
    SW_6451_NurtureGreen: 847,
    SW_6452_Inland: 848,
    SW_6453_Cilantro: 849,
    SW_6454_Shamrock: 850,
    SW_6455_FleetingGreen: 851,
    SW_6456_SlowGreen: 852,
    SW_6457_KindGreen: 853,
    SW_6458_Restful: 854,
    SW_6459_Jadite: 855,
    SW_6460_KaleGreen: 856,
    SW_6461_IsleofPines: 857,
    SW_6462_GreenTrance: 858,
    SW_6463_Breaktime: 859,
    SW_6464_Aloe: 860,
    SW_6465_Spearmint: 861,
    SW_6466_Grandview: 862,
    SW_6467_KendalGreen: 863,
    SW_6468_HuntClub: 864,
    SW_6470_Waterscape: 865,
    SW_6471_Hazel: 866,
    SW_6472_Composed: 867,
    SW_6473_SurfGreen: 868,
    SW_6474_RagingSea: 869,
    SW_6475_CountrySquire: 870,
    SW_6476_Glimmer: 871,
    SW_6477_Tidewater: 872,
    SW_6478_Watery: 873,
    SW_6479_Drizzle: 874,
    SW_6480_Lagoon: 875,
    SW_6481_GreenBay: 876,
    SW_6482_CapeVerde: 877,
    SW_6484_MeanderBlue: 878,
    SW_6485_Raindrop: 879,
    SW_6486_ReflectingPool: 880,
    SW_6487_Cloudburst: 881,
    SW_6488_GrandCanal: 882,
    SW_6489_ReallyTeal: 883,
    SW_6491_OpenAir: 884,
    SW_6492_Jetstream: 885,
    SW_6493_Ebbtide: 886,
    SW_6494_Lakeshore: 887,
    SW_6495_GreatFalls: 888,
    SW_6496_Oceanside: 889,
    SW_6497_BlueHorizon: 890,
    SW_6498_ByteBlue: 891,
    SW_6499_Stream: 892,
    SW_6500_OpenSeas: 893,
    SW_6501_ManitouBlue: 894,
    SW_6502_LochBlue: 895,
    SW_6503_Bosporus: 896,
    SW_6504_SkyHigh: 897,
    SW_6505_Atmospheric: 898,
    SW_6506_VastSky: 899,
    SW_6507_ResoluteBlue: 900,
    SW_6508_SecureBlue: 901,
    SW_6509_GeorgianBay: 902,
    SW_6510_LoyalBlue: 903,
    SW_6511_Snowdrop: 904,
    SW_6512_Balmy: 905,
    SW_6513_TakeFive: 906,
    SW_6514_Respite: 907,
    SW_6515_LeisureBlue: 908,
    SW_6516_DownPour: 909,
    SW_6517_Regatta: 910,
    SW_6519_HintingBlue: 911,
    SW_6520_HonestBlue: 912,
    SW_6521_NotableHue: 913,
    SW_6522_SportyBlue: 914,
    SW_6523_Denim: 915,
    SW_6524_Commodore: 916,
    SW_6525_RarifiedAir: 917,
    SW_6526_Icelandic: 918,
    SW_6527_BlissfulBlue: 919,
    SW_6528_Cosmos: 920,
    SW_6529_Scanda: 921,
    SW_6530_RevelBlue: 922,
    SW_6531_Indigo: 923,
    SW_6533_MildBlue: 924,
    SW_6534_Icy: 925,
    SW_6535_Solitude: 926,
    SW_6536_SearchingBlue: 927,
    SW_6537_LuxeBlue: 928,
    SW_6538_Dignified: 929,
    SW_6540_StarryNight: 930,
    SW_6541_Daydream: 931,
    SW_6542_VesperViolet: 932,
    SW_6543_SoulfulBlue: 933,
    SW_6544_Mesmerize: 934,
    SW_6545_MajesticPurple: 935,
    SW_6547_SilverPeony: 936,
    SW_6548_GrapeMist: 937,
    SW_6549_AshViolet: 938,
    SW_6550_Mythical: 939,
    SW_6551_PurplePassage: 940,
    SW_6552_Dewberry: 941,
    SW_6554_LiteLavender: 942,
    SW_6555_Enchant: 943,
    SW_6556_ObiLilac: 944,
    SW_6557_WoodViolet: 945,
    SW_6558_Plummy: 946,
    SW_6559_ConcordGrape: 947,
    SW_6561_Teaberry: 948,
    SW_6562_Irresistible: 949,
    SW_6563_Rosebay: 950,
    SW_6564_RedClover: 951,
    SW_6565_GrandeurPlum: 952,
    SW_6566_Framboise: 953,
    SW_6568_LightheartedPink: 954,
    SW_6569_Childlike: 955,
    SW_6570_HautePink: 956,
    SW_6571_Cyclamen: 957,
    SW_6572_RubyShade: 958,
    SW_6573_Juneberry: 959,
    SW_6575_Priscilla: 960,
    SW_6576_AzaleaFlower: 961,
    SW_6577_JaipurPink: 962,
    SW_6578_Tuberose: 963,
    SW_6579_GalaPink: 964,
    SW_6580_Cerise: 965,
    SW_6582_ImpatiensPetal: 966,
    SW_6583_InthePink: 967,
    SW_6584_Cheery: 968,
    SW_6585_ComingupRoses: 969,
    SW_6586_Heartfelt: 970,
    SW_6587_Valentine: 971,
    SW_6589_Alyssum: 972,
    SW_6590_Loveable: 973,
    SW_6591_Amaryllis: 974,
    SW_6592_Grenadine: 975,
    SW_6593_CoralBells: 976,
    SW_6594_Poinsettia: 977,
    SW_6596_BellaPink: 978,
    SW_6597_Hopeful: 979,
    SW_6598_DishyCoral: 980,
    SW_6599_Begonia: 981,
    SW_6600_EnticingRed: 982,
    SW_6601_Tanager: 983,
    SW_6603_Oleander: 984,
    SW_6604_YouthfulCoral: 985,
    SW_6605_Charisma: 986,
    SW_6606_CoralReef: 987,
    SW_6607_RedTomato: 988,
    SW_6608_RaveRed: 989,
    SW_6610_KoralKicks: 990,
    SW_6611_Jovial: 991,
    SW_6612_RavishingCoral: 992,
    SW_6613_LeiFlower: 993,
    SW_6614_QuiteCoral: 994,
    SW_6615_Peppery: 995,
    SW_6617_Blushing: 996,
    SW_6618_CosmeticPeach: 997,
    SW_6619_Sockeye: 998,
    SW_6620_Rejuvenate: 999,
    SW_6621_Emotional: 1000,
    SW_6622_HeartyOrange: 1001,
    SW_6624_PeachBlossom: 1002,
    SW_6625_CertainPeach: 1003,
    SW_6626_Sunset: 1004,
    SW_6627_Emberglow: 1005,
    SW_6628_RobustOrange: 1006,
    SW_6629_Jalapeno: 1007,
    SW_6631_NaivePeach: 1008,
    SW_6632_NeighborlyPeach: 1009,
    SW_6633_InventiveOrange: 1010,
    SW_6634_CopperHarbor: 1011,
    SW_6635_DeterminedOrange: 1012,
    SW_6636_HuskyOrange: 1013,
    SW_6638_FlatteringPeach: 1014,
    SW_6639_AvidApricot: 1015,
    SW_6640_Tangerine: 1016,
    SW_6641_OutgoingOrange: 1017,
    SW_6642_RhumbaOrange: 1018,
    SW_6643_Yam: 1019,
    SW_6644_Champagne: 1020,
    SW_6652_Flan: 1021,
    SW_6653_DeliciousMelon: 1022,
    SW_6654_SurpriseAmber: 1023,
    SW_6655_AdventureOrange: 1024,
    SW_6656_Serape: 1025,
    SW_6657_AmberWave: 1026,
    SW_6658_WelcomeWhite: 1027,
    SW_6659_CaptivatingCream: 1028,
    SW_6660_HoneyBlush: 1029,
    SW_6661_Papaya: 1030,
    SW_6662_SummerDay: 1031,
    SW_6663_SaffronThread: 1032,
    SW_6664_Marigold: 1033,
    SW_6665_Gardenia: 1034,
    SW_6666_EnjoyableYellow: 1035,
    SW_6667_Afterglow: 1036,
    SW_6668_Sunrise: 1037,
    SW_6669_Yarrow: 1038,
    SW_6670_GoldCrest: 1039,
    SW_6671_Curry: 1040,
    SW_6672_MorningSun: 1041,
    SW_6673_BananaCream: 1042,
    SW_6674_Jonquil: 1043,
    SW_6675_Afternoon: 1044,
    SW_6676_Butterfield: 1045,
    SW_6677_Goldenrod: 1046,
    SW_6678_Sunflower: 1047,
    SW_6679_FullMoon: 1048,
    SW_6680_FriendlyYellow: 1049,
    SW_6681_ButterUp: 1050,
    SW_6682_JuneDay: 1051,
    SW_6683_Bee: 1052,
    SW_6684_Brittlebush: 1053,
    SW_6685_Trinket: 1054,
    SW_6686_LemonChiffon: 1055,
    SW_6687_LanternLight: 1056,
    SW_6688_Solaria: 1057,
    SW_6689_Overjoy: 1058,
    SW_6690_GambolGold: 1059,
    SW_6691_GlitzyGold: 1060,
    SW_6692_Auric: 1061,
    SW_6693_Lily: 1062,
    SW_6694_GladYellow: 1063,
    SW_6695_Midday: 1064,
    SW_6696_QuiltGold: 1065,
    SW_6697_Nugget: 1066,
    SW_6698_KingdomGold: 1067,
    SW_6699_CrispyGold: 1068,
    SW_6700_Daybreak: 1069,
    SW_6701_Moonraker: 1070,
    SW_6702_LivelyYellow: 1071,
    SW_6703_Frolic: 1072,
    SW_6704_HepGreen: 1073,
    SW_6705_HighStrung: 1074,
    SW_6706_OffbeatGreen: 1075,
    SW_6708_Springtime: 1076,
    SW_6709_Gleeful: 1077,
    SW_6710_MelangeGreen: 1078,
    SW_6711_Parakeet: 1079,
    SW_6712_LuauGreen: 1080,
    SW_6713_Verdant: 1081,
    SW_6715_LimeGranita: 1082,
    SW_6716_DancingGreen: 1083,
    SW_6717_LimeRickey: 1084,
    SW_6718_OvertGreen: 1085,
    SW_6719_Gecko: 1086,
    SW_6720_Paradise: 1087,
    SW_6722_Cucumber: 1088,
    SW_6723_Jardin: 1089,
    SW_6724_MesclunGreen: 1090,
    SW_6725_Pickle: 1091,
    SW_6726_TalipotPalm: 1092,
    SW_6727_Houseplant: 1093,
    SW_6729_Lacewing: 1094,
    SW_6730_Romaine: 1095,
    SW_6731_Picnic: 1096,
    SW_6732_OrganicGreen: 1097,
    SW_6733_Grasshopper: 1098,
    SW_6734_Espalier: 1099,
    SW_6736_JocularGreen: 1100,
    SW_6737_Kiwi: 1101,
    SW_6738_Vegan: 1102,
    SW_6739_EcoGreen: 1103,
    SW_6740_Kilkenny: 1104,
    SW_6741_Derbyshire: 1105,
    SW_6743_MintCondition: 1106,
    SW_6744_RecliningGreen: 1107,
    SW_6745_LarkGreen: 1108,
    SW_6746_Julep: 1109,
    SW_6747_Argyle: 1110,
    SW_6748_Greens: 1111,
    SW_6749_EmbellishedBlue: 1112,
    SW_6750_Waterfall: 1113,
    SW_6751_Refresh: 1114,
    SW_6752_Larchmere: 1115,
    SW_6753_JargonJade: 1116,
    SW_6754_Ionian: 1117,
    SW_6755_Starboard: 1118,
    SW_6757_TameTeal: 1119,
    SW_6758_Aqueduct: 1120,
    SW_6759_CooledBlue: 1121,
    SW_6760_Rivulet: 1122,
    SW_6761_ThermalSpring: 1123,
    SW_6762_Poseidon: 1124,
    SW_6764_Swimming: 1125,
    SW_6765_Spa: 1126,
    SW_6766_Mariner: 1127,
    SW_6767_Aquarium: 1128,
    SW_6768_Gulfstream: 1129,
    SW_6769_MaxiTeal: 1130,
    SW_6771_BatheBlue: 1131,
    SW_6772_Cay: 1132,
    SW_6773_RaptureBlue: 1133,
    SW_6774_Freshwater: 1134,
    SW_6775_Briny: 1135,
    SW_6776_BlueNile: 1136,
    SW_6778_AviaryBlue: 1137,
    SW_6779_LiquidBlue: 1138,
    SW_6780_Nautilus: 1139,
    SW_6781_JamaicaBay: 1140,
    SW_6782_Cruising: 1141,
    SW_6783_Amalfi: 1142,
    SW_6784_BravoBlue: 1143,
    SW_6785_QuenchBlue: 1144,
    SW_6786_Cloudless: 1145,
    SW_6787_Fountain: 1146,
    SW_6788_Capri: 1147,
    SW_6789_BlueMosque: 1148,
    SW_6790_AdriaticSea: 1149,
    SW_6792_MinorBlue: 1150,
    SW_6793_Bluebell: 1151,
    SW_6794_Flyway: 1152,
    SW_6795_MajorBlue: 1153,
    SW_6796_BluePlate: 1154,
    SW_6797_JayBlue: 1155,
    SW_6798_Iceberg: 1156,
    SW_6799_Soar: 1157,
    SW_6800_SomethingBlue: 1158,
    SW_6801_RegaleBlue: 1159,
    SW_6802_Jacaranda: 1160,
    SW_6803_Danube: 1161,
    SW_6804_DignityBlue: 1162,
    SW_6806_RhythmicBlue: 1163,
    SW_6807_WondrousBlue: 1164,
    SW_6808_Celestial: 1165,
    SW_6809_Lobelia: 1166,
    SW_6810_Lupine: 1167,
    SW_6811_HonorableBlue: 1168,
    SW_6813_WishfulBlue: 1169,
    SW_6814_Breathtaking: 1170,
    SW_6815_AwesomeViolet: 1171,
    SW_6816_Dahlia: 1172,
    SW_6817_Gentian: 1173,
    SW_6818_ValiantViolet: 1174,
    SW_6820_InspiredLilac: 1175,
    SW_6821_PotentiallyPurple: 1176,
    SW_6822_Wisteria: 1177,
    SW_6823_BravePurple: 1178,
    SW_6824_ForgetMeNot: 1179,
    SW_6825_IzmirPurple: 1180,
    SW_6827_Elation: 1181,
    SW_6828_RhapsodyLilac: 1182,
    SW_6829_Magical: 1183,
    SW_6830_Kismet: 1184,
    SW_6831_Clematis: 1185,
    SW_6832_ImpulsivePurple: 1186,
    SW_6834_Spangle: 1187,
    SW_6835_EuphoricLilac: 1188,
    SW_6836_NovelLilac: 1189,
    SW_6837_Baroness: 1190,
    SW_6838_VigorousViolet: 1191,
    SW_6839_KimonoViolet: 1192,
    SW_6840_ExuberantPink: 1193,
    SW_6841_Dynamo: 1194,
    SW_6842_ForwardFuchsia: 1195,
    SW_6843_Hot: 1196,
    SW_6855_DragonFruit: 1197,
    SW_6860_ErosPink: 1198,
    SW_6861_Radish: 1199,
    SW_6862_CherriesJubilee: 1200,
    SW_6866_Heartthrob: 1201,
    SW_6868_RealRed: 1202,
    SW_6869_Stop: 1203,
    SW_6871_PositiveRed: 1204,
    SW_6876_ComicalCoral: 1205,
    SW_6881_Cayenne: 1206,
    SW_6883_RaucousOrange: 1207,
    SW_6884_ObstinateOrange: 1208,
    SW_6885_KnockoutOrange: 1209,
    SW_6886_Invigorate: 1210,
    SW_6887_Navel: 1211,
    SW_6890_OsageOrange: 1212,
    SW_6892_Carnival: 1213,
    SW_6896_Sole: 1214,
    SW_6900_OptimisticYellow: 160,
    SW_6901_Daffodil: 1215,
    SW_6902_DecisiveYellow: 1216,
    SW_6903_Cheerful: 1217,
    SW_6904_GustoGold: 1218,
    SW_6905_Goldfinch: 1219,
    SW_6907_Forsythia: 1220,
    SW_6908_FunYellow: 1221,
    SW_6909_LemonTwist: 1222,
    SW_6910_Daisy: 1223,
    SW_6911_ConfidentYellow: 1224,
    SW_6913_FunkyYellow: 1225,
    SW_6914_EyeCatching: 1226,
    SW_6915_Citronella: 1227,
    SW_6918_HumorousGreen: 1228,
    SW_6920_CenterStage: 1229,
    SW_6921_ElectricLime: 1230,
    SW_6924_DirectGreen: 1231,
    SW_6925_Envy: 1232,
    SW_6926_LuckyGreen: 1233,
    SW_6927_Greenbelt: 1234,
    SW_6928_GreenVibes: 1235,
    SW_6937_TantalizingTeal: 1236,
    SW_6941_NiftyTurquoise: 1237,
    SW_6942_Splashy: 1238,
    SW_6943_IntenseTeal: 1239,
    SW_6950_Calypso: 1240,
    SW_6957_Undercool: 1241,
    SW_6958_DynamicBlue: 1242,
    SW_6959_BlueChip: 1243,
    SW_6965_HyperBlue: 1244,
    SW_6966_Blueblood: 1245,
    SW_6967_FrankBlue: 1246,
    SW_6968_HyacinthTint: 1247,
    SW_6971_MorningGlory: 1248,
    SW_6973_FreeSpirit: 1249,
    SW_6981_PassionatePurple: 1250,
    SW_6982_AfricanViolet: 1251,
    SW_6983_FullyPurple: 1252,
    SW_6987_JitterbugJade: 1253,
    SW_6988_BohemianBlack: 1254,
    SW_6989_Domino: 1255,
    SW_6990_Caviar: 180,
    SW_6991_BlackMagic: 1256,
    SW_6992_Inkwell: 1257,
    SW_6993_BlackofNight: 1258,
    SW_6994_Greenblack: 237,
    SW_7000_IbisWhite: 1259,
    SW_7001_Marshmallow: 1260,
    SW_7002_Downy: 1261,
    SW_7003_ToqueWhite: 238,
    SW_7004_Snowbound: 245,
    SW_7005_PureWhite: 239,
    SW_7006_ExtraWhite: 149,
    SW_7007_CeilingBrightWhite: 1262,
    SW_7008_Alabaster: 1263,
    SW_7009_PearlyWhite: 1264,
    SW_7010_WhiteDuck: 1265,
    SW_7011_NaturalChoice: 86,
    SW_7012_Creamy: 1266,
    SW_7013_IvoryLace: 1267,
    SW_7014_EiderWhite: 264,
    SW_7015_ReposeGray: 87,
    SW_7016_MindfulGray: 265,
    SW_7017_DorianGray: 1268,
    SW_7018_Dovetail: 1269,
    SW_7019_GauntletGray: 181,
    SW_7020_BlackFox: 88,
    SW_7021_SimpleWhite: 1270,
    SW_7022_Alpaca: 89,
    SW_7023_RequisiteGray: 1271,
    SW_7024_FunctionalGray: 1272,
    SW_7025_Backdrop: 228,
    SW_7026_Griffin: 1273,
    SW_7027_WellBredBrown: 1274,
    SW_7028_IncredibleWhite: 1275,
    SW_7029_AgreeableGray: 1276,
    SW_7030_AnewGray: 1277,
    SW_7031_MegaGreige: 1278,
    SW_7032_WarmStone: 182,
    SW_7033_BrainstormBronze: 1279,
    SW_7034_StatusBronze: 1280,
    SW_7035_AestheticWhite: 1281,
    SW_7036_AccessibleBeige: 240,
    SW_7037_BalancedBeige: 213,
    SW_7038_TonyTaupe: 1282,
    SW_7039_VirtualTaupe: 1283,
    SW_7040_Smokehouse: 1284,
    SW_7041_VanDykeBrown: 1285,
    SW_7042_ShojiWhite: 1286,
    SW_7043_WorldlyGray: 266,
    SW_7044_AmazingGray: 94,
    SW_7045_IntellectualGray: 267,
    SW_7046_Anonymous: 1287,
    SW_7047_Porpoise: 229,
    SW_7048_UrbaneBronze: 1288,
    SW_7049_Nuance: 1289,
    SW_7050_UsefulGray: 1290,
    SW_7051_AnalyticalGray: 1291,
    SW_7052_GrayArea: 1292,
    SW_7053_AdaptiveShade: 1293,
    SW_7054_SuitableBrown: 1294,
    SW_7055_EnduringBronze: 1295,
    SW_7056_ReservedWhite: 221,
    SW_7057_SilverStrand: 1296,
    SW_7058_MagneticGray: 1297,
    SW_7059_UnusualGray: 1298,
    SW_7060_AttitudeGray: 268,
    SW_7061_NightOwl: 1299,
    SW_7062_RockBottom: 1300,
    SW_7063_NebulousWhite: 1301,
    SW_7064_Passive: 1302,
    SW_7065_Argos: 269,
    SW_7066_GrayMatters: 97,
    SW_7067_Cityscape: 230,
    SW_7068_GrizzleGray: 214,
    SW_7069_IronOre: 1303,
    SW_7070_SiteWhite: 1304,
    SW_7071_GrayScreen: 1305,
    SW_7072_Online: 1306,
    SW_7073_NetworkGray: 1307,
    SW_7074_Software: 1308,
    SW_7075_WebGray: 1309,
    SW_7076_Cyberspace: 1310,
    SW_7077_OriginalWhite: 1311,
    SW_7078_MinuteMauve: 1312,
    SW_7079_Ponder: 1313,
    SW_7080_QuestGray: 1314,
    SW_7081_SensuousGray: 1315,
    SW_7082_StunningShade: 1316,
    SW_7083_Darkroom: 1317,
    SW_7100_ArcadeWhite: 1318,
    SW_7101_Futon: 1319,
    SW_7102_WhiteFlour: 1320,
    SW_7103_Whitetail: 1321,
    SW_7104_CottonWhite: 1322,
    SW_7105_Paperwhite: 1323,
    SW_7106_HoniedWhite: 1324,
    SW_7138_LavendarWisp: 1802,
    SW_7459_Clay: 1755,
    SW_7501_ThresholdTaupe: 1325,
    SW_7502_DryDock: 1326,
    SW_7503_SticksAndStones: 1327,
    SW_7504_KeystoneGray: 1328,
    SW_7505_ManorHouse: 1329,
    SW_7506_Loggia: 1330,
    SW_7507_StoneLion: 1331,
    SW_7508_TavernTaupe: 1332,
    SW_7509_TikiHut: 1333,
    SW_7510_ChateauBrown: 1334,
    SW_7511_BungalowBeige: 1335,
    SW_7512_PavilionBeige: 1336,
    SW_7513_Sanderling: 1337,
    SW_7514_Foothills: 1338,
    SW_7515_HomesteadBrown: 1339,
    SW_7516_KestrelWhite: 1340,
    SW_7517_ChinaDoll: 1341,
    SW_7518_BeachHouse: 1342,
    SW_7519_MexicanSand: 1343,
    SW_7520_PlantationShutters: 1344,
    SW_7521_DormerBrown: 1345,
    SW_7522_Meadowlark: 1346,
    SW_7523_BurnishedBrandy: 1347,
    SW_7524_DhurrieBeige: 1348,
    SW_7525_TreeBranch: 1349,
    SW_7526_MaisonBlanche: 1350,
    SW_7527_NantucketDune: 1351,
    SW_7528_WindsorGreige: 1352,
    SW_7529_SandBeach: 1353,
    SW_7530_BarcelonaBeige: 1354,
    SW_7531_CanvasTan: 1355,
    SW_7532_UrbanPutty: 1356,
    SW_7533_KhakiShade: 1357,
    SW_7534_Outerbanks: 1358,
    SW_7535_SandyRidge: 1359,
    SW_7536_BittersweetStem: 1360,
    SW_7537_IrishCream: 1361,
    SW_7538_Tamarind: 1362,
    SW_7539_CorkWedge: 1363,
    SW_7540_ArtisanTan: 1364,
    SW_7541_GrecianIvory: 1365,
    SW_7542_Naturel: 1366,
    SW_7543_AvenueTan: 1367,
    SW_7544_Fenland: 1368,
    SW_7545_Pier: 1369,
    SW_7546_PrairieGrass: 1370,
    SW_7547_Sandbar: 1371,
    SW_7548_Portico: 270,
    SW_7549_StudioTaupe: 1372,
    SW_7550_ResortTan: 1373,
    SW_7551_GreekVilla: 1374,
    SW_7552_BauhausBuff: 1375,
    SW_7553_FragileBeauty: 1376,
    SW_7554_SteamedMilk: 1377,
    SW_7555_Patience: 1378,
    SW_7556_Creme: 1379,
    SW_7557_SummerWhite: 1380,
    SW_7558_MediciIvory: 1381,
    SW_7559_DecorWhite: 1382,
    SW_7560_ImpressiveIvory: 1383,
    SW_7561_LemonMeringue: 1384,
    SW_7562_RomanColumn: 1385,
    SW_7563_RestfulWhite: 1386,
    SW_7564_PolarBear: 1387,
    SW_7565_OysterBar: 1388,
    SW_7566_WesthighlandWhite: 1389,
    SW_7567_NaturalTan: 100,
    SW_7568_NeutralGround: 1390,
    SW_7569_Stucco: 1391,
    SW_7570_EgretWhite: 1392,
    SW_7571_CasaBlanca: 1393,
    SW_7572_LotusPod: 1394,
    SW_7573_EagletBeige: 1395,
    SW_7574_EchelonEcru: 1396,
    SW_7575_Chopsticks: 1397,
    SW_7577_Blackberry: 1398,
    SW_7578_Borscht: 1399,
    SW_7579_Alaea: 1400,
    SW_7580_Carnelian: 1401,
    SW_7582_Salute: 1402,
    SW_7583_WildCurrant: 1403,
    SW_7584_RedTheatre: 1404,
    SW_7585_SunDriedTomato: 1405,
    SW_7586_StolenKiss: 1406,
    SW_7587_AntiqueRed: 1407,
    SW_7588_ShowStopper: 1408,
    SW_7589_HabaneroChile: 1409,
    SW_7591_RedBarn: 1410,
    SW_7592_CrabbyApple: 1411,
    SW_7593_RusticRed: 1412,
    SW_7594_CarriageDoor: 1413,
    SW_7595_Sommelier: 1414,
    SW_7596_OnlyNatural: 1415,
    SW_7598_SierraRedwood: 1416,
    SW_7599_BrickPaver: 1417,
    SW_7600_Bolero: 1418,
    SW_7601_DocksideBlue: 1419,
    SW_7602_IndigoBatik: 1420,
    SW_7603_Poolhouse: 1421,
    SW_7604_SmokyBlue: 1422,
    SW_7605_GaleForce: 1423,
    SW_7606_BlueCruise: 1424,
    SW_7607_SantoriniBlue: 1425,
    SW_7608_Adrift: 1426,
    SW_7609_GeorgianRevivalBlue: 1427,
    SW_7610_TurkishTile: 1428,
    SW_7611_TranquilAqua: 1429,
    SW_7612_MountainStream: 1430,
    SW_7613_AquaSphere: 1431,
    SW_7614_StBarts: 1432,
    SW_7615_SeaSerpent: 1433,
    SW_7616_Breezy: 1434,
    SW_7617_Mediterranean: 101,
    SW_7618_DeepSeaDive: 1435,
    SW_7619_Labradorite: 102,
    SW_7620_Seaworthy: 1436,
    SW_7621_Silvermist: 246,
    SW_7622_HomburgGray: 1437,
    SW_7623_Cascades: 1438,
    SW_7624_SlateTile: 1439,
    SW_7625_MountEtna: 1440,
    SW_7626_ZurichWhite: 1441,
    SW_7627_WhiteHeron: 1442,
    SW_7628_WindfreshWhite: 1443,
    SW_7629_Grapy: 1444,
    SW_7630_Raisin: 1445,
    SW_7631_CityLoft: 1446,
    SW_7632_ModernGray: 1447,
    SW_7633_TaupeTone: 1448,
    SW_7634_Pediment: 161,
    SW_7635_Palisade: 1449,
    SW_7636_OrigamiWhite: 1450,
    SW_7637_OysterWhite: 271,
    SW_7638_JoggingPath: 1451,
    SW_7639_EtherealMood: 1452,
    SW_7640_FawnBrindle: 1453,
    SW_7641_ColonnadeGray: 1454,
    SW_7642_Pavestone: 1455,
    SW_7643_Pussywillow: 241,
    SW_7644_GatewayGray: 272,
    SW_7645_ThunderGray: 1456,
    SW_7646_FirstStar: 1457,
    SW_7647_CrushedIce: 1458,
    SW_7648_BigChill: 1459,
    SW_7649_Silverplate: 1460,
    SW_7650_EllieGray: 1461,
    SW_7651_FrontPorch: 1462,
    SW_7652_MineralDeposit: 1463,
    SW_7653_Silverpointe: 1464,
    SW_7654_Lattice: 1465,
    SW_7655_StampedConcrete: 1466,
    SW_7656_Rhinestone: 1467,
    SW_7657_Tinsmith: 1468,
    SW_7658_GrayClouds: 273,
    SW_7659_Gris: 1469,
    SW_7660_EarlGrey: 1470,
    SW_7661_Reflection: 1471,
    SW_7662_EveningShadow: 1472,
    SW_7663_MonorailSilver: 1473,
    SW_7664_SteelyGray: 1474,
    SW_7665_WallStreet: 1475,
    SW_7666_FleurdeSel: 1476,
    SW_7667_Zircon: 1477,
    SW_7668_MarchWind: 157,
    SW_7669_SummitGray: 1478,
    SW_7670_GrayShingle: 1479,
    SW_7671_OntheRocks: 1480,
    SW_7672_KnittingNeedles: 1481,
    SW_7673_PewterCast: 274,
    SW_7674_Peppercorn: 275,
    SW_7675_Sealskin: 165,
    SW_7676_PaperLantern: 1482,
    SW_7677_GoldVessel: 1483,
    SW_7678_CottageCream: 1484,
    SW_7679_GoldenGate: 1485,
    SW_7680_Lanyard: 1486,
    SW_7681_TeaLight: 1487,
    SW_7682_BeesWax: 1488,
    SW_7683_Buff: 1489,
    SW_7684_ConcordBuff: 1490,
    SW_7685_WhiteRaisin: 1491,
    SW_7686_Hinoki: 1492,
    SW_7687_AugustMoon: 1493,
    SW_7688_Sundew: 1494,
    SW_7689_RowHouseTan: 1495,
    SW_7690_TownhallTan: 1496,
    SW_7691_PaleYellow: 1497,
    SW_7692_CupolaYellow: 1498,
    SW_7693_Stonebriar: 1499,
    SW_7694_DromedaryCamel: 1500,
    SW_7695_MesaTan: 1501,
    SW_7696_ToastedPineNut: 1502,
    SW_7697_Safari: 1503,
    SW_7698_StrawHarvest: 1504,
    SW_7699_RusticCity: 1505,
    SW_7700_OldeWorldGold: 1506,
    SW_7701_CavernClay: 1507,
    SW_7702_SpicedCider: 1508,
    SW_7703_EarthenJug: 1509,
    SW_7704_TowerTan: 1510,
    SW_7705_WheatPenny: 1511,
    SW_7707_CopperWire: 1512,
    SW_7709_CopperPot: 1513,
    SW_7710_Brandywine: 1514,
    SW_7711_Pueblo: 1515,
    SW_7712_TownhouseTan: 1516,
    SW_7713_TawnyTan: 1517,
    SW_7714_OakBarrel: 1518,
    SW_7715_PotteryUrn: 1519,
    SW_7716_Croissant: 1520,
    SW_7717_LigonierTan: 1521,
    SW_7718_OakCreek: 1522,
    SW_7719_FrescoCream: 1523,
    SW_7720_DeerValley: 1524,
    SW_7721_CrescentCream: 1525,
    SW_7722_Travertine: 1526,
    SW_7723_ColonyBuff: 1527,
    SW_7724_Canoe: 1528,
    SW_7725_Yearling: 1529,
    SW_7726_LemonVerbena: 1530,
    SW_7727_KoiPond: 1531,
    SW_7728_GreenSprout: 1532,
    SW_7729_Edamame: 1533,
    SW_7730_Forestwood: 1534,
    SW_7731_SanAntonioSage: 1535,
    SW_7732_Lemongrass: 1536,
    SW_7733_BambooShoot: 1537,
    SW_7734_OliveGrove: 1538,
    SW_7735_PalmLeaf: 1539,
    SW_7736_GardenSage: 1540,
    SW_7737_MeadowTrail: 1541,
    SW_7738_CargoPants: 1542,
    SW_7739_HerbalWash: 1543,
    SW_7740_MessengerBag: 1544,
    SW_7741_WillowTree: 1545,
    SW_7742_AgateGreen: 1546,
    SW_7743_MountainRoad: 1547,
    SW_7744_Zeus: 1548,
    SW_7745_MuddledBasil: 1549,
    SW_7746_RushingRiver: 1550,
    SW_7747_RecycledGlass: 1551,
    SW_7748_GreenEarth: 1552,
    SW_7749_LaurelWoods: 1553,
    SW_7750_OlympicRange: 1554,
    SW_7757_HighReflectiveWhite: 1555,
    SW_8917_ShellWhite: 1556,
    SW_9001_AudreysBlush: 1557,
    SW_9002_CarleysRose: 1558,
    SW_9003_RitasRouge: 1559,
    SW_9004_CoralRose: 1560,
    SW_9005_CoralClay: 1561,
    SW_9006_RojoDust: 1562,
    SW_9007_MelonMeloso: 1563,
    SW_9008_BelliniFizz: 1564,
    SW_9009_SubduedSienna: 1565,
    SW_9010_WindsweptCanyon: 1566,
    SW_9011_SunBleachedOchre: 1567,
    SW_9012_PolvodeOro: 1568,
    SW_9013_OldenAmber: 1569,
    SW_9014_PollenPowder: 1570,
    SW_9015_TheyCallItMellow: 1571,
    SW_9016_LaLunaAmarilla: 1572,
    SW_9017_SunnyVeranda: 1573,
    SW_9018_HoneyBees: 1574,
    SW_9019_GoldenPlumeria: 1575,
    SW_9020_RayodeSol: 1576,
    SW_9021_NaplesYellow: 1577,
    SW_9022_YellowBird: 1578,
    SW_9023_DakotaWheat: 1579,
    SW_9024_VintageGold: 1580,
    SW_9025_CorianderPowder: 1581,
    SW_9026_TarnishedTrumpet: 1582,
    SW_9027_PaleMoss: 1583,
    SW_9028_DustedOlive: 1584,
    SW_9029_CoolAvocado: 1585,
    SW_9030_LimonFresco: 1586,
    SW_9031_Primavera: 1587,
    SW_9032_StayinLime: 1588,
    SW_9033_OhPistachio: 1589,
    SW_9034_SeawashedGlass: 1590,
    SW_9035_FrostedEmerald: 1591,
    SW_9036_RetroMint: 1592,
    SW_9037_BabyBokChoy: 1593,
    SW_9038_CucuzzaVerde: 1594,
    SW_9039_Broccoflower: 1595,
    SW_9040_ResedaGreen: 1596,
    SW_9041_ParisianPatina: 1597,
    SW_9042_Verdigreen: 1598,
    SW_9043_Aquastone: 1599,
    SW_9044_LittleBlueBox: 1600,
    SW_9045_BoraBoraShore: 1601,
    SW_9046_GentleAquamarine: 1602,
    SW_9047_AfterTheRain: 1603,
    SW_9048_Surfin: 1604,
    SW_9049_SkyFall: 1605,
    SW_9050_VintageVessel: 1606,
    SW_9051_Aquaverde: 1607,
    SW_9052_BlitheBlue: 1608,
    SW_9053_AguaFria: 1609,
    SW_9054_LittleBoyBlu: 1610,
    SW_9055_BillowyBreeze: 1611,
    SW_9056_FrenchMoire: 1612,
    SW_9057_Aquitaine: 1613,
    SW_9058_SecretCove: 1614,
    SW_9059_SilkenPeacock: 1615,
    SW_9060_ConnorsLakefront: 1616,
    SW_9061_RestAssured: 1617,
    SW_9062_BluebirdFeather: 1618,
    SW_9063_PorchCeiling: 1619,
    SW_9064_BluesyNote: 1620,
    SW_9065_PerfectPeriwinkle: 1621,
    SW_9066_Agapanthus: 1622,
    SW_9067_ForeverLilac: 1623,
    SW_9068_BerryFrappe: 1624,
    SW_9069_VeriBerri: 1625,
    SW_9070_BabyBlueEyes: 1626,
    SW_9071_DyersWoad: 1627,
    SW_9072_DriedLavender: 1628,
    SW_9073_DustyHeather: 1629,
    SW_9074_GentleGrape: 1630,
    SW_9075_BerryCream: 1631,
    SW_9076_RubyViolet: 1632,
    SW_9077_RosalinePearl: 1633,
    SW_9078_CocoaBerry: 1634,
    SW_9079_VelvetyChestnut: 1635,
    SW_9080_HushedAuburn: 1636,
    SW_9081_RedendPoint: 1637,
    SW_9082_ChocolatePowder: 1638,
    SW_9083_DustedTruffle: 1639,
    SW_9084_CocoaWhip: 1640,
    SW_9085_TouchofSand: 1641,
    SW_9086_CoolBeige: 1642,
    SW_9087_SmokyBeige: 1643,
    SW_9088_Utaupeia: 1644,
    SW_9089_LlamaWool: 1645,
    SW_9090_Caraibe: 1646,
    SW_9091_HalfCaff: 1647,
    SW_9092_IcedMocha: 1648,
    SW_9093_NearlyBrown: 1649,
    SW_9094_PlayaArenosa: 1650,
    SW_9095_GingerRoot: 1651,
    SW_9096_BeigeIntenso: 1652,
    SW_9097_SoftFawn: 1653,
    SW_9098_BakedCookie: 1654,
    SW_9099_SaddleUp: 1655,
    SW_9100_UmberRust: 1656,
    SW_9101_TresNaturale: 1657,
    SW_9102_Quinoa: 1658,
    SW_9103_Farro: 1659,
    SW_9104_WovenWicker: 1660,
    SW_9105_AlmondRoca: 1661,
    SW_9106_ElCaramelo: 1662,
    SW_9107_UberUmber: 1663,
    SW_9108_DoubleLatte: 1664,
    SW_9109_NaturalLinen: 1665,
    SW_9110_Malabar: 156,
    SW_9111_AntlerVelvet: 1666,
    SW_9112_SongThrush: 1667,
    SW_9113_Mudslide: 1668,
    SW_9114_FallenLeaves: 1669,
    SW_9115_CowboyBoots: 1670,
    SW_9116_SerengetiGrass: 1671,
    SW_9117_UrbanJungle: 1672,
    SW_9118_TarnishedTreasure: 1673,
    SW_9119_DirtyMartini: 1674,
    SW_9120_TumblinTumbleweed: 1675,
    SW_9121_SawgrassBasket: 1676,
    SW_9122_DriedEdamame: 1677,
    SW_9123_BarroVerde: 1678,
    SW_9124_VerdeMarron: 1679,
    SW_9125_OlivaOscuro: 1680,
    SW_9126_HonedSoapstone: 104,
    SW_9127_AtEaseSoldier: 1681,
    SW_9128_GreenOnyx: 1682,
    SW_9129_JadeDragon: 1683,
    SW_9130_EvergreenFog: 276,
    SW_9131_CornwallSlate: 146,
    SW_9132_AcaciaHaze: 1684,
    SW_9133_JasperStone: 1685,
    SW_9134_Delft: 1686,
    SW_9135_Whirlpool: 1687,
    SW_9136_Lullaby: 1688,
    SW_9137_NieblaAzul: 1689,
    SW_9138_Stardew: 1690,
    SW_9139_Debonair: 1691,
    SW_9140_BlusterySky: 1692,
    SW_9141_Waterloo: 170,
    SW_9142_MoscowMidnight: 1693,
    SW_9143_Cadet: 277,
    SW_9144_Moonmist: 1694,
    SW_9145_SleepyHollow: 1695,
    SW_9146_FadedFlaxflower: 1696,
    SW_9147_FavoriteJeans: 150,
    SW_9148_SmokyAzurite: 1697,
    SW_9149_InkyBlue: 1698,
    SW_9150_EndlessSea: 1699,
    SW_9151_Daphne: 1700,
    SW_9152_LetItRain: 1701,
    SW_9153_MoonlitOrchid: 1702,
    SW_9154_PerleNoir: 162,
    SW_9155_SlateViolet: 1703,
    SW_9156_GrisMorado: 1704,
    SW_9157_AutumnOrchid: 1705,
    SW_9158_Coquina: 1706,
    SW_9159_AugerShell: 1707,
    SW_9160_Armadillo: 1708,
    SW_9161_Dustblu: 1709,
    SW_9162_AfricanGray: 1710,
    SW_9163_TinLizzie: 222,
    SW_9164_IllusiveGreen: 1711,
    SW_9165_GossamerVeil: 1712,
    SW_9166_DriftOfMist: 1713,
    SW_9167_PolishedConcrete: 1714,
    SW_9168_ElephantEar: 107,
    SW_9169_ChaturaGray: 1715,
    SW_9170_Acier: 1716,
    SW_9171_FeltedWool: 278,
    SW_9172_StudioClay: 1717,
    SW_9173_Shiitake: 1718,
    SW_9174_MothWing: 1719,
    SW_9175_DeepForestBrown: 1720,
    SW_9176_DressBlues: 1721,
    SW_9177_SaltyDog: 1722,
    SW_9178_IntheNavy: 1723,
    SW_9179_AnchorsAweigh: 1724,
    SW_9180_AgedWhite: 1725,
    SW_9182_RojoMarron: 1726,
    SW_9183_DarkClove: 1727,
    SW_9184_FoxhallGreen: 1728,
    SW_9185_MareaBaja: 1729,
    SW_9186_Caramelized: 1730,
    SW_9504_ColdFoam: 4463,
    SW_9519_CountryTweed: 10805,
    SW_9541_WhiteSnow: 2130,
    SW_9543_Gypsum: 2131,
    SW_9553_Allegory: 1803,
    SW_9565_ForgedSteel: 11424,
    SW_9580_CrackedPepper: 1804,
    SW_9586_WhiteSesame: 4464,
    SW_9591_Whisper: 4462,
    SW_9635_Stargazer: 10584,
    SW_9650_Succulent: 6574,
    SW_9660_Tarragon: 10635,
    SW_9683_Lakeside: 10585,
    SW_9684_AzureTide: 10678,
    SW_9685_AfterTheStorm: 4465,
  },
  Superior: {
    Superior_Almond: 10551,
    Superior_Black: 10552,
    Superior_Clay: 10553,
    Superior_White: 10554,
  },
  SystemColors: {
    Black: 0,
    Blue: 1,
    Brown: 2,
    Cream: 3,
    Dark_Blue: 4,
    Dark_Brown: 5,
    Dark_Cream: 6,
    Dark_Green: 7,
    Dark_Orange: 8,
    Dark_Purple: 9,
    Dark_Red: 10,
    Dark_Turquoise: 11,
    Dark_Yellow: 12,
    Darkest_Blue: 2262,
    Darkest_Brown: 2263,
    Darkest_Cream: 2264,
    Darkest_Green: 2265,
    Darkest_Orange: 2266,
    Darkest_Purple: 2267,
    Darkest_Red: 2268,
    Darkest_Turquoise: 2269,
    Darkest_Yellow: 2270,
    Gray40: 13,
    Gray55: 14,
    Gray70: 15,
    Gray80: 16,
    Gray90: 17,
    Green: 18,
    Light_Blue: 19,
    Light_Brown: 20,
    Light_Cream: 21,
    Light_Green: 22,
    Light_Orange: 23,
    Light_Purple: 24,
    Light_Red: 25,
    Light_Turquoise: 26,
    Light_Yellow: 27,
    Orange: 28,
    Pink: 29,
    Purple: 30,
    Red: 31,
    Turquoise: 32,
    Very_Dark_Turquoise: 2015,
    White: 33,
    Yellow: 34,
  },
  ThermaTru: {
    TT_Alpine: 1792,
    TT_ArcticIce: 10765,
    TT_Cabernet: 1793,
    TT_Canyon: 10766,
    TT_Chestnut: 1794,
    TT_Cypress: 1795,
    TT_Elk: 10767,
    TT_Estuary: 10768,
    TT_GoldenWheat: 10769,
    TT_Granite: 1796,
    TT_Indigo: 1797,
    TT_NaturalOak: 10658,
    TT_Obsidian: 10770,
    TT_Onyx: 1798,
    TT_Peregrine: 10771,
    TT_RubyRed: 1799,
  },
  TimberTech: {
    TimberTech_AntiqueLeather: 10975,
    TimberTech_Brownstone: 10545,
    TimberTech_DarkCocoa: 11363,
    TimberTech_DarkTeak: 10976,
    TimberTech_Kona: 10546,
    TimberTech_SlateGray: 10547,
  },
  UnionCorrugating: {
    UC_ArticWhite: 2238,
    UC_BarnRed: 2239,
    UC_Black: 2240,
    UC_Burgundy: 2241,
    UC_BurnishedSlate: 2242,
    UC_CharcoalGray: 2243,
    UC_Clay: 2244,
    UC_CocoaBrown: 2245,
    UC_CopperMetallic: 2246,
    UC_Evergreen: 2247,
    UC_GalleryBlue: 2248,
    UC_Ivory: 2249,
    UC_LightBrown: 2250,
    UC_LightStone: 2251,
    UC_MarineGreen: 2252,
    UC_PatriotRed: 2253,
    UC_PearlGray: 2254,
    UC_RoyalBlue: 2255,
    UC_SaharaTan: 2256,
    UC_White: 2257,
  },
  Valspar: {
    Valspar_10059A_RichChocolate: 1887,
    Valspar_10118_AntiqueBurgundy: 1888,
    Valspar_20057C_DesertCarnation: 1889,
    Valspar_20059A_BostonLegacy: 1890,
    Valspar_20087C_CafeMiel: 1891,
    Valspar_2613_FreshHoneysuckle: 1892,
    Valspar_2921_TeaBiscuit: 1893,
    Valspar_2926_GoldPlate: 1894,
    Valspar_30037B_LeatherSatchel: 1895,
    Valspar_3374_Tattletale: 1896,
    Valspar_3405_SilverSaber: 1897,
    Valspar_40031C_RockyBluffs: 1898,
    Valspar_40042A_OmbraGray: 1899,
    Valspar_40052B_HighSpeedSteel: 1900,
    Valspar_50032C_BlackenedPine: 1901,
    Valspar_50044B_JekyllSansSouci: 1902,
    Valspar_50053A_Luna: 1903,
    Valspar_50053C_JekyllGrandDining: 1904,
    Valspar_50061A_CometDust: 1905,
    Valspar_50061C_GraniteDust: 1906,
    Valspar_50062B_PorcelainShale: 1907,
    Valspar_50081C_LyndhurstCastle: 1908,
    Valspar_50102_PitchedCobalt: 1909,
    Valspar_60032B_Empire: 1910,
    Valspar_60042C_EnglishTeaParty: 1911,
    Valspar_60093_MontanaMoss: 1912,
    Valspar_AR1326_PresidentialSuite: 1913,
    Valspar_AR721_LibertyBell: 1914,
    Valspar_CI59_MinkStole: 1915,
    Valspar_EB113_Coir: 1916,
    Valspar_EB281_Calico: 1917,
    Valspar_EE2017A_BareValley: 1918,
    Valspar_EE2020B_DryRiverbed: 1919,
    Valspar_EE2022C_AncientBog: 1920,
    Valspar_EE2043B_StarDust: 1921,
    Valspar_EE2104A_Downpour: 1922,
    Valspar_LA309A_PaintedLavender: 1923,
    Valspar_WV37008_BeachHouse: 1924,
  },
  Variform: {
    Variform_GeorgianGray: 215,
    Variform_SilverMist: 216,
  },
  Waudena: {
    Waudena_AbbeyStone: 6517,
    Waudena_ArtisanBrown: 6518,
    Waudena_BeachHouse: 6519,
    Waudena_Bonfire: 6520,
    Waudena_ClassicWhite: 6521,
    Waudena_Courtyard: 6522,
    Waudena_CrumbCake: 6523,
    Waudena_Daydream: 6524,
    Waudena_Fern: 6525,
    Waudena_FlannelGray: 6526,
    Waudena_FlowerPower: 6527,
    Waudena_FreeSpirit: 6528,
    Waudena_FrenchManor: 6529,
    Waudena_GardenGate: 6530,
    Waudena_GatheringPlace: 6531,
    Waudena_GroovyGreen: 6532,
    Waudena_HappyDays: 6533,
    Waudena_HearthStone: 6534,
    Waudena_HeartOfGold: 6535,
    Waudena_Heirloom: 6536,
    Waudena_Homespun: 6537,
    Waudena_HorizonGray: 6538,
    Waudena_IvyLeague: 6539,
    Waudena_Keepsake: 6540,
    Waudena_Lakeshore: 6541,
    Waudena_Linen: 6542,
    Waudena_Noble: 6543,
    Waudena_OffTheRecord: 6544,
    Waudena_OldWorld: 6545,
    Waudena_OxfordWhite: 6546,
    Waudena_ParkAvenue: 6547,
    Waudena_PeacefulPorch: 6548,
    Waudena_PeaceNLove: 6549,
    Waudena_PicketFence: 6550,
    Waudena_QuietNook: 6551,
    Waudena_RedVelvet: 6552,
    Waudena_RubyRed: 6553,
    Waudena_ShiplapWhite: 6554,
    Waudena_SoulfulBlue: 6555,
    Waudena_SummerDay: 6556,
    Waudena_Symphony: 6557,
    Waudena_Traditions: 6558,
    Waudena_Veranda: 6559,
    Waudena_Wanderlust: 6560,
    Waudena_WindsorCastle: 6561,
  },
  WayneDalton: {
    WD_Almond: 1732,
    WD_Black: 10772,
    WD_Brown: 1733,
    WD_Clay: 2258,
    WD_DesertTan: 1734,
    WD_Gray: 1735,
    WD_Green: 1736,
    WD_Sandstone: 10773,
    WD_Taupe: 1737,
    WD_White: 1738,
  },
  Weatherables: {
    Weatherables_Khaki: 2259,
    Weatherables_Tan: 2260,
    Weatherables_White: 2261,
  },
  Westlake: {
    Westlake_AspenWhite: 10415,
    Westlake_Black: 10983,
    Westlake_BlueGray: 2630,
    Westlake_Bone: 10416,
    Westlake_Brownstone: 2631,
    Westlake_Canyon: 10493,
    Westlake_Carbon: 10497,
    Westlake_Clay: 10417,
    Westlake_Cocoa: 2632,
    Westlake_CountryBeige: 10418,
    Westlake_Cypress: 2633,
    Westlake_Driftwood: 10419,
    Westlake_Espresso: 10498,
    Westlake_Flagstone: 2634,
    Westlake_FrenchRoast: 10980,
    Westlake_Granite: 2635,
    Westlake_Graphite: 10499,
    Westlake_Greystone: 10420,
    Westlake_HarvardSlate: 2636,
    Westlake_Heather: 2637,
    Westlake_HeritageBlue: 2638,
    Westlake_Indigo: 10500,
    Westlake_Ironstone: 2639,
    Westlake_LighthouseRed: 10501,
    Westlake_Linen: 2640,
    Westlake_MarineBlue: 2641,
    Westlake_MetropolitanGray: 10494,
    Westlake_MidnightBlue: 10586,
    Westlake_MidnightSurf: 2642,
    Westlake_Mocha: 10421,
    Westlake_MusketBrown: 10981,
    Westlake_Nantucket: 10422,
    Westlake_Oceanside: 10495,
    Westlake_Pearl: 10423,
    Westlake_PebbleClay: 2643,
    Westlake_Peppercorn: 10502,
    Westlake_Platinum: 10984,
    Westlake_Polaris: 10424,
    Westlake_Redwood: 2644,
    Westlake_Regatta: 10503,
    Westlake_Riverway: 2645,
    Westlake_Rockslide: 2646,
    Westlake_Rye: 10425,
    Westlake_Saddle: 10426,
    Westlake_Sand: 2647,
    Westlake_Shamrock: 2648,
    Westlake_SilverMist: 2649,
    Westlake_Slate: 10504,
    Westlake_SmokyAsh: 10496,
    Westlake_SoftMaple: 2650,
    Westlake_Spruce: 10505,
    Westlake_Sterling: 2651,
    Westlake_StoneHarbor: 10506,
    Westlake_Storm: 2652,
    Westlake_ToastedAlmond: 2653,
    Westlake_TreeMoss: 2654,
    Westlake_TuxedoGrey: 10985,
    Westlake_UrbanBronze: 2655,
    Westlake_VintageCream: 2656,
    Westlake_Walnut: 2657,
    Westlake_WeatheredGray: 2658,
    Westlake_Wedgewood: 2659,
    Westlake_Wheat: 10427,
    Westlake_White: 2660,
    Westlake_Wicker: 2661,
  },
  Window_AAF: {
    AAF_AlmondIvory_GD016A: 9529,
    AAF_AmberGold_E42TM: 9530,
    AAF_AnodicBronze_GY114A: 9531,
    AAF_AnodicBronze_GY125A: 9532,
    AAF_AnodicChampagne_GY276A: 9533,
    AAF_AnodicClear_GY221A: 9534,
    AAF_AnodicDarkGrey_GL213A: 9535,
    AAF_AnodicFrenchChampagne_GX207A: 9536,
    AAF_AnodicNatural_GY235A: 9537,
    AAF_AnodicNatural_YY223A: 9538,
    AAF_AnodicNaturalMerlin_GY243A: 9539,
    AAF_AnodicNaturalSilk_GY242A: 9540,
    AAF_AnodicNighthawk_GY244A: 9541,
    AAF_AnodicOffWhite_GD227A: 9542,
    AAF_AnodicPrecisBlackInk_GN21BA: 9543,
    AAF_AnodicSaintsBronze_GY101A: 9544,
    AAF_AnodicSilverGrey_GL237A: 9545,
    AAF_AnodicSlateGrey_GY218A: 9546,
    AAF_AnodicSlateGrey_YY218A: 9547,
    AAF_AnodicStellarBronze_YY253A: 9548,
    AAF_AnotecDarkGrey_260_7538M: 9549,
    AAF_AnotecDarkGrey_272_51275: 9550,
    AAF_AnotecMidBronze_272_51014: 9551,
    AAF_AnotecOffWhite_260_2181M: 9552,
    AAF_AnotecSilverGrey_272_51272: 9553,
    AAF_AnthraciteIn_GY144A: 9554,
    AAF_AntigraffitiBlack_910_9024S: 9555,
    AAF_APOGrey_260_32786: 9556,
    AAF_ApoGrey_272_32786: 9557,
    AAF_ApoGrey_GL107A: 9558,
    AAF_APOGreyScylla_901_36612: 9559,
    AAF_ApolloGrey_E66NM: 9560,
    AAF_ApplianceWhite_90Z_1341S: 9561,
    AAF_ArcticWhite_900_58851: 9562,
    AAF_ArcticWhite_90Z_1342S: 9563,
    AAF_AsteroidPearl_8Y270A: 9564,
    AAF_AsteroidPearl_GY270A: 9565,
    AAF_AsteroidPearl_YY270A: 9566,
    AAF_Atlante_YY293A: 9567,
    AAF_AzCustomBlack_GN215A: 9568,
    AAF_AztecBlack_901_82757: 9569,
    AAF_AztecSilver_901_85040: 9570,
    AAF_AztecSilver_E68NL: 9571,
    AAF_AzurePearl_8Y205A: 9572,
    AAF_Barley_272_3089G: 9573,
    AAF_Barley_GD007A: 9574,
    AAF_Basalt_260_7473S: 9575,
    AAF_Basalt_272_7865M: 9576,
    AAF_Basalt_40X_7475M: 9577,
    AAF_Basalt_906_7645F: 9578,
    AAF_Basalt_90E_7723Z: 9579,
    AAF_Basalt_GP208A: 9580,
    AAF_BeachouseYellow_8E219A: 9581,
    AAF_BeachSand_GY234A: 9582,
    AAF_Beige_MM110A: 9583,
    AAF_BerryGrey_272_7262G: 9584,
    AAF_BerryGrey_272_88362: 9585,
    AAF_BistroOrange_MF014A: 9586,
    AAF_Black_260_9132G: 9587,
    AAF_Black_272_9090G: 9588,
    AAF_Black_40X_9204M: 9589,
    AAF_Black_8N202A: 9590,
    AAF_Black_GN150A: 9591,
    AAF_BlackAce_906_9116F: 9592,
    AAF_BlackNightSky_260_9128S: 9593,
    AAF_BlackNightSky_260_9129M: 9594,
    AAF_BlackNightSky_272_19268: 9595,
    AAF_BlackNightSky_272_19319: 9596,
    AAF_BlackNightSky_90E_9190Z: 9597,
    AAF_BlackNightSky_959_81878: 9598,
    AAF_BlackOnyx_GY042A: 9599,
    AAF_BlackPearl_YY242A: 9600,
    AAF_BlackSarouk_935_51146: 9601,
    AAF_BlackScylla_901_50003: 9602,
    AAF_BlazeBlue_265_5268G: 9603,
    AAF_BlazeBlue_984_19941: 9604,
    AAF_BlazeBlue_MJ034A: 9605,
    AAF_Blue_8J207A: 9606,
    AAF_BlueHammer_901_85159: 9607,
    AAF_BlueLightPearl_971_5209Q: 9608,
    AAF_BlueRidge_272_88480: 9609,
    AAF_BlueRidge_GJ221A: 9610,
    AAF_BlueRidge_GQ121A: 9611,
    AAF_BlueSuedeShoes_906_5178K: 9612,
    AAF_Blush_E64RL: 9613,
    AAF_BoldAsBrass_E58TL: 9614,
    AAF_BondiBlue_GJ045A: 9615,
    AAF_BondiBlue_YJ046A: 9616,
    AAF_BoundaryBrown_GM103A: 9617,
    AAF_BowralBrown_102_2727: 9618,
    AAF_Boysenberry_8H214A: 9619,
    AAF_BoysenberryPrl_YY24EA: 9620,
    AAF_BrightSilver_MW201T: 9621,
    AAF_BrightSilverMetallic_961_51491: 9622,
    AAF_BrightWhite_260_84636: 9623,
    AAF_BrightWhite_272_84636: 9624,
    AAF_BrightWhite_GA030A: 9625,
    AAF_BrilliantYellow_GE087A: 9626,
    AAF_BrilliantYellow_YE087A: 9627,
    AAF_BronzeMonument_E30TL: 9628,
    AAF_BronzePearl_8Y220A: 9629,
    AAF_BronzePearl_8Y225A: 9630,
    AAF_BronzePearl_YY225A: 9631,
    AAF_BronzePrl_YY26FA: 9632,
    AAF_BronzeRich_YW260G: 9633,
    AAF_BubblyPearl_260_8229Q: 9634,
    AAF_BurnishedCopper_906_8185K: 9635,
    AAF_BurnishedGold_E80GB: 9636,
    AAF_BurntSienna_E29TM: 9637,
    AAF_Bushland_GK203A: 9638,
    AAF_Bushland_GS103A: 9639,
    AAF_BwsAnodicDarkGreyL_S_GL247A: 9640,
    AAF_Cabernet_E36RL: 9641,
    AAF_CanolaCream_272_81796: 9642,
    AAF_Canon_YY287A: 9643,
    AAF_CanvasCloth_900_7327M: 9644,
    AAF_CanvasCloth_90Z_7327M: 9645,
    AAF_CapriOlivePrl_YY29FA: 9646,
    AAF_ChalkUSA_900_73713: 9647,
    AAF_ChalkUSA_90Z_1343G: 9648,
    AAF_Champagne_40A_7302Q: 9649,
    AAF_ChampagneKinetic_900_3059K: 9650,
    AAF_ChampagneKinetic_90T_3059K: 9651,
    AAF_ChampagneKinetic_971_3059K: 9652,
    AAF_ChampagnePearl_8Y276A: 9653,
    AAF_ChampagnePearl_YY276A: 9654,
    AAF_ChampagneRich_YW277G: 9655,
    AAF_Charcoal_260_88351: 9656,
    AAF_Charcoal_272_88351: 9657,
    AAF_Charcoal_272_9086G: 9658,
    AAF_Charcoal_40X_7297M: 9659,
    AAF_Charcoal_GL035A: 9660,
    AAF_Charcoal_GL180A: 9661,
    AAF_Charcoal_YL238A: 9662,
    AAF_CharcoalLowSheen_8L290A: 9663,
    AAF_CharcoalMetallic_971_18796: 9664,
    AAF_CharcoalMetallic_GM019A: 9665,
    AAF_CharcoalPearl_GY237A: 9666,
    AAF_CharcoalPearl_YY237A: 9667,
    AAF_CitiPearl_971_88471: 9668,
    AAF_CitiPearl_GL211A: 9669,
    AAF_CitiPearl_YY245A: 9670,
    AAF_CitrusDelightPrl_YY23GA: 9671,
    AAF_Claret_GG142A: 9672,
    AAF_ClassicCream_260_2095S: 9673,
    AAF_ClassicCream_260_84732: 9674,
    AAF_ClassicCream_272_2095S: 9675,
    AAF_ClassicCream_GD245A: 9676,
    AAF_ClassicCream_GU145A: 9677,
    AAF_ClassicHawthornGreen_272_33709: 9678,
    AAF_ClassicWhite_260_1228G: 9679,
    AAF_ClassicWhite_272_81880: 9680,
    AAF_Coin_40A_7289Q: 9681,
    AAF_Copper_961_4137Q: 9682,
    AAF_CopperCoin_E56RL: 9683,
    AAF_CopperCoinPearl_90T_4350Q: 9684,
    AAF_CopperKinetic_971_7183K: 9685,
    AAF_CopperMetallicKinetic_900_7183K: 9686,
    AAF_CopperMetallicKinetic_90T_7183K: 9687,
    AAF_CopperOre_90E_6413Z: 9688,
    AAF_CopperPearl_8Y204A: 9689,
    AAF_CopperPenny_YY22AA: 9690,
    AAF_CoralBlack_GN016A: 9691,
    AAF_CoralBlack_GN063A: 9692,
    AAF_Corsican_YK248A: 9693,
    AAF_CottageGreen_260_6304M: 9694,
    AAF_CottageGreen_260_84219: 9695,
    AAF_CottageGreen_272_84219: 9696,
    AAF_CottageGreen_GK274A: 9697,
    AAF_CottageGreen_GS174A: 9698,
    AAF_Cove_260_6250S: 9699,
    AAF_Cove_260_6252M: 9700,
    AAF_Cove_GD274A: 9701,
    AAF_CrystalMintPearl_8Y223A: 9702,
    AAF_CustomBlack_GN248A: 9703,
    AAF_CwcBlack_GN216A: 9704,
    AAF_DarkBronze_8Y224A: 9705,
    AAF_DarkBronze_906_8184K: 9706,
    AAF_DarkViolet_984_51926: 9707,
    AAF_DeepBronzePearl_260_8228Q: 9708,
    AAF_DeepBrunswickGreen_260_6134G: 9709,
    AAF_DeepBrunswickGreen_272_6134G: 9710,
    AAF_DeepBrunswickGreen_MK017A: 9711,
    AAF_DeepOcean_260_5125S: 9712,
    AAF_DeepOcean_260_5267M: 9713,
    AAF_DeepOcean_272_5125S: 9714,
    AAF_DeepOcean_GJ203A: 9715,
    AAF_DeepOcean_GQ103A: 9716,
    AAF_DeepOcean_YJ200A: 9717,
    AAF_DeepPool_MK002A: 9718,
    AAF_DesertDream_8M201A: 9719,
    AAF_DesertHaze_E59RM: 9720,
    AAF_DiamondLight_E87CB: 9721,
    AAF_Doeskin_260_32516: 9722,
    AAF_Doeskin_GD188A: 9723,
    AAF_Domain_GD230A: 9724,
    AAF_Driftwood_YL258A: 9725,
    AAF_Dune_260_3087S: 9726,
    AAF_Dune_260_7558M: 9727,
    AAF_Dune_272_3087S: 9728,
    AAF_Dune_GL252A: 9729,
    AAF_Dune_GP152A: 9730,
    AAF_Ebony_E26TM: 9731,
    AAF_Ebony_YN201A: 9732,
    AAF_EmeraldForest_YY283A: 9733,
    AAF_EnduraBronze_YY248A: 9734,
    AAF_EnzianBlue_YJ028A: 9735,
    AAF_EssentialSilverPearl_260_3146Q: 9736,
    AAF_Estate_GM247A: 9737,
    AAF_EternalSilver_YW100C: 9738,
    AAF_EternityBronzePearl_900_88393: 9739,
    AAF_EternityBronzePearl_90T_8356Q: 9740,
    AAF_EternityChainPearl_900_89119: 9741,
    AAF_EternityChainPearl_90T_7761Q: 9742,
    AAF_EternityCharcoalPearl_900_88394: 9743,
    AAF_EternityCharcoalPearl_90T_7762Q: 9744,
    AAF_EternityCitiSilverPearl_900_7024Q: 9745,
    AAF_EternityCitiSilverPearl_90T_7024Q: 9746,
    AAF_EternityLinenPearl_900_1138Q: 9747,
    AAF_EternityLinenPearl_90T_1138Q: 9748,
    AAF_EternityNickelPearl_900_88395: 9749,
    AAF_EternityNickelPearl_90T_7763Q: 9750,
    AAF_EternityPewterPearl_900_88396: 9751,
    AAF_EternityPewterPearl_90T_7764Q: 9752,
    AAF_EternitySilver_900_7160K: 9753,
    AAF_EternitySilver_90T_7160K: 9754,
    AAF_EternityStarPearl_900_7005F: 9755,
    AAF_EternityTitaniumPearl_900_87728: 9756,
    AAF_EternityTitaniumPearl_90T_7765Q: 9757,
    AAF_EveningHaze_260_3168M: 9758,
    AAF_EveningHaze_260_3175S: 9759,
    AAF_EveningHaze_272_3055S: 9760,
    AAF_EveningHaze_GM235A: 9761,
    AAF_EveningHaze_GT135A: 9762,
    AAF_FlameRed_984_19959: 9763,
    AAF_FlameRed_MG071A: 9764,
    AAF_FlamingRed_MG045A: 9765,
    AAF_FlatWhite_906_1200F: 9766,
    AAF_FrenchBlue_984_32725: 9767,
    AAF_FrenchBlue_MJ067A: 9768,
    AAF_GlowPearl_260_7471Q: 9769,
    AAF_GoldenTouch_906_8182K: 9770,
    AAF_GoldOdyssey_E78GL: 9771,
    AAF_GoldPearl_8Y221A: 9772,
    AAF_GoldPearl_906_2221K: 9773,
    AAF_GoldPearl_971_96604: 9774,
    AAF_GoldPearl_YY217A: 9775,
    AAF_GraphiteSarouk_935_51677: 9776,
    AAF_GreenPacifica_8K217A: 9777,
    AAF_GreenTea_906_6197K: 9778,
    AAF_GreyHammer_901_85184: 9779,
    AAF_GreyNurse_260_50060: 9780,
    AAF_Gully_260_8233S: 9781,
    AAF_Gully_260_8235M: 9782,
    AAF_Gully_GM242A: 9783,
    AAF_GunBarrel_E25TL: 9784,
    AAF_GunmetalKinetic_971_8115K: 9785,
    AAF_HamersleyBrown_GM100A: 9786,
    AAF_HammersleyBrown_260_84657: 9787,
    AAF_HardyReef_8J215A: 9788,
    AAF_Harvest_GD215A: 9789,
    AAF_HawthornGreen_GK030A: 9790,
    AAF_Headland_GG219A: 9791,
    AAF_Headland_GV119A: 9792,
    AAF_HeritageGreen_GK044A: 9793,
    AAF_HoneyMyrtle_8E207A: 9794,
    AAF_HorizonWhiteScylla_901_51608: 9795,
    AAF_HyperBlack_8N209A: 9796,
    AAF_HyperCharcoal_8L210A: 9797,
    AAF_HyperCoin_8Y211A: 9798,
    AAF_HyperWhite_8A210A: 9799,
    AAF_IntensityCoast_900_5233S: 9800,
    AAF_IntensityCoast_90N_5233S: 9801,
    AAF_IntensityDesert_900_4227S: 9802,
    AAF_IntensityDesert_90N_4227S: 9803,
    AAF_IntensityEvergreen_900_6005S: 9804,
    AAF_IntensityEvergreen_90N_6005S: 9805,
    AAF_IntensityFlame_900_4007G: 9806,
    AAF_IntensityFlame_90N_4007G: 9807,
    AAF_IntensityLeaf_900_6167S: 9808,
    AAF_IntensityLeaf_90N_6167S: 9809,
    AAF_IntensityMoonlight_900_2004S: 9810,
    AAF_IntensityMoonlight_90N_2004S: 9811,
    AAF_IntensityReef_900_5011G: 9812,
    AAF_IntensityReef_90N_5011G: 9813,
    AAF_IntensityStorm_900_89584: 9814,
    AAF_IntensityStorm_90N_5365S: 9815,
    AAF_IntensitySummer_900_4008G: 9816,
    AAF_IntensitySunshine_900_2084G: 9817,
    AAF_IntensitySunshine_90N_2084G: 9818,
    AAF_InterstateGreenPrl_YY21GA: 9819,
    AAF_Ironstone_260_7257S: 9820,
    AAF_Ironstone_260_7556M: 9821,
    AAF_Ironstone_272_7257S: 9822,
    AAF_Ironstone_GL236A: 9823,
    AAF_Ironstone_GP136A: 9824,
    AAF_Ivory_8D212A: 9825,
    AAF_JamaicanChocolate_E35TM: 9826,
    AAF_Jasper_260_8122S: 9827,
    AAF_Jasper_260_8252M: 9828,
    AAF_Jasper_272_8122S: 9829,
    AAF_Jasper_GM214A: 9830,
    AAF_Jasper_GT114A: 9831,
    AAF_Jasper_YT214A: 9832,
    AAF_Jaybird_GJ174A: 9833,
    AAF_Jaybird_YJ175A: 9834,
    AAF_JetPearl_260_9144Q: 9835,
    AAF_Kalahari_E53RM: 9836,
    AAF_Latte_YY298A: 9837,
    AAF_LawnGreen_MK038A: 9838,
    AAF_LemonYellow_984_32120: 9839,
    AAF_LemonYellow_ME068A: 9840,
    AAF_LightGrey_272_7263G: 9841,
    AAF_LightGreyScylla_901_50766: 9842,
    AAF_LightLichenPrl_YY24GA: 9843,
    AAF_Lobster_GG155A: 9844,
    AAF_Lobster_YG054A: 9845,
    AAF_Lobster_YG154A: 9846,
    AAF_Loft_GM236A: 9847,
    AAF_LoftIn_GT136A: 9848,
    AAF_LuxeBronze_YY240A: 9849,
    AAF_LuxeBronzePearl_YY255A: 9850,
    AAF_LycraStrip_GK063A: 9851,
    AAF_LycraStrip_YK063A: 9852,
    AAF_Macchiato_E36TL: 9853,
    AAF_Magnatite_90E_7725Z: 9854,
    AAF_Magnolia_272_32658: 9855,
    AAF_Magnolia_GD025A: 9856,
    AAF_Mangrove_260_6251M: 9857,
    AAF_Mangrove_260_6262S: 9858,
    AAF_Mangrove_GK277A: 9859,
    AAF_MannexBlack_901_32679: 9860,
    AAF_MannexSilverLodePearl_901_7034Z: 9861,
    AAF_MannexSuede_901_37543: 9862,
    AAF_MannexWhite_901_33641: 9863,
    AAF_ManorRed_260_4134S: 9864,
    AAF_ManorRed_260_4292M: 9865,
    AAF_ManorRed_272_4134S: 9866,
    AAF_ManorRed_GG262A: 9867,
    AAF_ManorRed_GV162A: 9868,
    AAF_MANORRED_GV262A: 9869,
    AAF_MarbleBlack_YN166A: 9870,
    AAF_MaroochySand_E74GM: 9871,
    AAF_MedallionBronze_E44TL: 9872,
    AAF_MediumBronze_906_8183k: 9873,
    AAF_MercurySilver_GW003K: 9874,
    AAF_Merlot_E35RM: 9875,
    AAF_MetallicLustre_GW215A: 9876,
    AAF_MetropolisBronze_971_59003: 9877,
    AAF_MetropolisSilverGlow_971_84623: 9878,
    AAF_MetropolisStorm_971_84684: 9879,
    AAF_Minky_8L227A: 9880,
    AAF_Mistletoe_265_6292G: 9881,
    AAF_Mistletoe_984_51040: 9882,
    AAF_MonacoStone_E65TL: 9883,
    AAF_Monument_260_9066M: 9884,
    AAF_Monument_260_9067S: 9885,
    AAF_Monument_272_9067S: 9886,
    AAF_Monument_40X_8148M: 9887,
    AAF_Monument_8L244A: 9888,
    AAF_Monument_906_9171F: 9889,
    AAF_Monument_90E_7724Z: 9890,
    AAF_Monument_90Z_7307S: 9891,
    AAF_Monument_90Z_8189M: 9892,
    AAF_Monument_959_9066M: 9893,
    AAF_Monument_GL229A: 9894,
    AAF_Monument_GP129A: 9895,
    AAF_Monument_YL264A: 9896,
    AAF_MonumentmkII_YP182A: 9897,
    AAF_Moonbeam_E74NB: 9898,
    AAF_MotherOfPearl_971_84678: 9899,
    AAF_Mystic_GY236A: 9900,
    AAF_Natural_971_89119: 9901,
    AAF_NaturalBronze_90E_8341Z: 9902,
    AAF_NaturalSilver_906_7365K: 9903,
    AAF_Navy_984_50282: 9904,
    AAF_Navy_MJ011A: 9905,
    AAF_Nickel_971_88360: 9906,
    AAF_NightSky_GN121A: 9907,
    AAF_NightSky_GN231A: 9908,
    AAF_NobelSilverPearl_GY119A: 9909,
    AAF_NobelSilverPearl_YX136A: 9910,
    AAF_NobelSilverPearl_YY268A: 9911,
    AAF_NotreDame_260_36672: 9912,
    AAF_NotreDame_272_36672: 9913,
    AAF_NotreDame_GL040A: 9914,
    AAF_NotreDameScylla_901_50223: 9915,
    AAF_NuanceSilverPearl_GW104C: 9916,
    AAF_OffWhite_260_3149S: 9917,
    AAF_OffWhite_272_33732: 9918,
    AAF_OffWhite_GA211A: 9919,
    AAF_OldePewter_260_50243: 9920,
    AAF_OldePewter_272_50243: 9921,
    AAF_OldePewter_GL175A: 9922,
    AAF_OldePewter_YL275A: 9923,
    AAF_Onyx_971_52052: 9924,
    AAF_OrangeX15_265_4293G: 9925,
    AAF_OrangeX15_984_51439: 9926,
    AAF_OutbackRed_8G212A: 9927,
    AAF_Oyster_260_36858: 9928,
    AAF_Oyster_272_36858: 9929,
    AAF_OysterGrey_GL258A: 9930,
    AAF_PacificAvenue_YY288A: 9931,
    AAF_PaleEucalypt_260_6127S: 9932,
    AAF_PaleEucalypt_260_6303M: 9933,
    AAF_PaleEucalypt_GK236A: 9934,
    AAF_PaleEucalypt_GS136A: 9935,
    AAF_PalladiumCoin_E87CL: 9936,
    AAF_PalladiumSilverPearl_GY184C: 9937,
    AAF_PallidSky_YY281A: 9938,
    AAF_PandemoniumSilver_971_7004F: 9939,
    AAF_PantherPearl_8Y212A: 9940,
    AAF_Paperbark_260_3135S: 9941,
    AAF_Paperbark_260_3174M: 9942,
    AAF_Paperbark_272_3088S: 9943,
    AAF_Paperbark_GD214A: 9944,
    AAF_Paperbark_GU114A: 9945,
    AAF_PapyrusWhite_GA018A: 9946,
    AAF_PatinaPearl_8Y207A: 9947,
    AAF_PearlWhite_260_1229G: 9948,
    AAF_PearlWhite_272_1114G: 9949,
    AAF_PearlWhite_GA029A: 9950,
    AAF_PearlWhite_GA078A: 9951,
    AAF_PearlWhite_YA074A: 9952,
    AAF_PearlWhite_YA078A: 9953,
    AAF_PearlWhite_YA278A: 9954,
    AAF_Pewter_971_88202: 9955,
    AAF_PewterPearl_GY199A: 9956,
    AAF_PistachioPearl_YY20GA: 9957,
    AAF_Platinum_E87CM: 9958,
    AAF_PlatypusKinetic_971_7214K: 9959,
    AAF_PommelBlue_984_51034: 9960,
    AAF_PortlandStone_E60TM: 9961,
    AAF_Pottery_GM175A: 9962,
    AAF_PrecisChampagneShimmer_YY24NA: 9963,
    AAF_PrecisDarkBronze_GY20BA: 9964,
    AAF_PrecisGoldenTouch_YY25BA: 9965,
    AAF_PrecisMediumBronze_YY23NA: 9966,
    AAF_PrecisNaturalShimmer_GY21AA: 9967,
    AAF_PrecisTMBlackInk_YN21BA: 9968,
    AAF_PrecisTMDarkBronze_YY20BA: 9969,
    AAF_PrecisTMNaturalShimmer_YY25AA: 9970,
    AAF_PrecisTMPacificBlue_YY23BA: 9971,
    AAF_PrecisTMPureGold_YY22BA: 9972,
    AAF_PrecisTMSunstoneBronze_YY21BA: 9973,
    AAF_PrecisVintageSilver_YY22NA: 9974,
    AAF_Primrose_260_84365: 9975,
    AAF_Primrose_272_84365: 9976,
    AAF_Primrose_GD031A: 9977,
    AAF_Primrose_GD037A: 9978,
    AAF_Primrose_YD037A: 9979,
    AAF_PropellerPearl_260_8230Q: 9980,
    AAF_Prosecco_E70RM: 9981,
    AAF_QuartzPearlLowSheen_8Y216A: 9982,
    AAF_RAL1001Beige_101_2521: 9983,
    AAF_RAL1003SignalYellow_102_5616: 9984,
    AAF_RAL1007DaffodilYellow_102_6678: 9985,
    AAF_RAL1013OysterWhite_102_5619: 9986,
    AAF_RAL1014Ivory_102_5620: 9987,
    AAF_RAL1015LightIvory_102_6668: 9988,
    AAF_RAL1018ZincYellow_102_6631: 9989,
    AAF_RAL1019GreyBeige_102_5637: 9990,
    AAF_RAL1021RapeYellow_102_5653: 9991,
    AAF_RAL1023TrafficYellow_120_5603: 9992,
    AAF_RAL1035PearlBeige_102_6258: 9993,
    AAF_RAL2000YellowOrange_102_6287: 9994,
    AAF_RAL2002Butorange_102_8021: 9995,
    AAF_RAL2003PastelOrange_102_5622: 9996,
    AAF_RAL2008BrightRedOrange_102_5636: 9997,
    AAF_RAL3000FlameRed_102_5623: 9998,
    AAF_RAL3001SignalRed_102_6681: 9999,
    AAF_RAL3002CarmineRed_102_5635: 10000,
    AAF_RAL3003RubyRed_102_6645: 10001,
    AAF_RAL3005WineRed_102_5617: 10002,
    AAF_RAL3009OxideRed_102_5647: 10003,
    AAF_RAL3011BrownRed_102_5630: 10004,
    AAF_RAL3012BeigeRed_100_0311: 10005,
    AAF_RAL3020TrafficRed_102_6685: 10006,
    AAF_RAL4010Telemagenta_102_7862: 10007,
    AAF_RAL4011PurplePearl_100_3296: 10008,
    AAF_RAL5002UltramarineBlue_102_6629: 10009,
    AAF_RAL5003SapphieBlie_102_6659: 10010,
    AAF_RAL5005SignalBlue_102_5655: 10011,
    AAF_RAL5010GentianBlue_102_6657: 10012,
    AAF_RAL5012LightBlue_102_6642: 10013,
    AAF_RAL5013CobaltBlue_102_6660: 10014,
    AAF_RAL5015SkyBlue_102_6637: 10015,
    AAF_RAL5017TrafficBlue_102_6674: 10016,
    AAF_RAL5019CapriBlue_102_6317: 10017,
    AAF_RAL5020OceanBlue_100_0588: 10018,
    AAF_RAL5021WaterBlue_102_6319: 10019,
    AAF_RAL6002LeafGreen_120_5611: 10020,
    AAF_RAL6003OliveGreen_102_5627: 10021,
    AAF_RAL6005MossGreen_102_6627: 10022,
    AAF_RAL6009FirGreen_102_6628: 10023,
    AAF_RAL6010GrassGreen_102_6326: 10024,
    AAF_RAL6011ResedaGreen_102_5615: 10025,
    AAF_RAL6014YellowOlive_102_6328: 10026,
    AAF_RAL6018Green_102_3801: 10027,
    AAF_RAL6024TrafficGreen_102_6332: 10028,
    AAF_RAL7001SilverGrey_102_6366: 10029,
    AAF_RAL7004SignalGrey_102_6369: 10030,
    AAF_RAL7005MouseGrey_102_5634: 10031,
    AAF_RAL7006BeigeGrey_102_2207: 10032,
    AAF_RAL7011IronGrey_102_6676: 10033,
    AAF_RAL7012BasaltGrey_102_6371: 10034,
    AAF_RAL7015SlateGrey_102_6373: 10035,
    AAF_RAL7016AnthraciteGrey_102_6374: 10036,
    AAF_RAL7021BlackGrey_102_5643: 10037,
    AAF_RAL7022UmbraGrey_102_5633: 10038,
    AAF_RAL7024GraphiteGrey_102_6375: 10039,
    AAF_RAL7030StoneGrey_102_5649: 10040,
    AAF_RAL7031BlueGrey_102_6664: 10041,
    AAF_RAL7032GreyB27_100_4732: 10042,
    AAF_RAL7032GreyRipple_100_3717: 10043,
    AAF_RAL7035LightGrey_100_3719: 10044,
    AAF_RAL7035LightGreyRipple_100_3711: 10045,
    AAF_RAL7036PlatinumGrey_102_5659: 10046,
    AAF_RAL7037DustyGrey_102_6378: 10047,
    AAF_RAL7038AgateGrey_102_6633: 10048,
    AAF_RAL7039QuartzGrey_102_6683: 10049,
    AAF_RAL7040WindowGrey_102_6634: 10050,
    AAF_RAL7042TrafficGreyA_102_6379: 10051,
    AAF_RAL7043TrafficGreyB_102_6650: 10052,
    AAF_RAL7044SilkGrey_102_5650: 10053,
    AAF_RAL7045TeleGrey1_102_6662: 10054,
    AAF_RAL7046Telegray2_102_6632: 10055,
    AAF_RAL7047Telegray4_102_6658: 10056,
    AAF_RAL7048MouseGreyPearl_103_1082: 10057,
    AAF_RAL8004CopperBrown_102_6666: 10058,
    AAF_RAL8014SepiaBrown_102_5654: 10059,
    AAF_RAL8017ChocolateBrown_102_6654: 10060,
    AAF_RAL8019GreyBrown_102_6648: 10061,
    AAF_RAL8028TerraBrown_120_5487: 10062,
    AAF_RAL9001Cream_102_6391: 10063,
    AAF_RAL9002GreyWhite_102_6671: 10064,
    AAF_RAL9003SignalWhite_102_4983: 10065,
    AAF_RAL9004SignalBlack_102_5657: 10066,
    AAF_RAL9005JetBlack_102_7013: 10067,
    AAF_RAL9006MattSilver_100_3317: 10068,
    AAF_RAL9006SilverGloss_100_3295: 10069,
    AAF_RAL9007MetallicGrey_100_3306: 10070,
    AAF_RAL9010PureWhite_102_1880: 10071,
    AAF_RAL9011GraphiteBlack_102_6393: 10072,
    AAF_RAL9016TrafficWhite_101_9786: 10073,
    AAF_RAL9016TrafficWhite_102_6394: 10074,
    AAF_RAL9018PapyrusWhite_102_6396: 10075,
    AAF_RAL9023PearlDarkGrey_102_6431: 10076,
    AAF_RedBrownScylla_901_85473: 10077,
    AAF_RedBushApple_8M214A: 10078,
    AAF_RedEmperor_971_4205Q: 10079,
    AAF_RippleApoGrey_ML463A: 10080,
    AAF_RippleBlack_MN427A: 10081,
    AAF_RippleBlackLeather_EN432A: 10082,
    AAF_RippleGraphite_EY422A: 10083,
    AAF_RippleGreyNurse_EL422A: 10084,
    AAF_RippleGypsyBeige_MD453A: 10085,
    AAF_RippleN42StormGrey_ML421A: 10086,
    AAF_RippleNotreDame_ML444A: 10087,
    AAF_RippleRal7035_ML435A: 10088,
    AAF_RippleRal9002_MA424A: 10089,
    AAF_RippleWhite_MA494A: 10090,
    AAF_RippleX15Orange_MF406A: 10091,
    AAF_Rivergum_GD042A: 10092,
    AAF_RivergumBeige_272_36991: 10093,
    AAF_Riversand_260_3193M: 10094,
    AAF_Riversand_959_36656: 10095,
    AAF_Riversand_GM204A: 10096,
    AAF_RojoRock_8M213A: 10097,
    AAF_RojoRock_GM298A: 10098,
    AAF_RoseberryGrey_GL015A: 10099,
    AAF_Rouge_YY285A: 10100,
    AAF_SableApoGrey_ML307A: 10101,
    AAF_SableAsteroid_GN271A: 10102,
    AAF_SableAsteroid_YY371A: 10103,
    AAF_SableBass_GN297A: 10104,
    AAF_SableBass_YY397A: 10105,
    AAF_SableBlack_GN341A: 10106,
    AAF_SableBrillance_GL277A: 10107,
    AAF_SableBrilliance_YY377A: 10108,
    AAF_SableCoreTen_GX350A: 10109,
    AAF_SableCoreTen_YX350A: 10110,
    AAF_SableGildedGreen_YY380A: 10111,
    AAF_SableGreyNurse_GL320A: 10112,
    AAF_SableGreyNurse_ML320A: 10113,
    AAF_SableMediumBronze_GY366A: 10114,
    AAF_SableMediumBronze_YY366A: 10115,
    AAF_SableSagraGreen_YY345A: 10116,
    AAF_SableSilver_GY301A: 10117,
    AAF_SableSilverTexture_YY301A: 10118,
    AAF_SafetyYellow_265_2162G: 10119,
    AAF_SafetyYellow_984_2015G: 10120,
    AAF_SafetyYellow_ME096A: 10121,
    AAF_Sage_YY296A: 10122,
    AAF_SagePearl_YY28FA: 10123,
    AAF_Sandbank_GM216A: 10124,
    AAF_SandbankIn_GT116A: 10125,
    AAF_Sandstone_8A237A: 10126,
    AAF_Sandstone_GL281A: 10127,
    AAF_SanskritPearl_YY25GA: 10128,
    AAF_SchoolInkPearl_YY22GA: 10129,
    AAF_Scintillation_906_8186K: 10130,
    AAF_SeaBreeze_E67TM: 10131,
    AAF_SeafoamPearl_YY269A: 10132,
    AAF_SeaStorm_8L216A: 10133,
    AAF_Sensation_GF049A: 10134,
    AAF_Sensation_YF049A: 10135,
    AAF_ShaleGrey_260_7557M: 10136,
    AAF_ShaleGrey_260_83246: 10137,
    AAF_ShaleGrey_272_83246: 10138,
    AAF_ShaleGrey_GL284A: 10139,
    AAF_ShaleGrey_GP184A: 10140,
    AAF_Shamrock_GK043A: 10141,
    AAF_Shamrock_YK043A: 10142,
    AAF_SharpSilverKinetic_971_7238K: 10143,
    AAF_ShimmeringChampagne_906_3116K: 10144,
    AAF_ShojiWhite_260_84682: 10145,
    AAF_ShojiWhite_272_84682: 10146,
    AAF_ShojiWhite_GA160A: 10147,
    AAF_SignalRed_265_4294G: 10148,
    AAF_SignalRed_984_50735: 10149,
    AAF_SignalRed_MG036A: 10150,
    AAF_SignalRed90_GG040A: 10151,
    AAF_Silver_40A_7273Q: 10152,
    AAF_SilverGrey_ML194A: 10153,
    AAF_SilverKinetic_971_7043K: 10154,
    AAF_SilverPearl_YY230A: 10155,
    AAF_SilverReef_YY365A: 10156,
    AAF_SilverRich_YW209G: 10157,
    AAF_SilverSarouk_935_84874: 10158,
    AAF_SimpsonClay_8G200A: 10159,
    AAF_SkybridgePearl_YY291A: 10160,
    AAF_SlatePearlLowSheen_8Y213A: 10161,
    AAF_SmokeyQuartz_E60TB: 10162,
    AAF_SmoothOnyx_E25TB: 10163,
    AAF_SnowDust_GA228A: 10164,
    AAF_Sorcerer_YJ254A: 10165,
    AAF_SovereignGold_E78GM: 10166,
    AAF_SpaceBlue_984_19990: 10167,
    AAF_SpaceBlue_MJ008A: 10168,
    AAF_SpanishEyes_YY279A: 10169,
    AAF_SpecialWhite_100_3270: 10170,
    AAF_SpecialWhite_MA042A: 10171,
    AAF_StarDust_E70NM: 10172,
    AAF_StarryNightPearl_260_9139Q: 10173,
    AAF_Steel_971_57127: 10174,
    AAF_SteelPearlLowSheen_8Y215A: 10175,
    AAF_StellaGrey_E78NM: 10176,
    AAF_StElmosFireKinetic_971_7208K: 10177,
    AAF_StfNewDarkBeige_GZ306A: 10178,
    AAF_StoneBeige_260_32538: 10179,
    AAF_StoneBeige_GD247A: 10180,
    AAF_StoneBeigeScylla_901_85474: 10181,
    AAF_StoneGrey_260_78126: 10182,
    AAF_StoneGrey_272_78126: 10183,
    AAF_StormFront_GL249A: 10184,
    AAF_StormGreyN42_GL060A: 10185,
    AAF_StormGreyScylla_901_50183: 10186,
    AAF_StreetwiseSilver_910_7049Q: 10187,
    AAF_Stromboli_GK148A: 10188,
    AAF_SubtleBlue_906_5177K: 10189,
    AAF_SummerMaize_E82GM: 10190,
    AAF_SupremeSilverPearl_260_7466Q: 10191,
    AAF_Surfmist_260_1137S: 10192,
    AAF_Surfmist_260_3167M: 10193,
    AAF_Surfmist_272_1137S: 10194,
    AAF_Surfmist_40X_1182S: 10195,
    AAF_Surfmist_90E_1330Z: 10196,
    AAF_Surfmist_959_84758: 10197,
    AAF_Surfmist_GA236A: 10198,
    AAF_Surfmist_GB136A: 10199,
    AAF_Surfmist_YA236A: 10200,
    AAF_SurfPearlLowSheen_8Y208A: 10201,
    AAF_SwordPearl_260_7468Q: 10202,
    AAF_Talc_900_84682: 10203,
    AAF_Talc_90Z_1344S: 10204,
    AAF_TanninPearl_YY173A: 10205,
    AAF_Terrain_260_8232S: 10206,
    AAF_Terrain_260_8234M: 10207,
    AAF_Terrain_GM243A: 10208,
    AAF_TexturaDeepOcean_GJ301A: 10209,
    AAF_TexturaDune_GL352A: 10210,
    AAF_TexturaIronstone_GL336A: 10211,
    AAF_TexturaJasper_GM314A: 10212,
    AAF_TexturaMonument_GL329A: 10213,
    AAF_TexturaPaperbark_GD314A: 10214,
    AAF_TexturaPrimrose_GD331A: 10215,
    AAF_TexturaSilver_GN305A: 10216,
    AAF_TexturaSilver_GY35LA: 10217,
    AAF_TexturaSurfmist_GA336A: 10218,
    AAF_TexturaWoodlandGrey_GL333A: 10219,
    AAF_TitaniumPearl_8Y263A: 10220,
    AAF_TitaniumPearl_YY263A: 10221,
    AAF_TorresBlue_GJ215A: 10222,
    AAF_ToyotaWhite040_GA019A: 10223,
    AAF_TransformerGrey_984_32186: 10224,
    AAF_TransformerGrey_GL031A: 10225,
    AAF_TreasuredSilverPearl_GW103C: 10226,
    AAF_TreasuredSilverPearl_GW103K: 10227,
    AAF_TrophyPearl_260_7470Q: 10228,
    AAF_TurquoiseSea_8K218A: 10229,
    AAF_TuscanRed_E47RL: 10230,
    AAF_TyphoonPearl_260_7469Q: 10231,
    AAF_UltraBlack_GN261A: 10232,
    AAF_UltraSilver_GY070A: 10233,
    AAF_UrbanPearl_260_7467Q: 10234,
    AAF_VelocityGreen_910_33709: 10235,
    AAF_VintageSilver_906_7377K: 10236,
    AAF_ViperGreen_GK051A: 10237,
    AAF_ViperGreen_YK051A: 10238,
    AAF_Wallaby_260_7474S: 10239,
    AAF_Wallaby_260_7476M: 10240,
    AAF_Wallaby_GL210A: 10241,
    AAF_WeatheredCopper_272_33724: 10242,
    AAF_WeatheredSteel_90E_8340Z: 10243,
    AAF_Wedgewood_272_50279: 10244,
    AAF_Wedgewood_MJ180A: 10245,
    AAF_WetlandFern_YY289A: 10246,
    AAF_White_260_1139S: 10247,
    AAF_White_272_1139S: 10248,
    AAF_White_40X_1157S: 10249,
    AAF_White_8A202A: 10250,
    AAF_White_910_19143: 10251,
    AAF_White_961_32312: 10252,
    AAF_White_GA113A: 10253,
    AAF_White_GA124A: 10254,
    AAF_WhiteBirch_260_2057G: 10255,
    AAF_WhiteBirch_272_37131: 10256,
    AAF_WhiteBirch_GA057A: 10257,
    AAF_WhiteBirch_YA057A: 10258,
    AAF_WhiteBirchGloss_101_6355: 10259,
    AAF_WhiteFlatMatt_YA25BA: 10260,
    AAF_WhiteMatt_103_1710: 10261,
    AAF_Wilderness_272_84224: 10262,
    AAF_Wilderness_GK289A: 10263,
    AAF_WILDERNESS_GK289A: 10264,
    AAF_Wilderness_GS189A: 10265,
    AAF_Windspray_260_7256S: 10266,
    AAF_Windspray_260_7559M: 10267,
    AAF_Windspray_272_7256S: 10268,
    AAF_Windspray_GL266A: 10269,
    AAF_Windspray_GP166A: 10270,
    AAF_WineberryPrl_YY21EA: 10271,
    AAF_Wizard_GJ054A: 10272,
    AAF_WoodlandGrey_260_6255S: 10273,
    AAF_WoodlandGrey_260_6256M: 10274,
    AAF_WoodlandGrey_272_7255S: 10275,
    AAF_WoodlandGrey_959_51698: 10276,
    AAF_WoodlandGrey_GL205A: 10277,
    AAF_WoodlandGrey_GP105A: 10278,
    AAF_X15Orange_MF035A: 10279,
    AAF_XtremeBlack_964_56970: 10280,
    AAF_XtremeChampagne_964_7302Q: 10281,
    AAF_XtremeCharcoal_964_7297M: 10282,
    AAF_XtremeCoin_964_7289S: 10283,
    AAF_XtremeSilver_964_7273Q: 10284,
    AAF_XtremeWhite_964_1157M: 10285,
    AAF_YellowGold_265_2188G: 10286,
    AAF_YellowGold_984_33617: 10287,
    AAF_YellowGold_ME038A: 10288,
    AAF_ZeusBlack_900_88702: 10289,
    AAF_ZeusBlack_90Z_9202M: 10290,
    AAF_ZeusCharcoal_900_87732: 10291,
    AAF_ZeusCharcoal_90Z_7766S: 10292,
    AAF_ZeusDarkGrey_900_51275: 10293,
    AAF_ZeusDarkGrey_90Z_7767M: 10294,
    AAF_ZeusGrey_900_88416: 10295,
    AAF_ZeusGrey_90Z_7768S: 10296,
    AAF_ZeusLunarEclipse_900_87734: 10297,
    AAF_ZeusLunarEclipse_90Z_9203S: 10298,
    AAF_ZeusLunarGrey_900_88417: 10299,
    AAF_ZeusLunarGrey_90Z_7769M: 10300,
    AAF_ZeusSilverGrey_900_51272: 10301,
    AAF_ZeusSilverGrey_90Z_7770M: 10302,
    AAF_ZeusTimberland_900_7315S: 10303,
    AAF_ZeusTimberland_90Z_7315S: 10304,
    AAF_ZeusWhite_900_1110G: 10305,
    AAF_ZeusWhite_90Z_1110G: 10306,
  },
  Window_Alliance: {
    Alliance_ArcticBlue: 10787,
    Alliance_Black: 10788,
    Alliance_Clay: 10789,
    Alliance_DarkBronze: 10790,
    Alliance_ForestGreen: 10791,
    Alliance_GunMetal: 10792,
    Alliance_IvoryCream: 10793,
    Alliance_RoyalBrown: 10794,
    Alliance_Tan: 10795,
    Alliance_TerraBronze: 10796,
    Alliance_White: 10797,
  },
  Window_AllTemp: {
    Adobe: 4459,
    Black: 10706,
    Sandstone: 4460,
    White: 4461,
  },
  Window_AMSCO: {
    AMSCO_Black: 10383,
    AMSCO_Bronze: 10384,
    AMSCO_Brown: 10385,
    AMSCO_Clay: 10386,
    AMSCO_Cream: 10387,
    AMSCO_DarkBrown: 10388,
    AMSCO_ForestGreen: 10389,
    AMSCO_Gray: 10390,
    AMSCO_Green: 10391,
    AMSCO_Olive: 10392,
    AMSCO_Red: 10393,
    AMSCO_Silver: 10394,
    AMSCO_Taupe: 10395,
    AMSCO_White: 10396,
  },
  Window_Anderson: {
    Black: 10774,
    Canvas: 10775,
    DarkBronze: 10776,
    ForestGreen: 10777,
    Sandtone: 10778,
    Terratone: 10779,
    White: 10780,
  },
  Window_Atrium: {
    Atrium_Almond: 10900,
    Atrium_Black: 10901,
    Atrium_BrickRed: 10902,
    Atrium_Bronze: 10903,
    Atrium_Clay: 10904,
    Atrium_DarkChocolate: 10905,
    Atrium_Gray: 10906,
    Atrium_HunterGreen: 10907,
    Atrium_Tan: 10908,
    Atrium_Terratone: 10909,
    Atrium_White: 10910,
  },
  Window_Cascade: {
    Cascade_Almond: 10649,
    Cascade_Black: 10650,
    Cascade_Bronze: 10651,
    Cascade_Clay: 10652,
    Cascade_White: 10653,
  },
  Window_Colors: {
    Black: 242,
    Bronze: 1801,
    DesertSand: 243,
    Taupe: 1981,
    White: 244,
  },
  Window_Elevate: {
    Elevate_Black: 4487,
    Elevate_Bronze: 4488,
    Elevate_Khaki: 4489,
    Elevate_Taupe: 4490,
    Elevate_White: 4491,
  },
  Window_Gerkin: {
    Gerkin_Midnight: 10654,
    Gerkin_Sandstone: 10655,
    Gerkin_Tan: 10656,
    Gerkin_White: 10657,
  },
  Window_Harvey: {
    Harvey_Almond: 10659,
    Harvey_Black: 10670,
    Harvey_Bronze: 10671,
    Harvey_Cranberry: 10672,
    Harvey_DarkBronze: 10673,
    Harvey_ForestGreen: 10674,
    Harvey_Ivory: 10675,
    Harvey_MatteBlack: 10676,
    Harvey_WedgewoodBlue: 10677,
    Harvey_White: 10660,
  },
  Window_HoffmanWeber: {
    HW_Black: 10629,
    HW_Bronze: 10630,
    HW_Clay: 10631,
    HW_Sandstone: 10632,
    HW_White: 10633,
  },
  Window_JeldWen: {
    Almond: 10701,
    Black: 10702,
    Bronze: 10703,
    DesertSand: 10704,
    White: 10705,
  },
  Window_Lindsay: {
    AnthraciteGrayLaminate: 2109,
    BlackLaminate: 2110,
    BrickRed510: 2111,
    BronzeLaminate: 2112,
    Buttercream712: 2113,
    Clay: 2114,
    Clay145: 2115,
    CreamWhite100: 2116,
    LindsayBronze9001: 2117,
    LindsayEarthtone9003: 2118,
    LindsayGreen9002: 2119,
    LindsaySandstone9004: 2120,
    MidnightBlack201: 2121,
    MountainRidge: 2122,
    Parchment: 2123,
    RoyalBrown905: 2124,
    Sandstone: 2125,
    SilverMetallicLaminate: 2126,
    StormGray310: 2127,
    Terratone9005: 2128,
    White: 2129,
  },
  Window_Marvin: {
    Marvin_Bronze: 10950,
    Marvin_Cashmere: 10951,
    Marvin_Ebony: 10952,
    Marvin_Gunmetal: 10953,
    Marvin_PebbleGray: 10954,
    Marvin_StoneWhite: 10955,
  },
  Window_MGM: {
    MGM_Black: 11420,
    MGM_Bronze: 11421,
    MGM_Earthtone: 11422,
    MGM_Tan: 11423,
    MGM_White: 10879,
  },
  Window_MI: {
    Almond: 4634,
    AntiqueBrown: 6440,
    Black: 4635,
    Bronze: 4636,
    Clay: 4637,
    Cocoa: 4638,
    Cream: 4639,
    Earthtone: 6441,
    ForestGreen: 4640,
    MysticGray: 6442,
    PaintersWhite: 6443,
    RoyalBrown: 6444,
    Sandstone: 6445,
    Silver: 4641,
    Tan: 6446,
    VintageLinen: 6447,
    White: 4642,
  },
  Window_MidwayWindows: {
    Midway_ArcticBlue: 11442,
    Midway_Black: 11443,
    Midway_Clay: 11444,
    Midway_DarkBronze: 11445,
    Midway_ForestGreen: 11446,
    Midway_Gunmetal: 11447,
    Midway_IvoryCream: 11448,
    Midway_RoyalBrown: 11449,
    Midway_Tan: 11450,
    Midway_TerraBronze: 11451,
    Midway_White: 11452,
  },
  Window_Milgard: {
    Adobe: 4427,
    Almond: 4428,
    Black: 4429,
    Bronze: 4430,
    White: 4431,
  },
  Window_Pella: {
    Pella_Alum_Almond: 6422,
    Pella_Alum_Black: 6423,
    Pella_Alum_BrickRed: 6424,
    Pella_Alum_Brown: 6425,
    Pella_Alum_ClassicWhite: 6426,
    Pella_Alum_Fossil: 6427,
    Pella_Alum_HarfordGreen: 6428,
    Pella_Alum_IronOre: 6429,
    Pella_Alum_Portobello: 6430,
    Pella_Alum_Putty: 6431,
    Pella_Alum_White: 6432,
    Pella_Alum_WolfGray: 6433,
    Pella_Black: 6417,
    Pella_Brown: 6418,
    Pella_MorningSkyGray: 6419,
    Pella_Tan: 6420,
    Pella_White: 6421,
  },
  Window_PGT: {
    Black: 4466,
    Bronze: 4467,
    ClearAnodize: 4468,
    White: 4469,
  },
  Window_PlyGem: {
    Adobe: 2012,
    Almond: 2040,
    Beige: 2041,
    Black: 2042,
    Bronze: 2043,
    Clay: 2044,
    DarkBronze: 2045,
    DoveGrey: 2046,
    Sand: 2047,
    TerraBeige: 2013,
    White: 2014,
  },
  Window_Prime: {
    Prime_Adobe: 10967,
    Prime_Almond: 10968,
    Prime_Black: 10969,
    Prime_Brown: 10970,
    Prime_CranberryRed: 10971,
    Prime_Green: 10972,
    Prime_Silver: 10973,
    Prime_White: 10974,
  },
  Window_Reliabilt: {
    Reliabilt_Black: 11354,
    Reliabilt_BrickRed: 11355,
    Reliabilt_Bronze: 11356,
    Reliabilt_Clay: 11357,
    Reliabilt_DarkChocolate: 11358,
    Reliabilt_Gray: 11359,
    Reliabilt_HunterGreen: 11360,
    Reliabilt_Tan: 11361,
    Reliabilt_Terratone: 11362,
  },
  Window_Silverline: {
    Beige: 1749,
    Black: 1750,
    DarkBronze: 1751,
    Sandstone: 1752,
    White: 1753,
  },
  Window_United: {
    United_AnthraciteGrey: 10454,
    United_Beige: 10455,
    United_Black: 10456,
    United_BrickRed: 10457,
    United_Bronze: 10458,
    United_Clay: 10459,
    United_Gray: 10460,
    United_Green: 10461,
    United_Sable: 10462,
    United_White: 10463,
  },
  Window_Westlake: {
    Clay: 6414,
    Pebblestone: 6415,
    Tan: 10781,
    White: 6416,
  },
  Window_WinDor: {
    Beige: 6434,
    BeigeCoated: 6435,
    Bronze: 6436,
    JetBlack: 6437,
    TaupeCoated: 6438,
    White: 6439,
  },
  Window_Windsor: {
    Windsor_Black: 10864,
    Windsor_Cinnamon: 10880,
    Windsor_Clay: 10865,
    Windsor_DarkBronze: 10866,
    Windsor_Ivory: 10867,
    Windsor_White: 10868,
  },
  Window_YKK: {
    YKK_Black: 11217,
    YKK_Bronze: 11218,
    YKK_Stone: 11219,
    YKK_Tan: 11220,
    YKK_White: 11221,
  },
  WolfHomeProducts: {
    WHP_White: 11340,
  },
  Wood_ChamClad: {
    Wood_ChamClad_6001_BeachwoodGrey: 10830,
    Wood_ChamClad_6020_SunbleachedOak: 10831,
    Wood_ChamClad_6036_Toffee: 10832,
    Wood_ChamClad_6045_BarrelOak: 10833,
    Wood_ChamClad_6046_CinnamonWalnut: 10834,
    Wood_ChamClad_6050_SugarMaple: 10835,
    Wood_ChamClad_6088_BlueRiver: 10836,
    Wood_ChamClad_6105_Sandlewood: 10837,
    Wood_ChamClad_7010_Honey: 10838,
    Wood_ChamClad_7027_HarvestWalnut: 10839,
    Wood_ChamClad_7080_RockyMountainOak: 10840,
    Wood_ChamClad_7081_ManhattanNaturalOak: 10841,
    Wood_ChamClad_CanadianPine: 11364,
    Wood_ChamClad_Cypress: 11365,
    Wood_ChamClad_WhiteOak: 11366,
  },
  Wood_Fiberon: {
    Fiberon_BeachHouse: 11319,
    Fiberon_Bungalow: 11320,
    Fiberon_Cabana: 11321,
    Fiberon_Cabin: 11322,
    Fiberon_Cottage: 11323,
    Fiberon_TuscanVilla: 11324,
  },
  Wood_LUX: {
    Wood_LUX_Charwood: 10842,
    Wood_LUX_Cypress: 10843,
    Wood_LUX_WhiteOak: 10844,
  },
  Wood_Messmers: {
    Wood_Messmers_CapeCodGray: 10845,
    Wood_Messmers_CharcoalGray: 10881,
    Wood_Messmers_ColoradoBrown: 11409,
    Wood_Messmers_DarkWalnut: 11410,
    Wood_Messmers_DriftwoodGray: 10846,
    Wood_Messmers_LakesideBrown: 11411,
    Wood_Messmers_MissionOak: 11412,
    Wood_Messmers_Natural: 11413,
    Wood_Messmers_NaturalCedar: 11414,
    Wood_Messmers_NaturalPineFir: 11415,
    Wood_Messmers_NaturalRedwood: 11416,
    Wood_Messmers_NavajoRed: 11417,
    Wood_Messmers_OakBrown: 11418,
    Wood_Messmers_OxfordBrown: 10847,
    Wood_Messmers_SequioaRed: 11419,
  },
  Wood_MicroProSienna: {
    Wood_MicroProSienna_PressureTreatedWood: 11065,
  },
  Wood_OldMasters: {
    Wood_OldMasters_AgedOak: 10848,
    Wood_OldMasters_AmericanWalnut: 11066,
    Wood_OldMasters_CarbonBlack: 10849,
    Wood_OldMasters_DarkWalnut: 10850,
    Wood_OldMasters_Espresso: 10851,
    Wood_OldMasters_FruitWood: 10852,
    Wood_OldMasters_NaturalWalnut: 11067,
    Wood_OldMasters_Provincial: 10853,
    Wood_OldMasters_SpanishOak: 10854,
    Wood_OldMasters_SpecialWalnut: 10855,
    Wood_OldMasters_WeatheredWood: 10856,
  },
  Wood_Olympic: {
    Wood_Olympic_CanyonBrown: 10882,
    Wood_Olympic_Cedar: 10883,
    Wood_Olympic_HoneyGold: 10884,
    Wood_Olympic_Redwood: 10885,
  },
  Wood_PittsburghStains: {
    Wood_Pittsburgh_GingerBrown: 10960,
    Wood_Pittsburgh_Mink: 10961,
  },
  Wood_ProWood: {
    ProWood_PressureTreatedSouthernYellowPine: 11068,
  },
  Wood_Varathane: {
    Wood_Varathane_AmericanWalnut: 10886,
    Wood_Varathane_Black: 10887,
    Wood_Varathane_Briarsmoke: 10888,
    Wood_Varathane_CarbonGray: 10889,
    Wood_Varathane_Cherrywood: 10890,
    Wood_Varathane_Cognac: 10891,
    Wood_Varathane_DarkWalnut: 10892,
    Wood_Varathane_GoldenOak: 10893,
    Wood_Varathane_Hickory: 10894,
    Wood_Varathane_JetBlack: 10895,
    Wood_Varathane_Kona: 10896,
    Wood_Varathane_Mahogany: 10897,
    Wood_Varathane_MidnightBlue: 10898,
    Wood_Varathane_WeatheredGray: 10899,
  },
  Wood_WayneDalton: {
    Wood_WD_Beachwood: 10857,
    Wood_WD_Black: 10858,
    Wood_WD_CarbonOak: 10859,
    Wood_WD_Cedar: 10860,
    Wood_WD_MediumOak: 10861,
  },
};
